import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** MediaURI custom scalar type */
  MediaURI: { input: any; output: any; }
  /**
   *
   *     Since Zendesk Return type is highly complex and many of the fields are not used in this application.
   *     Therefore by this implementation we will not have to code the graphql type
   */
  ZendeskTicketCommentResponseModel: { input: any; output: any; }
  /**
   *
   *   Since Zendesk Return type is highly complex and many of the fields are not used in this application.
   *   Therefore by this implementation we will not have to code the graphql type
   */
  ZendeskTicketResponseModel: { input: any; output: any; }
};

export type Ab_ReleasePanel = {
  __typename?: 'AB_ReleasePanel';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  featureName?: Maybe<Scalars['String']['output']>;
  isFeatureLive?: Maybe<Scalars['Boolean']['output']>;
  releaseId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  userIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Ab_ReleasePanelOutput = {
  __typename?: 'AB_ReleasePanelOutput';
  AB_ReleasePanelData?: Maybe<Array<Maybe<Ab_ReleasePanel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AccountSyncV2_OutputType = {
  __typename?: 'AccountSyncV2_OutputType';
  success?: Maybe<Scalars['Boolean']['output']>;
  userDetails?: Maybe<User>;
};

export type AchievementDetailsOutput = {
  __typename?: 'AchievementDetailsOutput';
  allowFeedback?: Maybe<Scalars['Boolean']['output']>;
  badgeDetails?: Maybe<Badges>;
  share?: Maybe<PromotionShareObj>;
  text1?: Maybe<Scalars['String']['output']>;
  text2?: Maybe<Scalars['String']['output']>;
  text3?: Maybe<Scalars['String']['output']>;
};

export type ActionHistoryOutput = {
  __typename?: 'ActionHistoryOutput';
  actions?: Maybe<Array<Maybe<ReportHistory>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ActionInput = {
  HiddenStatus: HiddenStatus;
  ReportId: Scalars['String']['input'];
  ReportStatus: ReportStatus;
  SuspectedStatus: SuspectedStatus;
  SuspendedStatus: SuspendedStatus;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  remark: Scalars['String']['input'];
};

export type ActionInputUserReport = {
  ReportId: Scalars['String']['input'];
  ReportStatus: ReportStatus;
  SuspendedStatus: SuspendedStatus;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  remark: Scalars['String']['input'];
};

export type ActionOutput = {
  HiddenStatus: HiddenStatus;
  ReportId: Scalars['String']['input'];
  ReportStatus: ReportStatus;
  SuspectedStatus: SuspectedStatus;
  SuspendedStatus: SuspendedStatus;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  remark: Scalars['String']['input'];
};

export type ActionOutputUserReport = {
  ReportId: Scalars['String']['input'];
  ReportStatus: ReportStatus;
  SuspendedStatus: SuspendedStatus;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  remark: Scalars['String']['input'];
};

export type ActionState = {
  __typename?: 'ActionState';
  HiddenStatus?: Maybe<HiddenStatus>;
  ReportId?: Maybe<Scalars['String']['output']>;
  ReportStatus?: Maybe<ReportStatus>;
  SuspectedStatus?: Maybe<SuspectedStatus>;
  SuspendedStatus?: Maybe<SuspendedStatus>;
};

export type ActivateOrDeactivatePromotionArgs = {
  promotionId: Scalars['String']['input'];
};

export type Activity = {
  __typename?: 'Activity';
  OwnerOfEntity?: Maybe<User>;
  OwnerOfEntityId?: Maybe<Scalars['String']['output']>;
  activityId?: Maybe<Scalars['Int']['output']>;
  activityType?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  chkbnsts?: Maybe<Scalars['String']['output']>;
  chksts?: Maybe<Scalars['String']['output']>;
  club?: Maybe<Club>;
  clubId?: Maybe<Scalars['String']['output']>;
  clubPostType?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Comment>;
  commentId?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  followhash?: Maybe<Scalars['String']['output']>;
  followingHash?: Maybe<Hashtag>;
  followingStock?: Maybe<Stock>;
  followingUser?: Maybe<User>;
  followstock?: Maybe<Scalars['Int']['output']>;
  followuser?: Maybe<Scalars['String']['output']>;
  post?: Maybe<Post>;
  postId?: Maybe<Scalars['String']['output']>;
  reply?: Maybe<Reply>;
  replyId?: Maybe<Scalars['String']['output']>;
  sharePostId?: Maybe<Scalars['String']['output']>;
  sharePostUserId?: Maybe<Scalars['String']['output']>;
  sharedPost?: Maybe<Post>;
  sharedPostUser?: Maybe<User>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  edges?: Maybe<Array<Maybe<ActivityEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ActivityEdge = {
  __typename?: 'ActivityEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ActivityFeedV2>;
};

export type ActivityFeed = {
  __typename?: 'ActivityFeed';
  actId?: Maybe<Scalars['String']['output']>;
  activityId?: Maybe<Scalars['Int']['output']>;
  activityType?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['MediaURI']['output']>;
  club?: Maybe<ClubFeedOutput>;
  comment?: Maybe<Post>;
  cover?: Maybe<Scalars['MediaURI']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  followingHashtag?: Maybe<HashtagFeedOutput>;
  followingStocktag?: Maybe<StockFeedOutput>;
  followingUser?: Maybe<UserFeedOutput>;
  post?: Maybe<Post>;
  reply?: Maybe<Post>;
  user?: Maybe<UserFeedOutput>;
};

export type ActivityFeedV2 = {
  __typename?: 'ActivityFeedV2';
  actId?: Maybe<Scalars['String']['output']>;
  activityId?: Maybe<Scalars['String']['output']>;
  activityType?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['MediaURI']['output']>;
  club?: Maybe<ClubFeedOutput>;
  comment?: Maybe<Post>;
  cover?: Maybe<Scalars['MediaURI']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  followingHashtag?: Maybe<HashtagFeedOutput>;
  followingStocktag?: Maybe<StockFeedOutput>;
  followingUser?: Maybe<UserFeedOutput>;
  post?: Maybe<Post>;
  reply?: Maybe<Post>;
  user?: Maybe<UserFeedOutput>;
};

export type ActivityFilterOutput = {
  __typename?: 'ActivityFilterOutput';
  activityList?: Maybe<Array<Maybe<Activity>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum ActivityTypeForAdmin {
  All = 'All',
  Comment = 'comment',
  DownvoteComment = 'downvoteComment',
  DownvotePost = 'downvotePost',
  DownvoteReply = 'downvoteReply',
  Followhash = 'followhash',
  Followstock = 'followstock',
  Followuser = 'followuser',
  Post = 'post',
  Reply = 'reply',
  Share = 'share',
  UpvoteComment = 'upvoteComment',
  UpvotePost = 'upvotePost',
  UpvoteReply = 'upvoteReply'
}

export type Admin = {
  __typename?: 'Admin';
  User?: Maybe<User>;
  adminId?: Maybe<Scalars['Int']['output']>;
  adminType?: Maybe<AdminType>;
  avatar?: Maybe<Scalars['MediaURI']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  empId?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AdminArgs = {
  adminType: AdminType;
  avatar?: InputMaybe<Scalars['MediaURI']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AdminCreateClubArgs = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  clubBio: Scalars['String']['input'];
  clubCategory?: InputMaybe<Array<InputMaybe<ClubCategories>>>;
  clubHandle: Scalars['String']['input'];
  clubHeadline?: InputMaybe<Scalars['String']['input']>;
  clubName: Scalars['String']['input'];
  clubPriority?: InputMaybe<Scalars['Int']['input']>;
  clubSettings?: InputMaybe<Array<InputMaybe<ClubSettings>>>;
  cover?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  isAutoJoinable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
};

export type AdminLogin = {
  email: Scalars['String']['input'];
  empId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type AdminNotificationFilter = {
  read?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminNotificationOutput = {
  __typename?: 'AdminNotificationOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  notificationId?: Maybe<Scalars['String']['output']>;
  notificationType?: Maybe<AdminNotificationType>;
  read?: Maybe<Scalars['Boolean']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum AdminNotificationType {
  ApprovalSystem = 'ApprovalSystem'
}

export type AdminSearchOutput = {
  __typename?: 'AdminSearchOutput';
  page?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type AdminSignUp = {
  email?: InputMaybe<Scalars['String']['input']>;
  empId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export enum AdminUserSearchFilterType {
  BlueTick = 'blueTick',
  GreenTick = 'greenTick',
  YellowTick = 'yellowTick'
}

export type AnalystDetails = {
  __typename?: 'AnalystDetails';
  User?: Maybe<User>;
  analystBio?: Maybe<Scalars['String']['output']>;
  analystDetailsId?: Maybe<Scalars['String']['output']>;
  awards?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  experience?: Maybe<Scalars['String']['output']>;
  qualification?: Maybe<Scalars['String']['output']>;
  sebiCertificate?: Maybe<Scalars['String']['output']>;
  specializes?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ApprovalRequestAdminFilter = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  requestStatus?: InputMaybe<ApprovalRequestStatus>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApprovalRequestData = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  pollData?: InputMaybe<CreatePollArgs>;
  postCategory: PostCategory;
  postId?: InputMaybe<Scalars['String']['input']>;
  sharePostId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ApprovalRequestDataOutput = {
  __typename?: 'ApprovalRequestDataOutput';
  categoryDisplayName?: Maybe<Scalars['String']['output']>;
  clubId?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<Maybe<Media>>>;
  pollData?: Maybe<CreatePollArgsOutput>;
  postCategory: PostCategory;
  postId?: Maybe<Scalars['String']['output']>;
  sharePostId?: Maybe<Scalars['String']['output']>;
  sharedPostDetails?: Maybe<Post>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  text?: Maybe<Scalars['String']['output']>;
};

export enum ApprovalRequestEntityType {
  Post = 'Post',
  Share = 'Share'
}

export enum ApprovalRequestStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type ApprovalRequests = {
  __typename?: 'ApprovalRequests';
  Club?: Maybe<Club>;
  User?: Maybe<User>;
  actionTakenBy?: Maybe<User>;
  actionTakenById?: Maybe<Scalars['String']['output']>;
  approvalRequestId?: Maybe<Scalars['String']['output']>;
  clubId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<ApprovalRequestDataOutput>;
  ownerId?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  requestEntityType?: Maybe<ApprovalRequestEntityType>;
  requestStatus?: Maybe<ApprovalRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApprovalRequestsListAdminOutput = {
  __typename?: 'ApprovalRequestsListAdminOutput';
  approvalRequests?: Maybe<Array<Maybe<ApprovalRequests>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  canBeOnboarded?: Maybe<Scalars['Boolean']['output']>;
  interimToken?: Maybe<Scalars['String']['output']>;
  isSuccess?: Maybe<IsSuccess>;
  profileDetails?: Maybe<UserProfileDetailsFromIdp>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type AutoFollow = {
  __typename?: 'AutoFollow';
  User?: Maybe<User>;
  addedBy?: Maybe<User>;
  addedById?: Maybe<Scalars['String']['output']>;
  autoFollowId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AutoFollowArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AutoFollowInputs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type AutoFollowListOutput = {
  __typename?: 'AutoFollowListOutput';
  autoFollowList?: Maybe<Array<Maybe<AutoFollow>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BadgeFeedback = {
  __typename?: 'BadgeFeedback';
  questionText?: Maybe<Scalars['String']['output']>;
  responseText?: Maybe<Scalars['String']['output']>;
};

export type Badges = {
  __typename?: 'Badges';
  badgeIcon?: Maybe<Scalars['String']['output']>;
  badgeId?: Maybe<Scalars['String']['output']>;
  badgeName?: Maybe<Scalars['String']['output']>;
  badgeType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalImageLink?: Maybe<Scalars['String']['output']>;
  externalShareText?: Maybe<Scalars['String']['output']>;
  promotionLink?: Maybe<Scalars['String']['output']>;
  promotionText?: Maybe<Scalars['String']['output']>;
  shareImageLink?: Maybe<Scalars['String']['output']>;
  shareText?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
};

export type BlueTickListOutput = {
  __typename?: 'BlueTickListOutput';
  blueTickList?: Maybe<Array<Maybe<User>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Bookmark = {
  __typename?: 'Bookmark';
  postId?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CategoryDisplayDetails = {
  __typename?: 'CategoryDisplayDetails';
  categoryDisplayName?: Maybe<Scalars['String']['output']>;
};

export type ChartPeriod = {
  __typename?: 'ChartPeriod';
  Code?: Maybe<Scalars['ID']['output']>;
  FromDate?: Maybe<Scalars['String']['output']>;
  IntervalType?: Maybe<Scalars['Int']['output']>;
  IsActive?: Maybe<Scalars['Boolean']['output']>;
  Text?: Maybe<Scalars['String']['output']>;
  Todate?: Maybe<Scalars['String']['output']>;
};

export type ChartPrice = {
  __typename?: 'ChartPrice';
  Close?: Maybe<Scalars['Float']['output']>;
  Date?: Maybe<Scalars['String']['output']>;
  High?: Maybe<Scalars['Float']['output']>;
  Low?: Maybe<Scalars['Float']['output']>;
  Open?: Maybe<Scalars['Float']['output']>;
  TradeQuantity?: Maybe<Scalars['Int']['output']>;
};

export type CheckUserPollResponseArgs = {
  pollId?: InputMaybe<Scalars['String']['input']>;
};

export type Club = {
  __typename?: 'Club';
  avatar?: Maybe<Scalars['MediaURI']['output']>;
  canJoinClub?: Maybe<Scalars['Boolean']['output']>;
  clubBio?: Maybe<Scalars['String']['output']>;
  clubCategory?: Maybe<Array<Maybe<ClubCategories>>>;
  clubHandle?: Maybe<Scalars['String']['output']>;
  clubHeadline?: Maybe<Scalars['String']['output']>;
  clubId?: Maybe<Scalars['String']['output']>;
  clubName?: Maybe<Scalars['String']['output']>;
  clubSettings?: Maybe<Array<Maybe<ClubSettings>>>;
  clubType?: Maybe<ClubType>;
  cover?: Maybe<Scalars['MediaURI']['output']>;
  createdByAdmin?: Maybe<User>;
  createdByAdminId?: Maybe<Scalars['String']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy?: Maybe<User>;
  deactivatedById?: Maybe<Scalars['String']['output']>;
  deactivationReason?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  displayCategoryName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isAutoJoinable?: Maybe<Scalars['Boolean']['output']>;
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  isFavourite?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  ismember?: Maybe<Scalars['String']['output']>;
  issubscribed?: Maybe<Scalars['Int']['output']>;
  memberType?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['String']['output']>;
  rule?: Maybe<Scalars['String']['output']>;
  showDisclaimer?: Maybe<Scalars['Boolean']['output']>;
  totalMemberCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByAdmin?: Maybe<User>;
  updatedByAdminId?: Maybe<Scalars['String']['output']>;
  viewFeedPermission?: Maybe<ViewFeedPermission>;
};

export type ClubAndUtilityToFeatureOutput = {
  __typename?: 'ClubAndUtilityToFeatureOutput';
  clubFeatures?: Maybe<Array<Maybe<ClubFeaturesOutput>>>;
  platformFeatures?: Maybe<Array<Maybe<UtilityFeaturesOutput>>>;
};

export enum ClubCategories {
  Biotechnology = 'BIOTECHNOLOGY',
  Education = 'EDUCATION',
  Energy = 'ENERGY',
  Equity = 'EQUITY',
  Etfs = 'ETFS',
  Finance = 'FINANCE',
  Forex = 'FOREX',
  Fundamental = 'FUNDAMENTAL',
  Futures = 'FUTURES',
  Investing = 'INVESTING',
  Metals = 'METALS',
  News = 'NEWS',
  Options = 'OPTIONS',
  Quant = 'QUANT',
  Swing = 'SWING',
  Technical = 'TECHNICAL',
  Technology = 'TECHNOLOGY',
  Trading = 'TRADING'
}

export type ClubCategory = {
  __typename?: 'ClubCategory';
  categoryId?: Maybe<Scalars['Int']['output']>;
  categoryName?: Maybe<ClubCategories>;
};

export type ClubChanges = {
  __typename?: 'ClubChanges';
  addedNew?: Maybe<Array<Maybe<Club>>>;
  updated?: Maybe<Array<Maybe<Club>>>;
};

export type ClubFeedOutput = {
  __typename?: 'ClubFeedOutput';
  avatar?: Maybe<Scalars['MediaURI']['output']>;
  clubBio?: Maybe<Scalars['String']['output']>;
  clubHandle?: Maybe<Scalars['String']['output']>;
  clubId?: Maybe<Scalars['String']['output']>;
  clubName?: Maybe<Scalars['String']['output']>;
  clubType?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<Scalars['MediaURI']['output']>;
  ismember?: Maybe<Scalars['String']['output']>;
};

export type ClubImageArgs = {
  clubId: Scalars['String']['input'];
  imageURL?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ImageType>;
};

export type ClubInput = {
  clubId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ClubListOutputAdmin = {
  __typename?: 'ClubListOutputAdmin';
  clubData?: Maybe<Array<Maybe<ClubWithPermission>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ClubMember = {
  __typename?: 'ClubMember';
  addedBy?: Maybe<User>;
  addedById?: Maybe<Scalars['String']['output']>;
  banStatus?: Maybe<Status>;
  club?: Maybe<Club>;
  clubId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  joiningTime?: Maybe<Scalars['DateTime']['output']>;
  member?: Maybe<User>;
  memberId?: Maybe<Scalars['String']['output']>;
  memberType?: Maybe<ClubMemberType>;
  membershipExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  membershipStatus?: Maybe<Status>;
  permissions?: Maybe<Array<Maybe<Permissions>>>;
  remarks?: Maybe<Scalars['String']['output']>;
  remarksDoc?: Maybe<Scalars['String']['output']>;
  subscribe?: Maybe<Scalars['Boolean']['output']>;
  unsubscribedTo?: Maybe<Array<Maybe<ClubSubscriptionType>>>;
};

export type ClubMemberArgs = {
  clubId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

export enum ClubMemberType {
  Member = 'Member',
  Moderator = 'Moderator',
  Owner = 'Owner',
  Team = 'Team'
}

export type ClubOutputAdmin = {
  __typename?: 'ClubOutputAdmin';
  clubData?: Maybe<Array<Maybe<ClubWithPermission>>>;
};

export type ClubReport = {
  __typename?: 'ClubReport';
  Club?: Maybe<Club>;
  Comment?: Maybe<Comment>;
  Member?: Maybe<ClubMember>;
  Post?: Maybe<Post>;
  Reply?: Maybe<Reply>;
  ReportData?: Maybe<Array<Maybe<ReportData>>>;
  abusecount?: Maybe<Scalars['Int']['output']>;
  clubId?: Maybe<Scalars['String']['output']>;
  clubReportId?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['String']['output']>;
  hatefulcount?: Maybe<Scalars['Int']['output']>;
  lastReportedTime?: Maybe<Scalars['DateTime']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  othercount?: Maybe<Scalars['Int']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  replyId?: Maybe<Scalars['String']['output']>;
  reportCount?: Maybe<Scalars['Int']['output']>;
  resolvedBy?: Maybe<Scalars['String']['output']>;
  spamcount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ReportStatus>;
};

export type ClubSettingArgs = {
  clubId: Scalars['String']['input'];
  settings: Array<InputMaybe<ClubSettings>>;
};

export enum ClubSettings {
  InviteEnabled = 'INVITE_ENABLED',
  PostDisabled = 'POST_DISABLED',
  TrialEnabled = 'TRIAL_ENABLED'
}

export enum ClubType {
  Paid = 'Paid',
  Private = 'Private',
  Public = 'Public'
}

export type ClubWithPermission = {
  __typename?: 'ClubWithPermission';
  avatar?: Maybe<Scalars['MediaURI']['output']>;
  canJoinClub?: Maybe<Scalars['Boolean']['output']>;
  clubBio?: Maybe<Scalars['String']['output']>;
  clubCategory?: Maybe<Array<Maybe<ClubCategories>>>;
  clubHandle?: Maybe<Scalars['String']['output']>;
  clubHeadline?: Maybe<Scalars['String']['output']>;
  clubId?: Maybe<Scalars['String']['output']>;
  clubName?: Maybe<Scalars['String']['output']>;
  clubPriority?: Maybe<Scalars['Int']['output']>;
  clubSettings?: Maybe<Array<Maybe<ClubSettings>>>;
  clubType?: Maybe<ClubType>;
  cover?: Maybe<Scalars['MediaURI']['output']>;
  createdByAdmin?: Maybe<User>;
  createdByAdminId?: Maybe<Scalars['String']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy?: Maybe<User>;
  deactivatedById?: Maybe<Scalars['String']['output']>;
  deactivationReason?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  isAutoJoinable?: Maybe<Scalars['Boolean']['output']>;
  isClubLive?: Maybe<Scalars['Boolean']['output']>;
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  ismember?: Maybe<Scalars['String']['output']>;
  issubscribed?: Maybe<Scalars['Int']['output']>;
  madeLiveBy?: Maybe<User>;
  madeLiveById?: Maybe<Scalars['String']['output']>;
  memberType?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<MemberTypeClubPermissionData>>>;
  rule?: Maybe<Scalars['String']['output']>;
  showDisclaimer?: Maybe<Scalars['Boolean']['output']>;
  totalMemberCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByAdmin?: Maybe<User>;
  updatedByAdminId?: Maybe<Scalars['String']['output']>;
};

export type Comment = {
  __typename?: 'Comment';
  User?: Maybe<User>;
  commentId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  downvotecount?: Maybe<Scalars['Int']['output']>;
  editHistory?: Maybe<Array<Maybe<EditHistoryData>>>;
  hasReplies?: Maybe<Scalars['Boolean']['output']>;
  isCheckedByCM?: Maybe<Scalars['Int']['output']>;
  isDownvoted?: Maybe<Scalars['Int']['output']>;
  isEdited?: Maybe<Scalars['Boolean']['output']>;
  isSuspected?: Maybe<Scalars['Int']['output']>;
  isTopComment?: Maybe<Scalars['Boolean']['output']>;
  isUpvoted?: Maybe<Scalars['Int']['output']>;
  linkPreview?: Maybe<LinkPreview>;
  media?: Maybe<Array<Maybe<Media>>>;
  memberType?: Maybe<ClubMemberType>;
  membershipLevelOfCreator?: Maybe<Scalars['Int']['output']>;
  post?: Maybe<Post>;
  postId?: Maybe<Scalars['String']['output']>;
  replies?: Maybe<Array<Maybe<Reply>>>;
  replycount?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  text?: Maybe<Scalars['String']['output']>;
  textV2?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upvotecount?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CommentConnection = {
  __typename?: 'CommentConnection';
  edges: Array<CommentEdge>;
  pageInfo: PageInfo;
};

export type CommentData = {
  linkPreview?: InputMaybe<LinkPreviewInput>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CommentEdge = {
  __typename?: 'CommentEdge';
  cursor: Scalars['String']['output'];
  node: Comment;
};

export type CommentId = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type CommentInput = {
  commentData: CommentData;
  postId: Scalars['String']['input'];
};

export type CommentUpvoteDownVoteCountV2 = {
  __typename?: 'CommentUpvoteDownVoteCountV2';
  comment?: Maybe<Comment>;
  downvotes?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  upvotes?: Maybe<Scalars['Int']['output']>;
};

export type CommentsByPost = {
  __typename?: 'CommentsByPost';
  comments?: Maybe<Array<Maybe<Comment>>>;
  errorMessage?: Maybe<ErrorMessage>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  since?: Maybe<Scalars['String']['output']>;
};

export type CompanyEquityInfo = {
  __typename?: 'CompanyEquityInfo';
  BookNavPerShare?: Maybe<Scalars['Float']['output']>;
  EPS?: Maybe<Scalars['Float']['output']>;
  FaceValue?: Maybe<Scalars['Int']['output']>;
  Fincode?: Maybe<Scalars['Int']['output']>;
  ID?: Maybe<Scalars['ID']['output']>;
  Industry?: Maybe<Scalars['String']['output']>;
  IndustryID?: Maybe<Scalars['Int']['output']>;
  IndustryPE?: Maybe<Scalars['Float']['output']>;
  IndustrySlug?: Maybe<Scalars['String']['output']>;
  MCAP?: Maybe<Scalars['Float']['output']>;
  NumberOfSharesSubscribed?: Maybe<Scalars['Int']['output']>;
  PE?: Maybe<Scalars['Float']['output']>;
  Price?: Maybe<Scalars['Float']['output']>;
  PriceToBookNavPerShare?: Maybe<Scalars['Float']['output']>;
  Sector?: Maybe<Scalars['String']['output']>;
  SectorID?: Maybe<Scalars['Int']['output']>;
  SectorSlug?: Maybe<Scalars['String']['output']>;
  Security?: Maybe<Scalars['String']['output']>;
  SecuritySlug?: Maybe<Scalars['String']['output']>;
  TTMEPS?: Maybe<Scalars['Float']['output']>;
  TTMNetProfit?: Maybe<Scalars['Int']['output']>;
  TTMPE?: Maybe<Scalars['Float']['output']>;
  TTMYearEnd?: Maybe<Scalars['Int']['output']>;
  Website?: Maybe<Scalars['String']['output']>;
  YearEnd?: Maybe<Scalars['Int']['output']>;
  Yield?: Maybe<Scalars['Float']['output']>;
};

export type CompanyEquityTypeInfo = {
  __typename?: 'CompanyEquityTypeInfo';
  ID?: Maybe<Scalars['ID']['output']>;
  IsActive: Scalars['Boolean']['output'];
  StatementType?: Maybe<Scalars['String']['output']>;
  YearEnd?: Maybe<Scalars['Int']['output']>;
};

export type CompanyProfileForSecurity = {
  __typename?: 'CompanyProfileForSecurity';
  ID?: Maybe<Scalars['ID']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ProfileText?: Maybe<Scalars['String']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
};

export enum ContentMadeByUser {
  AllContent = 'AllContent',
  BeginnerContent = 'BeginnerContent',
  InvestorContent = 'InvestorContent',
  TraderContent = 'TraderContent'
}

export type CreateBookmark = {
  postId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClubArgs = {
  avatar?: InputMaybe<Scalars['MediaURI']['input']>;
  clubBio?: InputMaybe<Scalars['String']['input']>;
  clubCategory: Array<InputMaybe<ClubCategories>>;
  clubHandle: Scalars['String']['input'];
  clubHeadline?: InputMaybe<Scalars['String']['input']>;
  clubName: Scalars['String']['input'];
  clubSettings: Array<InputMaybe<ClubSettings>>;
  clubType: ClubType;
  cover?: InputMaybe<Scalars['MediaURI']['input']>;
};

export type CreateDollarArgs = {
  alias: Scalars['String']['input'];
  dollarTagName: Scalars['String']['input'];
  dollarTagType: DollarTagEnum;
  slug: Scalars['String']['input'];
  sourceEntityId: Scalars['String']['input'];
  sourceEntityIdType: SourceEntityId;
};

export type CreateInterest = {
  categoryId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sectorId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CreateReportInput = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  replyId?: InputMaybe<Scalars['String']['input']>;
  reportType: ReportType;
  reportedOn: ReportedOn;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Cta = {
  __typename?: 'Cta';
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DateForFeedbackMis = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum DateRange {
  Daily = 'daily',
  Monthly = 'monthly',
  Today = 'today',
  Weekly = 'weekly',
  Yearly = 'yearly'
}

export type DeletePostInput = {
  postId: Scalars['String']['input'];
  sharePostId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeletedPosts = {
  __typename?: 'DeletedPosts';
  clubId?: Maybe<Scalars['String']['output']>;
  commentcount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  downvotecount?: Maybe<Scalars['Int']['output']>;
  editHistory?: Maybe<Array<Maybe<EditHistoryData>>>;
  flagged?: Maybe<Scalars['Int']['output']>;
  hasPoll?: Maybe<Scalars['Boolean']['output']>;
  ideaType?: Maybe<IdeaType>;
  isCheckedByCM?: Maybe<Scalars['Int']['output']>;
  isClubPropagatable?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isDownvoted?: Maybe<Scalars['Int']['output']>;
  isEdited?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isPinnedByUser?: Maybe<Scalars['Boolean']['output']>;
  isSuspected?: Maybe<Scalars['Int']['output']>;
  isUpvoted?: Maybe<Scalars['Int']['output']>;
  isUserDeleted?: Maybe<Scalars['Boolean']['output']>;
  isbookmarked?: Maybe<Scalars['Int']['output']>;
  linkPreview?: Maybe<LinkPreview>;
  media?: Maybe<Array<Maybe<Media>>>;
  memberType?: Maybe<ClubMemberType>;
  membershipLevelOfCreator?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<Meta>;
  notificationToBeSentToOwner?: Maybe<Scalars['Boolean']['output']>;
  oldPostId?: Maybe<Scalars['Int']['output']>;
  postCategory?: Maybe<PostCategory>;
  postId?: Maybe<Scalars['String']['output']>;
  postType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reportCount?: Maybe<Scalars['Int']['output']>;
  sharePostId?: Maybe<Scalars['String']['output']>;
  sharecount?: Maybe<Scalars['Int']['output']>;
  stockName?: Maybe<Scalars['String']['output']>;
  stopLoss?: Maybe<Scalars['String']['output']>;
  suspectedAt?: Maybe<Scalars['DateTime']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  target?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  topCommentId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upvotecount?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userInfo?: Maybe<UserInfo>;
};

export type DeletedPostsLogOutput = {
  __typename?: 'DeletedPostsLogOutput';
  deletedPostsLog?: Maybe<Array<Maybe<DeletedPosts>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum DeviceType {
  Android = 'android',
  Ios = 'ios',
  Mobileweb = 'mobileweb',
  Web = 'web'
}

export enum DeviceTypeEnum {
  Android = 'android',
  Ios = 'ios',
  Mobileweb = 'mobileweb',
  Web = 'web'
}

export type DollarTag = {
  __typename?: 'DollarTag';
  alias?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dollarTagId: Scalars['Int']['output'];
  dollarTagName: Scalars['String']['output'];
  dollarTagType: DollarTagEnum;
  followers?: Maybe<Scalars['Int']['output']>;
  isfollow?: Maybe<Scalars['Int']['output']>;
  issubscribed?: Maybe<Scalars['Int']['output']>;
  postCount?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sourceEntityId?: Maybe<Scalars['String']['output']>;
  sourceEntityIdType?: Maybe<SourceEntityId>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  viewFeedPermission?: Maybe<ViewFeedPermission>;
};

export type DollarTagSearch = {
  __typename?: 'DollarTagSearch';
  dollarTag?: Maybe<DollarTag>;
  followers?: Maybe<Scalars['Int']['output']>;
};

export type EditHistoryData = {
  __typename?: 'EditHistoryData';
  User?: Maybe<User>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  media?: Maybe<Array<Maybe<Media>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type EditNormalPostData = {
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  poll?: InputMaybe<CreatePollArgs>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type EditNormalPostInput = {
  postData?: InputMaybe<EditNormalPostData>;
  postId?: InputMaybe<Scalars['String']['input']>;
};

export type EditPromotionArgs = {
  imageURL?: InputMaybe<Scalars['String']['input']>;
  promotionId: Scalars['String']['input'];
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  shareableURL?: InputMaybe<Scalars['String']['input']>;
};

export type EditPromotionArgsForSmartFeed = {
  audience?: InputMaybe<UserAudienceType>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  promotionId: Scalars['String']['input'];
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  shareableURL?: InputMaybe<Scalars['String']['input']>;
};

export type EditPromotionArgsWithAudience = {
  audience: UserAudienceType;
  imageURL?: InputMaybe<Scalars['String']['input']>;
  promotionId: Scalars['String']['input'];
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  shareableURL?: InputMaybe<Scalars['String']['input']>;
};

export type EditQueryData = {
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  postId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type EditQueryInput = {
  postData: EditQueryData;
  postId?: InputMaybe<Scalars['String']['input']>;
};

export type EditStockIdeaData = {
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  postId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type EditStockIdeasInput = {
  postData?: InputMaybe<EditStockIdeaData>;
  postId?: InputMaybe<Scalars['String']['input']>;
};

export type EditedPost = {
  __typename?: 'EditedPost';
  Club?: Maybe<Club>;
  User?: Maybe<User>;
  categoryDisplayDetails?: Maybe<CategoryDisplayDetails>;
  clubId?: Maybe<Scalars['String']['output']>;
  clubPostShareSetting?: Maybe<ClubPostShareSettingScheme>;
  clubPostShareSettingV2?: Maybe<Scalars['Boolean']['output']>;
  commentcount?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  downvotecount?: Maybe<Scalars['Int']['output']>;
  editHistory?: Maybe<Array<Maybe<EditHistoryData>>>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  flagged?: Maybe<Scalars['Int']['output']>;
  getPoll?: Maybe<Poll>;
  getSharedPost?: Maybe<Post>;
  hasComments?: Maybe<Scalars['Boolean']['output']>;
  hasPoll?: Maybe<Scalars['Boolean']['output']>;
  ideaType?: Maybe<IdeaType>;
  isCheckedByCM?: Maybe<Scalars['Int']['output']>;
  isDownvoted?: Maybe<Scalars['Int']['output']>;
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  isEdited?: Maybe<Scalars['Boolean']['output']>;
  isFollowed?: Maybe<Scalars['Boolean']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  isPinnedByUser?: Maybe<Scalars['Boolean']['output']>;
  isSuspected?: Maybe<Scalars['Int']['output']>;
  isUpvoted?: Maybe<Scalars['Int']['output']>;
  isbookmarked?: Maybe<Scalars['Int']['output']>;
  linkPreview?: Maybe<LinkPreview>;
  media?: Maybe<Array<Maybe<Media>>>;
  memberType?: Maybe<ClubMemberType>;
  membershipLevelOfCreator?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<Meta>;
  postCategory?: Maybe<PostCategory>;
  postId?: Maybe<Scalars['String']['output']>;
  postSharePermissions?: Maybe<Array<Maybe<PostShareTypePermissions>>>;
  postType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sharePostId?: Maybe<Scalars['String']['output']>;
  sharecount?: Maybe<Scalars['Int']['output']>;
  stockName?: Maybe<Scalars['String']['output']>;
  stopLoss?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  target?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  textV2?: Maybe<Scalars['String']['output']>;
  topComment?: Maybe<Comment>;
  topCommentId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upvotecount?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userShares?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EditedPostClubPostShareSettingV2Args = {
  clubBasedPermissionToken: Scalars['String']['input'];
};

export type ErrorMessage = {
  __typename?: 'ErrorMessage';
  errCode?: Maybe<Scalars['String']['output']>;
  errLabel?: Maybe<Scalars['String']['output']>;
  errMessage?: Maybe<Scalars['String']['output']>;
};

export type Exchange = {
  __typename?: 'Exchange';
  Exchange?: Maybe<Scalars['Int']['output']>;
  ExchangeName?: Maybe<Scalars['String']['output']>;
  IsActive: Scalars['Boolean']['output'];
  ListingID?: Maybe<Scalars['Int']['output']>;
  SecurityID?: Maybe<Scalars['Int']['output']>;
  SecurityName?: Maybe<Scalars['String']['output']>;
  ShortName?: Maybe<Scalars['String']['output']>;
  Symbol?: Maybe<Scalars['String']['output']>;
};

export enum ExternalLoginProviderType {
  Apple = 'Apple',
  Facebook = 'Facebook',
  Google = 'Google'
}

export type ExternalResource = {
  __typename?: 'ExternalResource';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ExternalResourceListOutput = {
  __typename?: 'ExternalResourceListOutput';
  resourceList?: Maybe<Array<Maybe<ExternalResource>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FeatureClubCategory = {
  __typename?: 'FeatureClubCategory';
  clubCategoryId?: Maybe<Scalars['String']['output']>;
  clubCategoryName?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
};

export type FeatureClubCategoryInputArgs = {
  clubCategoryName: Scalars['String']['input'];
  cover: Scalars['String']['input'];
  description: Scalars['String']['input'];
  headline: Scalars['String']['input'];
  icon: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
};

export type FeatureClubCategoryUpdateArgs = {
  clubCategoryId: Scalars['String']['input'];
  clubCategoryName: Scalars['String']['input'];
  cover: Scalars['String']['input'];
  description: Scalars['String']['input'];
  headline: Scalars['String']['input'];
  icon: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
};

export type FeatureClubGroup = {
  __typename?: 'FeatureClubGroup';
  Club?: Maybe<Club>;
  FeatureMap?: Maybe<FeatureMapping>;
  clubId?: Maybe<Scalars['String']['output']>;
  featureId?: Maybe<Scalars['String']['output']>;
  featurePlatformRuleId?: Maybe<Scalars['String']['output']>;
};

export type FeatureClubGroupData = {
  __typename?: 'FeatureClubGroupData';
  dataList?: Maybe<Array<Maybe<FeatureClubGroup>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FeatureClubRules = {
  __typename?: 'FeatureClubRules';
  Club?: Maybe<Club>;
  canBookmark?: Maybe<Scalars['Boolean']['output']>;
  canEngage?: Maybe<Scalars['Boolean']['output']>;
  canPost?: Maybe<Scalars['Boolean']['output']>;
  canReport?: Maybe<Scalars['Boolean']['output']>;
  canView?: Maybe<Scalars['Boolean']['output']>;
  clubId?: Maybe<Scalars['String']['output']>;
  clubRuleId?: Maybe<Scalars['String']['output']>;
};

export type FeatureDataArgs = {
  featureAlias?: InputMaybe<Scalars['String']['input']>;
  featureName?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureDataType = {
  __typename?: 'FeatureDataType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  featureAlias?: Maybe<Scalars['String']['output']>;
  featureId?: Maybe<Scalars['String']['output']>;
  featureName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
};

export type FeatureMapping = {
  __typename?: 'FeatureMapping';
  clubIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  feature?: Maybe<Scalars['String']['output']>;
  featureAlias?: Maybe<Scalars['String']['output']>;
  featureId?: Maybe<Scalars['String']['output']>;
  featureName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
};

export type FeatureMappingData = {
  __typename?: 'FeatureMappingData';
  dataList?: Maybe<Array<Maybe<FeatureWithPermissionDataOutput>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FeaturePlatformPermission = {
  __typename?: 'FeaturePlatformPermission';
  Feature?: Maybe<FeatureMapping>;
  canAutoJoinBlueTick?: Maybe<Scalars['Boolean']['output']>;
  canAutoJoinGreenTick?: Maybe<Scalars['Boolean']['output']>;
  canAutoJoinYellowTick?: Maybe<Scalars['Boolean']['output']>;
  canBeFollowed?: Maybe<Scalars['Boolean']['output']>;
  canBlock?: Maybe<Scalars['Boolean']['output']>;
  canCreateStockIdea?: Maybe<Scalars['Boolean']['output']>;
  canEngage?: Maybe<Scalars['Boolean']['output']>;
  canFollow?: Maybe<Scalars['Boolean']['output']>;
  canFollowPost?: Maybe<Scalars['Boolean']['output']>;
  canPost?: Maybe<Scalars['Boolean']['output']>;
  canQuery?: Maybe<Scalars['Boolean']['output']>;
  canReport?: Maybe<Scalars['Boolean']['output']>;
  canSeeClubPromotion?: Maybe<Scalars['Boolean']['output']>;
  canSeeMarketingPage?: Maybe<Scalars['Boolean']['output']>;
  canSeeOthersFeedPosts?: Maybe<Scalars['Boolean']['output']>;
  canSeePremiumPromotion?: Maybe<Scalars['Boolean']['output']>;
  canSeeWatchList?: Maybe<Scalars['Boolean']['output']>;
  canShowNps?: Maybe<Scalars['Boolean']['output']>;
  canViewPost?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  featureId?: Maybe<Scalars['String']['output']>;
  featurePlatformRuleId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
};

export type FeaturePlatformPermissionArgs = {
  canAutoJoinBlueTick?: InputMaybe<Scalars['Boolean']['input']>;
  canAutoJoinGreenTick?: InputMaybe<Scalars['Boolean']['input']>;
  canAutoJoinYellowTick?: InputMaybe<Scalars['Boolean']['input']>;
  canBeFollowed?: InputMaybe<Scalars['Boolean']['input']>;
  canBlock?: InputMaybe<Scalars['Boolean']['input']>;
  canCreateStockIdea?: InputMaybe<Scalars['Boolean']['input']>;
  canEngage?: InputMaybe<Scalars['Boolean']['input']>;
  canFollow?: InputMaybe<Scalars['Boolean']['input']>;
  canFollowPost?: InputMaybe<Scalars['Boolean']['input']>;
  canPost?: InputMaybe<Scalars['Boolean']['input']>;
  canQuery?: InputMaybe<Scalars['Boolean']['input']>;
  canReport?: InputMaybe<Scalars['Boolean']['input']>;
  canSeeClubPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  canSeeMarketingPage?: InputMaybe<Scalars['Boolean']['input']>;
  canSeeOthersFeedPosts?: InputMaybe<Scalars['Boolean']['input']>;
  canSeePremiumPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  canSeeWatchList?: InputMaybe<Scalars['Boolean']['input']>;
  canShowNps?: InputMaybe<Scalars['Boolean']['input']>;
  canViewPost?: InputMaybe<Scalars['Boolean']['input']>;
  featureId?: InputMaybe<Scalars['String']['input']>;
};

export type FeaturePlatformPermissionData = {
  __typename?: 'FeaturePlatformPermissionData';
  dataList?: Maybe<Array<Maybe<FeaturePlatformPermission>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FeatureWithPermissionDataInput = {
  featureData?: InputMaybe<FeatureDataArgs>;
  platformPermissionData?: InputMaybe<PlatformPermissionArgs>;
};

export type FeatureWithPermissionDataOutput = {
  __typename?: 'FeatureWithPermissionDataOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  featureAlias?: Maybe<Scalars['String']['output']>;
  featureId?: Maybe<Scalars['String']['output']>;
  featureName?: Maybe<Scalars['String']['output']>;
  platformPermissionData?: Maybe<PlatformPermissionOutputType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
};

export type FeedList = {
  __typename?: 'FeedList';
  default?: Maybe<Scalars['Boolean']['output']>;
  feedDisplayName?: Maybe<Scalars['String']['output']>;
  feedType?: Maybe<Scalars['String']['output']>;
  feedTypeId?: Maybe<Scalars['String']['output']>;
  showSmartFeed?: Maybe<Scalars['Boolean']['output']>;
};

export type Feedback = {
  __typename?: 'Feedback';
  attachment?: Maybe<Media>;
  comment?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  feedbackId?: Maybe<Scalars['String']['output']>;
  replies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<FeedbackStatus>;
  subject?: Maybe<Scalars['String']['output']>;
  type?: Maybe<FeedbackTypeEnum>;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type FeedbackData = {
  __typename?: 'FeedbackData';
  badgeFeedback?: Maybe<Array<Maybe<BadgeFeedback>>>;
  badgeName?: Maybe<Scalars['String']['output']>;
  badgeType?: Maybe<Scalars['String']['output']>;
  gotBadgeAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type FeedbackInput = {
  Type?: InputMaybe<FeedbackTypeEnum>;
  attachment?: InputMaybe<MediaInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackQuestionResponseInput = {
  badgeId?: InputMaybe<Scalars['String']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  responseText?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackQuestions = {
  __typename?: 'FeedbackQuestions';
  Badge?: Maybe<Badges>;
  badgeId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  questionId?: Maybe<Scalars['String']['output']>;
  questionText?: Maybe<Scalars['String']['output']>;
};

export enum FeedbackStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export enum FeedbackTypeEnum {
  Bug = 'BUG',
  Feature = 'FEATURE'
}

export type FilterActivityArgs = {
  activityType: Array<InputMaybe<ActivityTypeForAdmin>>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  hashTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  securityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userType: Array<InputMaybe<UserTypeForAdmin>>;
};

export type FilterForPowerUserFeedbackMis = {
  dateRange: DateForFeedbackMis;
  feedbackGiven?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilteredPostListSinceDate = {
  __typename?: 'FilteredPostListSinceDate';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  posts?: Maybe<Array<Maybe<Post>>>;
  since?: Maybe<Scalars['String']['output']>;
};

export type FollowArgs = {
  entity: FollowEntity;
  id: Scalars['String']['input'];
  limits?: InputMaybe<Limits>;
  subscribeTo?: InputMaybe<UserSubscriptionType>;
  unsubscribeTo?: InputMaybe<UserSubscriptionType>;
};

export enum FollowEntity {
  Dollartag = 'Dollartag',
  Hashtag = 'Hashtag',
  Stock = 'Stock',
  User = 'User'
}

export type FollowOutput = {
  __typename?: 'FollowOutput';
  followStatus?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FollowPostInput = {
  postId?: InputMaybe<Scalars['String']['input']>;
};

export enum FollowStatus {
  Rejected = 'Rejected',
  Resolved = 'Resolved'
}

export enum FollowType {
  Follower = 'Follower',
  Subscriber = 'Subscriber'
}

export type FollowingType = {
  __typename?: 'FollowingType';
  hashtags?: Maybe<Array<Maybe<Hashtag>>>;
  stocks?: Maybe<Array<Maybe<Stock>>>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type FollowingTypeNew = {
  __typename?: 'FollowingTypeNew';
  hashtags?: Maybe<Array<Maybe<TrendingHashTag>>>;
  stocks?: Maybe<Array<Maybe<TrendingStocktag>>>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type FolowPostOutput = {
  __typename?: 'FolowPostOutput';
  message?: Maybe<Scalars['String']['output']>;
  post?: Maybe<Post>;
};

export enum Gender {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other'
}

export type GetChartPeriodsInput = {
  ID?: InputMaybe<Scalars['ID']['input']>;
};

export type GetClubReport = {
  clubId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  reportStatus: ReportStatusType;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type: ReportedOnType;
};

export type GetClubsByTopicsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  topics?: InputMaybe<Array<InputMaybe<ClubCategories>>>;
};

export type GetCompanyEquityInfoInput = {
  StatementType: Scalars['String']['input'];
  securityID: Scalars['Int']['input'];
};

export type GetCompanyEquityTypeInfoInput = {
  securityID: Scalars['Int']['input'];
};

export type GetCompanyProfileForSecurityInput = {
  SecurityID: Scalars['Int']['input'];
};

export type GetCronJobLogsOutput = {
  __typename?: 'GetCronJobLogsOutput';
  cronJobs?: Maybe<Array<Maybe<CronJobExecutionLogs>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum GetCronJobStatus {
  All = 'All',
  Failed = 'Failed',
  Passed = 'Passed'
}

export enum GetCronJobsStatusType {
  Failed = 'Failed',
  Running = 'Running',
  Successful = 'Successful'
}

export type GetHashtagBySearchTextArgs = {
  searchText: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GetInterest = {
  interestType: InterestType;
  userId: Scalars['String']['input'];
};

export type GetIntradayPricesInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  listingID?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type GetLatestListingPriceInput = {
  listingID?: InputMaybe<Scalars['Int']['input']>;
};

export type GetListingsForSecurityInput = {
  securityID?: InputMaybe<Scalars['Int']['input']>;
};

export type GetMomListArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type GetPricesInput = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  intervalType?: InputMaybe<Scalars['Int']['input']>;
  listingID?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type GetReportData = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  reportType: GetReportType;
  reportedById?: InputMaybe<Scalars['String']['input']>;
  reportedByType: ReportedByType;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<ReportedOnType>;
};

export type GetSectorsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GetSiteReport = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  reportStatus: ReportStatusType;
  reportType: GetReportType;
  reportedByType: ReportedByType;
  reportedUserId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type: ReportedOnType;
};

export type GetStocksBySearchTextArgs = {
  searchText: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GetStocksBySectorsArgs = {
  sectorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GetTickListArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type GetUserClubsArgs = {
  memberType: ClubMemberType;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserListArgs = {
  searchText: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalSearchForPosts = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  dollarTagMentioned?: InputMaybe<Scalars['Int']['input']>;
  hashTagMentioned?: InputMaybe<Scalars['String']['input']>;
  postCategory?: InputMaybe<PostCategoryForSearch>;
  userCreatorId?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalSearchPostListSinceDate = {
  __typename?: 'GlobalSearchPostListSinceDate';
  errorMessage?: Maybe<ErrorMessage>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  posts?: Maybe<Array<Maybe<Post>>>;
  since?: Maybe<Scalars['String']['output']>;
};

export type GreenTickListOutput = {
  __typename?: 'GreenTickListOutput';
  greenTickList?: Maybe<Array<Maybe<User>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type HashTagSearch = {
  __typename?: 'HashTagSearch';
  followers?: Maybe<Scalars['Int']['output']>;
  hashtag?: Maybe<Hashtag>;
};

export type Hashtag = {
  __typename?: 'Hashtag';
  TagId?: Maybe<Scalars['String']['output']>;
  followers?: Maybe<Scalars['Int']['output']>;
  hashtagName?: Maybe<Scalars['String']['output']>;
  hashtagType?: Maybe<HashtagType>;
  isPreSelected?: Maybe<Scalars['Boolean']['output']>;
  isPreferred?: Maybe<Scalars['Boolean']['output']>;
  isfollow?: Maybe<Scalars['Int']['output']>;
  issubscribed?: Maybe<Scalars['Int']['output']>;
  postCount?: Maybe<Scalars['Int']['output']>;
  viewFeedPermission?: Maybe<ViewFeedPermission>;
};

export type HashtagFeedOutput = {
  __typename?: 'HashtagFeedOutput';
  hashtagId?: Maybe<Scalars['String']['output']>;
  hashtagName?: Maybe<Scalars['String']['output']>;
  hashtagType?: Maybe<Scalars['String']['output']>;
  isfollow?: Maybe<Scalars['Int']['output']>;
};

export enum HashtagType {
  Default = 'Default',
  Exclusive = 'Exclusive'
}

export enum HiddenStatus {
  IsHidden = 'isHidden',
  IsVisible = 'isVisible'
}

export type HighlightedAchievements = {
  __typename?: 'HighlightedAchievements';
  achievementType?: Maybe<Scalars['String']['output']>;
  badges?: Maybe<Badges>;
  promotionImage?: Maybe<Scalars['String']['output']>;
  promotionText?: Maybe<Scalars['String']['output']>;
  sourceOfClick?: Maybe<Scalars['String']['output']>;
};

export enum IdeaType {
  Buy = 'Buy',
  Sell = 'Sell'
}

export enum ImageType {
  Avatar = 'Avatar',
  Cover = 'Cover'
}

export type Interest = {
  __typename?: 'Interest';
  categoryId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interestId?: Maybe<Scalars['Int']['output']>;
  interestType?: Maybe<InterestType>;
  sectorId?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export enum InterestType {
  ClubCategories = 'ClubCategories',
  Sector = 'Sector'
}

export type Interstitials = {
  __typename?: 'Interstitials';
  audience?: Maybe<UserAudienceType>;
  componentType?: Maybe<ComponentType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  interstitialsId?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  platformType?: Maybe<PlatformTypeForInterstitial>;
  position?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
};

export type InterstitialsConfig = {
  __typename?: 'InterstitialsConfig';
  componentType?: Maybe<Scalars['String']['output']>;
  componentTypeName?: Maybe<Scalars['String']['output']>;
  dropdown?: Maybe<Array<Maybe<InterstitialsDropdownData>>>;
};

export type InterstitialsData = {
  __typename?: 'InterstitialsData';
  componentType?: Maybe<ComponentType>;
  data?: Maybe<Scalars['String']['output']>;
  interstitialsId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type InterstitialsDropdownData = {
  __typename?: 'InterstitialsDropdownData';
  data?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type InterstitialsFilterArgs = {
  componentType?: InputMaybe<FilterComponentType>;
  platformType?: InputMaybe<FilterPlatformType>;
};

export type IsFollowed = {
  __typename?: 'IsFollowed';
  followType?: Maybe<FollowType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type IsSuccess = {
  __typename?: 'IsSuccess';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type IsSuspectedStatus = {
  __typename?: 'IsSuspectedStatus';
  isSuspected?: Maybe<Scalars['Int']['output']>;
};

export type JobsOutput = {
  __typename?: 'JobsOutput';
  jobs?: Maybe<Array<Maybe<ScheduledJobs>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type JoinClubArgs = {
  agreedToDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  clubId: Scalars['String']['input'];
  memberType?: InputMaybe<ClubMemberType>;
};

export type Limits = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type LinkPreview = {
  __typename?: 'LinkPreview';
  description?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  siteName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LinkPreviewInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ListOfBadges = {
  __typename?: 'ListOfBadges';
  badgesList?: Maybe<Array<Maybe<Badges>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListOfEvents = {
  __typename?: 'ListOfEvents';
  eventsList?: Maybe<Array<Maybe<UpcomingEvents>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListOfInterstitials = {
  __typename?: 'ListOfInterstitials';
  interstitialsList?: Maybe<Array<Maybe<Interstitials>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListOfUserBadges = {
  __typename?: 'ListOfUserBadges';
  errorMessage?: Maybe<ErrorMessage>;
  userBadgesList?: Maybe<Array<Maybe<UserBadges>>>;
};

export type ListOfWhatsNew = {
  __typename?: 'ListOfWhatsNew';
  total?: Maybe<Scalars['Int']['output']>;
  whatsNewList?: Maybe<Array<Maybe<WhatsNew>>>;
};

export type ListingPrice = {
  __typename?: 'ListingPrice';
  C?: Maybe<Scalars['Float']['output']>;
  C1?: Maybe<Scalars['Float']['output']>;
  CZ?: Maybe<Scalars['Float']['output']>;
  CZG?: Maybe<Scalars['Float']['output']>;
  Date?: Maybe<Scalars['String']['output']>;
  H?: Maybe<Scalars['Float']['output']>;
  L?: Maybe<Scalars['Float']['output']>;
  O?: Maybe<Scalars['Float']['output']>;
  TQ?: Maybe<Scalars['Float']['output']>;
};

export type LoginUserInput = {
  deviceType?: InputMaybe<DeviceType>;
  email: Scalars['EmailAddress']['input'];
  notificationToken?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type MisInput = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  memberType?: InputMaybe<MemberTypeForMis>;
  page?: InputMaybe<Scalars['Int']['input']>;
  periodType?: InputMaybe<SessionPeriodType>;
  postCategory?: InputMaybe<PostCategoryForMis>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type MisOutput = {
  __typename?: 'MISOutput';
  date?: Maybe<Scalars['String']['output']>;
  entityCount?: Maybe<Scalars['String']['output']>;
  userCount?: Maybe<Scalars['String']['output']>;
};

export type MisOutputAdminPanel = {
  __typename?: 'MISOutputAdminPanel';
  entityCount?: Maybe<Scalars['String']['output']>;
  userCount?: Maybe<Scalars['String']['output']>;
};

export type MomArgs = {
  link: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MomData = {
  __typename?: 'MOMData';
  User?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['MediaURI']['output']>;
  momId?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type MomListOutput = {
  __typename?: 'MOMListOutput';
  momList?: Maybe<Array<Maybe<MomData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MomUpdateArgs = {
  link?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Media = {
  __typename?: 'Media';
  height?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rotation?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uri: Scalars['MediaURI']['output'];
  width?: Maybe<Scalars['String']['output']>;
};

export type MediaInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  rotation?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  uri: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type MediaPostId = {
  __typename?: 'MediaPostID';
  media?: Maybe<Media>;
  postId: Scalars['String']['output'];
};

export type MediaUrl = {
  __typename?: 'MediaURL';
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MemberType = {
  __typename?: 'MemberType';
  MemberType?: Maybe<Scalars['String']['output']>;
  memberTypeId?: Maybe<Scalars['String']['output']>;
};

export type MemberTypeClubPermissionData = {
  __typename?: 'MemberTypeClubPermissionData';
  memberType?: Maybe<MemberType>;
  memberTypeClubPermissionId?: Maybe<Scalars['String']['output']>;
  memberTypeId?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<ClubPermissionType>;
  tickType?: Maybe<TickType>;
};

export type MemberTypeClubPermissionMap = {
  __typename?: 'MemberTypeClubPermissionMap';
  Club?: Maybe<Club>;
  canCreateStockIdea?: Maybe<Scalars['Boolean']['output']>;
  canEngage?: Maybe<Scalars['Boolean']['output']>;
  canPost?: Maybe<Scalars['Boolean']['output']>;
  canPropagatePost?: Maybe<Scalars['Boolean']['output']>;
  canQuery?: Maybe<Scalars['Boolean']['output']>;
  canViewPost?: Maybe<Scalars['Boolean']['output']>;
  clubId?: Maybe<Scalars['String']['output']>;
  memberType?: Maybe<MemberType>;
  memberTypeClubPermissionId?: Maybe<Scalars['String']['output']>;
  memberTypeId?: Maybe<Scalars['String']['output']>;
};

export enum MemberTypeForMis {
  All = 'all',
  BlueTick = 'blueTick',
  GoldenTick = 'goldenTick',
  GreenTick = 'greenTick',
  Normal = 'normal'
}

export type MemberTypeListData = {
  __typename?: 'MemberTypeListData';
  dataList?: Maybe<Array<Maybe<MemberType>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MembertypeClubPermissionMapData = {
  __typename?: 'MembertypeClubPermissionMapData';
  dataList?: Maybe<Array<Maybe<MemberTypeClubPermissionMap>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Meta = {
  __typename?: 'Meta';
  isAvatar?: Maybe<Scalars['Boolean']['output']>;
  isCover?: Maybe<Scalars['Boolean']['output']>;
};

export type MilestoneType = {
  __typename?: 'MilestoneType';
  MilestoneName?: Maybe<Scalars['String']['output']>;
  isMilestoneCompleted?: Maybe<Scalars['Boolean']['output']>;
  runningMilestone?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  ActionToFeedback?: Maybe<Scalars['Boolean']['output']>;
  AdminloginWithOIDC?: Maybe<UserInfoFromIdp>;
  GreenVerificationToggle?: Maybe<User>;
  ReplyToFeedback?: Maybe<Scalars['Boolean']['output']>;
  SE_LOGIN: AuthPayload;
  SE_LOGIN_V2: AuthPayload;
  SE_LOGIN_V3: AuthPayload;
  SE_SOCIAL_LOGIN: AuthPayload;
  SE_SOCIAL_LOGIN_V2: AuthPayload;
  SE_SOCIAL_LOGIN_V3: AuthPayload;
  SEsignup: AuthPayload;
  SEsignupViaOIDC: UserInfoFromIdp;
  SEsignupViaOIDC_V2: UserInfoFromIdp;
  SEsignup_V2: AuthPayload;
  SEsignup_V3: AuthPayload;
  SEsignup_V4: AuthPayload;
  ToggleSuspect?: Maybe<IsSuspectedStatus>;
  VerificationToggle?: Maybe<User>;
  accountSync?: Maybe<IsSuccess>;
  accountSync_V2?: Maybe<AccountSyncV2_OutputType>;
  activatePromotion?: Maybe<PromotionData>;
  addAdminPushNotificationToken?: Maybe<IsSuccess>;
  addBadgeFeedbackQuestionAdmin?: Maybe<FeedbackQuestions>;
  addBadgeJourneyFeedback?: Maybe<IsSuccess>;
  addClubCategoryV2?: Maybe<FeatureClubCategory>;
  addClubFeature?: Maybe<IsSuccess>;
  addDataForAB_ReleasePanel?: Maybe<Ab_ReleasePanel>;
  addDataForInterstitials?: Maybe<Interstitials>;
  addEmail?: Maybe<Scalars['Boolean']['output']>;
  addExternalResource?: Maybe<ExternalResource>;
  addFeatureClubGroup?: Maybe<FeatureDataType>;
  addFeatureDataForClubGroup?: Maybe<FeatureWithPermissionDataOutput>;
  addFeatureMapping?: Maybe<FeatureWithPermissionDataOutput>;
  addFeaturePlatformPermission?: Maybe<FeaturePlatformPermission>;
  addGuidedTourDataByAdmin?: Maybe<Array<Maybe<TourKeys>>>;
  addGuidedTourStatusForUser?: Maybe<IsSuccess>;
  addMemberTypeAndPermissionsByClubId?: Maybe<MemberTypeClubPermissionData>;
  addMemberTypeClubPermission?: Maybe<MemberTypeClubPermissionMap>;
  addNewBadge?: Maybe<Badges>;
  addNewPopUp?: Maybe<PopUpAdminPanel>;
  addNotificationToken: IsSuccess;
  addNpsRatingForApp?: Maybe<IsSuccess>;
  addNpsRatingForWeb?: Maybe<IsSuccess>;
  addPreferredHashtag?: Maybe<Hashtag>;
  addPromotionDataForSmartFeed?: Maybe<Scalars['String']['output']>;
  addSuggestedSearch?: Maybe<UserSuggestedSearchOutput>;
  addToRecentSearch?: Maybe<IsSuccess>;
  addToSavedSearch?: Maybe<UserRecentSearchOutput>;
  addToWatchList?: Maybe<Scalars['Boolean']['output']>;
  addUpcomingEvent?: Maybe<UpcomingEvents>;
  addUserCreatorTypeOfContentForTickUser?: Maybe<User>;
  addUserPreferenceClubMapAdmin?: Maybe<UserPreferenceClubMapOutput>;
  addWhatsNew?: Maybe<WhatsNew>;
  adminClubCreation?: Maybe<ClubWithPermission>;
  adminDeleteNotificationToTopic?: Maybe<IsSuccess>;
  adminNotificationToTopic?: Maybe<PushNotificationLog>;
  approveRequestByAdmin?: Maybe<ApprovalRequests>;
  assignCategoryToClub?: Maybe<FeatureClubCategory>;
  autoFollowAddVerified?: Maybe<AutoFollow>;
  autoFollowDeleteVerified?: Maybe<IsSuccess>;
  blockUser: IsSuccess;
  cancelFollow: IsSuccess;
  cancelFollowUserV2?: Maybe<User>;
  cancelManualCronJob?: Maybe<IsSuccess>;
  celebritySyncOfIndividualUserInMongo: IsSuccess;
  clearRecentSearch?: Maybe<IsSuccess>;
  createBookmark?: Maybe<Bookmark>;
  createComment: Comment;
  createCommentV2: Comment;
  createFeedback?: Maybe<Feedback>;
  createInterest?: Maybe<Interest>;
  createManualCronJob?: Maybe<IsSuccess>;
  createNormalPost?: Maybe<PostOutput>;
  createPost: Post;
  createPostAsync: Post;
  createPostV2: Post;
  createPostV3: Post;
  createPromotion?: Maybe<PromotionData>;
  createQueryPost?: Maybe<PostOutput>;
  createReply: Reply;
  createReplyV2: Reply;
  createReport?: Maybe<ReportData>;
  createStockIdeasPost?: Maybe<PostOutput>;
  createZendeskTicket?: Maybe<Scalars['ZendeskTicketResponseModel']['output']>;
  createZendeskTicketComment?: Maybe<Array<Maybe<Scalars['ZendeskTicketCommentResponseModel']['output']>>>;
  deactivateClubByAdmin?: Maybe<ClubWithPermission>;
  deactivatePromotion?: Maybe<PromotionData>;
  deleteAlertNotificationByUserId?: Maybe<IsSuccess>;
  deleteBadge?: Maybe<IsSuccess>;
  deleteBadgeFeedbackQuestionAdmin?: Maybe<IsSuccess>;
  deleteCategoryToClub?: Maybe<IsSuccess>;
  deleteClubCategory?: Maybe<IsSuccess>;
  deleteClubFeature?: Maybe<IsSuccess>;
  deleteClubNotificationByUserId?: Maybe<IsSuccess>;
  deleteComment: IsSuccess;
  deleteExternalResource?: Maybe<IsSuccess>;
  deleteFeatureClubGroup?: Maybe<IsSuccess>;
  deleteFeatureDataForClubGroup?: Maybe<IsSuccess>;
  deleteFeatureMapping?: Maybe<IsSuccess>;
  deleteFeaturePlatformPermission?: Maybe<IsSuccess>;
  deleteGuidedTourDataByAdmin?: Maybe<IsSuccess>;
  deleteInterstitial?: Maybe<IsSuccess>;
  deleteMOM?: Maybe<MomData>;
  deleteMemberTypeAndPermissionByClubId?: Maybe<IsSuccess>;
  deleteMemberTypeClubPermission?: Maybe<IsSuccess>;
  deleteNotificationById?: Maybe<IsSuccess>;
  deleteNotificationByUserId?: Maybe<IsSuccess>;
  deletePost: IsSuccess;
  deleteProfileAsImportantProfile?: Maybe<IsSuccess>;
  deleteReply: IsSuccess;
  deleteSuggestedSearch?: Maybe<UserSuggestedSearchOutput>;
  deleteUpcomingEvent?: Maybe<IsSuccess>;
  deleteWhatsNew?: Maybe<IsSuccess>;
  dollarFollow?: Maybe<DollarTag>;
  dollarSubscribe?: Maybe<DollarTag>;
  dollarUnfollow?: Maybe<DollarTag>;
  dollarUnsubscribe?: Maybe<DollarTag>;
  downvote: UpvoteDownVoteCount;
  editBadge?: Maybe<Badges>;
  editClubDetailsAdmin?: Maybe<ClubWithPermission>;
  editFeatureDataForClubGroup?: Maybe<FeatureWithPermissionDataOutput>;
  editMOM?: Maybe<MomData>;
  editMemberTypeClubPermission?: Maybe<MemberTypeClubPermissionMap>;
  editNormalPost?: Maybe<PostOutput>;
  editPopUp?: Maybe<PopUpAdminPanel>;
  editPromotion?: Maybe<PromotionData>;
  editPromotionDataForSmartFeed?: Maybe<Scalars['String']['output']>;
  editQuery?: Maybe<PostOutput>;
  editStockIdea?: Maybe<PostOutput>;
  editTourComponentDetailsByTourKeyAdmin?: Maybe<TourKeys>;
  editUpcomingEvent?: Maybe<UpcomingEvents>;
  editWhatsNew?: Maybe<WhatsNew>;
  executeVisitedOnboardScreens?: Maybe<IsSuccess>;
  follow: FollowOutput;
  followHashtagV2?: Maybe<Hashtag>;
  followPost?: Maybe<FolowPostOutput>;
  followUserV2?: Maybe<User>;
  hasSeenPopUp?: Maybe<PopUpSeen>;
  hideNotification?: Maybe<IsSuccess>;
  ignoreNpsRating?: Maybe<IsSuccess>;
  joinClub?: Maybe<IsSuccess>;
  joinClubV2?: Maybe<Club>;
  leaveClub?: Maybe<IsSuccess>;
  leaveClubV2?: Maybe<Club>;
  loginWithOIDC?: Maybe<UserInfoFromIdp>;
  loginWithOIDC_V2?: Maybe<UserInfoFromIdp>;
  logout: Scalars['Boolean']['output'];
  logoutFromAllDevices: Scalars['Boolean']['output'];
  makeClubLiveByAdmin?: Maybe<ClubWithPermission>;
  makeMOM?: Maybe<MomData>;
  markAsPinPost?: Maybe<Post>;
  markClubAsFavourite?: Maybe<Club>;
  markMultipleAsRead?: Maybe<IsSuccess>;
  markMultipleAsUnread?: Maybe<IsSuccess>;
  onboardUser?: Maybe<IsSuccess>;
  performAction?: Maybe<ReportHistory>;
  performActionOnUserReport?: Maybe<ReportHistory>;
  readAdminNotificationById?: Maybe<AdminNotificationOutput>;
  readAllNotifications?: Maybe<IsSuccess>;
  readNotification?: Maybe<IsSuccess>;
  rejectRequestByAdmin?: Maybe<ApprovalRequests>;
  rejectSuggestedSearch?: Maybe<UserSuggestedSearchOutput>;
  removeAdminPushNotificationToken?: Maybe<IsSuccess>;
  removeBookmark?: Maybe<IsSuccess>;
  removeDataForAB_ReleasePanel?: Maybe<Ab_ReleasePanel>;
  removeDownvote: UpvoteDownVoteCount;
  removeEmail?: Maybe<Scalars['Boolean']['output']>;
  removeFromRecentSearch?: Maybe<IsSuccess>;
  removeFromSavedSearch?: Maybe<UserRecentSearchOutput>;
  removeFromWatchList?: Maybe<Scalars['Boolean']['output']>;
  removeNotificationToken: IsSuccess;
  removePopUp?: Maybe<PopUpSeen>;
  removePreferredHashtag?: Maybe<Hashtag>;
  removeUpvote: UpvoteDownVoteCount;
  removeUserPreferenceClubMapAdmin?: Maybe<UserPreferenceClubMapOutput>;
  resolveFollow: IsSuccess;
  selectPollOption?: Maybe<Array<Maybe<Option>>>;
  selectPollOptionV2?: Maybe<Poll>;
  setDefaultFeed?: Maybe<FeedList>;
  setProfileAsImportantProfile?: Maybe<User>;
  sharePost: Post;
  sharePostV2: Post;
  sharePostV3: Post;
  sharePostV4: PostOutput;
  shareStockIdeaUpdate: PostOutput;
  subscribe: IsSuccess;
  subscribeClub: IsSuccess;
  subscribeToAdminNotificationTopic?: Maybe<IsSuccess>;
  tick3Toggle?: Maybe<User>;
  toggleAB_ReleasePanel?: Maybe<Ab_ReleasePanel>;
  toggleDownvoteComment?: Maybe<Comment>;
  toggleDownvotePost?: Maybe<Post>;
  toggleDownvoteReply?: Maybe<Reply>;
  toggleEventActiveStatus?: Maybe<UpcomingEvents>;
  toggleInterstitialsActiveStatus?: Maybe<Interstitials>;
  toggleIsPreselectedUserPreferenceClubMapAdmin?: Maybe<UserPreferenceClubMapOutput>;
  toggleIsWatchlistVisible?: Maybe<Scalars['Boolean']['output']>;
  toggleSubscribeHashtag?: Maybe<Hashtag>;
  toggleSubscribeUser?: Maybe<User>;
  toggleUpvoteComment?: Maybe<Comment>;
  toggleUpvotePost?: Maybe<Post>;
  toggleUpvoteReply?: Maybe<Reply>;
  toggleWhatsNewActiveStatus?: Maybe<WhatsNew>;
  turnOffHighlightForAchievement?: Maybe<IsSuccess>;
  turnOffNotificationByTypeOfNotification?: Maybe<IsSuccess>;
  unPinPost?: Maybe<Post>;
  unblockUser: IsSuccess;
  unfollow: IsSuccess;
  unfollowHashtagV2?: Maybe<Hashtag>;
  unfollowPost?: Maybe<FolowPostOutput>;
  unfollowUserV2?: Maybe<User>;
  unmarkClubFavourite?: Maybe<Club>;
  unreadNotification?: Maybe<IsSuccess>;
  unsubscribe: IsSuccess;
  unsubscribeClub: IsSuccess;
  unsubscribeToAdminNotificationTopic?: Maybe<IsSuccess>;
  updateAnalystDetails?: Maybe<AnalystDetails>;
  updateBadgeFeedbackQuestionAdmin?: Maybe<FeedbackQuestions>;
  updateClubCategoryV2?: Maybe<FeatureClubCategory>;
  updateClubFeature?: Maybe<IsSuccess>;
  updateComment: Post;
  updateDataForAB_ReleasePanel?: Maybe<Ab_ReleasePanel>;
  updateDataForInterstitials?: Maybe<Interstitials>;
  updateExternalResource?: Maybe<ExternalResource>;
  updateFeatureMapping?: Maybe<FeatureWithPermissionDataOutput>;
  updateFeaturePlatformPermission?: Maybe<FeaturePlatformPermission>;
  updateGreenTickUserImage?: Maybe<User>;
  updateHashtagContentType?: Maybe<Array<Maybe<Hashtag>>>;
  updateMemberTypeAndPermissionsByClubId?: Maybe<MemberTypeClubPermissionData>;
  updatePost: Post;
  updateReply: Post;
  updateUser?: Maybe<User>;
  updateUserImage?: Maybe<IsSuccess>;
  updateUserPreferenceClubMapAdmin?: Maybe<Array<Maybe<UserPreferenceClubMapOutput>>>;
  updateUserSettings?: Maybe<ProfileSettings>;
  upvote: UpvoteDownVoteCount;
  withdrawApprovalRequest?: Maybe<IsSuccess>;
};


export type MutationActionToFeedbackArgs = {
  feedbackId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminloginWithOidcArgs = {
  accessToken: Scalars['String']['input'];
};


export type MutationGreenVerificationToggleArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReplyToFeedbackArgs = {
  feedbackId?: InputMaybe<Scalars['String']['input']>;
  reply?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSe_LoginArgs = {
  data: LoginUserInput;
};


export type MutationSe_Login_V2Args = {
  data: LoginUserInput;
};


export type MutationSe_Login_V3Args = {
  data: LoginUserInput;
};


export type MutationSe_Social_LoginArgs = {
  data: SocialLoginUserInput;
};


export type MutationSe_Social_Login_V2Args = {
  data: SocialLoginUserInput;
};


export type MutationSe_Social_Login_V3Args = {
  data: SocialLoginUserInput;
};


export type MutationSEsignupArgs = {
  AcceptTerms?: InputMaybe<Scalars['Boolean']['input']>;
  data: SignupUserInput;
  interimToken: Scalars['String']['input'];
};


export type MutationSEsignupViaOidcArgs = {
  AcceptTerms?: InputMaybe<Scalars['Boolean']['input']>;
  data: SignupUserInput;
  interimToken: Scalars['String']['input'];
};


export type MutationSEsignupViaOidc_V2Args = {
  AcceptTerms?: InputMaybe<Scalars['Boolean']['input']>;
  data: SignupUserInput;
  interimToken: Scalars['String']['input'];
};


export type MutationSEsignup_V2Args = {
  AcceptTerms?: InputMaybe<Scalars['Boolean']['input']>;
  data: SignupUserInput;
  interimToken: Scalars['String']['input'];
};


export type MutationSEsignup_V3Args = {
  AcceptTerms?: InputMaybe<Scalars['Boolean']['input']>;
  data: SignupUserInput;
  interimToken: Scalars['String']['input'];
};


export type MutationSEsignup_V4Args = {
  AcceptTerms?: InputMaybe<Scalars['Boolean']['input']>;
  data: SignupUserInput;
  interimToken: Scalars['String']['input'];
};


export type MutationToggleSuspectArgs = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  replyId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerificationToggleArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationActivatePromotionArgs = {
  data?: InputMaybe<ActivateOrDeactivatePromotionArgs>;
};


export type MutationAddAdminPushNotificationTokenArgs = {
  deviceType?: InputMaybe<DeviceType>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddBadgeFeedbackQuestionAdminArgs = {
  badgeId?: InputMaybe<Scalars['String']['input']>;
  questionText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddBadgeJourneyFeedbackArgs = {
  questionResponse?: InputMaybe<Array<InputMaybe<FeedbackQuestionResponseInput>>>;
};


export type MutationAddClubCategoryV2Args = {
  data?: InputMaybe<FeatureClubCategoryInputArgs>;
};


export type MutationAddClubFeatureArgs = {
  clubIds: Array<InputMaybe<Scalars['String']['input']>>;
  featureName: Scalars['String']['input'];
};


export type MutationAddDataForAb_ReleasePanelArgs = {
  featureName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddDataForInterstitialsArgs = {
  audience: UserAudienceType;
  componentType: ComponentType;
  data?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  platformType: PlatformTypeForInterstitial;
  position: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};


export type MutationAddEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddExternalResourceArgs = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationAddFeatureClubGroupArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  featureId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddFeatureDataForClubGroupArgs = {
  featureData?: InputMaybe<FeatureDataArgs>;
};


export type MutationAddFeatureMappingArgs = {
  data?: InputMaybe<FeatureWithPermissionDataInput>;
};


export type MutationAddFeaturePlatformPermissionArgs = {
  data: FeaturePlatformPermissionArgs;
};


export type MutationAddGuidedTourDataByAdminArgs = {
  endingTourKey: Scalars['Float']['input'];
  startingTourKey: Scalars['Float']['input'];
  tourComponent: Scalars['String']['input'];
  tourDescription: Scalars['String']['input'];
};


export type MutationAddGuidedTourStatusForUserArgs = {
  tourComponent?: InputMaybe<Scalars['String']['input']>;
  tourSource?: InputMaybe<TourSourceType>;
  visitedTourKeys?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};


export type MutationAddMemberTypeAndPermissionsByClubIdArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  memberTypeAndPermission?: InputMaybe<ClubMemberPermissionArgs>;
};


export type MutationAddMemberTypeClubPermissionArgs = {
  canCreateStockIdea?: InputMaybe<Scalars['Boolean']['input']>;
  canEngage?: InputMaybe<Scalars['Boolean']['input']>;
  canPost?: InputMaybe<Scalars['Boolean']['input']>;
  canPropagatePost?: InputMaybe<Scalars['Boolean']['input']>;
  canQuery?: InputMaybe<Scalars['Boolean']['input']>;
  canViewPost?: InputMaybe<Scalars['Boolean']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  memberTypeId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddNewBadgeArgs = {
  badgeIcon?: InputMaybe<Scalars['String']['input']>;
  badgeName?: InputMaybe<Scalars['String']['input']>;
  badgeType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalImageLink?: InputMaybe<Scalars['String']['input']>;
  externalShareText?: InputMaybe<Scalars['String']['input']>;
  promotionLink?: InputMaybe<Scalars['String']['input']>;
  promotionText?: InputMaybe<Scalars['String']['input']>;
  shareImageLink?: InputMaybe<Scalars['String']['input']>;
  shareText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddNewPopUpArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  popUpDelay?: InputMaybe<Scalars['Int']['input']>;
  popUpType?: InputMaybe<Scalars['String']['input']>;
  showTill?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddNotificationTokenArgs = {
  deviceType?: InputMaybe<DeviceType>;
  notificationToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddNpsRatingForAppArgs = {
  platformType?: InputMaybe<DeviceType>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddNpsRatingForWebArgs = {
  RecaptchaToken: Scalars['String']['input'];
  platformType: DeviceType;
  rating?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddPreferredHashtagArgs = {
  hashtagId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddPromotionDataForSmartFeedArgs = {
  data?: InputMaybe<PromotionArgsForSmartFeed>;
};


export type MutationAddSuggestedSearchArgs = {
  searchElements?: InputMaybe<Array<InputMaybe<UserSearchInput>>>;
};


export type MutationAddToRecentSearchArgs = {
  data?: InputMaybe<Array<InputMaybe<UserRecentSearchInput>>>;
};


export type MutationAddToSavedSearchArgs = {
  data?: InputMaybe<Array<InputMaybe<UserRecentSearchInput>>>;
};


export type MutationAddToWatchListArgs = {
  securityId: Scalars['Int']['input'];
};


export type MutationAddUpcomingEventArgs = {
  audience: UserAudienceType;
  ctaButtonText: Scalars['String']['input'];
  ctaButtonUrl: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTime']['input'];
  imageUrl: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  startTime: Scalars['DateTime']['input'];
  text: Scalars['String']['input'];
};


export type MutationAddUserCreatorTypeOfContentForTickUserArgs = {
  contentMadeByUser?: InputMaybe<Array<InputMaybe<ContentMadeByUser>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddUserPreferenceClubMapAdminArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  isPreSelected?: InputMaybe<Scalars['Boolean']['input']>;
  preference?: InputMaybe<UserPreference>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddWhatsNewArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  platformType?: InputMaybe<Array<InputMaybe<PlatformTypeForWhatsNew>>>;
  versionNo?: InputMaybe<Scalars['String']['input']>;
  whatsNew?: InputMaybe<Array<InputMaybe<WhatsNewInput>>>;
};


export type MutationAdminClubCreationArgs = {
  data?: InputMaybe<AdminCreateClubArgs>;
};


export type MutationAdminDeleteNotificationToTopicArgs = {
  pushLogId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminNotificationToTopicArgs = {
  analyticsLabel?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  scheduleTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationApproveRequestByAdminArgs = {
  approvalRequestId: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAssignCategoryToClubArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  featureClubCategoryId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAutoFollowAddVerifiedArgs = {
  data?: InputMaybe<AutoFollowArgs>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAutoFollowDeleteVerifiedArgs = {
  data?: InputMaybe<AutoFollowArgs>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBlockUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationCancelFollowArgs = {
  data?: InputMaybe<FollowArgs>;
};


export type MutationCancelFollowUserV2Args = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCancelManualCronJobArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationCelebritySyncOfIndividualUserInMongoArgs = {
  userId: Scalars['String']['input'];
};


export type MutationCreateBookmarkArgs = {
  data: CreateBookmark;
};


export type MutationCreateCommentArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<CommentInput>;
};


export type MutationCreateCommentV2Args = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<CommentInput>;
};


export type MutationCreateFeedbackArgs = {
  data?: InputMaybe<FeedbackInput>;
};


export type MutationCreateInterestArgs = {
  data?: InputMaybe<CreateInterest>;
};


export type MutationCreateManualCronJobArgs = {
  nameOfCron: NameOfCron;
  scheduleTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationCreateNormalPostArgs = {
  data?: InputMaybe<NormalPostInput>;
};


export type MutationCreatePostArgs = {
  data?: InputMaybe<PostInput>;
};


export type MutationCreatePostAsyncArgs = {
  data?: InputMaybe<PostInput>;
};


export type MutationCreatePostV2Args = {
  data?: InputMaybe<PostInput>;
};


export type MutationCreatePostV3Args = {
  data?: InputMaybe<PostInput>;
};


export type MutationCreatePromotionArgs = {
  data?: InputMaybe<PromotionArgsWithAudience>;
};


export type MutationCreateQueryPostArgs = {
  data?: InputMaybe<QueryInput>;
};


export type MutationCreateReplyArgs = {
  data?: InputMaybe<ReplyInput>;
};


export type MutationCreateReplyV2Args = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<ReplyInput>;
};


export type MutationCreateReportArgs = {
  data?: InputMaybe<CreateReportInput>;
};


export type MutationCreateStockIdeasPostArgs = {
  data?: InputMaybe<StockIdeasInput>;
};


export type MutationCreateZendeskTicketArgs = {
  data?: InputMaybe<TicketInput>;
};


export type MutationCreateZendeskTicketCommentArgs = {
  data?: InputMaybe<TicketCommentInput>;
  ticketId: Scalars['Int']['input'];
};


export type MutationDeactivateClubByAdminArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeactivatePromotionArgs = {
  data?: InputMaybe<ActivateOrDeactivatePromotionArgs>;
};


export type MutationDeleteBadgeArgs = {
  badgeId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteBadgeFeedbackQuestionAdminArgs = {
  questionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCategoryToClubArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  featureClubCategoryId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteClubCategoryArgs = {
  clubCategoryId: Scalars['String']['input'];
};


export type MutationDeleteClubFeatureArgs = {
  featureId: Scalars['String']['input'];
};


export type MutationDeleteCommentArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<CommentId>;
};


export type MutationDeleteExternalResourceArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFeatureClubGroupArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  featureId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteFeatureDataForClubGroupArgs = {
  featureId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteFeatureMappingArgs = {
  featureId: Scalars['String']['input'];
};


export type MutationDeleteFeaturePlatformPermissionArgs = {
  featurePlatformRuleId: Scalars['String']['input'];
};


export type MutationDeleteGuidedTourDataByAdminArgs = {
  tourId: Scalars['String']['input'];
};


export type MutationDeleteInterstitialArgs = {
  interstitialsId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteMemberTypeAndPermissionByClubIdArgs = {
  memberTypeClubPermissionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteMemberTypeClubPermissionArgs = {
  memberTypeClubPermissionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteNotificationByIdArgs = {
  notificationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeletePostArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<DeletePostInput>;
};


export type MutationDeleteProfileAsImportantProfileArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDeleteReplyArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<ReplyId>;
};


export type MutationDeleteSuggestedSearchArgs = {
  searchId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteUpcomingEventArgs = {
  eventId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteWhatsNewArgs = {
  whatsNewId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDollarFollowArgs = {
  dollarTagId: Scalars['String']['input'];
};


export type MutationDollarSubscribeArgs = {
  dollarTagId: Scalars['String']['input'];
};


export type MutationDollarUnfollowArgs = {
  dollarTagId: Scalars['String']['input'];
};


export type MutationDollarUnsubscribeArgs = {
  dollarTagId: Scalars['String']['input'];
};


export type MutationDownvoteArgs = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<VoteInput>;
};


export type MutationEditBadgeArgs = {
  badgeIcon?: InputMaybe<Scalars['String']['input']>;
  badgeId?: InputMaybe<Scalars['String']['input']>;
  badgeName?: InputMaybe<Scalars['String']['input']>;
  badgeType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalImageLink?: InputMaybe<Scalars['String']['input']>;
  externalShareText?: InputMaybe<Scalars['String']['input']>;
  promotionLink?: InputMaybe<Scalars['String']['input']>;
  promotionText?: InputMaybe<Scalars['String']['input']>;
  shareImageLink?: InputMaybe<Scalars['String']['input']>;
  shareText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditClubDetailsAdminArgs = {
  clubId: Scalars['String']['input'];
  data?: InputMaybe<EditClubAdminArgs>;
};


export type MutationEditFeatureDataForClubGroupArgs = {
  featureData?: InputMaybe<FeatureDataArgs>;
  featureId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditMomArgs = {
  data?: InputMaybe<MomUpdateArgs>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditMemberTypeClubPermissionArgs = {
  canCreateStockIdea?: InputMaybe<Scalars['Boolean']['input']>;
  canEngage?: InputMaybe<Scalars['Boolean']['input']>;
  canPost?: InputMaybe<Scalars['Boolean']['input']>;
  canPropagatePost?: InputMaybe<Scalars['Boolean']['input']>;
  canQuery?: InputMaybe<Scalars['Boolean']['input']>;
  canViewPost?: InputMaybe<Scalars['Boolean']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  memberTypeClubPermissionId?: InputMaybe<Scalars['String']['input']>;
  memberTypeId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditNormalPostArgs = {
  data?: InputMaybe<EditNormalPostInput>;
};


export type MutationEditPopUpArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  popUpDelay?: InputMaybe<Scalars['Int']['input']>;
  popUpId?: InputMaybe<Scalars['String']['input']>;
  popUpType?: InputMaybe<Scalars['String']['input']>;
  showTill?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationEditPromotionArgs = {
  data?: InputMaybe<EditPromotionArgsWithAudience>;
};


export type MutationEditPromotionDataForSmartFeedArgs = {
  data?: InputMaybe<EditPromotionArgsForSmartFeed>;
  interstitialsId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditQueryArgs = {
  data?: InputMaybe<EditQueryInput>;
};


export type MutationEditStockIdeaArgs = {
  data?: InputMaybe<EditStockIdeasInput>;
};


export type MutationEditTourComponentDetailsByTourKeyAdminArgs = {
  tourComponent: Scalars['String']['input'];
  tourDescription: Scalars['String']['input'];
  tourKey: Scalars['Float']['input'];
};


export type MutationEditUpcomingEventArgs = {
  audience: UserAudienceType;
  ctaButtonText: Scalars['String']['input'];
  ctaButtonUrl: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endTime: Scalars['DateTime']['input'];
  eventId: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  startTime: Scalars['DateTime']['input'];
  text: Scalars['String']['input'];
};


export type MutationEditWhatsNewArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  platformType?: InputMaybe<Array<InputMaybe<PlatformTypeForWhatsNew>>>;
  versionNo?: InputMaybe<Scalars['String']['input']>;
  whatsNew?: InputMaybe<Array<InputMaybe<WhatsNewInput>>>;
  whatsNewId: Scalars['String']['input'];
};


export type MutationExecuteVisitedOnboardScreensArgs = {
  data?: InputMaybe<ScreenResponseArgs>;
};


export type MutationFollowArgs = {
  data?: InputMaybe<FollowArgs>;
};


export type MutationFollowHashtagV2Args = {
  hashtagId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationFollowPostArgs = {
  data: FollowPostInput;
};


export type MutationFollowUserV2Args = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationHasSeenPopUpArgs = {
  popUpType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationHideNotificationArgs = {
  notificationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationIgnoreNpsRatingArgs = {
  source?: InputMaybe<NpsIgnoreSource>;
};


export type MutationJoinClubArgs = {
  data: JoinClubArgs;
};


export type MutationJoinClubV2Args = {
  data: JoinClubArgs;
};


export type MutationLeaveClubArgs = {
  data: ClubInput;
};


export type MutationLeaveClubV2Args = {
  data: ClubInput;
};


export type MutationLoginWithOidcArgs = {
  accessToken: Scalars['String']['input'];
};


export type MutationLoginWithOidc_V2Args = {
  accessToken: Scalars['String']['input'];
};


export type MutationLogoutArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationMakeClubLiveByAdminArgs = {
  clubId: Scalars['String']['input'];
};


export type MutationMakeMomArgs = {
  data?: InputMaybe<MomArgs>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkAsPinPostArgs = {
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkClubAsFavouriteArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkMultipleAsReadArgs = {
  notificationIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationMarkMultipleAsUnreadArgs = {
  notificationIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationOnboardUserArgs = {
  dollarTagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  hashtagName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skipOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  typeOfUserByUserpreference?: InputMaybe<UserHashtagContentType>;
};


export type MutationPerformActionArgs = {
  data?: InputMaybe<ActionInput>;
};


export type MutationPerformActionOnUserReportArgs = {
  data?: InputMaybe<ActionInputUserReport>;
};


export type MutationReadAdminNotificationByIdArgs = {
  notificationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReadNotificationArgs = {
  notificationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectRequestByAdminArgs = {
  approvalRequestId: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectSuggestedSearchArgs = {
  searchId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveAdminPushNotificationTokenArgs = {
  deviceType?: InputMaybe<DeviceType>;
};


export type MutationRemoveBookmarkArgs = {
  data?: InputMaybe<CreateBookmark>;
};


export type MutationRemoveDataForAb_ReleasePanelArgs = {
  releaseId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveDownvoteArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<VoteInput>;
};


export type MutationRemoveEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveFromRecentSearchArgs = {
  searchId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveFromSavedSearchArgs = {
  searchId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveFromWatchListArgs = {
  securityId: Scalars['Int']['input'];
};


export type MutationRemoveNotificationTokenArgs = {
  deviceType?: InputMaybe<DeviceType>;
};


export type MutationRemovePopUpArgs = {
  popUpId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemovePreferredHashtagArgs = {
  hashtagId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveUpvoteArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<VoteInput>;
};


export type MutationRemoveUserPreferenceClubMapAdminArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  preference?: InputMaybe<UserPreference>;
};


export type MutationResolveFollowArgs = {
  followerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FollowStatus>;
};


export type MutationSelectPollOptionArgs = {
  data?: InputMaybe<SelectPollOptionArgs>;
};


export type MutationSelectPollOptionV2Args = {
  data?: InputMaybe<SelectPollOptionArgs>;
};


export type MutationSetDefaultFeedArgs = {
  feedTypeId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetProfileAsImportantProfileArgs = {
  priority: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSharePostArgs = {
  data?: InputMaybe<PostInput>;
};


export type MutationSharePostV2Args = {
  data?: InputMaybe<PostInput>;
};


export type MutationSharePostV3Args = {
  data?: InputMaybe<PostInput>;
};


export type MutationSharePostV4Args = {
  data?: InputMaybe<SharePostInput>;
};


export type MutationShareStockIdeaUpdateArgs = {
  data?: InputMaybe<SharePostInput>;
};


export type MutationSubscribeArgs = {
  data?: InputMaybe<FollowArgs>;
};


export type MutationSubscribeClubArgs = {
  clubId: Scalars['String']['input'];
  subscribeTo: ClubSubscriptionType;
};


export type MutationSubscribeToAdminNotificationTopicArgs = {
  topic?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTick3ToggleArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleAb_ReleasePanelArgs = {
  releaseId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleDownvoteCommentArgs = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleDownvotePostArgs = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleDownvoteReplyArgs = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  replyId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleEventActiveStatusArgs = {
  eventId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleInterstitialsActiveStatusArgs = {
  interstitialsId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleIsPreselectedUserPreferenceClubMapAdminArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  preference?: InputMaybe<UserPreference>;
};


export type MutationToggleSubscribeHashtagArgs = {
  hashtagId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationToggleSubscribeUserArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationToggleUpvoteCommentArgs = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleUpvotePostArgs = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleUpvoteReplyArgs = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  replyId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleWhatsNewActiveStatusArgs = {
  whatsNewId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTurnOffHighlightForAchievementArgs = {
  achievementType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTurnOffNotificationByTypeOfNotificationArgs = {
  notificationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnPinPostArgs = {
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnblockUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationUnfollowArgs = {
  data?: InputMaybe<FollowArgs>;
};


export type MutationUnfollowHashtagV2Args = {
  hashtagId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUnfollowPostArgs = {
  data?: InputMaybe<FollowPostInput>;
};


export type MutationUnfollowUserV2Args = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUnmarkClubFavouriteArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnreadNotificationArgs = {
  notificationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnsubscribeArgs = {
  data?: InputMaybe<FollowArgs>;
};


export type MutationUnsubscribeClubArgs = {
  clubId: Scalars['String']['input'];
  unsubscribeTo: ClubSubscriptionType;
};


export type MutationUnsubscribeToAdminNotificationTopicArgs = {
  topic?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAnalystDetailsArgs = {
  data?: InputMaybe<UpdateAnalystDetailsArgs>;
};


export type MutationUpdateBadgeFeedbackQuestionAdminArgs = {
  questionId?: InputMaybe<Scalars['String']['input']>;
  questionText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateClubCategoryV2Args = {
  data?: InputMaybe<FeatureClubCategoryUpdateArgs>;
};


export type MutationUpdateClubFeatureArgs = {
  clubIds: Array<InputMaybe<Scalars['String']['input']>>;
  featureId: Scalars['String']['input'];
  featureName: Scalars['String']['input'];
};


export type MutationUpdateCommentArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<UpdateCommentInput>;
};


export type MutationUpdateDataForAb_ReleasePanelArgs = {
  releaseId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDataForInterstitialsArgs = {
  audience: UserAudienceType;
  componentType?: InputMaybe<ComponentType>;
  data?: InputMaybe<Scalars['String']['input']>;
  interstitialsId: Scalars['String']['input'];
  platformType?: InputMaybe<PlatformTypeForInterstitial>;
  position?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateExternalResourceArgs = {
  id: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateFeatureMappingArgs = {
  data?: InputMaybe<FeatureWithPermissionDataInput>;
  featureId: Scalars['String']['input'];
};


export type MutationUpdateFeaturePlatformPermissionArgs = {
  featurePlatformRuleId: Scalars['String']['input'];
  updateData: FeaturePlatformPermissionArgs;
};


export type MutationUpdateGreenTickUserImageArgs = {
  data?: InputMaybe<UpdateImageArgs>;
};


export type MutationUpdateHashtagContentTypeArgs = {
  data?: InputMaybe<Array<InputMaybe<UpdateHashtagContentTypeArgs>>>;
  typeOfContentMadeByHashtag?: InputMaybe<UserHashtagContentType>;
};


export type MutationUpdateMemberTypeAndPermissionsByClubIdArgs = {
  memberTypeAndPermission?: InputMaybe<ClubMemberPermissionArgs>;
  memberTypeClubPermissionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePostArgs = {
  data?: InputMaybe<UpdatePostInput>;
};


export type MutationUpdateReplyArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<UpdateReplyInput>;
};


export type MutationUpdateUserArgs = {
  data: UserUpdateArgs;
};


export type MutationUpdateUserImageArgs = {
  data: UserImageArgs;
};


export type MutationUpdateUserPreferenceClubMapAdminArgs = {
  data?: InputMaybe<Array<InputMaybe<UpdateUserPreferenceClubInput>>>;
  preference?: InputMaybe<UserPreference>;
};


export type MutationUpdateUserSettingsArgs = {
  data: UpdateUserSettings;
};


export type MutationUpvoteArgs = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<VoteInput>;
};


export type MutationWithdrawApprovalRequestArgs = {
  approvalRequestId: Scalars['String']['input'];
};

export type Nps = {
  __typename?: 'NPS';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  npsId?: Maybe<Scalars['String']['output']>;
  npsIndex?: Maybe<Scalars['Int']['output']>;
  platform?: Maybe<DeviceTypeEnum>;
  rating?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum NameOfCron {
  All = 'All',
  DeleteCommentCron = 'DeleteCommentCron',
  DeleteNotificationCron = 'DeleteNotificationCron',
  DeletePostCron = 'DeletePostCron',
  DeleteReplyCron = 'DeleteReplyCron',
  ExpiryDateSyncForRecentExpires = 'ExpiryDateSyncForRecentExpires',
  IndustryDataSync = 'IndustryDataSync',
  SectorDataSync = 'SectorDataSync',
  CalculateUserRecoScore = 'calculateUserRecoScore',
  CelebrityChecker = 'celebrityChecker',
  CelebrityCheckerForDollarTag = 'celebrityCheckerForDollarTag',
  CelebrityCheckerForHashTag = 'celebrityCheckerForHashTag',
  ComputeMonthlyFeatureUsage = 'computeMonthlyFeatureUsage',
  ContainsAMissedWeek = 'containsAMissedWeek',
  CountSync = 'countSync',
  CurrentWeekMissed = 'currentWeekMissed',
  FcmUserTokenSubscription = 'fcmUserTokenSubscription',
  FeedSuccessCalculator = 'feedSuccessCalculator',
  PostDollarTagSync = 'postDollarTagSync',
  PostHashTagSync = 'postHashTagSync',
  PostStockSync = 'postStockSync',
  PreComputeTopPostsOfAnalysts = 'preComputeTopPostsOfAnalysts',
  PushNotificationForPowerUser = 'pushNotificationForPowerUser',
  SyncActivityOfPostCommentReply = 'syncActivityOfPostCommentReply',
  SyncAllEntityToReco = 'syncAllEntityToReco',
  SyncClublistWithMongo = 'syncClublistWithMongo',
  UserEngagementSummaryMlCron = 'userEngagementSummaryMlCron'
}

export type NormalPostInput = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  poll?: InputMaybe<CreatePollArgs>;
  postId?: InputMaybe<Scalars['String']['input']>;
  sharePostId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  Activity?: Maybe<ActivityFeed>;
  Club?: Maybe<Club>;
  Notifier?: Maybe<User>;
  Post?: Maybe<Post>;
  ReportId?: Maybe<Scalars['String']['output']>;
  User?: Maybe<User>;
  activityId?: Maybe<Scalars['Int']['output']>;
  clubId?: Maybe<Scalars['String']['output']>;
  clubReportId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  isGeneratedByAdmin?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  notificationId?: Maybe<Scalars['String']['output']>;
  notificationType?: Maybe<Scalars['String']['output']>;
  notifierId?: Maybe<Scalars['String']['output']>;
  postHashtagId?: Maybe<Scalars['Int']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  postStockTagId?: Maybe<Scalars['Int']['output']>;
  postUserTagId?: Maybe<Scalars['Int']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  requestStatus?: Maybe<Scalars['Int']['output']>;
  sharePostId?: Maybe<Scalars['String']['output']>;
  sharePostUserId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userdownvotes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userscomments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  usersreply?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userupvotes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum NotificationFilter {
  All = 'all',
  Read = 'read',
  Unread = 'unread'
}

export type NpsDataOutputType = {
  __typename?: 'NpsDataOutputType';
  type?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export enum NpsIgnoreSource {
  Cross = 'Cross',
  TooEarlyToRate = 'TooEarlyToRate'
}

export type NpsInInterValOuptut = {
  __typename?: 'NpsInInterValOuptut';
  data?: Maybe<Array<Maybe<NpsDataOutputType>>>;
  dateRange?: Maybe<Array<Maybe<Scalars['DateTime']['output']>>>;
};

export type NpsIntervalData = {
  __typename?: 'NpsIntervalData';
  daily?: Maybe<Array<Maybe<NpsData>>>;
  monthly?: Maybe<Array<Maybe<NpsData>>>;
  today?: Maybe<Array<Maybe<NpsTodayData>>>;
  weekly?: Maybe<Array<Maybe<NpsData>>>;
  yearly?: Maybe<Array<Maybe<NpsData>>>;
};

export type OnboardScreens = {
  __typename?: 'OnboardScreens';
  screenId?: Maybe<Scalars['String']['output']>;
  screenName?: Maybe<Scalars['String']['output']>;
};

export type Option = {
  __typename?: 'Option';
  hasUserSelected?: Maybe<Scalars['Boolean']['output']>;
  optionId?: Maybe<Scalars['String']['output']>;
  optionText?: Maybe<Scalars['String']['output']>;
  pollId?: Maybe<Scalars['String']['output']>;
  votes?: Maybe<Scalars['Int']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PendingPushNotificationLogOutput = {
  __typename?: 'PendingPushNotificationLogOutput';
  pendingPushNotification?: Maybe<Array<Maybe<PushNotificationLog>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PendingScheduledJobsOutput = {
  __typename?: 'PendingScheduledJobsOutput';
  scheduledJobs?: Maybe<Array<Maybe<ScheduledJobs>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum Permissions {
  AddModerator = 'ADD_MODERATOR',
  AddTeam = 'ADD_TEAM',
  BanUser = 'BAN_USER',
  ChangeClubInfo = 'CHANGE_CLUB_INFO',
  HidePost = 'HIDE_POST'
}

export enum PermissionsInAnyClub {
  CanCreateStockIdea = 'canCreateStockIdea',
  CanPost = 'canPost',
  CanQuery = 'canQuery'
}

export type PlatformActionPermission = {
  __typename?: 'PlatformActionPermission';
  canBlockUser?: Maybe<Scalars['Boolean']['output']>;
  canBookmarkPost?: Maybe<Scalars['Boolean']['output']>;
  canComment?: Maybe<Scalars['Boolean']['output']>;
  canCreateClub?: Maybe<Scalars['Boolean']['output']>;
  canDownvote?: Maybe<Scalars['Boolean']['output']>;
  canFollowHash?: Maybe<Scalars['Boolean']['output']>;
  canFollowStock?: Maybe<Scalars['Boolean']['output']>;
  canFollowUser?: Maybe<Scalars['Boolean']['output']>;
  canJoinClub?: Maybe<Scalars['Boolean']['output']>;
  canPost?: Maybe<Scalars['Boolean']['output']>;
  canReply?: Maybe<Scalars['Boolean']['output']>;
  canReport?: Maybe<Scalars['Boolean']['output']>;
  canReportPost?: Maybe<Scalars['Boolean']['output']>;
  canSelectOption?: Maybe<Scalars['Boolean']['output']>;
  canShare?: Maybe<Scalars['Boolean']['output']>;
  canSubscribe?: Maybe<Scalars['Boolean']['output']>;
  canUpvote?: Maybe<Scalars['Boolean']['output']>;
};

export type PlatformActionPermissionsAlias = {
  __typename?: 'PlatformActionPermissionsAlias';
  cblus?: Maybe<Scalars['Int']['output']>;
  cbopo?: Maybe<Scalars['Int']['output']>;
  ccom?: Maybe<Scalars['Int']['output']>;
  ccrcl?: Maybe<Scalars['Int']['output']>;
  cdovo?: Maybe<Scalars['Int']['output']>;
  cfoha?: Maybe<Scalars['Int']['output']>;
  cfost?: Maybe<Scalars['Int']['output']>;
  cfous?: Maybe<Scalars['Int']['output']>;
  cjocl?: Maybe<Scalars['Int']['output']>;
  cpo?: Maybe<Scalars['Int']['output']>;
  cre?: Maybe<Scalars['Int']['output']>;
  crep?: Maybe<Scalars['Int']['output']>;
  crepo?: Maybe<Scalars['Int']['output']>;
  cseop?: Maybe<Scalars['Int']['output']>;
  csh?: Maybe<Scalars['Int']['output']>;
  csu?: Maybe<Scalars['Int']['output']>;
  cupvo?: Maybe<Scalars['Int']['output']>;
};

export type PlatformPermissionArgs = {
  canAutoJoinBlueTick?: InputMaybe<Scalars['Boolean']['input']>;
  canAutoJoinGreenTick?: InputMaybe<Scalars['Boolean']['input']>;
  canAutoJoinYellowTick?: InputMaybe<Scalars['Boolean']['input']>;
  canBeFollowed?: InputMaybe<Scalars['Boolean']['input']>;
  canBlock?: InputMaybe<Scalars['Boolean']['input']>;
  canCreateStockIdea?: InputMaybe<Scalars['Boolean']['input']>;
  canEngage?: InputMaybe<Scalars['Boolean']['input']>;
  canFollow?: InputMaybe<Scalars['Boolean']['input']>;
  canFollowPost?: InputMaybe<Scalars['Boolean']['input']>;
  canPost?: InputMaybe<Scalars['Boolean']['input']>;
  canQuery?: InputMaybe<Scalars['Boolean']['input']>;
  canReport?: InputMaybe<Scalars['Boolean']['input']>;
  canSeeClubPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  canSeeMarketingPage?: InputMaybe<Scalars['Boolean']['input']>;
  canSeeOthersFeedPosts?: InputMaybe<Scalars['Boolean']['input']>;
  canSeePremiumPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  canSeeWatchList?: InputMaybe<Scalars['Boolean']['input']>;
  canShowNps?: InputMaybe<Scalars['Boolean']['input']>;
  canViewPost?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PlatformPermissionFromFeatureTypes {
  CanAutoJoinBlueTick = 'canAutoJoinBlueTick',
  CanAutoJoinGreenTick = 'canAutoJoinGreenTick',
  CanAutoJoinYellowTick = 'canAutoJoinYellowTick',
  CanBeFollowed = 'canBeFollowed',
  CanBlock = 'canBlock',
  CanCreateStockIdea = 'canCreateStockIdea',
  CanEngage = 'canEngage',
  CanFollow = 'canFollow',
  CanFollowPost = 'canFollowPost',
  CanPost = 'canPost',
  CanQuery = 'canQuery',
  CanReport = 'canReport',
  CanSeeClubPromotion = 'canSeeClubPromotion',
  CanSeeMarketingPage = 'canSeeMarketingPage',
  CanSeeOthersFeedPosts = 'canSeeOthersFeedPosts',
  CanSeePremiumPromotion = 'canSeePremiumPromotion',
  CanSeeWatchList = 'canSeeWatchList',
  CanShowNps = 'canShowNps',
  CanViewPost = 'canViewPost'
}

export type PlatformPermissionOutputType = {
  __typename?: 'PlatformPermissionOutputType';
  canAutoJoinBlueTick?: Maybe<Scalars['Boolean']['output']>;
  canAutoJoinGreenTick?: Maybe<Scalars['Boolean']['output']>;
  canAutoJoinYellowTick?: Maybe<Scalars['Boolean']['output']>;
  canBeFollowed?: Maybe<Scalars['Boolean']['output']>;
  canBlock?: Maybe<Scalars['Boolean']['output']>;
  canCreateStockIdea?: Maybe<Scalars['Boolean']['output']>;
  canEngage?: Maybe<Scalars['Boolean']['output']>;
  canFollow?: Maybe<Scalars['Boolean']['output']>;
  canFollowPost?: Maybe<Scalars['Boolean']['output']>;
  canPost?: Maybe<Scalars['Boolean']['output']>;
  canQuery?: Maybe<Scalars['Boolean']['output']>;
  canReport?: Maybe<Scalars['Boolean']['output']>;
  canSeeClubPromotion?: Maybe<Scalars['Boolean']['output']>;
  canSeeMarketingPage?: Maybe<Scalars['Boolean']['output']>;
  canSeeOthersFeedPosts?: Maybe<Scalars['Boolean']['output']>;
  canSeePremiumPromotion?: Maybe<Scalars['Boolean']['output']>;
  canSeeWatchList?: Maybe<Scalars['Boolean']['output']>;
  canShowNps?: Maybe<Scalars['Boolean']['output']>;
  canViewPost?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
};

export enum PlatformTypeForWhatsNew {
  Android = 'android',
  Ios = 'ios',
  Web = 'web'
}

export type Poll = {
  __typename?: 'Poll';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  expiryEnum?: Maybe<PollExpiryEnum>;
  hasExpired?: Maybe<Scalars['Boolean']['output']>;
  hasUserSelected?: Maybe<Scalars['Boolean']['output']>;
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<Option>>>;
  pollId?: Maybe<Scalars['String']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
  votes?: Maybe<Scalars['Int']['output']>;
};

export enum PollExpiryType {
  OneDay = 'oneDay',
  OneWeek = 'oneWeek',
  ThreeDay = 'threeDay',
  ThreeWeek = 'threeWeek'
}

export type PollMisInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type PollMisOutput = {
  __typename?: 'PollMISOutput';
  data?: Maybe<Array<Maybe<PollMisOutputData>>>;
  total?: Maybe<PollMisOutputTotal>;
};

export type PollMisOutputData = {
  __typename?: 'PollMISOutputData';
  Date?: Maybe<Scalars['String']['output']>;
  polls?: Maybe<Scalars['Int']['output']>;
  totalvotes?: Maybe<Scalars['Int']['output']>;
  votes?: Maybe<Scalars['Int']['output']>;
};

export type PollMisOutputTotal = {
  __typename?: 'PollMISOutputTotal';
  poll?: Maybe<PollMisOutputTotalPoll>;
  votes?: Maybe<PollMisOutputTotalVotes>;
};

export type PollMisOutputTotalPoll = {
  __typename?: 'PollMISOutputTotalPOLL';
  pollCount?: Maybe<Scalars['Int']['output']>;
};

export type PollMisOutputTotalVotes = {
  __typename?: 'PollMISOutputTotalVOTES';
  votesCount?: Maybe<Scalars['Int']['output']>;
};

export type PopUpAdminPanel = {
  __typename?: 'PopUpAdminPanel';
  data?: Maybe<Scalars['String']['output']>;
  popUpDelay?: Maybe<Scalars['Int']['output']>;
  popUpId?: Maybe<Scalars['String']['output']>;
  popUpType?: Maybe<Scalars['String']['output']>;
  showTill?: Maybe<Scalars['Int']['output']>;
};

export type PopUpData = {
  __typename?: 'PopUpData';
  data?: Maybe<Array<Maybe<PopUp>>>;
  errorMessage?: Maybe<ErrorMessage>;
};

export type PopUpSeen = {
  __typename?: 'PopUpSeen';
  errorMessage?: Maybe<ErrorMessage>;
  success?: Maybe<IsSuccess>;
};

export type Post = {
  __typename?: 'Post';
  Club?: Maybe<Club>;
  User?: Maybe<User>;
  categoryDisplayDetails?: Maybe<CategoryDisplayDetails>;
  clubId?: Maybe<Scalars['String']['output']>;
  clubPostShareSetting?: Maybe<ClubPostShareSettingScheme>;
  clubPostShareSettingV2?: Maybe<Scalars['Boolean']['output']>;
  commentcount?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  downvotecount?: Maybe<Scalars['Int']['output']>;
  editHistory?: Maybe<Array<Maybe<EditHistoryData>>>;
  flagged?: Maybe<Scalars['Int']['output']>;
  getPoll?: Maybe<Poll>;
  getSharedPost?: Maybe<Post>;
  hasComments?: Maybe<Scalars['Boolean']['output']>;
  hasPoll?: Maybe<Scalars['Boolean']['output']>;
  ideaType?: Maybe<IdeaType>;
  isCheckedByCM?: Maybe<Scalars['Int']['output']>;
  isDownvoted?: Maybe<Scalars['Int']['output']>;
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  isEdited?: Maybe<Scalars['Boolean']['output']>;
  isFollowed?: Maybe<Scalars['Boolean']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  isPinnedByUser?: Maybe<Scalars['Boolean']['output']>;
  isSuspected?: Maybe<Scalars['Int']['output']>;
  isUpvoted?: Maybe<Scalars['Int']['output']>;
  isbookmarked?: Maybe<Scalars['Int']['output']>;
  linkPreview?: Maybe<LinkPreview>;
  media?: Maybe<Array<Maybe<Media>>>;
  memberType?: Maybe<ClubMemberType>;
  membershipLevelOfCreator?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<Meta>;
  postCategory?: Maybe<PostCategory>;
  postId?: Maybe<Scalars['String']['output']>;
  postSharePermissions?: Maybe<Array<Maybe<PostShareTypePermissions>>>;
  postType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sharePostId?: Maybe<Scalars['String']['output']>;
  sharecount?: Maybe<Scalars['Int']['output']>;
  stockName?: Maybe<Scalars['String']['output']>;
  stopLoss?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  target?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  textV2?: Maybe<Scalars['String']['output']>;
  topComment?: Maybe<Comment>;
  topCommentId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upvotecount?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userShares?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PostClubPostShareSettingV2Args = {
  clubBasedPermissionToken: Scalars['String']['input'];
};

export enum PostCategory {
  NormalPost = 'NormalPost',
  Query = 'Query',
  StockIdea = 'StockIdea'
}

export enum PostCategoryForMis {
  All = 'All',
  NormalPost = 'NormalPost',
  Query = 'Query',
  StockIdea = 'StockIdea'
}

export enum PostCategoryForSearch {
  All = 'All',
  Query = 'Query',
  StockIdea = 'StockIdea'
}

export type PostConnection = {
  __typename?: 'PostConnection';
  edges?: Maybe<Array<Maybe<PostEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PostDetails = {
  __typename?: 'PostDetails';
  error?: Maybe<ErrorMessage>;
  post?: Maybe<Post>;
};

export type PostDollarTagArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  dollarTagId: Scalars['Int']['input'];
  postId: Scalars['String']['input'];
};

export type PostEdge = {
  __typename?: 'PostEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Post>;
};

export type PostId = {
  oldPostId?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
};

export type PostInput = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  ideaType?: InputMaybe<IdeaType>;
  linkPreview?: InputMaybe<LinkPreviewInput>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  poll?: InputMaybe<CreatePollArgs>;
  postId?: InputMaybe<Scalars['String']['input']>;
  sharePostId?: InputMaybe<Scalars['String']['input']>;
  stockName?: InputMaybe<Scalars['String']['input']>;
  stopLoss?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  target?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PostListSinceDate = {
  __typename?: 'PostListSinceDate';
  posts?: Maybe<Array<Maybe<Post>>>;
  since?: Maybe<Scalars['String']['output']>;
};

export type PostOutput = {
  __typename?: 'PostOutput';
  approvalRequestId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  post?: Maybe<Post>;
};

export enum PostShareTypePermissions {
  NormalShare = 'NormalShare',
  StockIdeaUpdateShare = 'StockIdeaUpdateShare'
}

export type PostUpvoteDownVoteCountV2 = {
  __typename?: 'PostUpvoteDownVoteCountV2';
  downvotes?: Maybe<Scalars['Int']['output']>;
  post?: Maybe<Post>;
  success?: Maybe<Scalars['Boolean']['output']>;
  upvotes?: Maybe<Scalars['Int']['output']>;
};

export type PostWithTag = {
  __typename?: 'PostWithTag';
  discussions?: Maybe<Scalars['Int']['output']>;
  followers?: Maybe<Scalars['Int']['output']>;
  hashtag?: Maybe<Hashtag>;
  post?: Maybe<Array<Maybe<Post>>>;
  stock?: Maybe<Stock>;
};

export type PowerUserComparisonOutput = {
  __typename?: 'PowerUserComparisonOutput';
  completedCount?: Maybe<Scalars['Int']['output']>;
  dropCount?: Maybe<Scalars['Int']['output']>;
  funnelWeekNo?: Maybe<Scalars['Int']['output']>;
  incompleteCount?: Maybe<Scalars['Int']['output']>;
  startedCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  weekName?: Maybe<Scalars['String']['output']>;
};

export type PowerUserFeedbackMisOutput = {
  __typename?: 'PowerUserFeedbackMISOutput';
  data?: Maybe<Array<Maybe<FeedbackData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PowerUserMisOutput = {
  __typename?: 'PowerUserMISOutput';
  powerUsers?: Maybe<PowerUsersCount>;
  totalUsers?: Maybe<TotalUsersCount>;
};

export type PowerUserWeeklyCountOutput = {
  __typename?: 'PowerUserWeeklyCountOutput';
  weekCompleted?: Maybe<WeekCompletedData>;
  weekMissed?: Maybe<WeekMissedData>;
  weekName?: Maybe<Scalars['String']['output']>;
};

export type PowerUsersCount = {
  __typename?: 'PowerUsersCount';
  MembershipLevel100?: Maybe<Scalars['Int']['output']>;
  MembershipLevel200?: Maybe<Scalars['Int']['output']>;
  MembershipLevel300?: Maybe<Scalars['Int']['output']>;
  MembershipLevelNull?: Maybe<Scalars['Int']['output']>;
  totalPowerUsers?: Maybe<Scalars['Int']['output']>;
};

export type PreferredHashtagList = {
  __typename?: 'PreferredHashtagList';
  preferredHashtagsList?: Maybe<Array<Maybe<Hashtag>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PreferredHashtagListFilter = {
  clubId?: InputMaybe<Scalars['String']['input']>;
};

export type PrevAndLaterComments = {
  __typename?: 'PrevAndLaterComments';
  comment?: Maybe<Comment>;
  hasLater?: Maybe<Scalars['Boolean']['output']>;
  hasPrev?: Maybe<Scalars['Boolean']['output']>;
};

export type Price = {
  __typename?: 'Price';
  C?: Maybe<Scalars['Float']['output']>;
  CZ?: Maybe<Scalars['Float']['output']>;
  CZG?: Maybe<Scalars['Float']['output']>;
  Dt?: Maybe<Scalars['DateTime']['output']>;
  H?: Maybe<Scalars['Float']['output']>;
  L?: Maybe<Scalars['Float']['output']>;
  O?: Maybe<Scalars['Float']['output']>;
  SecurityID?: Maybe<Scalars['Int']['output']>;
  TQ?: Maybe<Scalars['Float']['output']>;
};

export type ProfileSettings = {
  __typename?: 'ProfileSettings';
  isEmailPrivate?: Maybe<Scalars['Boolean']['output']>;
  isPhonePrivate?: Maybe<Scalars['Boolean']['output']>;
  lastLogin?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  profileType?: Maybe<ProfileType>;
};

export enum ProfileType {
  Private = 'private',
  Public = 'public'
}

export type Promotion = {
  __typename?: 'Promotion';
  imageURL?: Maybe<Scalars['String']['output']>;
  promotionId?: Maybe<Scalars['String']['output']>;
  redirectURL?: Maybe<Scalars['String']['output']>;
  shareableURL?: Maybe<Scalars['String']['output']>;
};

export type PromotionArgs = {
  imageURL: Scalars['String']['input'];
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  shareableURL?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionArgsForSmartFeed = {
  audience?: InputMaybe<UserAudienceType>;
  imageURL: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  shareableURL?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionArgsWithAudience = {
  audience: UserAudienceType;
  imageURL: Scalars['String']['input'];
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  shareableURL?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionData = {
  __typename?: 'PromotionData';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  activatedBy?: Maybe<User>;
  activatedById?: Maybe<Scalars['String']['output']>;
  audience?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy?: Maybe<User>;
  deactivatedById?: Maybe<Scalars['String']['output']>;
  imageURL?: Maybe<Scalars['MediaURI']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  promotionFor?: Maybe<Scalars['String']['output']>;
  promotionId?: Maybe<Scalars['String']['output']>;
  redirectURL?: Maybe<Scalars['String']['output']>;
  shareableURL?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
};

export type PromotionDataOutput = {
  __typename?: 'PromotionDataOutput';
  promotionData?: Maybe<Array<Maybe<PromotionData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PromotionShareObj = {
  __typename?: 'PromotionShareObj';
  ctaUrl?: Maybe<Scalars['String']['output']>;
  externalImageLink?: Maybe<Scalars['String']['output']>;
  externalText?: Maybe<Scalars['String']['output']>;
  imageLink?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export enum PushNotificationFilter {
  All = 'All',
  Completed = 'Completed',
  Pending = 'Pending'
}

export type PushNotificationLog = {
  __typename?: 'PushNotificationLog';
  Club?: Maybe<Club>;
  analyticsLabel?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  canDeletePushNotification?: Maybe<Scalars['Boolean']['output']>;
  clubId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['MediaURI']['output']>;
  isPushJobRunning?: Maybe<Scalars['Boolean']['output']>;
  isPushNotificationSent?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  pushLogId?: Maybe<Scalars['String']['output']>;
  scheduleTime?: Maybe<Scalars['DateTime']['output']>;
};

export type PushNotificationLogOutput = {
  __typename?: 'PushNotificationLogOutput';
  pushNotificationLog?: Maybe<Array<Maybe<PushNotificationLog>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  AdminloginWithOIDCV2?: Maybe<UserInfoFromIdp>;
  AutoFollowEnabledUsers?: Maybe<AutoFollowListOutput>;
  GetChartPeriods?: Maybe<Array<Maybe<ChartPeriod>>>;
  GetCompanyEquityInfo?: Maybe<CompanyEquityInfo>;
  GetCompanyEquityTypeInfo?: Maybe<Array<Maybe<CompanyEquityTypeInfo>>>;
  GetCompanyProfileForSecurity?: Maybe<CompanyProfileForSecurity>;
  GetIntradayPrices?: Maybe<Array<Maybe<ChartPrice>>>;
  GetLatestListingPrice?: Maybe<ListingPrice>;
  GetListingsForSecurity?: Maybe<Array<Maybe<Exchange>>>;
  GetPrices?: Maybe<Array<Maybe<ChartPrice>>>;
  adminLogin: AuthPayload;
  adminSearchText?: Maybe<Array<Maybe<Search>>>;
  adminSuspectedEntities?: Maybe<Array<Maybe<SuspectedEntities>>>;
  adminUserSearch?: Maybe<Array<Maybe<User>>>;
  checkClubHandleValidation?: Maybe<IsSuccess>;
  checkIfAddedToSavedSearch?: Maybe<UserRecentSearchOutput>;
  checkNewPosts?: Maybe<Scalars['Boolean']['output']>;
  checkNewPostsByFeedType?: Maybe<Scalars['Boolean']['output']>;
  checkNewPostsFavoritesFeed?: Maybe<Scalars['Boolean']['output']>;
  checkPermission: Scalars['Boolean']['output'];
  commentSummary?: Maybe<SummaryMisOutput>;
  currentMOM?: Maybe<MomData>;
  dailySignUpSummary?: Maybe<SummaryMisOutput>;
  getAchievementDetails?: Maybe<AchievementDetailsOutput>;
  getActivitiesForAdmin?: Maybe<Array<Maybe<Activity>>>;
  getActivityTypeListForAdmin?: Maybe<Array<Maybe<ActivityTypeForAdmin>>>;
  getAdminFilterActivity?: Maybe<ActivityFilterOutput>;
  getAdminNotificationList?: Maybe<Array<Maybe<AdminNotificationOutput>>>;
  getAlertNotifications?: Maybe<Array<Maybe<Notification>>>;
  getAllAchievementStatus?: Maybe<UserAchievemtStatusData>;
  getAllFeedbacks?: Maybe<Array<Maybe<Feedback>>>;
  getAllZendeskTickets?: Maybe<ZendeskTicketList>;
  getAnalystDetails?: Maybe<AnalystDetails>;
  getAnalystHighlightDetails?: Maybe<AnalystDetails>;
  getApprovalRequestById?: Maybe<ApprovalRequests>;
  getApprovalRequestByIdForAdmin?: Maybe<ApprovalRequests>;
  getApprovalRequests?: Maybe<Array<Maybe<ApprovalRequests>>>;
  getApprovalRequestsForAdmin?: Maybe<ApprovalRequestsListAdminOutput>;
  getBadgeFeedbackQuestion?: Maybe<Array<Maybe<FeedbackQuestions>>>;
  getBadgeFeedbackQuestionAdmin?: Maybe<Array<Maybe<FeedbackQuestions>>>;
  getBadgePromotionForSmartFeed?: Maybe<Array<Maybe<HighlightedAchievements>>>;
  getBadgesOfUser?: Maybe<ListOfUserBadges>;
  getBlockedList?: Maybe<Array<Maybe<User>>>;
  getBlueTickUserList?: Maybe<BlueTickListOutput>;
  getBookmark?: Maybe<Array<Maybe<Post>>>;
  getBookmarkV2?: Maybe<Array<Maybe<Post>>>;
  getBrokenStreakDetails?: Maybe<UserStreakData>;
  getCategories?: Maybe<Array<Maybe<FeatureClubCategory>>>;
  getCategoryById?: Maybe<FeatureClubCategory>;
  getCategoryListByClubId?: Maybe<Array<Maybe<FeatureClubCategory>>>;
  getClub?: Maybe<Club>;
  getClubAdmin?: Maybe<Club>;
  getClubAuthorityList: Array<Maybe<User>>;
  getClubCategories?: Maybe<Array<Maybe<ClubCategory>>>;
  getClubCategoryList?: Maybe<Array<Maybe<FeatureClubCategory>>>;
  getClubContributors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getClubDataChanges?: Maybe<ClubChanges>;
  getClubDetailForAdmin?: Maybe<GetClubDetails>;
  getClubFeatureList?: Maybe<Array<Maybe<FeatureMapping>>>;
  getClubList?: Maybe<Array<Maybe<Club>>>;
  getClubListForSmartFeed?: Maybe<Array<Maybe<Club>>>;
  getClubMarketingPosts?: Maybe<Array<Maybe<Post>>>;
  getClubMedia: Array<Maybe<MediaPostId>>;
  getClubMediaPosts: Array<Maybe<Post>>;
  getClubNotifications?: Maybe<Array<Maybe<Notification>>>;
  getClubPermissionsBasedOnFeatures?: Maybe<Array<Maybe<ClubPermissionsAuthorizationDetails>>>;
  getClubPosts?: Maybe<Array<Maybe<Post>>>;
  getClubPostsByHashTag: PostWithTag;
  getClubPostsByStockTag: PostWithTag;
  getClubPostsSinceDate?: Maybe<PostListSinceDate>;
  getClubPostsV2?: Maybe<Array<Maybe<Post>>>;
  getClubPostsbyClubId: Array<Maybe<Post>>;
  getClubStockIdeaPosts: Array<Maybe<Post>>;
  getClubTrendingDollarTag: Array<Maybe<DollarTag>>;
  getClubTrendingHashtags: Array<Maybe<TrendingHashTag>>;
  getClubTrendingHashtagsV2: Array<Maybe<Hashtag>>;
  getClubTrendingSectorsViaDollarTag: Array<Maybe<DollarTag>>;
  getClubTrendingStocks: Array<Maybe<TrendingStocktag>>;
  getClubTrendingStocksViaDollarTag: Array<Maybe<DollarTag>>;
  getClubsByCategory?: Maybe<Array<Maybe<Club>>>;
  getClubsByFeatureId?: Maybe<Array<Maybe<Club>>>;
  getClubsListForAdmin?: Maybe<ClubListOutputAdmin>;
  getClubsListForPlatform?: Maybe<Array<Maybe<Club>>>;
  getClubsListForPushNotification?: Maybe<ClubListOutputAdmin>;
  getClubsOfUser?: Maybe<Array<Maybe<Club>>>;
  getClubsOfUserCount: Scalars['Int']['output'];
  getCommentDetails: Comment;
  getComments: Array<Maybe<Comment>>;
  getCommentsConnection?: Maybe<CommentConnection>;
  getCountOfNpsReviews?: Maybe<GetCountOfReviews>;
  getCoursesUrl?: Maybe<Scalars['String']['output']>;
  getCronJobs?: Maybe<GetCronJobLogsOutput>;
  getDataForSmartFeedPromotion?: Maybe<PromotionData>;
  getDataListForAB_ReleaseFeatureAdmin?: Maybe<Ab_ReleasePanelOutput>;
  getDeletedPostsLog?: Maybe<DeletedPostsLogOutput>;
  getDollarTagDetails?: Maybe<DollarTag>;
  getDollarTagForSecurityId?: Maybe<DollarTag>;
  getDollartagBySearchText?: Maybe<Array<Maybe<DollarTag>>>;
  getDollartagMarketingPosts?: Maybe<Array<Maybe<Post>>>;
  getEditCommentHistory?: Maybe<Array<Maybe<EditHistoryData>>>;
  getEditPostHistory?: Maybe<Array<Maybe<EditHistoryData>>>;
  getEditPostHistoryV2?: Maybe<Array<Maybe<EditedPost>>>;
  getEditReplyHistory?: Maybe<Array<Maybe<EditHistoryData>>>;
  getElasticSearchSuggestion?: Maybe<Array<Maybe<UserRecentSearchOutput>>>;
  getExternalResourceList?: Maybe<ExternalResourceListOutput>;
  getFavouriteClubsOfUser?: Maybe<Array<Maybe<Club>>>;
  getFeatureMappingList?: Maybe<FeatureMappingData>;
  getFeatureMappingListForClub?: Maybe<Array<Maybe<FeatureWithPermissionDataOutput>>>;
  getFeaturePlatformPermissionList?: Maybe<FeaturePlatformPermissionData>;
  getFeatureToClubPermissionById?: Maybe<ClubPermissionsAuthorizationDetails>;
  getFeatureToPlatformPermission?: Maybe<Array<Maybe<PlatformPermissionFromFeatureTypes>>>;
  getFeedByType: Array<Maybe<ActivityFeed>>;
  getFeedByTypeV2?: Maybe<ActivityConnection>;
  getFeedPosts: Array<Maybe<ActivityFeed>>;
  getFeedPostsV3: ActivityFeedDetails;
  getFeedbackReplies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getFeedbackTypes?: Maybe<Array<Maybe<FeedbackTypeEnum>>>;
  getFollowers?: Maybe<FollowingType>;
  getFollowersCount: Scalars['Int']['output'];
  getFollowingDollarTag?: Maybe<Array<Maybe<DollarTag>>>;
  getFollowings?: Maybe<FollowingTypeNew>;
  getFollowingsCount: Scalars['Int']['output'];
  getGreenTickUserList?: Maybe<GreenTickListOutput>;
  getGuidedTour?: Maybe<Array<Maybe<TourKeys>>>;
  getGuidedTourListForAdmin?: Maybe<TourKeysAdminOutput>;
  getHashTagDetails: PostWithTag;
  getHashTagsUserTalksAbout?: Maybe<Array<Maybe<Hashtag>>>;
  getHashtagBySearchText: Array<Maybe<TrendingHashTag>>;
  getHashtagFollowings?: Maybe<Array<Maybe<Hashtag>>>;
  getHashtagListForAdminBasedOnContentFilter?: Maybe<Array<Maybe<Hashtag>>>;
  getHashtagMarketingPosts?: Maybe<Array<Maybe<Post>>>;
  getHashtagsListBasedOnTypeOfContent?: Maybe<Array<Maybe<Hashtag>>>;
  getImportantProfiles?: Maybe<Array<Maybe<User>>>;
  getImportantProfilesForAdmin?: Maybe<Array<Maybe<User>>>;
  getInterest?: Maybe<SecCat>;
  getInterstitials?: Maybe<Array<Maybe<InterstitialsData>>>;
  getInterstitialsConfigForAdmin?: Maybe<Array<Maybe<InterstitialsConfig>>>;
  getIsBookmarked: Scalars['Boolean']['output'];
  getIsReported: Scalars['Boolean']['output'];
  getJobsList?: Maybe<JobsOutput>;
  getLinkPreview: LinkPreview;
  getListOfBadges?: Maybe<ListOfBadges>;
  getListOfClubsWithPostPermission?: Maybe<Array<Maybe<Club>>>;
  getListOfClubsWithQueryPermission?: Maybe<Array<Maybe<Club>>>;
  getListOfClubsWithStockIdeaPermission?: Maybe<Array<Maybe<Club>>>;
  getListOfFeatureClubGroup?: Maybe<FeatureClubGroupData>;
  getListOfInterstitials?: Maybe<ListOfInterstitials>;
  getListOfMembertypeClubPermissionMap?: Maybe<MembertypeClubPermissionMapData>;
  getListOfPopUps?: Maybe<Array<Maybe<PopUpAdminPanel>>>;
  getListOfPreferredHashtags?: Maybe<PreferredHashtagList>;
  getListOfSuggestedSearch?: Maybe<SuggestedSearchListOutput>;
  getListOfUpcomingEvents?: Maybe<ListOfEvents>;
  getListOfWhatsNew?: Maybe<ListOfWhatsNew>;
  getMOMUserList?: Maybe<MomListOutput>;
  getMarkedUsers?: Maybe<MarkedUsersData>;
  getMarketExperts?: Maybe<Array<Maybe<User>>>;
  getMedia: Array<Maybe<MediaPostId>>;
  getMediaPosts: Array<Maybe<Post>>;
  getMediaUploadURLS: Array<Maybe<MediaUrl>>;
  getMemberCount?: Maybe<Scalars['Int']['output']>;
  getMemberTypeList?: Maybe<MemberTypeListData>;
  getMembers?: Maybe<Array<Maybe<User>>>;
  getMultipleExternalResource?: Maybe<Array<Maybe<ExternalResource>>>;
  getMutualFollowers?: Maybe<Array<Maybe<User>>>;
  getMutualFollowings?: Maybe<Array<Maybe<User>>>;
  getMyFeedbacks?: Maybe<Array<Maybe<Feedback>>>;
  getMySubscribers?: Maybe<Array<Maybe<User>>>;
  getMySubscriptions?: Maybe<Subscriptions>;
  getNotifications?: Maybe<Array<Maybe<Notification>>>;
  getNotificationsCount: Scalars['Int']['output'];
  getNpsData?: Maybe<GetNpsOutput>;
  getNpsInInterval?: Maybe<NpsIntervalData>;
  getNpsInIntervalV2?: Maybe<NpsInInterValOuptut>;
  getNpsScore?: Maybe<Scalars['Float']['output']>;
  getOnboardScreenContent?: Maybe<Scalars['JSON']['output']>;
  getPendingPushNotificationData?: Maybe<PendingPushNotificationLogOutput>;
  getPendingScheduledJobs?: Maybe<PendingScheduledJobsOutput>;
  getPendingScheduledJobsData?: Maybe<Array<Maybe<PendingJobs>>>;
  getPeopleListForSmartFeed?: Maybe<Array<Maybe<User>>>;
  getPermissionList?: Maybe<Array<Maybe<UserClubPermissionValues>>>;
  getPermissionToFeatureMappingList?: Maybe<ClubAndUtilityToFeatureOutput>;
  getPinnedPost?: Maybe<Array<Maybe<Post>>>;
  getPollExpiryTypeList?: Maybe<Array<Maybe<PollExpiryType>>>;
  getPopUp?: Maybe<PopUpData>;
  getPopularClubs?: Maybe<Array<Maybe<Club>>>;
  getPopularClubsInPlatform?: Maybe<Array<Maybe<Club>>>;
  getPopularPeopleClubBased?: Maybe<Array<Maybe<User>>>;
  getPopularUsers?: Maybe<Array<Maybe<User>>>;
  getPostByDollarTag?: Maybe<Array<Maybe<Post>>>;
  getPostByDollarTagSinceDate?: Maybe<PostListSinceDate>;
  getPostByHashTagSinceDate?: Maybe<PostListSinceDate>;
  getPostById: Post;
  getPostDetailsById?: Maybe<PostDetails>;
  getPostForAdmin?: Maybe<Post>;
  getPostPermissionsInAnyClub?: Maybe<Array<Maybe<PermissionsInAnyClub>>>;
  getPostsByFilters?: Maybe<FilteredPostListSinceDate>;
  getPostsByHashTag: PostWithTag;
  getPostsByHashTagV2: Array<Maybe<Post>>;
  getPostsByStockTag: PostWithTag;
  getPostsByStockTagV2: Array<Maybe<Post>>;
  getPostsConnectionByFilter?: Maybe<PostConnection>;
  getPowerUserDataComparison?: Maybe<Array<Maybe<PowerUserComparisonOutput>>>;
  getPowerUserDataWeekly?: Maybe<Array<Maybe<PowerUserWeeklyCountOutput>>>;
  getPowerUserFeedbackMIS?: Maybe<PowerUserFeedbackMisOutput>;
  getPowerUserMIS?: Maybe<PowerUserMisOutput>;
  getPowerUserStreakDetails?: Maybe<UserStreakData>;
  getPreferredHashTagsUserTalksAbout?: Maybe<Array<Maybe<Hashtag>>>;
  getPreferredHashtags?: Maybe<Array<Maybe<Hashtag>>>;
  getPreferredHashtagsByClub?: Maybe<Array<Maybe<Hashtag>>>;
  getProfileInfo?: Maybe<User>;
  getProfileInfoFromOIDCToken?: Maybe<User>;
  getProfileMarketingPosts?: Maybe<Array<Maybe<Post>>>;
  getProfilePosts: Array<Maybe<Post>>;
  getProfilePostsSinceDate?: Maybe<PostListSinceDate>;
  getProfilePostsV2: Array<Maybe<Post>>;
  getPromotion?: Maybe<Promotion>;
  getPromotionForSmartFeed?: Maybe<PromotionData>;
  getPromotionList?: Maybe<PromotionDataOutput>;
  getPushNotificationLogAdmin?: Maybe<PushNotificationLogOutput>;
  getReactions?: Maybe<Array<Maybe<Vote>>>;
  getRecentSearch?: Maybe<Array<Maybe<UserRecentSearchOutput>>>;
  getRecommendedPosts: Array<Maybe<ActivityFeed>>;
  getReferBanner?: Maybe<Scalars['String']['output']>;
  getReferMsg?: Maybe<ReferMsg>;
  getReplies?: Maybe<Array<Maybe<Reply>>>;
  getRepliesConnection?: Maybe<ReplyConnection>;
  getReportActionHistory?: Maybe<ActionHistoryOutput>;
  getReportActionHistoryList?: Maybe<ActionHistoryOutput>;
  getReportActionStatus?: Maybe<ActionState>;
  getReportCount?: Maybe<ReportCount>;
  getReportOnUserActionStatus?: Maybe<UserReportActionState>;
  getReportTypes?: Maybe<Array<Maybe<ReportType>>>;
  getReportedByList?: Maybe<Array<Maybe<ReportData>>>;
  getRequests?: Maybe<Array<Maybe<Notification>>>;
  getRequestsCount: Scalars['Int']['output'];
  getRestrictionModal?: Maybe<RestrictionModal>;
  getSavedFeatureClubGroup?: Maybe<Array<Maybe<FeatureDataType>>>;
  getSavedSearch?: Maybe<Array<Maybe<UserRecentSearchOutput>>>;
  getScreens?: Maybe<Array<Maybe<ScreenData>>>;
  getSearchSuggestion?: Maybe<Array<Maybe<UserRecentSearchOutput>>>;
  getSectorBySearchTextViaDollarTagForWatchlist?: Maybe<Array<Maybe<DollarTag>>>;
  getSectorListForSmartFeed?: Maybe<Array<Maybe<DollarTag>>>;
  getSectors: Array<Maybe<Sector>>;
  getSectorsByName: Array<Maybe<Sector>>;
  getSectorsUserTalksAbout?: Maybe<Array<Maybe<DollarTag>>>;
  getSelfFeed: Array<Maybe<ActivityFeed>>;
  getShareFeedForPost?: Maybe<Array<Maybe<Post>>>;
  getSimilarInterestUser?: Maybe<Array<Maybe<User>>>;
  getSiteReportById?: Maybe<SiteReport>;
  getSiteReportDataList?: Maybe<ReportDataListOutput>;
  getSiteReports?: Maybe<SiteReportOutput>;
  getStockFollowings?: Maybe<Array<Maybe<Stock>>>;
  getStockIdeaPosts: Array<Maybe<Post>>;
  getStockListForSmartFeed?: Maybe<Array<Maybe<DollarTag>>>;
  getStockTagDetails?: Maybe<PostWithTag>;
  getStocksBySearchText: Array<Maybe<TrendingStocktag>>;
  getStocksBySearchTextForWatchlist?: Maybe<Array<Maybe<Stock>>>;
  getStocksBySearchTextViaDollarTagForWatchlist?: Maybe<Array<Maybe<DollarTag>>>;
  getStocksBySectors: Array<Maybe<Stock>>;
  getStocksUserTalksAbout?: Maybe<Array<Maybe<DollarTag>>>;
  getSuggestedPeople?: Maybe<Array<Maybe<User>>>;
  getSuggestedSearch?: Maybe<Array<Maybe<UserSuggestedSearchOutput>>>;
  getTick3Experts?: Maybe<Array<Maybe<User>>>;
  getTick3UserList?: Maybe<Tick3ListOutput>;
  getTicketById?: Maybe<Scalars['ZendeskTicketResponseModel']['output']>;
  getTopMentionedPeople?: Maybe<Array<Maybe<User>>>;
  getTopTrendingHashTags?: Maybe<Array<Maybe<Hashtag>>>;
  getTopTrendingSectors?: Maybe<Array<Maybe<DollarTag>>>;
  getTopTrendingStocks?: Maybe<Array<Maybe<DollarTag>>>;
  getTopUnverifiedUsers?: Maybe<Array<Maybe<User>>>;
  getTopVerifiedUsers?: Maybe<Array<Maybe<User>>>;
  getTopicListForSmartFeed?: Maybe<Array<Maybe<Hashtag>>>;
  getTotalAndTickUsers?: Maybe<UsersCount>;
  getTotalMembershipLevelUsers?: Maybe<UsersCountBasedOnMembershipLevel>;
  getTotalMis?: Maybe<MisTotalCount>;
  getTrendingDollarTag?: Maybe<Array<Maybe<DollarTag>>>;
  getTrendingHashTags: Array<Maybe<TrendingHashTag>>;
  getTrendingHashTagsV2: Array<Maybe<Hashtag>>;
  getTrendingSectorsByDollarTag?: Maybe<Array<Maybe<DollarTag>>>;
  getTrendingStocks: Array<Maybe<TrendingStocktag>>;
  getTrendingStocksByDollarTag?: Maybe<Array<Maybe<DollarTag>>>;
  getTrendingStocksV2: Array<Maybe<Stock>>;
  getTurnOffNotificationText?: Maybe<Scalars['String']['output']>;
  getUnifiedFeed?: Maybe<Array<Maybe<Post>>>;
  getUniqueUsername?: Maybe<IsSuccess>;
  getUpcomingEvents?: Maybe<Array<Maybe<UpcomingEventsList>>>;
  getUser?: Maybe<User>;
  getUserCount?: Maybe<UserCount>;
  getUserCreatorTypeOfContentList?: Maybe<GetUserCreatorTypeOfContentListOutput>;
  getUserFeedTypeList?: Maybe<Array<Maybe<FeedList>>>;
  getUserFollowers?: Maybe<Array<Maybe<User>>>;
  getUserFollowings?: Maybe<Array<Maybe<User>>>;
  getUserInfoAdmin?: Maybe<User>;
  getUserLevelNameFromSE?: Maybe<UserHashtagContentType>;
  getUserList: Array<Maybe<User>>;
  getUserPreferenceClubMapAdmin?: Maybe<Array<Maybe<UserPreferenceClubMapOutput>>>;
  getUserTrendingHashTags: Array<Maybe<TrendingHashTag>>;
  getUserTrendingStocks: Array<Maybe<TrendingStocktag>>;
  getUserWatchlist?: Maybe<Array<Maybe<DollarTag>>>;
  getVerifiedUsers?: Maybe<Array<Maybe<User>>>;
  getViewOnlypermissionsFromToken?: Maybe<PlatformActionPermissionsAlias>;
  getVoterList?: Maybe<Array<Maybe<User>>>;
  getWatchlist?: Maybe<Array<Maybe<Stock>>>;
  getWatchlistCount?: Maybe<Scalars['Int']['output']>;
  getWatchlistV2?: Maybe<Array<Maybe<DollarTag>>>;
  getWebinarUrl?: Maybe<Scalars['String']['output']>;
  getWhatsNew?: Maybe<Array<Maybe<WhatsNewData>>>;
  getWhiteListedEmails?: Maybe<Array<Maybe<User>>>;
  getZendeskTicketComments?: Maybe<Array<Maybe<Scalars['ZendeskTicketCommentResponseModel']['output']>>>;
  getZendeskTicketTypeList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getZendeskTicketsByUser?: Maybe<ZendeskTicketList>;
  getlistOfUsersWhoMissedStreak?: Maybe<UsersWhoMissedStreakMisOutput>;
  globalSearchPosts?: Maybe<GlobalSearchPostListSinceDate>;
  hasPendingUnderApprovalRequests?: Maybe<Scalars['Int']['output']>;
  isFeatureVisible?: Maybe<Scalars['Boolean']['output']>;
  isFollowing: IsFollowed;
  isPostFollowed?: Maybe<Scalars['Boolean']['output']>;
  isSubscribed: IsSuccess;
  isSubscribedToAdminNotificationTopic?: Maybe<Scalars['Boolean']['output']>;
  isWatchlisted?: Maybe<Scalars['Boolean']['output']>;
  me: User;
  membersCountInClub?: Maybe<Array<Maybe<ClubMemberCount>>>;
  misForCreators?: Maybe<MisOutputForCreators>;
  pollInPostSummary?: Maybe<PollMisOutput>;
  postSummary?: Maybe<SummaryMisOutput>;
  refreshAccessToken: AuthPayload;
  refreshAccessTokenV2: AuthPayload;
  replySummary?: Maybe<SummaryMisOutput>;
  restriction?: Maybe<RestrictionDataForPremium>;
  searchPreferredHashtag?: Maybe<Array<Maybe<Hashtag>>>;
  sessionSummary?: Maybe<SessionMisOutput>;
  showEventsDot?: Maybe<Scalars['Boolean']['output']>;
  unifiedSearch?: Maybe<Array<Maybe<Search>>>;
  unifiedSearchV2?: Maybe<Array<Maybe<Search>>>;
  uniqueUsersWhoPosted?: Maybe<Array<Maybe<UniqueUsers>>>;
  userEngagementSummary?: Maybe<Array<Maybe<MisOutput>>>;
};


export type QueryAdminloginWithOidcv2Args = {
  accessToken: Scalars['String']['input'];
};


export type QueryAutoFollowEnabledUsersArgs = {
  data?: InputMaybe<AutoFollowInputs>;
};


export type QueryGetChartPeriodsArgs = {
  input?: InputMaybe<GetChartPeriodsInput>;
};


export type QueryGetCompanyEquityInfoArgs = {
  input?: InputMaybe<GetCompanyEquityInfoInput>;
};


export type QueryGetCompanyEquityTypeInfoArgs = {
  input?: InputMaybe<GetCompanyEquityTypeInfoInput>;
};


export type QueryGetCompanyProfileForSecurityArgs = {
  input?: InputMaybe<GetCompanyProfileForSecurityInput>;
};


export type QueryGetIntradayPricesArgs = {
  input?: InputMaybe<GetIntradayPricesInput>;
};


export type QueryGetLatestListingPriceArgs = {
  input?: InputMaybe<GetLatestListingPriceInput>;
};


export type QueryGetListingsForSecurityArgs = {
  input?: InputMaybe<GetListingsForSecurityInput>;
};


export type QueryGetPricesArgs = {
  input?: InputMaybe<GetPricesInput>;
};


export type QueryAdminLoginArgs = {
  data?: InputMaybe<AdminLogin>;
};


export type QueryAdminSearchTextArgs = {
  SearchFilter?: InputMaybe<SearchFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchText: Scalars['String']['input'];
  type: SearchType;
};


export type QueryAdminSuspectedEntitiesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryAdminUserSearchArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdminUserSearchFilterType>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckClubHandleValidationArgs = {
  clubHandle?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckIfAddedToSavedSearchArgs = {
  data?: InputMaybe<Array<InputMaybe<UserRecentSearchInput>>>;
};


export type QueryCheckNewPostsArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckNewPostsByFeedTypeArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  feedType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckNewPostsFavoritesFeedArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckPermissionArgs = {
  Action: UserClubPermissionValues;
  clubId: Scalars['String']['input'];
};


export type QueryCommentSummaryArgs = {
  data?: InputMaybe<MisInput>;
};


export type QueryDailySignUpSummaryArgs = {
  data?: InputMaybe<SignUpMisInput>;
};


export type QueryGetAchievementDetailsArgs = {
  achievementType?: InputMaybe<Scalars['String']['input']>;
  sourceOfClick?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetActivitiesForAdminArgs = {
  page: Scalars['Int']['input'];
};


export type QueryGetAdminFilterActivityArgs = {
  data?: InputMaybe<FilterActivityArgs>;
};


export type QueryGetAdminNotificationListArgs = {
  filter?: InputMaybe<AdminNotificationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAlertNotificationsArgs = {
  page: Scalars['Int']['input'];
};


export type QueryGetAllFeedbacksArgs = {
  page: Scalars['Int']['input'];
};


export type QueryGetAllZendeskTicketsArgs = {
  filter?: InputMaybe<ZendeskSearchfilter>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetAnalystDetailsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetAnalystHighlightDetailsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetApprovalRequestByIdArgs = {
  approvalRequestId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetApprovalRequestByIdForAdminArgs = {
  approvalRequestId: Scalars['String']['input'];
};


export type QueryGetApprovalRequestsArgs = {
  filter?: InputMaybe<ApprovalRequestStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetApprovalRequestsForAdminArgs = {
  filter?: InputMaybe<ApprovalRequestAdminFilter>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetBadgeFeedbackQuestionArgs = {
  badgeId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBadgeFeedbackQuestionAdminArgs = {
  badgeId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBadgesOfUserArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBlueTickUserListArgs = {
  data?: InputMaybe<GetTickListArgs>;
};


export type QueryGetBookmarkV2Args = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryGetCategoryByIdArgs = {
  clubCategoryId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCategoryListByClubIdArgs = {
  clubId: Scalars['String']['input'];
};


export type QueryGetClubArgs = {
  clubHandle?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClubAdminArgs = {
  clubHandle?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClubAuthorityListArgs = {
  clubId: Scalars['String']['input'];
  data?: InputMaybe<GetUserListArgs>;
};


export type QueryGetClubContributorsArgs = {
  clubId: Scalars['String']['input'];
};


export type QueryGetClubDataChangesArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClubDetailForAdminArgs = {
  clubId: Scalars['String']['input'];
};


export type QueryGetClubListForSmartFeedArgs = {
  data: Scalars['String']['input'];
};


export type QueryGetClubMarketingPostsArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClubMediaArgs = {
  data?: InputMaybe<ClubInput>;
  page: Scalars['Int']['input'];
};


export type QueryGetClubMediaPostsArgs = {
  data?: InputMaybe<ClubInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetClubNotificationsArgs = {
  page: Scalars['Int']['input'];
};


export type QueryGetClubPostsArgs = {
  clubId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preferredHashtagId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClubPostsByHashTagArgs = {
  clubId: Scalars['String']['input'];
  hashTagName: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetClubPostsByStockTagArgs = {
  clubId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  securityId: Scalars['Int']['input'];
};


export type QueryGetClubPostsSinceDateArgs = {
  clubId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  since?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClubPostsV2Args = {
  clubId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetClubPostsbyClubIdArgs = {
  data?: InputMaybe<ClubInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetClubStockIdeaPostsArgs = {
  data?: InputMaybe<ClubInput>;
  page: Scalars['Int']['input'];
};


export type QueryGetClubTrendingDollarTagArgs = {
  clubId: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryGetClubTrendingHashtagsArgs = {
  clubId: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryGetClubTrendingHashtagsV2Args = {
  clubId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryGetClubTrendingSectorsViaDollarTagArgs = {
  clubId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryGetClubTrendingStocksArgs = {
  clubId: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryGetClubTrendingStocksViaDollarTagArgs = {
  clubId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryGetClubsByCategoryArgs = {
  clubCategoryId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClubsByFeatureIdArgs = {
  featureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClubsListForAdminArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetClubsListForPlatformArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetClubsListForPushNotificationArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetClubsOfUserArgs = {
  entitlement?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryGetClubsOfUserCountArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetCommentDetailsArgs = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCommentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['String']['input'];
  takeCursorElement?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetCountOfNpsReviewsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetCronJobsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  jobStatus: GetCronJobStatus;
  limit: Scalars['Int']['input'];
  nameOfCron: NameOfCron;
  page: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDataForSmartFeedPromotionArgs = {
  interstitialsDataField?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDeletedPostsLogArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<PostCategory>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortDeletedPostsBy>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetDollarTagDetailsArgs = {
  dollarTagId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDollarTagForSecurityIdArgs = {
  securityId: Scalars['Int']['input'];
};


export type QueryGetDollartagBySearchTextArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchText: Scalars['String']['input'];
};


export type QueryGetDollartagMarketingPostsArgs = {
  dollarTagId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetEditCommentHistoryArgs = {
  commentId: Scalars['String']['input'];
};


export type QueryGetEditPostHistoryArgs = {
  postId: Scalars['String']['input'];
};


export type QueryGetEditPostHistoryV2Args = {
  postId: Scalars['String']['input'];
};


export type QueryGetEditReplyHistoryArgs = {
  replyId: Scalars['String']['input'];
};


export type QueryGetElasticSearchSuggestionArgs = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetExternalResourceListArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFeatureMappingListArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetFeaturePlatformPermissionListArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetFeatureToClubPermissionByIdArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFeedByTypeArgs = {
  feedType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFeedByTypeV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  feedType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFeedPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFeedPostsV3Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  since_activityId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFeedbackRepliesArgs = {
  feedbackId: Scalars['String']['input'];
};


export type QueryGetFollowersArgs = {
  data?: InputMaybe<FollowArgs>;
};


export type QueryGetFollowersCountArgs = {
  data?: InputMaybe<FollowArgs>;
};


export type QueryGetFollowingDollarTagArgs = {
  id: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryGetFollowingsArgs = {
  data?: InputMaybe<FollowArgs>;
};


export type QueryGetFollowingsCountArgs = {
  data?: InputMaybe<FollowArgs>;
};


export type QueryGetGreenTickUserListArgs = {
  data?: InputMaybe<GetTickListArgs>;
};


export type QueryGetGuidedTourArgs = {
  tourComponent?: InputMaybe<Scalars['String']['input']>;
  tourSource?: InputMaybe<TourSourceType>;
};


export type QueryGetGuidedTourListForAdminArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetHashTagDetailsArgs = {
  hashTagName?: InputMaybe<Scalars['String']['input']>;
  hashtagId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetHashTagsUserTalksAboutArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetHashtagBySearchTextArgs = {
  data?: InputMaybe<GetHashtagBySearchTextArgs>;
};


export type QueryGetHashtagFollowingsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetHashtagListForAdminBasedOnContentFilterArgs = {
  typeOfContentMadeByHashtag?: InputMaybe<UserHashtagContentType>;
};


export type QueryGetHashtagMarketingPostsArgs = {
  hashTagName?: InputMaybe<Scalars['String']['input']>;
  hashtagId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetHashtagsListBasedOnTypeOfContentArgs = {
  typeOfContentMadeByHashtag?: InputMaybe<UserHashtagContentType>;
};


export type QueryGetInterestArgs = {
  data: GetInterest;
};


export type QueryGetInterstitialsArgs = {
  platformType: PlatformTypeForInterstitial;
};


export type QueryGetIsBookmarkedArgs = {
  postId: Scalars['String']['input'];
};


export type QueryGetIsReportedArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  replyId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetJobsListArgs = {
  filter?: InputMaybe<ScheduleJobStatus>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLinkPreviewArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetListOfBadgesArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetListOfFeatureClubGroupArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetListOfInterstitialsArgs = {
  filter?: InputMaybe<InterstitialsFilterArgs>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetListOfMembertypeClubPermissionMapArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetListOfPreferredHashtagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetListOfSuggestedSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetListOfUpcomingEventsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetListOfWhatsNewArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetMomUserListArgs = {
  data?: InputMaybe<GetMomListArgs>;
};


export type QueryGetMarkedUsersArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMarketExpertsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetMediaArgs = {
  data?: InputMaybe<UserId>;
  page: Scalars['Int']['input'];
};


export type QueryGetMediaPostsArgs = {
  data?: InputMaybe<UserId>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetMediaUploadUrlsArgs = {
  data?: InputMaybe<Array<InputMaybe<MediaInput>>>;
};


export type QueryGetMemberCountArgs = {
  clubId: Scalars['String']['input'];
};


export type QueryGetMemberTypeListArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetMembersArgs = {
  clubId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetMultipleExternalResourceArgs = {
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetMutualFollowersArgs = {
  id: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryGetMutualFollowingsArgs = {
  id: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryGetNotificationsArgs = {
  filter?: InputMaybe<NotificationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetNpsDataArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<NpsReviewerCategory>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetNpsInIntervalArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<DateRange>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetNpsInIntervalV2Args = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<DateRange>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetNpsScoreArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetOnboardScreenContentArgs = {
  input?: InputMaybe<Scalars['JSON']['input']>;
  screenName?: InputMaybe<ScreenName>;
};


export type QueryGetPendingPushNotificationDataArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPendingScheduledJobsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetPendingScheduledJobsDataArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPeopleListForSmartFeedArgs = {
  data: Scalars['String']['input'];
};


export type QueryGetPermissionListArgs = {
  clubId: Scalars['String']['input'];
};


export type QueryGetPinnedPostArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPopularClubsArgs = {
  clubType: ClubType;
};


export type QueryGetPopularPeopleClubBasedArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPopularUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPostByDollarTagArgs = {
  dollarTagId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPostByDollarTagSinceDateArgs = {
  dollarTagId: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  since?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPostByHashTagSinceDateArgs = {
  hashTagName?: InputMaybe<Scalars['String']['input']>;
  hashtagId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  since?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPostByIdArgs = {
  data?: InputMaybe<PostId>;
};


export type QueryGetPostDetailsByIdArgs = {
  postId: Scalars['String']['input'];
};


export type QueryGetPostForAdminArgs = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  replyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPostsByFiltersArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  filter: SearchPostsFilterArgs;
  limit: Scalars['Int']['input'];
  since?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPostsByHashTagArgs = {
  hashTagName?: InputMaybe<Scalars['String']['input']>;
  hashtagId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPostsByHashTagV2Args = {
  hashTagName?: InputMaybe<Scalars['String']['input']>;
  hashtagId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPostsByStockTagArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  securityId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPostsByStockTagV2Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  securityId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPostsConnectionByFilterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: GlobalSearchForPosts;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPowerUserDataComparisonArgs = {
  weekName: Scalars['String']['input'];
};


export type QueryGetPowerUserDataWeeklyArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPowerUserFeedbackMisArgs = {
  filter: FilterForPowerUserFeedbackMis;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetPowerUserMisArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetPreferredHashTagsUserTalksAboutArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPreferredHashtagsByClubArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProfileInfoArgs = {
  data?: InputMaybe<UserId>;
};


export type QueryGetProfileMarketingPostsArgs = {
  data?: InputMaybe<UserId>;
};


export type QueryGetProfilePostsArgs = {
  data?: InputMaybe<UserId>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetProfilePostsSinceDateArgs = {
  data?: InputMaybe<UserId>;
  limit: Scalars['Int']['input'];
  since?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProfilePostsV2Args = {
  data?: InputMaybe<UserId>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPromotionForSmartFeedArgs = {
  data: Scalars['String']['input'];
};


export type QueryGetPromotionListArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetPushNotificationLogAdminArgs = {
  filter: PushNotificationFilter;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetReactionsArgs = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  replyId?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  voteType?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRecommendedPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRepliesArgs = {
  commentId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryGetRepliesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  replyId?: InputMaybe<Scalars['String']['input']>;
  takeCursorElement?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetReportActionHistoryArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  siteReportId: Scalars['String']['input'];
};


export type QueryGetReportActionHistoryListArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetReportActionStatusArgs = {
  siteReportId: Scalars['String']['input'];
};


export type QueryGetReportCountArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetReportOnUserActionStatusArgs = {
  siteReportId: Scalars['String']['input'];
};


export type QueryGetReportedByListArgs = {
  clubReportId?: InputMaybe<Scalars['String']['input']>;
  siteReportId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRequestsArgs = {
  page: Scalars['Int']['input'];
};


export type QueryGetSavedFeatureClubGroupArgs = {
  clubId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSavedSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetSearchSuggestionArgs = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSectorBySearchTextViaDollarTagForWatchlistArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchText: Scalars['String']['input'];
};


export type QueryGetSectorListForSmartFeedArgs = {
  data: Scalars['String']['input'];
};


export type QueryGetSectorsArgs = {
  limits?: InputMaybe<GetSectorsArgs>;
};


export type QueryGetSectorsByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryGetSectorsUserTalksAboutArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetSelfFeedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetShareFeedForPostArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['String']['input'];
};


export type QueryGetSimilarInterestUserArgs = {
  limits: Limits;
};


export type QueryGetSiteReportByIdArgs = {
  siteReportId: Scalars['String']['input'];
};


export type QueryGetSiteReportDataListArgs = {
  data?: InputMaybe<GetReportData>;
};


export type QueryGetSiteReportsArgs = {
  data?: InputMaybe<GetSiteReport>;
};


export type QueryGetStockFollowingsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetStockIdeaPostsArgs = {
  data?: InputMaybe<UserId>;
  page: Scalars['Int']['input'];
};


export type QueryGetStockListForSmartFeedArgs = {
  data: Scalars['String']['input'];
};


export type QueryGetStockTagDetailsArgs = {
  securityId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetStocksBySearchTextArgs = {
  data?: InputMaybe<GetStocksBySearchTextArgs>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetStocksBySearchTextForWatchlistArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchText: Scalars['String']['input'];
};


export type QueryGetStocksBySearchTextViaDollarTagForWatchlistArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchText: Scalars['String']['input'];
};


export type QueryGetStocksBySectorsArgs = {
  data?: InputMaybe<GetStocksBySectorsArgs>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetStocksUserTalksAboutArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetSuggestedSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTick3ExpertsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTick3UserListArgs = {
  data?: InputMaybe<GetTickListArgs>;
};


export type QueryGetTicketByIdArgs = {
  ticketId: Scalars['Int']['input'];
};


export type QueryGetTopMentionedPeopleArgs = {
  limits: Limits;
};


export type QueryGetTopUnverifiedUsersArgs = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetTopVerifiedUsersArgs = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetTopicListForSmartFeedArgs = {
  data: Scalars['String']['input'];
};


export type QueryGetTotalMisArgs = {
  data?: InputMaybe<MisInput>;
};


export type QueryGetTrendingDollarTagArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  type: Array<InputMaybe<DollarTagEnum>>;
};


export type QueryGetTrendingHashTagsArgs = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryGetTrendingHashTagsV2Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTrendingSectorsByDollarTagArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryGetTrendingStocksArgs = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryGetTrendingStocksByDollarTagArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryGetTrendingStocksV2Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTurnOffNotificationTextArgs = {
  notificationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUnifiedFeedArgs = {
  feedId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUniqueUsernameArgs = {
  username: Scalars['String']['input'];
};


export type QueryGetUpcomingEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUserCreatorTypeOfContentListArgs = {
  searchText?: InputMaybe<Scalars['String']['input']>;
  tickFilter?: InputMaybe<Array<InputMaybe<TickTypeForContent>>>;
  typeOfContentFilter?: InputMaybe<Array<InputMaybe<ContentMadeByUser>>>;
};


export type QueryGetUserFollowersArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetUserFollowingsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetUserInfoAdminArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserListArgs = {
  data?: InputMaybe<GetUserListArgs>;
};


export type QueryGetUserPreferenceClubMapAdminArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  preference?: InputMaybe<UserPreference>;
};


export type QueryGetUserTrendingHashTagsArgs = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryGetUserTrendingStocksArgs = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryGetUserWatchlistArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<DollarTagEnum>;
  userId: Scalars['String']['input'];
};


export type QueryGetVerifiedUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetVoterListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pollId: Scalars['String']['input'];
};


export type QueryGetWatchlistArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  limits?: InputMaybe<Limits>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetWatchlistCountArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetWatchlistV2Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<DollarTagEnum>;
};


export type QueryGetWhatsNewArgs = {
  platformType?: InputMaybe<PlatformTypeForWhatsNew>;
  versionNo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWhiteListedEmailsArgs = {
  page: Scalars['Int']['input'];
  searchtext?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetZendeskTicketCommentsArgs = {
  ticketId: Scalars['Int']['input'];
};


export type QueryGetZendeskTicketsByUserArgs = {
  filter?: InputMaybe<ZendeskSearchfilter>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetlistOfUsersWhoMissedStreakArgs = {
  filter: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGlobalSearchPostsArgs = {
  filter: GlobalSearchForPosts;
  limit: Scalars['Int']['input'];
  since?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsFeatureVisibleArgs = {
  featureName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsFollowingArgs = {
  data?: InputMaybe<FollowArgs>;
};


export type QueryIsPostFollowedArgs = {
  postId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsSubscribedArgs = {
  data?: InputMaybe<SubscribeArgs>;
};


export type QueryIsSubscribedToAdminNotificationTopicArgs = {
  topic?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsWatchlistedArgs = {
  securityId: Scalars['Int']['input'];
};


export type QueryMembersCountInClubArgs = {
  clubIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMisForCreatorsArgs = {
  data?: InputMaybe<MisForCreatorsData>;
};


export type QueryPollInPostSummaryArgs = {
  data?: InputMaybe<PollMisInput>;
};


export type QueryPostSummaryArgs = {
  data?: InputMaybe<MisInput>;
};


export type QueryRefreshAccessTokenArgs = {
  data?: InputMaybe<RefreshToken>;
};


export type QueryRefreshAccessTokenV2Args = {
  data?: InputMaybe<RefreshToken>;
};


export type QueryReplySummaryArgs = {
  data?: InputMaybe<MisInput>;
};


export type QuerySearchPreferredHashtagArgs = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySessionSummaryArgs = {
  data?: InputMaybe<MisInput>;
};


export type QueryUnifiedSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchText: Scalars['String']['input'];
  type: SearchType;
};


export type QueryUnifiedSearchV2Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchText: Scalars['String']['input'];
  type: SearchType;
};


export type QueryUniqueUsersWhoPostedArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserEngagementSummaryArgs = {
  data?: InputMaybe<MisInput>;
};

export type QueryInput = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  postId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ReferMsg = {
  __typename?: 'ReferMsg';
  message?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type RefreshToken = {
  deviceType?: InputMaybe<DeviceType>;
  refreshToken: Scalars['String']['input'];
};

export type RepliesByComment = {
  __typename?: 'RepliesByComment';
  errorMessage?: Maybe<ErrorMessage>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  replies?: Maybe<Array<Maybe<Reply>>>;
  since?: Maybe<Scalars['String']['output']>;
};

export type Reply = {
  __typename?: 'Reply';
  Comment?: Maybe<Comment>;
  Post?: Maybe<Post>;
  User?: Maybe<User>;
  commentId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  downvotecount?: Maybe<Scalars['Int']['output']>;
  editHistory?: Maybe<Array<Maybe<EditHistoryData>>>;
  isCheckedByCM?: Maybe<Scalars['Int']['output']>;
  isDownvoted?: Maybe<Scalars['Int']['output']>;
  isEdited?: Maybe<Scalars['Boolean']['output']>;
  isSuspected?: Maybe<Scalars['Int']['output']>;
  isUpvoted?: Maybe<Scalars['Int']['output']>;
  linkPreview?: Maybe<LinkPreview>;
  media?: Maybe<Array<Maybe<Media>>>;
  memberType?: Maybe<ClubMemberType>;
  membershipLevelOfCreator?: Maybe<Scalars['Int']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  replyId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  text?: Maybe<Scalars['String']['output']>;
  textV2?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upvotecount?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ReplyConnection = {
  __typename?: 'ReplyConnection';
  edges?: Maybe<Array<Maybe<ReplyEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ReplyEdge = {
  __typename?: 'ReplyEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Reply;
};

export type ReplyId = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  replyId: Scalars['String']['input'];
};

export type ReplyInput = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  replyData: CommentData;
};

export type ReplyUpvoteDownVoteCountV2 = {
  __typename?: 'ReplyUpvoteDownVoteCountV2';
  downvotes?: Maybe<Scalars['Int']['output']>;
  reply?: Maybe<Reply>;
  success?: Maybe<Scalars['Boolean']['output']>;
  upvotes?: Maybe<Scalars['Int']['output']>;
};

export type ReportData = {
  __typename?: 'ReportData';
  Club?: Maybe<Club>;
  Comment?: Maybe<Comment>;
  Member?: Maybe<ClubMember>;
  Post?: Maybe<Post>;
  Reply?: Maybe<Reply>;
  ReportId?: Maybe<Scalars['String']['output']>;
  User?: Maybe<User>;
  clubId?: Maybe<Scalars['String']['output']>;
  clubReportId?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  repId?: Maybe<Scalars['String']['output']>;
  replyId?: Maybe<Scalars['String']['output']>;
  reportTime?: Maybe<Scalars['DateTime']['output']>;
  reportType?: Maybe<ReportType>;
  reportedBy?: Maybe<Scalars['String']['output']>;
  reportedByBot?: Maybe<Scalars['Boolean']['output']>;
  reportedOn?: Maybe<ReportedOn>;
  reporter?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ReportDataListOutput = {
  __typename?: 'ReportDataListOutput';
  reportDataList?: Maybe<Array<Maybe<ReportData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ReportHistory = {
  __typename?: 'ReportHistory';
  Admin?: Maybe<User>;
  HiddenStatus: HiddenStatus;
  ReportActionId?: Maybe<Scalars['String']['output']>;
  ReportId?: Maybe<Scalars['String']['output']>;
  ReportStatus: ReportStatus;
  SiteReport?: Maybe<SiteReport>;
  SuspectedStatus: SuspectedStatus;
  SuspendedStatus: SuspendedStatus;
  actionByBot?: Maybe<Scalars['Boolean']['output']>;
  adminId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  media?: Maybe<Array<Maybe<Media>>>;
  remark?: Maybe<Scalars['String']['output']>;
};

export enum ReportStatus {
  Pending = 'Pending',
  Rejected = 'Rejected',
  Resolved = 'Resolved'
}

export enum ReportStatusType {
  All = 'All',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Resolved = 'Resolved'
}

export enum ReportType {
  Abusive = 'Abusive',
  Hateful = 'Hateful',
  Other = 'Other',
  Spam = 'Spam',
  Speculative = 'Speculative'
}

export enum ReportedByType {
  All = 'All',
  Bot = 'Bot',
  User = 'User'
}

export enum ReportedOn {
  Club = 'Club',
  Comment = 'Comment',
  Post = 'Post',
  Reply = 'Reply',
  User = 'User'
}

export enum ReportedOnType {
  All = 'All',
  Club = 'Club',
  Comment = 'Comment',
  Post = 'Post',
  Reply = 'Reply',
  User = 'User'
}

export type ResolveMembershipArgs = {
  clubId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  membershipStatus: Status;
};

export enum ResolverType {
  Admin = 'Admin',
  Moderator = 'Moderator',
  Owner = 'Owner'
}

export type RestrictionDataForPremium = {
  __typename?: 'RestrictionDataForPremium';
  isPremium?: Maybe<Scalars['Boolean']['output']>;
  isPromotion?: Maybe<Scalars['Boolean']['output']>;
  isReferAndEarn?: Maybe<Scalars['Boolean']['output']>;
  isViewOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type RestrictionModaLData = {
  __typename?: 'RestrictionModaLData';
  cta?: Maybe<Cta>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageUrl_dark?: Maybe<Scalars['String']['output']>;
};

export type RestrictionModal = {
  __typename?: 'RestrictionModal';
  KNOW_MORE_URL?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<RestrictionModaLData>>>;
  description?: Maybe<Scalars['String']['output']>;
  iosCtaText?: Maybe<Scalars['String']['output']>;
  iosCtaUrl?: Maybe<Scalars['String']['output']>;
  iosImage?: Maybe<Scalars['String']['output']>;
  iosImage_dark?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ScheduledJobs = {
  __typename?: 'ScheduledJobs';
  cancelledBy?: Maybe<User>;
  cancelledById?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  isJobCancelled?: Maybe<Scalars['Boolean']['output']>;
  isJobDone?: Maybe<Scalars['Boolean']['output']>;
  isJobFailed?: Maybe<Scalars['Boolean']['output']>;
  isJobRunning?: Maybe<Scalars['Boolean']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  jobStatus?: Maybe<Scalars['String']['output']>;
  jobToExecute: Scalars['String']['output'];
  scheduleTime?: Maybe<Scalars['DateTime']['output']>;
  scheduledBy?: Maybe<User>;
  scheduledById?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScreenData = {
  __typename?: 'ScreenData';
  priority?: Maybe<Scalars['Int']['output']>;
  screenName?: Maybe<ScreenName>;
};

export enum ScreenName {
  Interests = 'INTERESTS',
  RecommendedClubsForCommunity = 'RECOMMENDED_CLUBS_FOR_COMMUNITY',
  RecommendedClubsForSocialExperience = 'RECOMMENDED_CLUBS_FOR_SOCIAL_EXPERIENCE',
  UserCategory = 'USER_CATEGORY'
}

export type ScreenResponseArgs = {
  response?: InputMaybe<Scalars['JSON']['input']>;
  screenName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Search = {
  __typename?: 'Search';
  club?: Maybe<Club>;
  dollarTag?: Maybe<DollarTagSearch>;
  hashtag?: Maybe<HashTagSearch>;
  stock?: Maybe<StockSearch>;
  user?: Maybe<User>;
};

export type SearchFilter = {
  greenTick?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoFollowEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  tick3?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchPostsFilterArgs = {
  mentions?: InputMaybe<MentionsFilters>;
  postCategory?: InputMaybe<PostCategoryForSearch>;
  userCreatorId?: InputMaybe<Scalars['String']['input']>;
};

export enum SearchType {
  All = 'All',
  Club = 'Club',
  DollarTag = 'DollarTag',
  DollarTagSector = 'DollarTagSector',
  DollarTagStock = 'DollarTagStock',
  Hashtag = 'Hashtag',
  Stock = 'Stock',
  User = 'User'
}

export type SecCat = {
  __typename?: 'SecCat';
  clubcategory?: Maybe<Array<Maybe<ClubCategoryOutput>>>;
  sectors?: Maybe<Array<Maybe<Sector>>>;
};

export type Sector = {
  __typename?: 'Sector';
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sectorId?: Maybe<Scalars['Int']['output']>;
};

export type SelectPollOptionArgs = {
  optionId?: InputMaybe<Scalars['String']['input']>;
  pollId?: InputMaybe<Scalars['String']['input']>;
};

export type SessionMisOutput = {
  __typename?: 'SessionMISOutput';
  dataHeaders?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dataValues?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
};

export enum SessionPeriodType {
  Daily = 'Daily',
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

export type SharePostInput = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  sharePostId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SignUpMisInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type SignupUserInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  externalImageUrl?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  userName: Scalars['String']['input'];
};

export type SiteReport = {
  __typename?: 'SiteReport';
  Club?: Maybe<Club>;
  Comment?: Maybe<Comment>;
  Post?: Maybe<Post>;
  Reply?: Maybe<Reply>;
  ReportData?: Maybe<Array<Maybe<ReportData>>>;
  ReportId?: Maybe<Scalars['String']['output']>;
  ReportedByTypeForMIS?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  User?: Maybe<User>;
  abusecount?: Maybe<Scalars['Int']['output']>;
  clubId?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['String']['output']>;
  hatefulcount?: Maybe<Scalars['Int']['output']>;
  lastReportedTime?: Maybe<Scalars['DateTime']['output']>;
  othercount?: Maybe<Scalars['Int']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  replyId?: Maybe<Scalars['String']['output']>;
  reportCount?: Maybe<Scalars['Int']['output']>;
  reportedByBot?: Maybe<Scalars['Boolean']['output']>;
  reportedOn?: Maybe<ReportedOn>;
  reportedUser?: Maybe<User>;
  reportedUserId?: Maybe<Scalars['String']['output']>;
  spamcount?: Maybe<Scalars['Int']['output']>;
  speculativecount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ReportStatus>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SiteReportOutput = {
  __typename?: 'SiteReportOutput';
  reports?: Maybe<Array<Maybe<SiteReport>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SocialLoginUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  provider: ExternalLoginProviderType;
  token: Scalars['String']['input'];
};

export type SortDeletedPostsBy = {
  CreatedAt?: InputMaybe<SortOrder>;
  DeletedAt?: InputMaybe<SortOrder>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Status {
  Pending = 'Pending',
  Rejected = 'Rejected',
  Resolved = 'Resolved'
}

export type Stock = {
  __typename?: 'Stock';
  alias?: Maybe<Scalars['String']['output']>;
  bseListingId?: Maybe<Scalars['Int']['output']>;
  followers?: Maybe<Scalars['Int']['output']>;
  isfollow?: Maybe<Scalars['Int']['output']>;
  issubscribed?: Maybe<Scalars['Int']['output']>;
  nseListingId?: Maybe<Scalars['Int']['output']>;
  postCount?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['DateTime']['output']>;
  sector?: Maybe<Sector>;
  securityId?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stockName?: Maybe<Scalars['String']['output']>;
};

export type StockFeedOutput = {
  __typename?: 'StockFeedOutput';
  bseListingId?: Maybe<Scalars['String']['output']>;
  isfollow?: Maybe<Scalars['Int']['output']>;
  nseListingId?: Maybe<Scalars['String']['output']>;
  securityId?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stockName?: Maybe<Scalars['String']['output']>;
};

export type StockIdeasInput = {
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  postId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type StockSearch = {
  __typename?: 'StockSearch';
  followers?: Maybe<Scalars['Int']['output']>;
  stock?: Maybe<Stock>;
};

export type SubscribeArgs = {
  entity: SubscribeEntity;
  id: Scalars['String']['input'];
};

export enum SubscribeEntity {
  Club = 'Club',
  DollarTag = 'DollarTag',
  Hashtag = 'Hashtag',
  Stock = 'Stock',
  User = 'User'
}

export type Subscription = {
  __typename?: 'Subscription';
  adminNotificationCount: Scalars['Int']['output'];
  changePricePull?: Maybe<NewPrice>;
  changePricePush?: Maybe<NewPrice>;
  commentCreated?: Maybe<Comment>;
  likeCreated?: Maybe<Post>;
  newActivityCount: Scalars['Int']['output'];
  notificationCount: Scalars['Int']['output'];
  notificationCreated?: Maybe<Notification>;
  postCreated?: Maybe<Post>;
  postUpdated?: Maybe<Post>;
  replyCreated?: Maybe<Comment>;
  replyUpdated?: Maybe<Comment>;
  underApprovalCount: Scalars['Int']['output'];
};


export type SubscriptionAdminNotificationCountArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionChangePricePullArgs = {
  securityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  userId: Scalars['String']['input'];
};


export type SubscriptionChangePricePushArgs = {
  securityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  userId: Scalars['String']['input'];
};


export type SubscriptionNewActivityCountArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionNotificationCountArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionNotificationCreatedArgs = {
  type: Type;
  userId: Scalars['String']['input'];
};


export type SubscriptionUnderApprovalCountArgs = {
  userId: Scalars['String']['input'];
};

export type SuggestedSearchListOutput = {
  __typename?: 'SuggestedSearchListOutput';
  data?: Maybe<Array<Maybe<UserSuggestedSearchOutput>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SummaryMisOutput = {
  __typename?: 'SummaryMISOutput';
  dataHeaders?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dataValues?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
};

export type SuspectedEntities = {
  __typename?: 'SuspectedEntities';
  User?: Maybe<User>;
  commentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  isSuspected?: Maybe<Scalars['Int']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  replyId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SuspectedEntityType>;
};

export enum SuspectedEntityType {
  Comment = 'comment',
  Post = 'post',
  Reply = 'reply'
}

export enum SuspectedStatus {
  IsSuspected = 'isSuspected',
  IsUnsuspected = 'isUnsuspected'
}

export enum SuspendedStatus {
  IsNotSuspended = 'isNotSuspended',
  IsSuspended = 'isSuspended'
}

export type Tag = {
  __typename?: 'Tag';
  endIndex: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  startIndex: Scalars['String']['output'];
  type: TagType;
};

export type TagInput = {
  endIndex: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  startIndex: Scalars['Int']['input'];
  type: TagType;
};

export enum TagType {
  DollarTag = 'DollarTag',
  HashTag = 'HashTag',
  StockTag = 'StockTag',
  UserTag = 'UserTag'
}

export type Tick3ListOutput = {
  __typename?: 'Tick3ListOutput';
  tick3List?: Maybe<Array<Maybe<User>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TicketCommentInput = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type TicketInput = {
  Type: Scalars['String']['input'];
  attachment?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type TotalUsersCount = {
  __typename?: 'TotalUsersCount';
  MembershipLevel100?: Maybe<Scalars['Int']['output']>;
  MembershipLevel200?: Maybe<Scalars['Int']['output']>;
  MembershipLevel300?: Maybe<Scalars['Int']['output']>;
  MembershipLevelNull?: Maybe<Scalars['Int']['output']>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
};

export type TourKeys = {
  __typename?: 'TourKeys';
  tourComponent?: Maybe<Scalars['String']['output']>;
  tourDescription?: Maybe<Scalars['String']['output']>;
  tourId?: Maybe<Scalars['String']['output']>;
  tourKey?: Maybe<Scalars['Float']['output']>;
};

export type TourKeysAdminOutput = {
  __typename?: 'TourKeysAdminOutput';
  total?: Maybe<Scalars['Int']['output']>;
  tourData?: Maybe<Array<Maybe<TourKeys>>>;
};

export enum TourSourceType {
  App = 'App',
  Web = 'Web'
}

export type TrendingDollarTag = {
  __typename?: 'TrendingDollarTag';
  dollarTag?: Maybe<DollarTag>;
  followers?: Maybe<Scalars['Int']['output']>;
  userAvatars?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TrendingHashTag = {
  __typename?: 'TrendingHashTag';
  Hashtag?: Maybe<Hashtag>;
  followers?: Maybe<Scalars['Int']['output']>;
  userAvatars?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TrendingStocktag = {
  __typename?: 'TrendingStocktag';
  followers?: Maybe<Scalars['Int']['output']>;
  stock?: Maybe<Stock>;
  userAvatars?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UndoPollOptionArgs = {
  pollId?: InputMaybe<Scalars['String']['input']>;
};

export type UpcomingEvents = {
  __typename?: 'UpcomingEvents';
  audience?: Maybe<UserAudienceType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  ctaButtonText?: Maybe<Scalars['String']['output']>;
  ctaButtonUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['MediaURI']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
};

export type UpcomingEventsList = {
  __typename?: 'UpcomingEventsList';
  ctaButtonText?: Maybe<Scalars['String']['output']>;
  ctaButtonUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['MediaURI']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateAnalystDetailsArgs = {
  analystBio?: InputMaybe<Scalars['String']['input']>;
  awards?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experience?: InputMaybe<Scalars['String']['input']>;
  qualification?: InputMaybe<Scalars['String']['input']>;
  sebiCertificate?: InputMaybe<Scalars['String']['input']>;
  specializes?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateClubArgs = {
  clubBio?: InputMaybe<Scalars['String']['input']>;
  clubCategory?: InputMaybe<Array<InputMaybe<ClubCategories>>>;
  clubHandle?: InputMaybe<Scalars['String']['input']>;
  clubHeadline?: InputMaybe<Scalars['String']['input']>;
  clubId: Scalars['String']['input'];
  clubName?: InputMaybe<Scalars['String']['input']>;
  clubType?: InputMaybe<ClubType>;
};

export type UpdateCommentInput = {
  commentData: CommentData;
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type UpdateHashtagContentTypeArgs = {
  hashtagId?: InputMaybe<Scalars['String']['input']>;
  isPreSelected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateImageArgs = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateMemberTypeArgs = {
  clubId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  memberType: ClubMemberType;
};

export type UpdatePermissionsArgs = {
  clubId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  permissions?: InputMaybe<Array<InputMaybe<Permissions>>>;
};

export type UpdatePostInput = {
  postData: PostInput;
  postId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReplyInput = {
  commentId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
  replyData: CommentData;
  replyId: Scalars['String']['input'];
};

export type UpdateUserPreferenceClubInput = {
  clubId?: InputMaybe<Scalars['String']['input']>;
  isPreSelected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserSettings = {
  isEmailPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isPhonePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileType?: InputMaybe<ProfileType>;
};

export type UpvoteDownVoteCount = {
  __typename?: 'UpvoteDownVoteCount';
  downvotes?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  upvotes?: Maybe<Scalars['Int']['output']>;
};

export type User = {
  __typename?: 'User';
  ImportantProfilePriority?: Maybe<Scalars['Int']['output']>;
  MembershipExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  avatar?: Maybe<Scalars['MediaURI']['output']>;
  avatarPostId?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  canBeOnboarded?: Maybe<Scalars['Boolean']['output']>;
  cover?: Maybe<Scalars['MediaURI']['output']>;
  coverPostId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  eventsTabLastVisited?: Maybe<Scalars['DateTime']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  followerCount?: Maybe<Scalars['Int']['output']>;
  followingCount?: Maybe<Scalars['Int']['output']>;
  ga_secondary_id?: Maybe<Scalars['String']['output']>;
  greenTick?: Maybe<Scalars['Boolean']['output']>;
  hasUnderApprovalRequests?: Maybe<Scalars['Boolean']['output']>;
  highlightedAchievements?: Maybe<Array<Maybe<HighlightedAchievements>>>;
  id?: Maybe<Scalars['String']['output']>;
  isEmailPrivate?: Maybe<Scalars['Boolean']['output']>;
  isOnboarded?: Maybe<Scalars['Boolean']['output']>;
  isPhonePrivate?: Maybe<Scalars['Boolean']['output']>;
  isUserDeleted?: Maybe<Scalars['Boolean']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  isfollow?: Maybe<Scalars['String']['output']>;
  issubscribed?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedinLink?: Maybe<Scalars['String']['output']>;
  memberType?: Maybe<Scalars['String']['output']>;
  membershipLevel?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postCount?: Maybe<Scalars['Int']['output']>;
  profileType?: Maybe<ProfileType>;
  reportCount?: Maybe<Scalars['Int']['output']>;
  showNps?: Maybe<Scalars['Boolean']['output']>;
  showNpsV2?: Maybe<Scalars['Boolean']['output']>;
  showProductTour?: Maybe<Scalars['Boolean']['output']>;
  signUpTime?: Maybe<Scalars['DateTime']['output']>;
  tick3?: Maybe<Scalars['Boolean']['output']>;
  tickMarkedAt?: Maybe<Scalars['DateTime']['output']>;
  tickMarkedByAdmin?: Maybe<User>;
  tickMarkedByAdminId?: Maybe<Scalars['String']['output']>;
  tickRemovedAt?: Maybe<Scalars['DateTime']['output']>;
  tickUnmarkedByAdmin?: Maybe<User>;
  tickUnmarkedByAdminId?: Maybe<Scalars['String']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  typeOfContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userLevel?: Maybe<Scalars['Int']['output']>;
  userTags?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  viewFeedPermission?: Maybe<ViewFeedPermission>;
  watchlistVisibleStatus?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtubeLink?: Maybe<Scalars['String']['output']>;
};

export type UserAchievemtStatusData = {
  __typename?: 'UserAchievemtStatusData';
  data?: Maybe<Array<Maybe<UserAllAchievementStatus>>>;
  errorMessage?: Maybe<ErrorMessage>;
};

export enum UserAudienceType {
  All = 'All',
  Club = 'Club',
  Premium = 'Premium'
}

export type UserBadges = {
  __typename?: 'UserBadges';
  Badges?: Maybe<Badges>;
  achievementType?: Maybe<Scalars['String']['output']>;
  badgeId?: Maybe<Scalars['String']['output']>;
  hasTurnedOffPromotion?: Maybe<Scalars['Boolean']['output']>;
  ownedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceOfClick?: Maybe<Scalars['String']['output']>;
  userBadgeId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum UserClubPermissionValues {
  CanPost = 'can_post',
  ChangeAvatar = 'change_avatar',
  ChangeCover = 'change_cover',
  ViewPost = 'view_post'
}

export type UserFeedOutput = {
  __typename?: 'UserFeedOutput';
  avatar?: Maybe<Scalars['MediaURI']['output']>;
  cover?: Maybe<Scalars['MediaURI']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  greenTick?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  isfollow?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  membershipLevel?: Maybe<Scalars['Int']['output']>;
  profileType?: Maybe<Scalars['String']['output']>;
  tick3?: Maybe<Scalars['Boolean']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserFollow = {
  __typename?: 'UserFollow';
  avatar?: Maybe<Scalars['MediaURI']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<Scalars['MediaURI']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  userLevel?: Maybe<Scalars['Int']['output']>;
  userTags?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtubeLink?: Maybe<Scalars['String']['output']>;
};

export enum UserHashtagContentType {
  Beginner = 'Beginner',
  Investor = 'Investor',
  Trader = 'Trader'
}

export type UserId = {
  userId?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserImageArgs = {
  imageURL?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ImageType>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  avatar?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  greenTick?: Maybe<Scalars['Boolean']['output']>;
  isCelebrity?: Maybe<Scalars['Boolean']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  membershipLevel?: Maybe<Scalars['Int']['output']>;
  profileType?: Maybe<ProfileType>;
  tick3?: Maybe<Scalars['Boolean']['output']>;
};

export enum UserPreference {
  Beginner = 'Beginner',
  Investor = 'Investor',
  Trader = 'Trader'
}

export type UserPreferenceClubMapOutput = {
  __typename?: 'UserPreferenceClubMapOutput';
  Club?: Maybe<Club>;
  UserPreferenceClubMapId?: Maybe<Scalars['String']['output']>;
  clubId?: Maybe<Scalars['String']['output']>;
  isPreSelected?: Maybe<Scalars['Boolean']['output']>;
  preference?: Maybe<UserPreference>;
  priority?: Maybe<Scalars['Int']['output']>;
};

export enum UserRecentSearchElementType {
  Club = 'Club',
  DollarTag = 'DollarTag',
  HashTag = 'HashTag',
  User = 'User'
}

export type UserRecentSearchInput = {
  searchElementId?: InputMaybe<Scalars['String']['input']>;
  searchElementType?: InputMaybe<UserRecentSearchElementType>;
};

export type UserRecentSearchOutput = {
  __typename?: 'UserRecentSearchOutput';
  Club?: Maybe<Club>;
  Dollartag?: Maybe<DollarTag>;
  Hashtag?: Maybe<Hashtag>;
  User?: Maybe<User>;
  isSaved?: Maybe<Scalars['Boolean']['output']>;
  searchId?: Maybe<Scalars['String']['output']>;
};

export type UserReportActionState = {
  __typename?: 'UserReportActionState';
  ReportId?: Maybe<Scalars['String']['output']>;
  ReportStatus?: Maybe<ReportStatus>;
  SuspendedStatus?: Maybe<SuspendedStatus>;
};

export enum UserSearchElementType {
  Club = 'Club',
  DollarTag = 'DollarTag',
  HashTag = 'HashTag',
  User = 'User'
}

export type UserSearchInput = {
  searchElementId?: InputMaybe<Scalars['String']['input']>;
  searchElementType?: InputMaybe<UserSearchElementType>;
};

export type UserSelectOption = {
  __typename?: 'UserSelectOption';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  optionId?: Maybe<Scalars['String']['output']>;
  pollId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userOptionId?: Maybe<Scalars['String']['output']>;
};

export type UserStreakData = {
  __typename?: 'UserStreakData';
  data?: Maybe<UserStreak>;
  errorMessage?: Maybe<ErrorMessage>;
};

export enum UserSubscriptionType {
  All = 'all',
  ChangeAvatar = 'changeAvatar',
  ChangeCover = 'changeCover',
  Followhash = 'followhash',
  Followstock = 'followstock',
  Followuser = 'followuser',
  JoinClub = 'joinClub',
  Post = 'post',
  PostOnFollowedUser = 'postOnFollowedUser'
}

export type UserSuggestedSearchOutput = {
  __typename?: 'UserSuggestedSearchOutput';
  Club?: Maybe<Club>;
  Dollartag?: Maybe<DollarTag>;
  Hashtag?: Maybe<Hashtag>;
  User?: Maybe<User>;
  searchId?: Maybe<Scalars['String']['output']>;
};

export enum UserTypeForAdmin {
  All = 'All',
  GreenTick = 'greenTick',
  NonVerified = 'nonVerified',
  Tick3 = 'tick3',
  Verified = 'verified'
}

export type UserUpdateArgs = {
  bio?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedinLink?: InputMaybe<Scalars['String']['input']>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  userTags?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type UserWithPreferredHashtagOutput = {
  __typename?: 'UserWithPreferredHashtagOutput';
  Hashtag?: Maybe<Hashtag>;
  User?: Maybe<User>;
  searchId?: Maybe<Scalars['String']['output']>;
};

export type UsersWhoMissedStreak = {
  __typename?: 'UsersWhoMissedStreak';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  inactivefrom?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  weekName?: Maybe<Scalars['String']['output']>;
  weekNumber?: Maybe<Scalars['Int']['output']>;
};

export type UsersWhoMissedStreakMisOutput = {
  __typename?: 'UsersWhoMissedStreakMISOutput';
  data?: Maybe<Array<Maybe<UsersWhoMissedStreak>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type VersionControlSystem = {
  __typename?: 'VersionControlSystem';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserID?: Maybe<Scalars['String']['output']>;
  isAndroidVersionForced?: Maybe<Scalars['Boolean']['output']>;
  isBackendVersionForced?: Maybe<Scalars['Boolean']['output']>;
  isForAndroid?: Maybe<Scalars['Boolean']['output']>;
  isForBackend?: Maybe<Scalars['Boolean']['output']>;
  isForIOS?: Maybe<Scalars['Boolean']['output']>;
  isForWeb?: Maybe<Scalars['Boolean']['output']>;
  isIOSVersionForced?: Maybe<Scalars['Boolean']['output']>;
  isLatestVersionForAndroid?: Maybe<Scalars['Boolean']['output']>;
  isLatestVersionForBackend?: Maybe<Scalars['Boolean']['output']>;
  isLatestVersionForIOS?: Maybe<Scalars['Boolean']['output']>;
  isLatestVersionForWeb?: Maybe<Scalars['Boolean']['output']>;
  isReleasedForAndroid?: Maybe<Scalars['Boolean']['output']>;
  isReleasedForBackend?: Maybe<Scalars['Boolean']['output']>;
  isReleasedForIOS?: Maybe<Scalars['Boolean']['output']>;
  isReleasedForWeb?: Maybe<Scalars['Boolean']['output']>;
  isVersionForced?: Maybe<Scalars['Boolean']['output']>;
  isWebVersionForced?: Maybe<Scalars['Boolean']['output']>;
  releaseNoteIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserID?: Maybe<Scalars['String']['output']>;
  versionId?: Maybe<Scalars['String']['output']>;
  versionNo?: Maybe<Scalars['String']['output']>;
};

export type ViewFeedPermission = {
  __typename?: 'ViewFeedPermission';
  canSeeMarketingPost?: Maybe<Scalars['Boolean']['output']>;
  canViewPost?: Maybe<Scalars['Boolean']['output']>;
};

export type Vote = {
  __typename?: 'Vote';
  Comment?: Maybe<Comment>;
  Post?: Maybe<Post>;
  User?: Maybe<User>;
  commentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  membershipLevelOfVoter?: Maybe<Scalars['Int']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  replyId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  vote?: Maybe<Scalars['Int']['output']>;
  voteId?: Maybe<Scalars['Int']['output']>;
};

export type VoteInput = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  replyId?: InputMaybe<Scalars['String']['input']>;
};

export type WeekCompletedData = {
  __typename?: 'WeekCompletedData';
  total?: Maybe<Scalars['Int']['output']>;
  weeklyCount?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type WeekMissedData = {
  __typename?: 'WeekMissedData';
  total?: Maybe<Scalars['Int']['output']>;
  weeklyCount?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type WhatsNew = {
  __typename?: 'WhatsNew';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  platformType?: Maybe<Array<Maybe<PlatformTypeForWhatsNew>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  versionNo?: Maybe<Scalars['String']['output']>;
  whatsNew?: Maybe<Array<Maybe<WhatsNewData>>>;
  whatsNewId?: Maybe<Scalars['String']['output']>;
};

export type WhatsNewData = {
  __typename?: 'WhatsNewData';
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  subText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type WhatsNewInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  subText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type WhatsNewPlatform = {
  __typename?: 'WhatsNewPlatform';
  isActive?: Maybe<Scalars['Boolean']['output']>;
  platformType?: Maybe<Array<Maybe<PlatformTypeForWhatsNew>>>;
  versionNo?: Maybe<Scalars['String']['output']>;
  whatsNew?: Maybe<Array<Maybe<WhatsNewData>>>;
  whatsNewId?: Maybe<Scalars['String']['output']>;
};

export type ZendeskSearchfilter = {
  status?: InputMaybe<ZendeskStatus>;
  ticketId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum ZendeskStatus {
  All = 'all',
  Closed = 'closed',
  Hold = 'hold',
  New = 'new',
  Open = 'open',
  Pending = 'pending',
  Solved = 'solved'
}

export type ZendeskTicketList = {
  __typename?: 'ZendeskTicketList';
  tickets?: Maybe<Array<Maybe<Scalars['ZendeskTicketResponseModel']['output']>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ActivityFeedDetails = {
  __typename?: 'activityFeedDetails';
  data?: Maybe<Array<Maybe<ActivityFeed>>>;
  last_activityId?: Maybe<Scalars['Int']['output']>;
};

export enum AdminType {
  Finanace = 'Finanace',
  Marketing = 'Marketing',
  Sales = 'Sales',
  SuperAdmin = 'SuperAdmin',
  Support = 'Support'
}

export type ClubCategoryOutput = {
  __typename?: 'clubCategoryOutput';
  categoryId?: Maybe<Scalars['Int']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
};

export type ClubFeaturesOutput = {
  __typename?: 'clubFeaturesOutput';
  clubId?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ClubMemberCount = {
  __typename?: 'clubMemberCount';
  clubData?: Maybe<Club>;
  clubId?: Maybe<Scalars['String']['output']>;
  memberCount?: Maybe<Scalars['Int']['output']>;
};

export type ClubMemberPermissionArgs = {
  memberTypeName?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<ClubMemberPermissionsObj>;
  tickType?: InputMaybe<TickType>;
};

export type ClubMemberPermissionsObj = {
  canCreateStockIdea?: InputMaybe<Scalars['Boolean']['input']>;
  canEngage?: InputMaybe<Scalars['Boolean']['input']>;
  canPost?: InputMaybe<Scalars['Boolean']['input']>;
  canPropagatePost?: InputMaybe<Scalars['Boolean']['input']>;
  canQuery?: InputMaybe<Scalars['Boolean']['input']>;
  canViewPost?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClubPermissionType = {
  __typename?: 'clubPermissionType';
  canCreateStockIdea?: Maybe<Scalars['Boolean']['output']>;
  canEngage?: Maybe<Scalars['Boolean']['output']>;
  canPost?: Maybe<Scalars['Boolean']['output']>;
  canPropagatePost?: Maybe<Scalars['Boolean']['output']>;
  canQuery?: Maybe<Scalars['Boolean']['output']>;
  canViewPost?: Maybe<Scalars['Boolean']['output']>;
};

export type ClubPermissionsAuthorizationDetails = {
  __typename?: 'clubPermissionsAuthorizationDetails';
  clubId?: Maybe<Scalars['String']['output']>;
  club_permissions_token?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<ClubPermissionsBasedOnMemberType>>>;
};

export enum ClubPermissionsBasedOnMemberType {
  CanCreateStockIdea = 'canCreateStockIdea',
  CanEngage = 'canEngage',
  CanPost = 'canPost',
  CanPropagatePost = 'canPropagatePost',
  CanQuery = 'canQuery',
  CanViewPost = 'canViewPost'
}

export type ClubPostShareSettingScheme = {
  __typename?: 'clubPostShareSettingScheme';
  greenTickCanShare?: Maybe<Scalars['Boolean']['output']>;
  isVerifiedCanShare?: Maybe<Scalars['Boolean']['output']>;
  normalUserCanShare?: Maybe<Scalars['Boolean']['output']>;
};

export type ClubReportData = {
  __typename?: 'clubReportData';
  pending?: Maybe<Scalars['Int']['output']>;
  rejected?: Maybe<Scalars['Int']['output']>;
  resolved?: Maybe<Scalars['Int']['output']>;
};

export enum ClubSubscriptionType {
  All = 'all',
  ChangeAvatar = 'changeAvatar',
  ChangeCover = 'changeCover',
  Post = 'post'
}

export enum ComponentType {
  BadgePromotion = 'badgePromotion',
  ClubListForSmartFeed = 'clubListForSmartFeed',
  PeopleListForSmartFeed = 'peopleListForSmartFeed',
  PromotionsForSmartFeed = 'promotionsForSmartFeed',
  SectorListForSmartFeed = 'sectorListForSmartFeed',
  StockListForSmartFeed = 'stockListForSmartFeed',
  TopicListForSmartFeed = 'topicListForSmartFeed'
}

export type CreateOptionsArgs = {
  optionText?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePollArgs = {
  expiryEnum?: InputMaybe<PollExpiryEnum>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePollArgsOutput = {
  __typename?: 'createPollArgsOutput';
  expiryEnum?: Maybe<PollExpiryEnum>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  question?: Maybe<Scalars['String']['output']>;
};

export type CronJobExecutionLogs = {
  __typename?: 'cronJobExecutionLogs';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cronExecutionLogId?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  executionTimelapse?: Maybe<Scalars['Int']['output']>;
  isExecutionComplete?: Maybe<Scalars['Boolean']['output']>;
  jobExecutionId?: Maybe<Scalars['String']['output']>;
  manuallyExecutedBy?: Maybe<User>;
  manuallyExecutedById?: Maybe<Scalars['String']['output']>;
  nameOfCron?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<GetCronJobsStatusType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum DefaultMediaType {
  Avatar = 'Avatar',
  ClubAvatar = 'ClubAvatar',
  ClubCover = 'ClubCover',
  Cover = 'Cover'
}

export enum DollarTagEnum {
  Industry = 'Industry',
  MutualFund = 'Mutual_Fund',
  Sector = 'Sector',
  Stock = 'Stock'
}

export type EditClubAdminArgs = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  clubBio?: InputMaybe<Scalars['String']['input']>;
  clubHeadline?: InputMaybe<Scalars['String']['input']>;
  clubName?: InputMaybe<Scalars['String']['input']>;
  clubPriority?: InputMaybe<Scalars['Int']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  isAutoJoinable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
};

export type EditClubDetails = {
  __typename?: 'editClubDetails';
  getUpdatedClub?: Maybe<Club>;
  getUpdatedMemberTypePermissions?: Maybe<Array<Maybe<MemberTypeClubPermissionMap>>>;
};

export type FeatureToClubPermissionOutput = {
  __typename?: 'featureToClubPermissionOutput';
  clubId?: Maybe<Scalars['String']['output']>;
  clubToken?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<PlatformPermissionFromFeatureTypes>>>;
};

export enum FilterComponentType {
  All = 'all',
  BadgePromotion = 'badgePromotion',
  ClubListForSmartFeed = 'clubListForSmartFeed',
  PeopleListForSmartFeed = 'peopleListForSmartFeed',
  PromotionsForSmartFeed = 'promotionsForSmartFeed',
  SectorListForSmartFeed = 'sectorListForSmartFeed',
  StockListForSmartFeed = 'stockListForSmartFeed',
  TopicListForSmartFeed = 'topicListForSmartFeed'
}

export enum FilterPlatformType {
  All = 'all',
  Mobile = 'mobile',
  Web = 'web'
}

export enum FilterType {
  AllCreators = 'allCreators',
  Bluetick = 'bluetick',
  Goldentick = 'goldentick',
  Greentick = 'greentick'
}

export type GetClubDetails = {
  __typename?: 'getClubDetails';
  getClub?: Maybe<ClubWithPermission>;
  getMemberTypePermissions?: Maybe<Array<Maybe<MemberTypeClubPermissionMap>>>;
};

export type GetCountOfReviews = {
  __typename?: 'getCountOfReviews';
  detractors?: Maybe<Scalars['Int']['output']>;
  passive?: Maybe<Scalars['Int']['output']>;
  promoters?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type GetNpsOutput = {
  __typename?: 'getNpsOutput';
  npsOutput?: Maybe<Array<Maybe<Nps>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum GetReportType {
  Abusive = 'Abusive',
  All = 'All',
  Hateful = 'Hateful',
  Other = 'Other',
  Spam = 'Spam',
  Speculative = 'Speculative'
}

export type GetUserCreatorTypeOfContentListOutput = {
  __typename?: 'getUserCreatorTypeOfContentListOutput';
  UserObjWithTypeOfContent?: Maybe<Array<Maybe<User>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type IsHidden = {
  __typename?: 'isHidden';
  isHidden?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkedUsersData = {
  __typename?: 'markedUsersData';
  bluetick?: Maybe<Array<Maybe<User>>>;
  goldentick?: Maybe<Array<Maybe<User>>>;
  greentick?: Maybe<Array<Maybe<User>>>;
};

export type MentionsFilters = {
  dollarTagMentioned?: InputMaybe<Scalars['Int']['input']>;
  hashTagMentioned?: InputMaybe<Scalars['String']['input']>;
};

export type MisForCreatorsData = {
  endDate: Scalars['String']['input'];
  filter?: InputMaybe<Array<InputMaybe<FilterType>>>;
  skip: Scalars['Int']['input'];
  sort: SortOrder;
  sortType: SortType;
  startDate: Scalars['String']['input'];
  take: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MisForCreatorsOutput = {
  __typename?: 'misForCreatorsOutput';
  avatar?: Maybe<Scalars['MediaURI']['output']>;
  bluetick?: Maybe<Scalars['Boolean']['output']>;
  comment?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  downvote?: Maybe<Scalars['Float']['output']>;
  engagement?: Maybe<Scalars['Int']['output']>;
  fullname?: Maybe<Scalars['String']['output']>;
  goldentick?: Maybe<Scalars['Boolean']['output']>;
  greentick?: Maybe<Scalars['Boolean']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  postLink?: Maybe<Scalars['String']['output']>;
  profileLink?: Maybe<Scalars['String']['output']>;
  reply?: Maybe<Scalars['Float']['output']>;
  share?: Maybe<Scalars['Float']['output']>;
  upvote?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type MisOutputForCreators = {
  __typename?: 'misOutputForCreators';
  Data?: Maybe<Array<Maybe<MisForCreatorsOutput>>>;
  Total?: Maybe<TotalData>;
};

export type MisTotalCount = {
  __typename?: 'misTotalCount';
  comments?: Maybe<Array<Maybe<MisOutputAdminPanel>>>;
  engagements?: Maybe<Array<Maybe<MisOutputAdminPanel>>>;
  polls?: Maybe<Array<Maybe<MisOutputAdminPanel>>>;
  posts?: Maybe<Array<Maybe<MisOutputAdminPanel>>>;
  replies?: Maybe<Array<Maybe<MisOutputAdminPanel>>>;
  sessions?: Maybe<Array<Maybe<MisOutputAdminPanel>>>;
  signUps?: Maybe<Scalars['Int']['output']>;
};

export type NewPrice = {
  __typename?: 'newPrice';
  newPrice?: Maybe<Price>;
  securityId?: Maybe<Scalars['Int']['output']>;
};

export type NpsData = {
  __typename?: 'npsData';
  end_date?: Maybe<Scalars['DateTime']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  total?: Maybe<Scalars['String']['output']>;
};

export enum NpsReviewerCategory {
  All = 'All',
  Detractor = 'Detractor',
  Passive = 'Passive',
  Promoter = 'Promoter'
}

export type NpsTodayData = {
  __typename?: 'npsTodayData';
  count?: Maybe<Scalars['Int']['output']>;
};

export type PendingJobs = {
  __typename?: 'pendingJobs';
  count?: Maybe<Scalars['Int']['output']>;
  jobToExecute?: Maybe<Scalars['String']['output']>;
};

export enum PlatformListEnum {
  All = 'All',
  Android = 'Android',
  Backend = 'Backend',
  Ios = 'IOS',
  Web = 'Web'
}

export enum PlatformType {
  Android = 'Android',
  Backend = 'Backend',
  Ios = 'IOS',
  Web = 'Web'
}

export enum PlatformTypeForInterstitial {
  Mobile = 'mobile',
  Web = 'web'
}

export enum PollExpiryEnum {
  OneDay = 'oneDay',
  OneWeek = 'oneWeek',
  ThreeDay = 'threeDay',
  ThreeWeek = 'threeWeek'
}

export type PopUp = {
  __typename?: 'popUp';
  data?: Maybe<Scalars['String']['output']>;
  popUpDelay?: Maybe<Scalars['Int']['output']>;
  popUpType?: Maybe<Scalars['String']['output']>;
};

export type ReleaseNoteData = {
  isForAndroid?: InputMaybe<Scalars['Boolean']['input']>;
  isForIOS?: InputMaybe<Scalars['Boolean']['input']>;
  isForWeb?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  type: ReleaseNotesTypes;
};

export type ReleaseNoteEdit = {
  isDeleted: Scalars['Boolean']['input'];
  isForAndroid?: InputMaybe<Scalars['Boolean']['input']>;
  isForIOS?: InputMaybe<Scalars['Boolean']['input']>;
  isForWeb?: InputMaybe<Scalars['Boolean']['input']>;
  releaseNoteId?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  type: ReleaseNotesTypes;
};

export type ReleaseNoteOutput = {
  __typename?: 'releaseNoteOutput';
  isForAndroid?: Maybe<Scalars['Boolean']['output']>;
  isForIOS?: Maybe<Scalars['Boolean']['output']>;
  isForWeb?: Maybe<Scalars['Boolean']['output']>;
  releaseNoteId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ReleaseNotesTypes>;
};

export enum ReleaseNotesTypes {
  Bug = 'Bug',
  Enhancement = 'Enhancement',
  Feature = 'Feature'
}

export type ReportCount = {
  __typename?: 'reportCount';
  clubReportData?: Maybe<ClubReportData>;
  siteReportData?: Maybe<SiteReportData>;
};

export enum ScheduleJobStatus {
  All = 'all',
  Cancelled = 'cancelled',
  Complete = 'complete',
  Failed = 'failed',
  Pending = 'pending',
  Running = 'running'
}

export type SharedPostFeed = {
  __typename?: 'sharedPostFeed';
  getPost?: Maybe<Post>;
  postId: Scalars['String']['output'];
  sharedPosts?: Maybe<Array<Maybe<Post>>>;
};

export type SignUpSummary = {
  __typename?: 'signUpSummary';
  count?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
};

export type SignUpSummaryOutput = {
  __typename?: 'signUpSummaryOutput';
  signUpSummaryData?: Maybe<Array<Maybe<SignUpSummary>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SiteReportData = {
  __typename?: 'siteReportData';
  pending?: Maybe<Scalars['Int']['output']>;
  rejected?: Maybe<Scalars['Int']['output']>;
  resolved?: Maybe<Scalars['Int']['output']>;
};

export enum SortOrder {
  Comment = 'comment',
  Downvote = 'downvote',
  Reply = 'reply',
  Share = 'share',
  Upvote = 'upvote'
}

export enum SortType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SourceEntityId {
  Number = 'number',
  String = 'string'
}

export type StreakDay = {
  __typename?: 'streakDay';
  dayDate?: Maybe<Scalars['DateTime']['output']>;
  dayName?: Maybe<Scalars['String']['output']>;
  hasVisited?: Maybe<Scalars['Boolean']['output']>;
  visitedState?: Maybe<Scalars['String']['output']>;
};

export type Subscriptions = {
  __typename?: 'subscriptions';
  clubs?: Maybe<Array<Maybe<Club>>>;
  hashtags?: Maybe<Array<Maybe<Hashtag>>>;
  stocks?: Maybe<Array<Maybe<Stock>>>;
  users?: Maybe<Array<Maybe<User>>>;
};

export enum TickType {
  GreenTick = 'greenTick',
  IsVerified = 'isVerified',
  Normal = 'normal',
  Tick3 = 'tick3'
}

export enum TickTypeForContent {
  GreenTick = 'greenTick',
  IsVerified = 'isVerified',
  Tick3 = 'tick3'
}

export type TotalData = {
  __typename?: 'totalData';
  comment?: Maybe<Scalars['Float']['output']>;
  downvote?: Maybe<Scalars['Float']['output']>;
  post?: Maybe<Scalars['Float']['output']>;
  reply?: Maybe<Scalars['Float']['output']>;
  share?: Maybe<Scalars['Float']['output']>;
  upvote?: Maybe<Scalars['Float']['output']>;
};

export type TurnAroundTime = {
  __typename?: 'turnAroundTime';
  commentCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  postCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  timeLapse?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum Type {
  Alert = 'Alert',
  All = 'All',
  Club = 'Club',
  Request = 'Request'
}

export type UniqueUsers = {
  __typename?: 'uniqueUsers';
  count?: Maybe<Scalars['Int']['output']>;
};

export type UpdateExpiryArgs = {
  expiryEnum?: InputMaybe<PollExpiryEnum>;
  pollId?: InputMaybe<Scalars['String']['input']>;
};

export type UserAllAchievementStatus = {
  __typename?: 'userAllAchievementStatus';
  achievementName?: Maybe<Scalars['String']['output']>;
  achievementType?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  milestoneData?: Maybe<Array<Maybe<MilestoneType>>>;
};

export type UserCount = {
  __typename?: 'userCount';
  all?: Maybe<Scalars['Int']['output']>;
  bluetick?: Maybe<Scalars['Int']['output']>;
  goldentick?: Maybe<Scalars['Int']['output']>;
  greentick?: Maybe<Scalars['Int']['output']>;
  normal?: Maybe<Scalars['Int']['output']>;
};

export type UserInfoFromIdp = {
  __typename?: 'userInfoFromIDP';
  canBeOnboarded?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  interimToken?: Maybe<Scalars['String']['output']>;
  isUserMemberOfStockEdgeClub?: Maybe<Scalars['Boolean']['output']>;
  isViewOnly?: Maybe<Scalars['Boolean']['output']>;
  platformPermissions?: Maybe<PlatformActionPermission>;
  profileDetails?: Maybe<UserProfileDetailsFromIdp>;
  user?: Maybe<User>;
};

export type UserProfileDetailsFromIdp = {
  __typename?: 'userProfileDetailsFromIDP';
  Email?: Maybe<Scalars['String']['output']>;
  Firstname?: Maybe<Scalars['String']['output']>;
  Gender?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['String']['output']>;
  ImageFilePath?: Maybe<Scalars['String']['output']>;
  IsDeleted?: Maybe<Scalars['String']['output']>;
  IsInactive?: Maybe<Scalars['String']['output']>;
  Lastname?: Maybe<Scalars['String']['output']>;
  RegisteredOn?: Maybe<Scalars['String']['output']>;
  UserLevel?: Maybe<Scalars['String']['output']>;
  UserName?: Maybe<Scalars['String']['output']>;
};

export type UserStreak = {
  __typename?: 'userStreak';
  hasStreakCompleted?: Maybe<Scalars['Boolean']['output']>;
  hasStreakPopUpBeenSent?: Maybe<Scalars['Boolean']['output']>;
  prevStreak?: Maybe<Array<Maybe<WeekData>>>;
  userId?: Maybe<Scalars['String']['output']>;
  weekData?: Maybe<Array<Maybe<WeekData>>>;
};

export type UsersCount = {
  __typename?: 'usersCount';
  allUsers?: Maybe<Scalars['Int']['output']>;
  greenTickUsers?: Maybe<Scalars['Int']['output']>;
  normalUsers?: Maybe<Scalars['Int']['output']>;
  tick3Users?: Maybe<Scalars['Int']['output']>;
  tickUsers?: Maybe<Scalars['Int']['output']>;
  verifiedUsers?: Maybe<Scalars['Int']['output']>;
};

export type UsersCountBasedOnMembershipLevel = {
  __typename?: 'usersCountBasedOnMembershipLevel';
  MembershipLevel100?: Maybe<Scalars['Int']['output']>;
  MembershipLevel200?: Maybe<Scalars['Int']['output']>;
  MembershipLevel300?: Maybe<Scalars['Int']['output']>;
  MembershipLevelNull?: Maybe<Scalars['Int']['output']>;
};

export type UtilityFeaturesOutput = {
  __typename?: 'utilityFeaturesOutput';
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  permission?: Maybe<Scalars['String']['output']>;
};

export type VersionDataArgs = {
  isForAndroid?: InputMaybe<Scalars['Boolean']['input']>;
  isForBackend?: InputMaybe<Scalars['Boolean']['input']>;
  isForIOS?: InputMaybe<Scalars['Boolean']['input']>;
  isForWeb?: InputMaybe<Scalars['Boolean']['input']>;
  releaseNotes?: InputMaybe<Array<InputMaybe<ReleaseNoteData>>>;
  versionNo?: InputMaybe<Scalars['String']['input']>;
};

export type VersionEdit = {
  isAndroidVersionForced: Scalars['Boolean']['input'];
  isBackendVersionForced?: InputMaybe<Scalars['Boolean']['input']>;
  isForAndroid: Scalars['Boolean']['input'];
  isForBackend?: InputMaybe<Scalars['Boolean']['input']>;
  isForIOS: Scalars['Boolean']['input'];
  isForWeb: Scalars['Boolean']['input'];
  isIOSVersionForced: Scalars['Boolean']['input'];
  isLatestVersionForAndroid: Scalars['Boolean']['input'];
  isLatestVersionForBackend?: InputMaybe<Scalars['Boolean']['input']>;
  isLatestVersionForIOS: Scalars['Boolean']['input'];
  isLatestVersionForWeb: Scalars['Boolean']['input'];
  isReleasedForAndroid: Scalars['Boolean']['input'];
  isReleasedForBackend?: InputMaybe<Scalars['Boolean']['input']>;
  isReleasedForIOS: Scalars['Boolean']['input'];
  isReleasedForWeb: Scalars['Boolean']['input'];
  isWebVersionForced: Scalars['Boolean']['input'];
  releaseNotes: Array<InputMaybe<ReleaseNoteEdit>>;
  versionId: Scalars['String']['input'];
  versionNo: Scalars['String']['input'];
};

export type VersionListOutput = {
  __typename?: 'versionListOutput';
  total?: Maybe<Scalars['Int']['output']>;
  versionList?: Maybe<Array<Maybe<VersionControlSystem>>>;
};

export type VersionReleaseNotes = {
  __typename?: 'versionReleaseNotes';
  isForAndroid?: Maybe<Scalars['Boolean']['output']>;
  isForIOS?: Maybe<Scalars['Boolean']['output']>;
  isForWeb?: Maybe<Scalars['Boolean']['output']>;
  releaseNoteId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ReleaseNotesTypes>;
};

export type WeekData = {
  __typename?: 'weekData';
  currentWeekDayCount?: Maybe<Scalars['Int']['output']>;
  days?: Maybe<Array<Maybe<StreakDay>>>;
  hasCompleted?: Maybe<Scalars['Boolean']['output']>;
  hasWeekPopUpBeenSent?: Maybe<Scalars['Boolean']['output']>;
  isBrokenWeek?: Maybe<Scalars['Boolean']['output']>;
  isCurrentWeek?: Maybe<Scalars['Boolean']['output']>;
  weekDisplayName?: Maybe<Scalars['String']['output']>;
  weekFooter?: Maybe<Scalars['String']['output']>;
  weekHeader?: Maybe<Scalars['String']['output']>;
  weekHeaderMessage?: Maybe<Scalars['String']['output']>;
  weekName?: Maybe<Scalars['String']['output']>;
  weekNumber?: Maybe<Scalars['Int']['output']>;
};

export type UserRecentSearchOutputFragment = { __typename?: 'UserRecentSearchOutput', isSaved?: boolean | null, searchId?: string | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubName?: string | null } | null, Hashtag?: { __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null } | null, Dollartag?: { __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null };

export type ClubFieldsFragment = { __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null };

export type CommentFieldsFragment = { __typename?: 'Comment', textV2?: string | null, hasReplies?: boolean | null, commentId?: string | null, isUpvoted?: number | null, isDownvoted?: number | null, isSuspected?: number | null, upvotecount?: number | null, downvotecount?: number | null, replycount?: number | null, createdAt: any, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null };

export type UpvoteDownvotePostFragment = { __typename?: 'Post', isUpvoted?: number | null, isDownvoted?: number | null, upvotecount?: number | null, downvotecount?: number | null };

export type UpdatePostFragment = { __typename?: 'Post', isUpvoted?: number | null, isDownvoted?: number | null, upvotecount?: number | null, downvotecount?: number | null, commentcount?: number | null, sharecount?: number | null };

export type BookmarkPostFragment = { __typename?: 'Post', isbookmarked?: number | null };

export type UpdateCommentFragment = { __typename?: 'Comment', isUpvoted?: number | null, isDownvoted?: number | null, upvotecount?: number | null, downvotecount?: number | null, replycount?: number | null };

export type UpdateReplyFragment = { __typename?: 'Reply', isUpvoted?: number | null, isDownvoted?: number | null, upvotecount?: number | null, downvotecount?: number | null };

export type DollarTagFieldsFragment = { __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null };

export type UpdatePollFragment = { __typename?: 'Poll', votes?: number | null, hasUserSelected?: boolean | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null };

export type StockFieldsFragment = { __typename?: 'Stock', securityId?: number | null, stockName?: string | null, slug?: string | null, isfollow?: number | null, issubscribed?: number | null };

export type UpdateUserFragment = { __typename?: 'User', isfollow?: string | null, issubscribed?: number | null, avatar?: any | null, cover?: any | null, profileType?: ProfileType | null };

export type UpdateStockFragment = { __typename?: 'Stock', isfollow?: number | null, issubscribed?: number | null, followers?: number | null };

export type UpdateHashtagFragment = { __typename?: 'Hashtag', isfollow?: number | null, issubscribed?: number | null, followers?: number | null };

export type UpdateClubFragment = { __typename?: 'Club', ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null };

export type GetPollFieldsFragment = { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null };

export type HashTagFieldsFragment = { __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null, postCount?: number | null, isfollow?: number | null, issubscribed?: number | null, followers?: number | null };

export type PostFieldsFragment = { __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null };

export type ReplyFieldsFragment = { __typename?: 'Reply', textV2?: string | null, replyId?: string | null, isUpvoted?: number | null, isDownvoted?: number | null, isSuspected?: number | null, createdAt: any, upvotecount?: number | null, downvotecount?: number | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null };

export type GetSharedPostFieldsFragment = { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null };

export type UserFieldsFragment = { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null };

export type SEsignupViaOidc_V2MutationVariables = Exact<{
  data: SignupUserInput;
  interimToken: Scalars['String']['input'];
  AcceptTerms?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SEsignupViaOidc_V2Mutation = { __typename?: 'Mutation', SEsignupViaOIDC_V2: { __typename?: 'userInfoFromIDP', isUserMemberOfStockEdgeClub?: boolean | null, error?: string | null, isViewOnly?: boolean | null, user?: { __typename?: 'User', id?: string | null, username?: string | null, showNpsV2?: boolean | null } | null, profileDetails?: { __typename?: 'userProfileDetailsFromIDP', Id?: string | null, UserName?: string | null, Email?: string | null, Firstname?: string | null, Lastname?: string | null, RegisteredOn?: string | null, Gender?: string | null, ImageFilePath?: string | null } | null } };

export type AccountSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type AccountSyncMutation = { __typename?: 'Mutation', accountSync?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type AddBadgeJourneyFeedbackMutationVariables = Exact<{
  questionResponse?: InputMaybe<Array<InputMaybe<FeedbackQuestionResponseInput>> | InputMaybe<FeedbackQuestionResponseInput>>;
}>;


export type AddBadgeJourneyFeedbackMutation = { __typename?: 'Mutation', addBadgeJourneyFeedback?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type AddGuidedTourStatusForUserMutationVariables = Exact<{
  visitedTourKeys?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>> | InputMaybe<Scalars['Float']['input']>>;
  tourComponent?: InputMaybe<Scalars['String']['input']>;
  tourSource?: InputMaybe<TourSourceType>;
}>;


export type AddGuidedTourStatusForUserMutation = { __typename?: 'Mutation', addGuidedTourStatusForUser?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type AddNotificationTokenMutationVariables = Exact<{
  notificationToken?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<DeviceType>;
}>;


export type AddNotificationTokenMutation = { __typename?: 'Mutation', addNotificationToken: { __typename?: 'IsSuccess', success?: boolean | null } };

export type AddNpsRatingForWebMutationVariables = Exact<{
  rating?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  RecaptchaToken: Scalars['String']['input'];
  platformType: DeviceType;
}>;


export type AddNpsRatingForWebMutation = { __typename?: 'Mutation', addNpsRatingForWeb?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type AddToRecentSearchMutationVariables = Exact<{
  data?: InputMaybe<Array<InputMaybe<UserRecentSearchInput>> | InputMaybe<UserRecentSearchInput>>;
}>;


export type AddToRecentSearchMutation = { __typename?: 'Mutation', addToRecentSearch?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type AddToSavedSearchMutationVariables = Exact<{
  data?: InputMaybe<Array<InputMaybe<UserRecentSearchInput>> | InputMaybe<UserRecentSearchInput>>;
}>;


export type AddToSavedSearchMutation = { __typename?: 'Mutation', addToSavedSearch?: { __typename?: 'UserRecentSearchOutput', searchId?: string | null, isSaved?: boolean | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null, Hashtag?: { __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null, postCount?: number | null, isfollow?: number | null, issubscribed?: number | null, followers?: number | null } | null, Dollartag?: { __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string } | null } | null };

export type BlockUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BlockUserMutation = { __typename?: 'Mutation', blockUser: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } };

export type CancelFollowMutationVariables = Exact<{
  data?: InputMaybe<FollowArgs>;
}>;


export type CancelFollowMutation = { __typename?: 'Mutation', cancelFollow: { __typename?: 'IsSuccess', success?: boolean | null } };

export type CancelFollowUserV2MutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CancelFollowUserV2Mutation = { __typename?: 'Mutation', cancelFollowUserV2?: { __typename?: 'User', id?: string | null, username?: string | null, isfollow?: string | null } | null };

export type ClearRecentSearchMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearRecentSearchMutation = { __typename?: 'Mutation', clearRecentSearch?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type CreateBookmarkMutationVariables = Exact<{
  data: CreateBookmark;
}>;


export type CreateBookmarkMutation = { __typename?: 'Mutation', createBookmark?: { __typename?: 'Bookmark', postId?: string | null, userId?: string | null, timestamp?: any | null } | null };

export type CreateCommentV2MutationVariables = Exact<{
  data?: InputMaybe<CommentInput>;
  clubId?: InputMaybe<Scalars['String']['input']>;
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCommentV2Mutation = { __typename?: 'Mutation', createCommentV2: { __typename?: 'Comment', textV2?: string | null, hasReplies?: boolean | null, commentId?: string | null, isUpvoted?: number | null, isDownvoted?: number | null, isSuspected?: number | null, upvotecount?: number | null, downvotecount?: number | null, replycount?: number | null, createdAt: any, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } };

export type CreateFeedbackMutationVariables = Exact<{
  data?: InputMaybe<FeedbackInput>;
}>;


export type CreateFeedbackMutation = { __typename?: 'Mutation', createFeedback?: { __typename?: 'Feedback', feedbackId?: string | null, type?: FeedbackTypeEnum | null, subject?: string | null, comment?: string | null, status?: FeedbackStatus | null, attachment?: { __typename?: 'Media', type: string, uri: any, name: string } | null } | null };

export type CreateNormalPostMutationVariables = Exact<{
  data?: InputMaybe<NormalPostInput>;
}>;


export type CreateNormalPostMutation = { __typename?: 'Mutation', createNormalPost?: { __typename?: 'PostOutput', post?: { __typename?: 'Post', postId?: string | null } | null } | null };

export type CreateQueryPostMutationVariables = Exact<{
  data?: InputMaybe<QueryInput>;
}>;


export type CreateQueryPostMutation = { __typename?: 'Mutation', createQueryPost?: { __typename?: 'PostOutput', post?: { __typename?: 'Post', postId?: string | null } | null } | null };

export type CreateReplyV2MutationVariables = Exact<{
  data?: InputMaybe<ReplyInput>;
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateReplyV2Mutation = { __typename?: 'Mutation', createReplyV2: { __typename?: 'Reply', textV2?: string | null, replyId?: string | null, isUpvoted?: number | null, isDownvoted?: number | null, isSuspected?: number | null, createdAt: any, upvotecount?: number | null, downvotecount?: number | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } };

export type CreateReportMutationVariables = Exact<{
  data?: InputMaybe<CreateReportInput>;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport?: { __typename?: 'ReportData', repId?: string | null, ReportId?: string | null, remark?: string | null, reportedBy?: string | null, reportedOn?: ReportedOn | null, reportTime?: any | null, reportType?: ReportType | null, reporter?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null } | null, Post?: { __typename?: 'Post', postId?: string | null, text?: string | null } | null, Comment?: { __typename?: 'Comment', commentId?: string | null, text?: string | null } | null, Reply?: { __typename?: 'Reply', replyId?: string | null, text?: string | null } | null } | null };

export type CreateStockIdeasPostMutationVariables = Exact<{
  data?: InputMaybe<StockIdeasInput>;
}>;


export type CreateStockIdeasPostMutation = { __typename?: 'Mutation', createStockIdeasPost?: { __typename?: 'PostOutput', message?: string | null, approvalRequestId?: string | null, post?: { __typename?: 'Post', postId?: string | null } | null } | null };

export type CreateZendeskTicketMutationVariables = Exact<{
  data?: InputMaybe<TicketInput>;
}>;


export type CreateZendeskTicketMutation = { __typename?: 'Mutation', createZendeskTicket?: any | null };

export type CreateZendeskTicketCommentMutationVariables = Exact<{
  data?: InputMaybe<TicketCommentInput>;
  ticketId: Scalars['Int']['input'];
}>;


export type CreateZendeskTicketCommentMutation = { __typename?: 'Mutation', createZendeskTicketComment?: Array<any | null> | null };

export type DeleteCommentMutationVariables = Exact<{
  data?: InputMaybe<CommentId>;
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: { __typename?: 'IsSuccess', success?: boolean | null } };

export type DeletePostMutationVariables = Exact<{
  data?: InputMaybe<DeletePostInput>;
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeletePostMutation = { __typename?: 'Mutation', deletePost: { __typename?: 'IsSuccess', success?: boolean | null } };

export type DeleteReplyMutationVariables = Exact<{
  data?: InputMaybe<ReplyId>;
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteReplyMutation = { __typename?: 'Mutation', deleteReply: { __typename?: 'IsSuccess', success?: boolean | null } };

export type DollarFollowMutationVariables = Exact<{
  dollarTagId: Scalars['String']['input'];
}>;


export type DollarFollowMutation = { __typename?: 'Mutation', dollarFollow?: { __typename?: 'DollarTag', dollarTagId: number, isfollow?: number | null, issubscribed?: number | null, followers?: number | null } | null };

export type DollarSubscribeMutationVariables = Exact<{
  dollarTagId: Scalars['String']['input'];
}>;


export type DollarSubscribeMutation = { __typename?: 'Mutation', dollarSubscribe?: { __typename?: 'DollarTag', dollarTagId: number, isfollow?: number | null, issubscribed?: number | null, followers?: number | null } | null };

export type DollarUnfollowMutationVariables = Exact<{
  dollarTagId: Scalars['String']['input'];
}>;


export type DollarUnfollowMutation = { __typename?: 'Mutation', dollarUnfollow?: { __typename?: 'DollarTag', dollarTagId: number, isfollow?: number | null, issubscribed?: number | null, followers?: number | null } | null };

export type DollarUnsubscribeMutationVariables = Exact<{
  dollarTagId: Scalars['String']['input'];
}>;


export type DollarUnsubscribeMutation = { __typename?: 'Mutation', dollarUnsubscribe?: { __typename?: 'DollarTag', dollarTagId: number, isfollow?: number | null, issubscribed?: number | null, followers?: number | null } | null };

export type EditNormalPostMutationVariables = Exact<{
  data?: InputMaybe<EditNormalPostInput>;
}>;


export type EditNormalPostMutation = { __typename?: 'Mutation', editNormalPost?: { __typename?: 'PostOutput', post?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, isEdited?: boolean | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null } | null } | null };

export type EditQueryMutationVariables = Exact<{
  data?: InputMaybe<EditQueryInput>;
}>;


export type EditQueryMutation = { __typename?: 'Mutation', editQuery?: { __typename?: 'PostOutput', post?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, isEdited?: boolean | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null } | null } | null };

export type EditStockIdeaMutationVariables = Exact<{
  data?: InputMaybe<EditStockIdeasInput>;
}>;


export type EditStockIdeaMutation = { __typename?: 'Mutation', editStockIdea?: { __typename?: 'PostOutput', post?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, isEdited?: boolean | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null } | null } | null };

export type ExecuteVisitedOnboardScreensMutationVariables = Exact<{
  data?: InputMaybe<ScreenResponseArgs>;
}>;


export type ExecuteVisitedOnboardScreensMutation = { __typename?: 'Mutation', executeVisitedOnboardScreens?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type FollowHashtagV2MutationVariables = Exact<{
  hashtagId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FollowHashtagV2Mutation = { __typename?: 'Mutation', followHashtagV2?: { __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null, isfollow?: number | null, issubscribed?: number | null } | null };

export type FollowPostMutationVariables = Exact<{
  data: FollowPostInput;
}>;


export type FollowPostMutation = { __typename?: 'Mutation', followPost?: { __typename?: 'FolowPostOutput', message?: string | null, post?: { __typename?: 'Post', postId?: string | null, isFollowed?: boolean | null } | null } | null };

export type FollowUserV2MutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FollowUserV2Mutation = { __typename?: 'Mutation', followUserV2?: { __typename?: 'User', id?: string | null, username?: string | null, isfollow?: string | null, followerCount?: number | null, followingCount?: number | null } | null };

export type HasSeenPopUpMutationVariables = Exact<{
  popUpType?: InputMaybe<Scalars['String']['input']>;
}>;


export type HasSeenPopUpMutation = { __typename?: 'Mutation', hasSeenPopUp?: { __typename?: 'PopUpSeen', success?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null } | null };

export type IgnoreNpsRatingMutationVariables = Exact<{
  source?: InputMaybe<NpsIgnoreSource>;
}>;


export type IgnoreNpsRatingMutation = { __typename?: 'Mutation', ignoreNpsRating?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type JoinClubV2MutationVariables = Exact<{
  data: JoinClubArgs;
}>;


export type JoinClubV2Mutation = { __typename?: 'Mutation', joinClubV2?: { __typename?: 'Club', clubId?: string | null, ismember?: string | null, totalMemberCount?: number | null } | null };

export type LeaveClubV2MutationVariables = Exact<{
  data: ClubInput;
}>;


export type LeaveClubV2Mutation = { __typename?: 'Mutation', leaveClubV2?: { __typename?: 'Club', clubId?: string | null, isFavourite?: boolean | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null } | null };

export type LoginWithOidc_V2MutationVariables = Exact<{
  accessToken: Scalars['String']['input'];
}>;


export type LoginWithOidc_V2Mutation = { __typename?: 'Mutation', loginWithOIDC_V2?: { __typename?: 'userInfoFromIDP', isUserMemberOfStockEdgeClub?: boolean | null, error?: string | null, interimToken?: string | null, isViewOnly?: boolean | null, user?: { __typename?: 'User', id?: string | null, username?: string | null, showNpsV2?: boolean | null } | null, profileDetails?: { __typename?: 'userProfileDetailsFromIDP', Id?: string | null, UserName?: string | null, Email?: string | null, Firstname?: string | null, Lastname?: string | null, RegisteredOn?: string | null, Gender?: string | null, ImageFilePath?: string | null } | null } | null };

export type MarkAsPinPostMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarkAsPinPostMutation = { __typename?: 'Mutation', markAsPinPost?: { __typename?: 'Post', isPinned?: boolean | null, isPinnedByUser?: boolean | null, postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null };

export type MarkClubAsFavouriteMutationVariables = Exact<{
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarkClubAsFavouriteMutation = { __typename?: 'Mutation', markClubAsFavourite?: { __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null };

export type OnboardUserMutationVariables = Exact<{
  typeOfUserByUserpreference?: InputMaybe<UserHashtagContentType>;
  dollarTagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  hashtagName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  skipOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OnboardUserMutation = { __typename?: 'Mutation', onboardUser?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type ReadAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadAllNotificationsMutation = { __typename?: 'Mutation', readAllNotifications?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type ReadNotificationMutationVariables = Exact<{
  notificationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReadNotificationMutation = { __typename?: 'Mutation', readNotification?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type RejectSuggestedSearchMutationVariables = Exact<{
  searchId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectSuggestedSearchMutation = { __typename?: 'Mutation', rejectSuggestedSearch?: { __typename?: 'UserSuggestedSearchOutput', searchId?: string | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubName?: string | null } | null, Hashtag?: { __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null } | null, Dollartag?: { __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null } | null };

export type RemoveBookmarkMutationVariables = Exact<{
  data?: InputMaybe<CreateBookmark>;
}>;


export type RemoveBookmarkMutation = { __typename?: 'Mutation', removeBookmark?: { __typename?: 'IsSuccess', success?: boolean | null } | null };

export type RemoveFromRecentSearchMutationVariables = Exact<{
  searchId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveFromRecentSearchMutation = { __typename?: 'Mutation', removeFromRecentSearch?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type RemoveFromSavedSearchMutationVariables = Exact<{
  searchId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveFromSavedSearchMutation = { __typename?: 'Mutation', removeFromSavedSearch?: { __typename?: 'UserRecentSearchOutput', searchId?: string | null, isSaved?: boolean | null } | null };

export type ResolveFollowMutationVariables = Exact<{
  followerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FollowStatus>;
}>;


export type ResolveFollowMutation = { __typename?: 'Mutation', resolveFollow: { __typename?: 'IsSuccess', success?: boolean | null } };

export type SelectPollOptionV2MutationVariables = Exact<{
  data?: InputMaybe<SelectPollOptionArgs>;
}>;


export type SelectPollOptionV2Mutation = { __typename?: 'Mutation', selectPollOptionV2?: { __typename?: 'Poll', pollId?: string | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null };

export type SetDefaultFeedMutationVariables = Exact<{
  feedTypeId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetDefaultFeedMutation = { __typename?: 'Mutation', setDefaultFeed?: { __typename?: 'FeedList', feedTypeId?: string | null, feedType?: string | null, feedDisplayName?: string | null, default?: boolean | null, showSmartFeed?: boolean | null } | null };

export type SharePostV4MutationVariables = Exact<{
  data?: InputMaybe<SharePostInput>;
}>;


export type SharePostV4Mutation = { __typename?: 'Mutation', sharePostV4: { __typename?: 'PostOutput', message?: string | null, approvalRequestId?: string | null, post?: { __typename?: 'Post', postId?: string | null } | null } };

export type ShareStockIdeaUpdateMutationVariables = Exact<{
  data?: InputMaybe<SharePostInput>;
}>;


export type ShareStockIdeaUpdateMutation = { __typename?: 'Mutation', shareStockIdeaUpdate: { __typename?: 'PostOutput', message?: string | null, approvalRequestId?: string | null, post?: { __typename?: 'Post', postId?: string | null } | null } };

export type ToggleDownvoteCommentMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ToggleDownvoteCommentMutation = { __typename?: 'Mutation', toggleDownvoteComment?: { __typename?: 'Comment', postId?: string | null, commentId?: string | null, upvotecount?: number | null, downvotecount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null } | null };

export type ToggleDownvotePostMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ToggleDownvotePostMutation = { __typename?: 'Mutation', toggleDownvotePost?: { __typename?: 'Post', postId?: string | null, upvotecount?: number | null, downvotecount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null } | null };

export type ToggleDownvoteReplyMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  replyId?: InputMaybe<Scalars['String']['input']>;
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ToggleDownvoteReplyMutation = { __typename?: 'Mutation', toggleDownvoteReply?: { __typename?: 'Reply', postId?: string | null, commentId?: string | null, replyId?: string | null, upvotecount?: number | null, downvotecount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null } | null };

export type ToggleIsWatchlistVisibleMutationVariables = Exact<{ [key: string]: never; }>;


export type ToggleIsWatchlistVisibleMutation = { __typename?: 'Mutation', toggleIsWatchlistVisible?: boolean | null };

export type ToggleSubscribeHashtagMutationVariables = Exact<{
  hashtagId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ToggleSubscribeHashtagMutation = { __typename?: 'Mutation', toggleSubscribeHashtag?: { __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null, isfollow?: number | null, issubscribed?: number | null } | null };

export type ToggleSubscribeUserMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ToggleSubscribeUserMutation = { __typename?: 'Mutation', toggleSubscribeUser?: { __typename?: 'User', id?: string | null, username?: string | null, issubscribed?: number | null } | null };

export type ToggleUpvoteCommentMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ToggleUpvoteCommentMutation = { __typename?: 'Mutation', toggleUpvoteComment?: { __typename?: 'Comment', postId?: string | null, commentId?: string | null, upvotecount?: number | null, downvotecount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null } | null };

export type ToggleUpvotePostMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ToggleUpvotePostMutation = { __typename?: 'Mutation', toggleUpvotePost?: { __typename?: 'Post', postId?: string | null, upvotecount?: number | null, downvotecount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null } | null };

export type ToggleUpvoteReplyMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  replyId?: InputMaybe<Scalars['String']['input']>;
  clubBasedPermissionToken?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ToggleUpvoteReplyMutation = { __typename?: 'Mutation', toggleUpvoteReply?: { __typename?: 'Reply', postId?: string | null, commentId?: string | null, replyId?: string | null, upvotecount?: number | null, downvotecount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null } | null };

export type TurnOffHighlightForAchievementMutationVariables = Exact<{
  achievementType?: InputMaybe<Scalars['String']['input']>;
}>;


export type TurnOffHighlightForAchievementMutation = { __typename?: 'Mutation', turnOffHighlightForAchievement?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type TurnOffNotificationByTypeOfNotificationMutationVariables = Exact<{
  notificationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TurnOffNotificationByTypeOfNotificationMutation = { __typename?: 'Mutation', turnOffNotificationByTypeOfNotification?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type UnPinPostMutationVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnPinPostMutation = { __typename?: 'Mutation', unPinPost?: { __typename?: 'Post', isPinned?: boolean | null, isPinnedByUser?: boolean | null, postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null };

export type UnblockUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UnblockUserMutation = { __typename?: 'Mutation', unblockUser: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } };

export type UnfollowHashtagV2MutationVariables = Exact<{
  hashtagId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UnfollowHashtagV2Mutation = { __typename?: 'Mutation', unfollowHashtagV2?: { __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null, isfollow?: number | null, issubscribed?: number | null } | null };

export type UnfollowPostMutationVariables = Exact<{
  data: FollowPostInput;
}>;


export type UnfollowPostMutation = { __typename?: 'Mutation', unfollowPost?: { __typename?: 'FolowPostOutput', message?: string | null, post?: { __typename?: 'Post', postId?: string | null, isFollowed?: boolean | null } | null } | null };

export type UnfollowUserV2MutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UnfollowUserV2Mutation = { __typename?: 'Mutation', unfollowUserV2?: { __typename?: 'User', id?: string | null, username?: string | null, isfollow?: string | null, followerCount?: number | null, followingCount?: number | null } | null };

export type UnmarkClubFavouriteMutationVariables = Exact<{
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnmarkClubFavouriteMutation = { __typename?: 'Mutation', unmarkClubFavourite?: { __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null };

export type UnreadNotificationMutationVariables = Exact<{
  notificationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnreadNotificationMutation = { __typename?: 'Mutation', unreadNotification?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type UpdateUserMutationVariables = Exact<{
  data: UserUpdateArgs;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, bio?: string | null } | null };

export type UpdateUserImageMutationVariables = Exact<{
  data: UserImageArgs;
}>;


export type UpdateUserImageMutation = { __typename?: 'Mutation', updateUserImage?: { __typename?: 'IsSuccess', success?: boolean | null } | null };

export type UpdateUserSettingsMutationVariables = Exact<{
  data: UpdateUserSettings;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateUserSettings?: { __typename?: 'ProfileSettings', profileType?: ProfileType | null } | null };

export type WithdrawApprovalRequestMutationVariables = Exact<{
  approvalRequestId: Scalars['String']['input'];
}>;


export type WithdrawApprovalRequestMutation = { __typename?: 'Mutation', withdrawApprovalRequest?: { __typename?: 'IsSuccess', success?: boolean | null, message?: string | null } | null };

export type ClubExpertStockSectorTopicFilterQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  clubId: Scalars['String']['input'];
}>;


export type ClubExpertStockSectorTopicFilterQuery = { __typename?: 'Query', getClubTrendingStocksViaDollarTag: Array<{ __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null>, getClubTrendingSectorsViaDollarTag: Array<{ __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null>, getClubTrendingHashtagsV2: Array<{ __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null, postCount?: number | null, isfollow?: number | null, issubscribed?: number | null, followers?: number | null } | null>, getPopularPeopleClubBased?: Array<{ __typename?: 'User', id?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, avatar?: any | null, isfollow?: string | null, membershipLevel?: number | null, isVerified?: boolean | null, greenTick?: boolean | null } | null> | null };

export type GetAnalystHighlightDetailsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAnalystHighlightDetailsQuery = { __typename?: 'Query', getAnalystHighlightDetails?: { __typename?: 'AnalystDetails', awards?: Array<string | null> | null, userId?: string | null, experience?: string | null, qualification?: string | null, sebiCertificate?: string | null, specializes?: string | null } | null };

export type CheckIfAddedToSavedSearchQueryVariables = Exact<{
  data?: InputMaybe<Array<InputMaybe<UserRecentSearchInput>> | InputMaybe<UserRecentSearchInput>>;
}>;


export type CheckIfAddedToSavedSearchQuery = { __typename?: 'Query', checkIfAddedToSavedSearch?: { __typename?: 'UserRecentSearchOutput', searchId?: string | null, isSaved?: boolean | null } | null };

export type CheckNewPostsByFeedTypeQueryVariables = Exact<{
  date?: InputMaybe<Scalars['String']['input']>;
  feedType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckNewPostsByFeedTypeQuery = { __typename?: 'Query', checkNewPostsByFeedType?: boolean | null };

export type FollowFollowingClubCountsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type FollowFollowingClubCountsQuery = { __typename?: 'Query', followers: number, followings: number, clubs: number };

export type GetAchievementDetailsQueryVariables = Exact<{
  achievementType?: InputMaybe<Scalars['String']['input']>;
  sourceOfClick?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAchievementDetailsQuery = { __typename?: 'Query', getAchievementDetails?: { __typename?: 'AchievementDetailsOutput', text1?: string | null, text2?: string | null, text3?: string | null, allowFeedback?: boolean | null, badgeDetails?: { __typename?: 'Badges', badgeName?: string | null, badgeId?: string | null, badgeIcon?: string | null, badgeType?: string | null } | null, share?: { __typename?: 'PromotionShareObj', text?: string | null, imageLink?: string | null, externalImageLink?: string | null, externalText?: string | null, ctaUrl?: string | null } | null } | null };

export type GetAllAchievementStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAchievementStatusQuery = { __typename?: 'Query', getAllAchievementStatus?: { __typename?: 'UserAchievemtStatusData', data?: Array<{ __typename?: 'userAllAchievementStatus', achievementType?: string | null, achievementName?: string | null, milestoneData?: Array<{ __typename?: 'MilestoneType', isMilestoneCompleted?: boolean | null, MilestoneName?: string | null, runningMilestone?: boolean | null } | null> | null } | null> | null, errorMessage?: { __typename?: 'ErrorMessage', errCode?: string | null, errMessage?: string | null } | null } | null };

export type GetApprovalRequestByIdQueryVariables = Exact<{
  approvalRequestId: Scalars['String']['input'];
}>;


export type GetApprovalRequestByIdQuery = { __typename?: 'Query', getApprovalRequestById?: { __typename?: 'ApprovalRequests', approvalRequestId?: string | null, clubId?: string | null, requestEntityType?: ApprovalRequestEntityType | null, ownerId?: string | null, requestStatus?: ApprovalRequestStatus | null, remarks?: string | null, actionTakenById?: string | null, createdAt?: any | null, updatedAt?: any | null, data?: { __typename?: 'ApprovalRequestDataOutput', postCategory: PostCategory, categoryDisplayName?: string | null, text?: string | null, clubId?: string | null, postId?: string | null, commentId?: string | null, sharePostId?: string | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, pollData?: { __typename?: 'createPollArgsOutput', question?: string | null, expiryEnum?: PollExpiryEnum | null, options?: Array<string | null> | null } | null, tags?: Array<{ __typename?: 'Tag', startIndex: string, endIndex: string, name: string, type: TagType, id?: string | null, slug?: string | null } | null> | null, sharedPostDetails?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null } | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, actionTakenBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } | null };

export type GetApprovalRequestsQueryVariables = Exact<{
  filter?: InputMaybe<ApprovalRequestStatus>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetApprovalRequestsQuery = { __typename?: 'Query', getApprovalRequests?: Array<{ __typename?: 'ApprovalRequests', approvalRequestId?: string | null, clubId?: string | null, requestEntityType?: ApprovalRequestEntityType | null, ownerId?: string | null, requestStatus?: ApprovalRequestStatus | null, remarks?: string | null, actionTakenById?: string | null, createdAt?: any | null, updatedAt?: any | null, data?: { __typename?: 'ApprovalRequestDataOutput', postCategory: PostCategory, categoryDisplayName?: string | null, text?: string | null, clubId?: string | null, postId?: string | null, commentId?: string | null, sharePostId?: string | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, pollData?: { __typename?: 'createPollArgsOutput', question?: string | null, expiryEnum?: PollExpiryEnum | null, options?: Array<string | null> | null } | null, tags?: Array<{ __typename?: 'Tag', startIndex: string, endIndex: string, name: string, type: TagType, id?: string | null, slug?: string | null } | null> | null, sharedPostDetails?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null } | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, actionTakenBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } | null> | null };

export type GetBadgeFeedbackQuestionQueryVariables = Exact<{
  badgeId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBadgeFeedbackQuestionQuery = { __typename?: 'Query', getBadgeFeedbackQuestion?: Array<{ __typename?: 'FeedbackQuestions', questionId?: string | null, questionText?: string | null, badgeId?: string | null, createdAt?: any | null, Badge?: { __typename?: 'Badges', badgeId?: string | null, badgeName?: string | null, description?: string | null, badgeIcon?: string | null, badgeType?: string | null } | null } | null> | null };

export type GetBadgesOfUserQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBadgesOfUserQuery = { __typename?: 'Query', getBadgesOfUser?: { __typename?: 'ListOfUserBadges', userBadgesList?: Array<{ __typename?: 'UserBadges', userId?: string | null, badgeId?: string | null, hasTurnedOffPromotion?: boolean | null, sourceOfClick?: string | null, achievementType?: string | null, Badges?: { __typename?: 'Badges', badgeId?: string | null, badgeName?: string | null, description?: string | null, badgeIcon?: string | null, badgeType?: string | null } | null } | null> | null, errorMessage?: { __typename?: 'ErrorMessage', errMessage?: string | null } | null } | null };

export type GetBlockedListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBlockedListQuery = { __typename?: 'Query', getBlockedList?: Array<{ __typename?: 'User', cover?: any | null, isfollow?: string | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null> | null };

export type GetBookmarkV2QueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetBookmarkV2Query = { __typename?: 'Query', getBookmarkV2?: Array<{ __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> | null };

export type GetBrokenStreakDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrokenStreakDetailsQuery = { __typename?: 'Query', getBrokenStreakDetails?: { __typename?: 'UserStreakData', data?: { __typename?: 'userStreak', userId?: string | null, prevStreak?: Array<{ __typename?: 'weekData', isCurrentWeek?: boolean | null, weekDisplayName?: string | null, hasCompleted?: boolean | null, currentWeekDayCount?: number | null, weekNumber?: number | null, weekHeader?: string | null, weekHeaderMessage?: string | null, isBrokenWeek?: boolean | null, weekFooter?: string | null, days?: Array<{ __typename?: 'streakDay', dayName?: string | null, dayDate?: any | null, hasVisited?: boolean | null, visitedState?: string | null } | null> | null } | null> | null } | null } | null };

export type GetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoriesQuery = { __typename?: 'Query', getCategories?: Array<{ __typename?: 'FeatureClubCategory', clubCategoryId?: string | null, clubCategoryName?: string | null, headline?: string | null, description?: string | null, priority?: number | null, icon?: string | null, cover?: string | null } | null> | null };

export type GetCategoryByIdQueryVariables = Exact<{
  clubCategoryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCategoryByIdQuery = { __typename?: 'Query', getCategoryById?: { __typename?: 'FeatureClubCategory', clubCategoryId?: string | null, clubCategoryName?: string | null, headline?: string | null, description?: string | null, priority?: number | null, icon?: string | null, cover?: string | null } | null };

export type GetClubQueryVariables = Exact<{
  clubId: Scalars['String']['input'];
}>;


export type GetClubQuery = { __typename?: 'Query', getClub?: { __typename?: 'Club', clubType?: ClubType | null, memberType?: string | null, rule?: string | null, clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null, viewFeedPermission?: { __typename?: 'ViewFeedPermission', canViewPost?: boolean | null, canSeeMarketingPost?: boolean | null } | null } | null };

export type GetClubCategoryListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClubCategoryListQuery = { __typename?: 'Query', getClubCategoryList?: Array<{ __typename?: 'FeatureClubCategory', clubCategoryId?: string | null, clubCategoryName?: string | null, headline?: string | null, description?: string | null, priority?: number | null, icon?: string | null, cover?: string | null } | null> | null };

export type GetClubListForSmartFeedQueryVariables = Exact<{
  data: Scalars['String']['input'];
}>;


export type GetClubListForSmartFeedQuery = { __typename?: 'Query', getClubListForSmartFeed?: Array<{ __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null> | null };

export type GetClubMarketingPostsQueryVariables = Exact<{
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClubMarketingPostsQuery = { __typename?: 'Query', getClubMarketingPosts?: Array<{ __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> | null };

export type GetClubMediaPostsQueryVariables = Exact<{
  data?: InputMaybe<ClubInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetClubMediaPostsQuery = { __typename?: 'Query', getClubMediaPosts: Array<{ __typename?: 'Post', postId?: string | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null } | null> };

export type GetClubPermissionsBasedOnFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClubPermissionsBasedOnFeaturesQuery = { __typename?: 'Query', getClubPermissionsBasedOnFeatures?: Array<{ __typename?: 'clubPermissionsAuthorizationDetails', clubId?: string | null, permissions?: Array<ClubPermissionsBasedOnMemberType | null> | null, club_permissions_token?: string | null } | null> | null };

export type ClubPostQueryVariables = Exact<{
  clubId: Scalars['String']['input'];
  preferredHashtagId?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type ClubPostQuery = { __typename?: 'Query', getClubPosts?: Array<{ __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> | null };

export type GetClubPostsSinceDateQueryVariables = Exact<{
  clubId: Scalars['String']['input'];
  since?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type GetClubPostsSinceDateQuery = { __typename?: 'Query', getClubPostsSinceDate?: { __typename?: 'PostListSinceDate', since?: string | null, posts?: Array<{ __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> | null } | null };

export type GetClubTrendingHashtagsV2QueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  clubId: Scalars['String']['input'];
}>;


export type GetClubTrendingHashtagsV2Query = { __typename?: 'Query', getClubTrendingHashtagsV2: Array<{ __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null, postCount?: number | null, isfollow?: number | null, issubscribed?: number | null, followers?: number | null } | null> };

export type GetClubTrendingSectorsViaDollarTagQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  clubId: Scalars['String']['input'];
}>;


export type GetClubTrendingSectorsViaDollarTagQuery = { __typename?: 'Query', getClubTrendingSectorsViaDollarTag: Array<{ __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null> };

export type GetClubTrendingStocksViaDollarTagQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  clubId: Scalars['String']['input'];
}>;


export type GetClubTrendingStocksViaDollarTagQuery = { __typename?: 'Query', getClubTrendingStocksViaDollarTag: Array<{ __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null> };

export type GetClubsByCategoryQueryVariables = Exact<{
  clubCategoryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClubsByCategoryQuery = { __typename?: 'Query', getClubsByCategory?: Array<{ __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null> | null };

export type GetClubsListForPlatformQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetClubsListForPlatformQuery = { __typename?: 'Query', getClubsListForPlatform?: Array<{ __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null> | null };

export type GetClubsOfUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  entitlement?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetClubsOfUserQuery = { __typename?: 'Query', getClubsOfUser?: Array<{ __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null> | null };

export type GetCommentsConnectionQueryVariables = Exact<{
  postId: Scalars['String']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  takeCursorElement?: InputMaybe<Scalars['Boolean']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCommentsConnectionQuery = { __typename?: 'Query', getCommentsConnection?: { __typename?: 'CommentConnection', edges: Array<{ __typename?: 'CommentEdge', cursor: string, node: { __typename?: 'Comment', textV2?: string | null, hasReplies?: boolean | null, commentId?: string | null, isUpvoted?: number | null, isDownvoted?: number | null, isSuspected?: number | null, upvotecount?: number | null, downvotecount?: number | null, replycount?: number | null, createdAt: any, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null } } | null };

export type GetDollarTagDetailsQueryVariables = Exact<{
  dollarTagId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDollarTagDetailsQuery = { __typename?: 'Query', getDollarTagDetails?: { __typename?: 'DollarTag', sourceEntityId?: string | null, dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null, viewFeedPermission?: { __typename?: 'ViewFeedPermission', canViewPost?: boolean | null, canSeeMarketingPost?: boolean | null } | null } | null };

export type GetDollarTagForSecurityIdQueryVariables = Exact<{
  securityId: Scalars['Int']['input'];
}>;


export type GetDollarTagForSecurityIdQuery = { __typename?: 'Query', getDollarTagForSecurityId?: { __typename?: 'DollarTag', dollarTagId: number, slug?: string | null, dollarTagType: DollarTagEnum } | null };

export type GetDollartagBySearchTextQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type GetDollartagBySearchTextQuery = { __typename?: 'Query', getDollartagBySearchText?: Array<{ __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum } | null> | null };

export type GetDollartagMarketingPostsQueryVariables = Exact<{
  dollarTagId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDollartagMarketingPostsQuery = { __typename?: 'Query', getDollartagMarketingPosts?: Array<{ __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> | null };

export type GetEditPostHistoryQueryVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type GetEditPostHistoryQuery = { __typename?: 'Query', getEditPostHistory?: Array<{ __typename?: 'EditHistoryData', text?: string | null, editedAt?: any | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', startIndex: string, endIndex: string, name: string, type: TagType, id?: string | null, slug?: string | null } | null> | null } | null> | null };

export type GetEditPostHistoryV2QueryVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type GetEditPostHistoryV2Query = { __typename?: 'Query', getEditPostHistoryV2?: Array<{ __typename?: 'EditedPost', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, editedAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, editHistory?: Array<{ __typename?: 'EditHistoryData', text?: string | null, editedAt?: any | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } | null> | null } | null> | null };

export type GetFavouriteClubsOfUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFavouriteClubsOfUserQuery = { __typename?: 'Query', getFavouriteClubsOfUser?: Array<{ __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null> | null };

export type GetFeatureToClubPermissionByIdQueryVariables = Exact<{
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFeatureToClubPermissionByIdQuery = { __typename?: 'Query', getFeatureToClubPermissionById?: { __typename?: 'clubPermissionsAuthorizationDetails', clubId?: string | null, permissions?: Array<ClubPermissionsBasedOnMemberType | null> | null, club_permissions_token?: string | null } | null };

export type GetFeatureToPlatformPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeatureToPlatformPermissionQuery = { __typename?: 'Query', getFeatureToPlatformPermission?: Array<PlatformPermissionFromFeatureTypes | null> | null };

export type GetFeedByTypeQueryVariables = Exact<{
  feedType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFeedByTypeQuery = { __typename?: 'Query', getFeedByType: Array<{ __typename?: 'ActivityFeed', actId?: string | null, activityId?: number | null, activityType?: string | null, createdAt?: any | null, avatar?: any | null, cover?: any | null, user?: { __typename?: 'UserFeedOutput', id?: string | null, firstName?: string | null, lastName?: string | null, avatar?: any | null, cover?: any | null, username?: string | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, profileType?: string | null } | null, followingUser?: { __typename?: 'UserFeedOutput', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, cover?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, profileType?: string | null } | null, club?: { __typename?: 'ClubFeedOutput', clubId?: string | null, clubHandle?: string | null, avatar?: any | null, cover?: any | null, clubName?: string | null } | null, followingHashtag?: { __typename?: 'HashtagFeedOutput', hashtagName?: string | null, hashtagType?: string | null } | null, followingStocktag?: { __typename?: 'StockFeedOutput', securityId?: string | null, stockName?: string | null, slug?: string | null, nseListingId?: string | null, bseListingId?: string | null } | null, post?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, comments?: Array<{ __typename?: 'Comment', textV2?: string | null, hasReplies?: boolean | null, commentId?: string | null, isUpvoted?: number | null, isDownvoted?: number | null, isSuspected?: number | null, upvotecount?: number | null, downvotecount?: number | null, replycount?: number | null, createdAt: any, replies?: Array<{ __typename?: 'Reply', textV2?: string | null, replyId?: string | null, isUpvoted?: number | null, isDownvoted?: number | null, isSuspected?: number | null, createdAt: any, upvotecount?: number | null, downvotecount?: number | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } | null> | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null } | null> };

export type GetFeedbackTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeedbackTypesQuery = { __typename?: 'Query', getFeedbackTypes?: Array<FeedbackTypeEnum | null> | null };

export type GetGuidedTourQueryVariables = Exact<{
  tourComponent?: InputMaybe<Scalars['String']['input']>;
  tourSource?: InputMaybe<TourSourceType>;
}>;


export type GetGuidedTourQuery = { __typename?: 'Query', getGuidedTour?: Array<{ __typename?: 'TourKeys', tourId?: string | null, tourComponent?: string | null, tourKey?: number | null, tourDescription?: string | null } | null> | null };

export type GetHashTagDetailsQueryVariables = Exact<{
  hashTagName?: InputMaybe<Scalars['String']['input']>;
  hashtagId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHashTagDetailsQuery = { __typename?: 'Query', getHashTagDetails: { __typename?: 'PostWithTag', discussions?: number | null, followers?: number | null, hashtag?: { __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null, hashtagType?: HashtagType | null, postCount?: number | null, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, viewFeedPermission?: { __typename?: 'ViewFeedPermission', canViewPost?: boolean | null, canSeeMarketingPost?: boolean | null } | null } | null } };

export type GetHashTagsUserTalksAboutQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetHashTagsUserTalksAboutQuery = { __typename?: 'Query', getHashTagsUserTalksAbout?: Array<{ __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null, isfollow?: number | null } | null> | null };

export type GetHashtagBySearchTextQueryVariables = Exact<{
  data?: InputMaybe<GetHashtagBySearchTextArgs>;
}>;


export type GetHashtagBySearchTextQuery = { __typename?: 'Query', getHashtagBySearchText: Array<{ __typename?: 'TrendingHashTag', Hashtag?: { __typename?: 'Hashtag', hashtagName?: string | null, hashtagType?: HashtagType | null } | null } | null> };

export type GetHashtagFollowingsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetHashtagFollowingsQuery = { __typename?: 'Query', getHashtagFollowings?: Array<{ __typename?: 'Hashtag', hashtagName?: string | null, postCount?: number | null, isfollow?: number | null, issubscribed?: number | null, followers?: number | null } | null> | null };

export type GetHashtagMarketingPostsQueryVariables = Exact<{
  hashTagName?: InputMaybe<Scalars['String']['input']>;
  hashtagId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHashtagMarketingPostsQuery = { __typename?: 'Query', getHashtagMarketingPosts?: Array<{ __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> | null };

export type GetHashtagsListBasedOnTypeOfContentQueryVariables = Exact<{
  typeOfContentMadeByHashtag?: InputMaybe<UserHashtagContentType>;
}>;


export type GetHashtagsListBasedOnTypeOfContentQuery = { __typename?: 'Query', getHashtagsListBasedOnTypeOfContent?: Array<{ __typename?: 'Hashtag', hashtagName?: string | null } | null> | null };

export type GetImportantProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetImportantProfilesQuery = { __typename?: 'Query', getImportantProfiles?: Array<{ __typename?: 'User', cover?: any | null, isfollow?: string | null, postCount?: number | null, followerCount?: number | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null> | null };

export type GetInterstitialsQueryVariables = Exact<{
  platformType: PlatformTypeForInterstitial;
}>;


export type GetInterstitialsQuery = { __typename?: 'Query', getInterstitials?: Array<{ __typename?: 'InterstitialsData', interstitialsId?: string | null, componentType?: ComponentType | null, position?: number | null, data?: string | null, title?: string | null } | null> | null };

export type GetListOfClubsWithPostPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListOfClubsWithPostPermissionQuery = { __typename?: 'Query', getListOfClubsWithPostPermission?: Array<{ __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null> | null };

export type GetListOfClubsWithQueryPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListOfClubsWithQueryPermissionQuery = { __typename?: 'Query', getListOfClubsWithQueryPermission?: Array<{ __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null> | null };

export type GetListOfClubsWithStockIdeaPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListOfClubsWithStockIdeaPermissionQuery = { __typename?: 'Query', getListOfClubsWithStockIdeaPermission?: Array<{ __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null> | null };

export type GetMarketExpertsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMarketExpertsQuery = { __typename?: 'Query', getMarketExperts?: Array<{ __typename?: 'User', cover?: any | null, isfollow?: string | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null> | null };

export type GetProfileMediaQueryVariables = Exact<{
  data?: InputMaybe<UserId>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProfileMediaQuery = { __typename?: 'Query', getMediaPosts: Array<{ __typename?: 'Post', postId?: string | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null } | null> };

export type GetMembersQueryVariables = Exact<{
  clubId: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMembersQuery = { __typename?: 'Query', getMembers?: Array<{ __typename?: 'User', cover?: any | null, isfollow?: string | null, followerCount?: number | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null> | null };

export type GetMultipleExternalResourceQueryVariables = Exact<{
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetMultipleExternalResourceQuery = { __typename?: 'Query', getMultipleExternalResource?: Array<{ __typename?: 'ExternalResource', id?: string | null, type?: string | null, value?: string | null } | null> | null };

export type GetMyFeedbacksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyFeedbacksQuery = { __typename?: 'Query', getMyFeedbacks?: Array<{ __typename?: 'Feedback', feedbackId?: string | null, type?: FeedbackTypeEnum | null, subject?: string | null, comment?: string | null, status?: FeedbackStatus | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, id?: string | null, username?: string | null, avatar?: any | null, cover?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null } | null, attachment?: { __typename?: 'Media', type: string, uri: any, name: string } | null } | null> | null };

export type GetNotificationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<NotificationFilter>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', getNotifications?: Array<{ __typename?: 'Notification', notificationId?: string | null, notificationType?: string | null, createdAt?: any | null, link?: string | null, message?: string | null, read?: boolean | null, isGeneratedByAdmin?: boolean | null, postId?: string | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Notifier?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubHandle?: string | null, clubId?: string | null, clubName?: string | null } | null } | null> | null };

export type UpdateNotificationFragment = { __typename?: 'Notification', read?: boolean | null };

export type GetOnboardScreenContentQueryVariables = Exact<{
  screenName?: InputMaybe<ScreenName>;
  input?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetOnboardScreenContentQuery = { __typename?: 'Query', getOnboardScreenContent?: any | null };

export type GetPeopleListForSmartFeedQueryVariables = Exact<{
  data: Scalars['String']['input'];
}>;


export type GetPeopleListForSmartFeedQuery = { __typename?: 'Query', getPeopleListForSmartFeed?: Array<{ __typename?: 'User', isfollow?: string | null, followerCount?: number | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null> | null };

export type GetPermissionToFeatureMappingListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPermissionToFeatureMappingListQuery = { __typename?: 'Query', getPermissionToFeatureMappingList?: { __typename?: 'ClubAndUtilityToFeatureOutput', clubFeatures?: Array<{ __typename?: 'clubFeaturesOutput', clubId?: string | null, features?: Array<string | null> | null } | null> | null, platformFeatures?: Array<{ __typename?: 'utilityFeaturesOutput', permission?: string | null, features?: Array<string | null> | null } | null> | null } | null };

export type GetPinnedPostQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPinnedPostQuery = { __typename?: 'Query', getPinnedPost?: Array<{ __typename?: 'Post', isPinned?: boolean | null, postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> | null };

export type GetPopUpQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPopUpQuery = { __typename?: 'Query', getPopUp?: { __typename?: 'PopUpData', data?: Array<{ __typename?: 'popUp', popUpType?: string | null, data?: string | null, popUpDelay?: number | null } | null> | null } | null };

export type GetPopularClubsInPlatformQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPopularClubsInPlatformQuery = { __typename?: 'Query', getPopularClubsInPlatform?: Array<{ __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null> | null };

export type GetPopularPeopleClubBasedQueryVariables = Exact<{
  clubId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPopularPeopleClubBasedQuery = { __typename?: 'Query', getPopularPeopleClubBased?: Array<{ __typename?: 'User', id?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, avatar?: any | null, isfollow?: string | null, membershipLevel?: number | null, isVerified?: boolean | null, greenTick?: boolean | null } | null> | null };

export type GetPopularUsersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPopularUsersQuery = { __typename?: 'Query', getPopularUsers?: Array<{ __typename?: 'User', cover?: any | null, isfollow?: string | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null> | null };

export type GetPostByDollarTagQueryVariables = Exact<{
  dollarTagId: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPostByDollarTagQuery = { __typename?: 'Query', getPostByDollarTag?: Array<{ __typename?: 'Post', topCommentId?: string | null, postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, comments?: Array<{ __typename?: 'Comment', isTopComment?: boolean | null, textV2?: string | null, hasReplies?: boolean | null, commentId?: string | null, isUpvoted?: number | null, isDownvoted?: number | null, isSuspected?: number | null, upvotecount?: number | null, downvotecount?: number | null, replycount?: number | null, createdAt: any, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> | null };

export type GetPostByDollarTagSinceDateQueryVariables = Exact<{
  dollarTagId: Scalars['Int']['input'];
  since?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type GetPostByDollarTagSinceDateQuery = { __typename?: 'Query', getPostByDollarTagSinceDate?: { __typename?: 'PostListSinceDate', since?: string | null, posts?: Array<{ __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> | null } | null };

export type GetPostByHashTagSinceDateQueryVariables = Exact<{
  hashTagName?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type GetPostByHashTagSinceDateQuery = { __typename?: 'Query', getPostByHashTagSinceDate?: { __typename?: 'PostListSinceDate', since?: string | null, posts?: Array<{ __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> | null } | null };

export type SinglePostQueryVariables = Exact<{
  data?: InputMaybe<PostId>;
}>;


export type SinglePostQuery = { __typename?: 'Query', getPostById: { __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, comments?: Array<{ __typename?: 'Comment', replycount?: number | null, postId?: string | null, commentId?: string | null, userId?: string | null, textV2?: string | null, isSuspected?: number | null, createdAt: any, updatedAt?: any | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatar?: any | null, cover?: any | null, greenTick?: boolean | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', startIndex: string, endIndex: string, name: string, type: TagType, id?: string | null, slug?: string | null } | null> | null, linkPreview?: { __typename?: 'LinkPreview', siteName?: string | null, images?: Array<string | null> | null, url?: string | null, description?: string | null, title?: string | null } | null, replies?: Array<{ __typename?: 'Reply', replyId?: string | null, postId?: string | null, userId?: string | null, commentId?: string | null, textV2?: string | null, isSuspected?: number | null, createdAt: any, updatedAt?: any | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatar?: any | null, cover?: any | null, greenTick?: boolean | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', startIndex: string, endIndex: string, name: string, type: TagType, id?: string | null, slug?: string | null } | null> | null, linkPreview?: { __typename?: 'LinkPreview', siteName?: string | null, images?: Array<string | null> | null, url?: string | null, description?: string | null, title?: string | null } | null } | null> | null } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } };

export type GetPostDetailsByIdQueryVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type GetPostDetailsByIdQuery = { __typename?: 'Query', getPostDetailsById?: { __typename?: 'PostDetails', post?: { __typename?: 'Post', postId?: string | null, postCategory?: PostCategory | null, textV2?: string | null, isEditable?: boolean | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null, User?: { __typename?: 'User', isfollow?: string | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null, totalMemberCount?: number | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null } | null, error?: { __typename?: 'ErrorMessage', errCode?: string | null, errMessage?: string | null, errLabel?: string | null } | null } | null };

export type GetPostPermissionsInAnyClubQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPostPermissionsInAnyClubQuery = { __typename?: 'Query', getPostPermissionsInAnyClub?: Array<PermissionsInAnyClub | null> | null };

export type GetPostsByFiltersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  filter: SearchPostsFilterArgs;
  clubId?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPostsByFiltersQuery = { __typename?: 'Query', getPostsByFilters?: { __typename?: 'FilteredPostListSinceDate', since?: string | null, hasMore?: boolean | null, posts?: Array<{ __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> | null } | null };

export type GetPostsByHashTagQueryVariables = Exact<{
  hashTagName?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
}>;


export type GetPostsByHashTagQuery = { __typename?: 'Query', getPostsByHashTag: { __typename?: 'PostWithTag', discussions?: number | null, followers?: number | null, hashtag?: { __typename?: 'Hashtag', hashtagName?: string | null, hashtagType?: HashtagType | null, postCount?: number | null, isfollow?: number | null, issubscribed?: number | null } | null, post?: Array<{ __typename?: 'Post', commentcount?: number | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, hasPoll?: boolean | null, clubId?: string | null, postId?: string | null, userId?: string | null, stockName?: string | null, target?: string | null, stopLoss?: string | null, ideaType?: IdeaType | null, text?: string | null, postType?: Array<string | null> | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, createdAt?: any | null, updatedAt?: any | null, sharePostId?: string | null, userShares?: Array<string | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', startIndex: string, endIndex: string, name: string, type: TagType, id?: string | null, slug?: string | null } | null> | null, linkPreview?: { __typename?: 'LinkPreview', siteName?: string | null, images?: Array<string | null> | null, url?: string | null, description?: string | null, title?: string | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null } | null> | null } };

export type GetPostsByHashTagV2QueryVariables = Exact<{
  hashTagName?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPostsByHashTagV2Query = { __typename?: 'Query', getPostsByHashTagV2: Array<{ __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> };

export type GetPostsConnectionByFilterQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: GlobalSearchForPosts;
}>;


export type GetPostsConnectionByFilterQuery = { __typename?: 'Query', getPostsConnectionByFilter?: { __typename?: 'PostConnection', pageInfo?: { __typename?: 'PageInfo', startCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ __typename?: 'PostEdge', cursor?: string | null, node?: { __typename?: 'Post', isPinned?: boolean | null, isPinnedByUser?: boolean | null, postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null } | null> | null } | null };

export type GetPowerUserStreakDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPowerUserStreakDetailsQuery = { __typename?: 'Query', getPowerUserStreakDetails?: { __typename?: 'UserStreakData', data?: { __typename?: 'userStreak', userId?: string | null, weekData?: Array<{ __typename?: 'weekData', isCurrentWeek?: boolean | null, weekDisplayName?: string | null, hasCompleted?: boolean | null, currentWeekDayCount?: number | null, weekNumber?: number | null, weekHeader?: string | null, weekHeaderMessage?: string | null, weekFooter?: string | null, days?: Array<{ __typename?: 'streakDay', dayName?: string | null, dayDate?: any | null, hasVisited?: boolean | null, visitedState?: string | null } | null> | null } | null> | null } | null } | null };

export type GetPreferredHashTagsUserTalksAboutQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPreferredHashTagsUserTalksAboutQuery = { __typename?: 'Query', getPreferredHashTagsUserTalksAbout?: Array<{ __typename?: 'Hashtag', hashtagName?: string | null, TagId?: string | null } | null> | null };

export type GetPreferredHashtagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreferredHashtagsQuery = { __typename?: 'Query', getPreferredHashtags?: Array<{ __typename?: 'Hashtag', hashtagName?: string | null, hashtagType?: HashtagType | null, followers?: number | null, TagId?: string | null, isfollow?: number | null, issubscribed?: number | null, postCount?: number | null, isPreferred?: boolean | null } | null> | null };

export type GetPreferredHashtagsByClubQueryVariables = Exact<{
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPreferredHashtagsByClubQuery = { __typename?: 'Query', getPreferredHashtagsByClub?: Array<{ __typename?: 'Hashtag', hashtagName?: string | null, TagId?: string | null } | null> | null };

export type ProfileInfoQueryVariables = Exact<{
  data?: InputMaybe<UserId>;
}>;


export type ProfileInfoQuery = { __typename?: 'Query', getProfileInfo?: { __typename?: 'User', profileType?: ProfileType | null, isfollow?: string | null, issubscribed?: number | null, followerCount?: number | null, followingCount?: number | null, cover?: any | null, bio?: string | null, watchlistVisibleStatus?: boolean | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null, viewFeedPermission?: { __typename?: 'ViewFeedPermission', canViewPost?: boolean | null, canSeeMarketingPost?: boolean | null } | null } | null };

export type GetProfileMarketingPostsQueryVariables = Exact<{
  data?: InputMaybe<UserId>;
}>;


export type GetProfileMarketingPostsQuery = { __typename?: 'Query', getProfileMarketingPosts?: Array<{ __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> | null };

export type GetProfilePostsSinceDateQueryVariables = Exact<{
  data?: InputMaybe<UserId>;
  since?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type GetProfilePostsSinceDateQuery = { __typename?: 'Query', getProfilePostsSinceDate?: { __typename?: 'PostListSinceDate', since?: string | null, posts?: Array<{ __typename?: 'Post', isPinned?: boolean | null, postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> | null } | null };

export type GetProfilePostsV2QueryVariables = Exact<{
  data?: InputMaybe<UserId>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetProfilePostsV2Query = { __typename?: 'Query', getProfilePostsV2: Array<{ __typename?: 'Post', isPinned?: boolean | null, postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> };

export type GetPromotionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPromotionQuery = { __typename?: 'Query', getPromotion?: { __typename?: 'Promotion', promotionId?: string | null, redirectURL?: string | null, imageURL?: string | null } | null };

export type GetPromotionForSmartFeedQueryVariables = Exact<{
  data: Scalars['String']['input'];
}>;


export type GetPromotionForSmartFeedQuery = { __typename?: 'Query', getPromotionForSmartFeed?: { __typename?: 'PromotionData', promotionId?: string | null, redirectURL?: string | null, shareableURL?: string | null, imageURL?: any | null } | null };

export type GetReactionsQueryVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  replyId?: InputMaybe<Scalars['String']['input']>;
  voteType?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetReactionsQuery = { __typename?: 'Query', getReactions?: Array<{ __typename?: 'Vote', voteId?: number | null, postId?: string | null, commentId?: string | null, replyId?: string | null, createdAt?: any | null, vote?: number | null, User?: { __typename?: 'User', isfollow?: string | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } | null> | null };

export type GetRecentSearchQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecentSearchQuery = { __typename?: 'Query', getRecentSearch?: Array<{ __typename?: 'UserRecentSearchOutput', isSaved?: boolean | null, searchId?: string | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubName?: string | null } | null, Hashtag?: { __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null } | null, Dollartag?: { __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null } | null> | null };

export type GetRecommendedPostsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetRecommendedPostsQuery = { __typename?: 'Query', getRecommendedPosts: Array<{ __typename?: 'ActivityFeed', actId?: string | null, activityId?: number | null, activityType?: string | null, createdAt?: any | null, avatar?: any | null, cover?: any | null, user?: { __typename?: 'UserFeedOutput', id?: string | null, firstName?: string | null, lastName?: string | null, avatar?: any | null, cover?: any | null, username?: string | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, profileType?: string | null } | null, followingUser?: { __typename?: 'UserFeedOutput', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, cover?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, profileType?: string | null } | null, club?: { __typename?: 'ClubFeedOutput', clubId?: string | null, clubHandle?: string | null, avatar?: any | null, cover?: any | null, clubName?: string | null } | null, followingHashtag?: { __typename?: 'HashtagFeedOutput', hashtagName?: string | null, hashtagType?: string | null } | null, followingStocktag?: { __typename?: 'StockFeedOutput', securityId?: string | null, stockName?: string | null, slug?: string | null, nseListingId?: string | null, bseListingId?: string | null } | null, post?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, comments?: Array<{ __typename?: 'Comment', textV2?: string | null, hasReplies?: boolean | null, commentId?: string | null, isUpvoted?: number | null, isDownvoted?: number | null, isSuspected?: number | null, upvotecount?: number | null, downvotecount?: number | null, replycount?: number | null, createdAt: any, replies?: Array<{ __typename?: 'Reply', textV2?: string | null, replyId?: string | null, isUpvoted?: number | null, isDownvoted?: number | null, isSuspected?: number | null, createdAt: any, upvotecount?: number | null, downvotecount?: number | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } | null> | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null } | null> };

export type GetReferBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReferBannerQuery = { __typename?: 'Query', getReferBanner?: string | null };

export type GetReferMsgQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReferMsgQuery = { __typename?: 'Query', getReferMsg?: { __typename?: 'ReferMsg', url?: string | null, message?: string | null } | null };

export type GetRepliesConnectionQueryVariables = Exact<{
  commentId: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  takeCursorElement?: InputMaybe<Scalars['Boolean']['input']>;
  replyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRepliesConnectionQuery = { __typename?: 'Query', getRepliesConnection?: { __typename?: 'ReplyConnection', edges?: Array<{ __typename?: 'ReplyEdge', cursor?: string | null, node: { __typename?: 'Reply', textV2?: string | null, replyId?: string | null, isUpvoted?: number | null, isDownvoted?: number | null, isSuspected?: number | null, createdAt: any, upvotecount?: number | null, downvotecount?: number | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } } | null> | null, pageInfo?: { __typename?: 'PageInfo', startCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, endCursor?: string | null } | null } | null };

export type GetReportTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportTypesQuery = { __typename?: 'Query', getReportTypes?: Array<ReportType | null> | null };

export type GetSavedSearchQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSavedSearchQuery = { __typename?: 'Query', getSavedSearch?: Array<{ __typename?: 'UserRecentSearchOutput', isSaved?: boolean | null, searchId?: string | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubName?: string | null } | null, Hashtag?: { __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null } | null, Dollartag?: { __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null } | null> | null };

export type GetScreensQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScreensQuery = { __typename?: 'Query', getScreens?: Array<{ __typename?: 'ScreenData', screenName?: ScreenName | null, priority?: number | null } | null> | null };

export type GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type GetSectorBySearchTextViaDollarTagForWatchlistQuery = { __typename?: 'Query', getSectorBySearchTextViaDollarTagForWatchlist?: Array<{ __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null> | null };

export type GetSectorListForSmartFeedQueryVariables = Exact<{
  data: Scalars['String']['input'];
}>;


export type GetSectorListForSmartFeedQuery = { __typename?: 'Query', getSectorListForSmartFeed?: Array<{ __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null> | null };

export type GetSectorsUserTalksAboutQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetSectorsUserTalksAboutQuery = { __typename?: 'Query', getSectorsUserTalksAbout?: Array<{ __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, isfollow?: number | null, dollarTagType: DollarTagEnum } | null> | null };

export type GetSelfFeedQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetSelfFeedQuery = { __typename?: 'Query', getSelfFeed: Array<{ __typename?: 'ActivityFeed', actId?: string | null, activityId?: number | null, activityType?: string | null, createdAt?: any | null, avatar?: any | null, cover?: any | null, user?: { __typename?: 'UserFeedOutput', id?: string | null, firstName?: string | null, lastName?: string | null, avatar?: any | null, username?: string | null, isVerified?: boolean | null, greenTick?: boolean | null, profileType?: string | null, tick3?: boolean | null } | null, followingUser?: { __typename?: 'UserFeedOutput', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, profileType?: string | null } | null, club?: { __typename?: 'ClubFeedOutput', clubId?: string | null, clubHandle?: string | null, avatar?: any | null, clubName?: string | null } | null, followingHashtag?: { __typename?: 'HashtagFeedOutput', hashtagName?: string | null, hashtagType?: string | null } | null, followingStocktag?: { __typename?: 'StockFeedOutput', securityId?: string | null, stockName?: string | null, slug?: string | null, nseListingId?: string | null, bseListingId?: string | null } | null, post?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, comments?: Array<{ __typename?: 'Comment', textV2?: string | null, hasReplies?: boolean | null, commentId?: string | null, isUpvoted?: number | null, isDownvoted?: number | null, isSuspected?: number | null, upvotecount?: number | null, downvotecount?: number | null, replycount?: number | null, createdAt: any, replies?: Array<{ __typename?: 'Reply', textV2?: string | null, replyId?: string | null, isUpvoted?: number | null, isDownvoted?: number | null, isSuspected?: number | null, createdAt: any, upvotecount?: number | null, downvotecount?: number | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } | null> | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null } | null> | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null } | null> };

export type GetShareFeedForPostQueryVariables = Exact<{
  postId: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetShareFeedForPostQuery = { __typename?: 'Query', getShareFeedForPost?: Array<{ __typename?: 'Post', postId?: string | null, textV2?: string | null, isEditable?: boolean | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, hasPoll?: boolean | null, createdAt?: any | null, upvotecount?: number | null, downvotecount?: number | null, sharecount?: number | null, commentcount?: number | null, isUpvoted?: number | null, isDownvoted?: number | null, isbookmarked?: number | null, isSuspected?: number | null, isEdited?: boolean | null, isFollowed?: boolean | null, sharePostId?: string | null, clubId?: string | null, userId?: string | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, canJoinClub?: boolean | null, showDisclaimer?: boolean | null, disclaimer?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, getSharedPost?: { __typename?: 'Post', postId?: string | null, textV2?: string | null, hasPoll?: boolean | null, createdAt?: any | null, isSuspected?: number | null, postSharePermissions?: Array<PostShareTypePermissions | null> | null, postCategory?: PostCategory | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, media?: Array<{ __typename?: 'Media', type: string, uri: any, name: string, height?: string | null, width?: string | null, rotation?: string | null } | null> | null, getPoll?: { __typename?: 'Poll', pollId?: string | null, question?: string | null, userId: string, postId?: string | null, createdAt?: any | null, updatedAt?: any | null, expiryEnum?: PollExpiryEnum | null, expiryDate?: any | null, hasUserSelected?: boolean | null, hasExpired?: boolean | null, votes?: number | null, options?: Array<{ __typename?: 'Option', optionId?: string | null, pollId?: string | null, optionText?: string | null, hasUserSelected?: boolean | null, votes?: number | null } | null> | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null, clubPostShareSetting?: { __typename?: 'clubPostShareSettingScheme', isVerifiedCanShare?: boolean | null, greenTickCanShare?: boolean | null, normalUserCanShare?: boolean | null } | null, meta?: { __typename?: 'Meta', isCover?: boolean | null, isAvatar?: boolean | null } | null, categoryDisplayDetails?: { __typename?: 'CategoryDisplayDetails', categoryDisplayName?: string | null } | null } | null> | null };

export type GetStockListForSmartFeedQueryVariables = Exact<{
  data: Scalars['String']['input'];
}>;


export type GetStockListForSmartFeedQuery = { __typename?: 'Query', getStockListForSmartFeed?: Array<{ __typename?: 'DollarTag', sourceEntityId?: string | null, dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null> | null };

export type GetStockTagDetailsQueryVariables = Exact<{
  securityId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStockTagDetailsQuery = { __typename?: 'Query', getStockTagDetails?: { __typename?: 'PostWithTag', discussions?: number | null, followers?: number | null, stock?: { __typename?: 'Stock', isfollow?: number | null, issubscribed?: number | null, stockName?: string | null, securityId?: number | null } | null } | null };

export type GetStocksBySearchTextForWatchlistQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetStocksBySearchTextForWatchlistQuery = { __typename?: 'Query', getStocksBySearchTextForWatchlist?: Array<{ __typename?: 'Stock', securityId?: number | null, stockName?: string | null, slug?: string | null, isfollow?: number | null } | null> | null };

export type GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type GetStocksBySearchTextViaDollarTagForWatchlistQuery = { __typename?: 'Query', getStocksBySearchTextViaDollarTagForWatchlist?: Array<{ __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null> | null };

export type GetStocksUserTalksAboutQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetStocksUserTalksAboutQuery = { __typename?: 'Query', getStocksUserTalksAbout?: Array<{ __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, isfollow?: number | null, dollarTagType: DollarTagEnum } | null> | null };

export type SuggestedPeopleQueryVariables = Exact<{ [key: string]: never; }>;


export type SuggestedPeopleQuery = { __typename?: 'Query', getSuggestedPeople?: Array<{ __typename?: 'User', cover?: any | null, isfollow?: string | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null> | null };

export type GetSuggestedSearchQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSuggestedSearchQuery = { __typename?: 'Query', getSuggestedSearch?: Array<{ __typename?: 'UserSuggestedSearchOutput', searchId?: string | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubName?: string | null } | null, Hashtag?: { __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null } | null, Dollartag?: { __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null } | null> | null };

export type GetTick3ExpertsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTick3ExpertsQuery = { __typename?: 'Query', getTick3Experts?: Array<{ __typename?: 'User', cover?: any | null, isfollow?: string | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null> | null };

export type GetTicketByIdQueryVariables = Exact<{
  ticketId: Scalars['Int']['input'];
}>;


export type GetTicketByIdQuery = { __typename?: 'Query', getTicketById?: any | null };

export type GetTopicListForSmartFeedQueryVariables = Exact<{
  data: Scalars['String']['input'];
}>;


export type GetTopicListForSmartFeedQuery = { __typename?: 'Query', getTopicListForSmartFeed?: Array<{ __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null, postCount?: number | null, isfollow?: number | null, issubscribed?: number | null, followers?: number | null } | null> | null };

export type GetTrendingHashTagsV2QueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTrendingHashTagsV2Query = { __typename?: 'Query', getTrendingHashTagsV2: Array<{ __typename?: 'Hashtag', TagId?: string | null, hashtagName?: string | null, postCount?: number | null, isfollow?: number | null, issubscribed?: number | null, followers?: number | null } | null> };

export type GetTrendingSectorsByDollarTagQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetTrendingSectorsByDollarTagQuery = { __typename?: 'Query', getTrendingSectorsByDollarTag?: Array<{ __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null> | null };

export type TrendingStocksQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type TrendingStocksQuery = { __typename?: 'Query', getTrendingStocks: Array<{ __typename?: 'TrendingStocktag', followers?: number | null, userAvatars?: Array<string | null> | null, stock?: { __typename?: 'Stock', securityId?: number | null, slug?: string | null, stockName?: string | null, postCount?: number | null, isfollow?: number | null, issubscribed?: number | null, bseListingId?: number | null, nseListingId?: number | null } | null } | null> };

export type GetTrendingStocksByDollarTagQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetTrendingStocksByDollarTagQuery = { __typename?: 'Query', getTrendingStocksByDollarTag?: Array<{ __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, isfollow?: number | null, issubscribed?: number | null, followers?: number | null, postCount?: number | null } | null> | null };

export type GetTrendingStocksV2QueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTrendingStocksV2Query = { __typename?: 'Query', getTrendingStocksV2: Array<{ __typename?: 'Stock', postCount?: number | null, followers?: number | null, securityId?: number | null, stockName?: string | null, slug?: string | null, isfollow?: number | null, issubscribed?: number | null } | null> };

export type GetTurnOffNotificationTextQueryVariables = Exact<{
  notificationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTurnOffNotificationTextQuery = { __typename?: 'Query', getTurnOffNotificationText?: string | null };

export type GetUniqueUsernameQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type GetUniqueUsernameQuery = { __typename?: 'Query', getUniqueUsername?: { __typename?: 'IsSuccess', success?: boolean | null } | null };

export type GetUpcomingEventsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUpcomingEventsQuery = { __typename?: 'Query', getUpcomingEvents?: Array<{ __typename?: 'UpcomingEventsList', eventId?: string | null, title?: string | null, imageUrl?: any | null, ctaButtonText?: string | null, ctaButtonUrl?: string | null, startTime?: any | null, endTime?: any | null, description?: string | null } | null> | null };

export type GetUserFeedTypeListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserFeedTypeListQuery = { __typename?: 'Query', getUserFeedTypeList?: Array<{ __typename?: 'FeedList', feedTypeId?: string | null, feedType?: string | null, feedDisplayName?: string | null, default?: boolean | null, showSmartFeed?: boolean | null } | null> | null };

export type GetUserFollowersQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetUserFollowersQuery = { __typename?: 'Query', getUserFollowers?: Array<{ __typename?: 'User', isfollow?: string | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null> | null };

export type GetUserFollowingsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetUserFollowingsQuery = { __typename?: 'Query', getUserFollowings?: Array<{ __typename?: 'User', isfollow?: string | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null> | null };

export type GetUserLevelNameFromSeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLevelNameFromSeQuery = { __typename?: 'Query', getUserLevelNameFromSE?: UserHashtagContentType | null };

export type GetUserListQueryVariables = Exact<{
  data?: InputMaybe<GetUserListArgs>;
}>;


export type GetUserListQuery = { __typename?: 'Query', getUserList: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null> };

export type GetUserWatchlistQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  type?: InputMaybe<DollarTagEnum>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserWatchlistQuery = { __typename?: 'Query', getUserWatchlist?: Array<{ __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum, sourceEntityId?: string | null, isfollow?: number | null } | null> | null };

export type GetVerifiedUsersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVerifiedUsersQuery = { __typename?: 'Query', getVerifiedUsers?: Array<{ __typename?: 'User', cover?: any | null, isfollow?: string | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null> | null };

export type GetVoterListQueryVariables = Exact<{
  pollId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVoterListQuery = { __typename?: 'Query', getVoterList?: Array<{ __typename?: 'User', isfollow?: string | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null> | null };

export type GetWatchListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetWatchListQuery = { __typename?: 'Query', getWatchlist?: Array<{ __typename?: 'Stock', securityId?: number | null, stockName?: string | null, slug?: string | null, isfollow?: number | null } | null> | null };

export type GetWatchlistCountQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetWatchlistCountQuery = { __typename?: 'Query', getWatchlistCount?: number | null };

export type GetWatchlistV2QueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<DollarTagEnum>;
}>;


export type GetWatchlistV2Query = { __typename?: 'Query', getWatchlistV2?: Array<{ __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, alias?: string | null, dollarTagType: DollarTagEnum, sourceEntityId?: string | null, sourceEntityIdType?: SourceEntityId | null, isfollow?: number | null, issubscribed?: number | null, followers?: number | null } | null> | null };

export type GetZendeskTicketCommentsQueryVariables = Exact<{
  ticketId: Scalars['Int']['input'];
}>;


export type GetZendeskTicketCommentsQuery = { __typename?: 'Query', getZendeskTicketComments?: Array<any | null> | null };

export type GetZendeskTicketTypeListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetZendeskTicketTypeListQuery = { __typename?: 'Query', getZendeskTicketTypeList?: Array<string | null> | null };

export type GetZendeskTicketsByUserQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filter?: InputMaybe<ZendeskSearchfilter>;
}>;


export type GetZendeskTicketsByUserQuery = { __typename?: 'Query', getZendeskTicketsByUser?: { __typename?: 'ZendeskTicketList', total?: number | null, tickets?: Array<any | null> | null } | null };

export type IsFeatureVisibleQueryVariables = Exact<{
  featureName?: InputMaybe<Scalars['String']['input']>;
}>;


export type IsFeatureVisibleQuery = { __typename?: 'Query', isFeatureVisible?: boolean | null };

export type IsReportQueryVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  replyId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['String']['input']>;
}>;


export type IsReportQuery = { __typename?: 'Query', getIsReported: boolean };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', profileType?: ProfileType | null, showNpsV2?: boolean | null, watchlistVisibleStatus?: boolean | null, hasUnderApprovalRequests?: boolean | null, id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null, viewFeedPermission?: { __typename?: 'ViewFeedPermission', canViewPost?: boolean | null, canSeeMarketingPost?: boolean | null } | null, highlightedAchievements?: Array<{ __typename?: 'HighlightedAchievements', achievementType?: string | null, sourceOfClick?: string | null, promotionImage?: string | null, promotionText?: string | null, badges?: { __typename?: 'Badges', badgeId?: string | null, badgeName?: string | null, badgeIcon?: string | null } | null } | null> | null } };

export type GetPopularClubsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPopularClubsQuery = { __typename?: 'Query', private?: Array<{ __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null> | null, paid?: Array<{ __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null> | null, public?: Array<{ __typename?: 'Club', clubId?: string | null, clubName?: string | null, clubHeadline?: string | null, clubHandle?: string | null, clubBio?: string | null, ownerId?: string | null, avatar?: any | null, cover?: any | null, ismember?: string | null, issubscribed?: number | null, totalMemberCount?: number | null, isDeactivated?: boolean | null, deactivationReason?: string | null, deactivatedAt?: any | null, disclaimer?: string | null, showDisclaimer?: boolean | null, canJoinClub?: boolean | null, displayCategoryName?: Array<string | null> | null, isFavourite?: boolean | null } | null> | null };

export type PostMoreMenuQueryVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type PostMoreMenuQuery = { __typename?: 'Query', isFollowed?: boolean | null, isBookmarked: boolean, isReported: boolean };

export type SearchStocksQueryVariables = Exact<{
  search: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchStocksQuery = { __typename?: 'Query', getStocksBySearchText: Array<{ __typename?: 'TrendingStocktag', stock?: { __typename?: 'Stock', securityId?: number | null, stockName?: string | null, slug?: string | null, postCount?: number | null, isfollow?: number | null, issubscribed?: number | null } | null } | null> };

export type SearchTopicQueryVariables = Exact<{
  search: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchTopicQuery = { __typename?: 'Query', getHashtagBySearchText: Array<{ __typename?: 'TrendingHashTag', userAvatars?: Array<string | null> | null, followers?: number | null, Hashtag?: { __typename?: 'Hashtag', hashtagName?: string | null, hashtagType?: HashtagType | null, postCount?: number | null, isfollow?: number | null, issubscribed?: number | null } | null } | null> };

export type SearchUserQueryVariables = Exact<{
  search: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchUserQuery = { __typename?: 'Query', getUserList: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, userTags?: string | null, avatar?: any | null, cover?: any | null, email?: string | null, phone?: string | null, bio?: string | null, isfollow?: string | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null } | null> };

export type ShowEventsDotQueryVariables = Exact<{ [key: string]: never; }>;


export type ShowEventsDotQuery = { __typename?: 'Query', showEventsDot?: boolean | null };

export type UnifiedSearchV2QueryVariables = Exact<{
  searchText: Scalars['String']['input'];
  type: SearchType;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UnifiedSearchV2Query = { __typename?: 'Query', unifiedSearchV2?: Array<{ __typename?: 'Search', hashtag?: { __typename?: 'HashTagSearch', followers?: number | null, hashtag?: { __typename?: 'Hashtag', hashtagName?: string | null, postCount?: number | null, TagId?: string | null } | null } | null, user?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, username?: string | null, avatar?: any | null, isVerified?: boolean | null, greenTick?: boolean | null, tick3?: boolean | null, isUserDeleted?: boolean | null, membershipLevel?: number | null } | null, club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null, avatar?: any | null, clubBio?: string | null } | null, dollarTag?: { __typename?: 'DollarTagSearch', dollarTag?: { __typename?: 'DollarTag', dollarTagId: number, dollarTagName: string, slug?: string | null, dollarTagType: DollarTagEnum } | null } | null } | null> | null };

export type GetChartPeriodsQueryVariables = Exact<{
  input?: InputMaybe<GetChartPeriodsInput>;
}>;


export type GetChartPeriodsQuery = { __typename?: 'Query', GetChartPeriods?: Array<{ __typename?: 'ChartPeriod', Code?: string | null, FromDate?: string | null, IntervalType?: number | null, Text?: string | null, Todate?: string | null, IsActive?: boolean | null } | null> | null };

export type GetCompanyEquityInfoQueryVariables = Exact<{
  input?: InputMaybe<GetCompanyEquityInfoInput>;
}>;


export type GetCompanyEquityInfoQuery = { __typename?: 'Query', GetCompanyEquityInfo?: { __typename?: 'CompanyEquityInfo', BookNavPerShare?: number | null, EPS?: number | null, FaceValue?: number | null, Fincode?: number | null, ID?: string | null, Industry?: string | null, IndustryID?: number | null, IndustryPE?: number | null, IndustrySlug?: string | null, MCAP?: number | null, NumberOfSharesSubscribed?: number | null, PE?: number | null, Price?: number | null, PriceToBookNavPerShare?: number | null, Sector?: string | null, SectorID?: number | null, SectorSlug?: string | null, Security?: string | null, SecuritySlug?: string | null, TTMEPS?: number | null, TTMNetProfit?: number | null, TTMPE?: number | null, TTMYearEnd?: number | null, Website?: string | null, YearEnd?: number | null, Yield?: number | null } | null };

export type GetCompanyEquityTypeInfoQueryVariables = Exact<{
  input?: InputMaybe<GetCompanyEquityTypeInfoInput>;
}>;


export type GetCompanyEquityTypeInfoQuery = { __typename?: 'Query', GetCompanyEquityTypeInfo?: Array<{ __typename?: 'CompanyEquityTypeInfo', ID?: string | null, StatementType?: string | null, YearEnd?: number | null, IsActive: boolean } | null> | null };

export type GetCompanyProfileForSecurityQueryVariables = Exact<{
  input?: InputMaybe<GetCompanyProfileForSecurityInput>;
}>;


export type GetCompanyProfileForSecurityQuery = { __typename?: 'Query', GetCompanyProfileForSecurity?: { __typename?: 'CompanyProfileForSecurity', ID?: string | null, Name?: string | null, ProfileText?: string | null, Slug?: string | null } | null };

export type GetIntradayPricesQueryVariables = Exact<{
  input?: InputMaybe<GetIntradayPricesInput>;
}>;


export type GetIntradayPricesQuery = { __typename?: 'Query', GetIntradayPrices?: Array<{ __typename?: 'ChartPrice', Close?: number | null, Date?: string | null, High?: number | null, Low?: number | null, Open?: number | null, TradeQuantity?: number | null } | null> | null };

export type GetLatestListingPriceQueryVariables = Exact<{
  input?: InputMaybe<GetLatestListingPriceInput>;
}>;


export type GetLatestListingPriceQuery = { __typename?: 'Query', GetLatestListingPrice?: { __typename?: 'ListingPrice', C?: number | null, C1?: number | null, CZ?: number | null, CZG?: number | null, Date?: string | null, H?: number | null, L?: number | null, O?: number | null, TQ?: number | null } | null };

export type GetListingsForSecurityQueryVariables = Exact<{
  input?: InputMaybe<GetListingsForSecurityInput>;
}>;


export type GetListingsForSecurityQuery = { __typename?: 'Query', GetListingsForSecurity?: Array<{ __typename?: 'Exchange', Exchange?: number | null, ExchangeName?: string | null, ListingID?: number | null, SecurityID?: number | null, SecurityName?: string | null, ShortName?: string | null, Symbol?: string | null, IsActive: boolean } | null> | null };

export type GetPricesQueryVariables = Exact<{
  input?: InputMaybe<GetPricesInput>;
}>;


export type GetPricesQuery = { __typename?: 'Query', GetPrices?: Array<{ __typename?: 'ChartPrice', Close?: number | null, Date?: string | null, High?: number | null, Low?: number | null, Open?: number | null, TradeQuantity?: number | null } | null> | null };

export type NewActivityCountSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type NewActivityCountSubscription = { __typename?: 'Subscription', newActivityCount: number };

export type NotificationCreatedSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
  type: Type;
}>;


export type NotificationCreatedSubscription = { __typename?: 'Subscription', notificationCreated?: { __typename?: 'Notification', message?: string | null, link?: string | null, notificationId?: string | null, notificationType?: string | null, createdAt?: any | null, userId?: string | null, User?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatar?: any | null, username?: string | null } | null, Club?: { __typename?: 'Club', clubId?: string | null, clubHandle?: string | null, clubName?: string | null } | null, Notifier?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, avatar?: any | null, username?: string | null } | null } | null };

export type NotificationCountSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type NotificationCountSubscription = { __typename?: 'Subscription', counts: number };

export type UnderApprovalCountSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UnderApprovalCountSubscription = { __typename?: 'Subscription', underApprovalCount: number };

export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  firstName
  lastName
  username
  avatar
  isVerified
  greenTick
  tick3
  isUserDeleted
  membershipLevel
}
    `;
export const DollarTagFieldsFragmentDoc = gql`
    fragment DollarTagFields on DollarTag {
  dollarTagId
  dollarTagName
  slug
  dollarTagType
  isfollow
  issubscribed
  followers
  postCount
}
    `;
export const UserRecentSearchOutputFragmentDoc = gql`
    fragment UserRecentSearchOutput on UserRecentSearchOutput {
  isSaved
  searchId
  User {
    ...UserFields
  }
  Club {
    clubId
    clubName
  }
  Hashtag {
    TagId
    hashtagName
  }
  Dollartag {
    ...DollarTagFields
  }
}
    ${UserFieldsFragmentDoc}
${DollarTagFieldsFragmentDoc}`;
export const ClubFieldsFragmentDoc = gql`
    fragment ClubFields on Club {
  clubId
  clubName
  clubHeadline
  clubHandle
  clubBio
  ownerId
  avatar
  cover
  ismember
  issubscribed
  totalMemberCount
  isDeactivated
  deactivationReason
  deactivatedAt
  disclaimer
  showDisclaimer
  canJoinClub
  displayCategoryName
  isDeactivated
  deactivatedAt
  deactivationReason
  isFavourite
}
    `;
export const CommentFieldsFragmentDoc = gql`
    fragment CommentFields on Comment {
  textV2
  hasReplies
  media {
    type
    uri
    name
  }
  commentId
  isUpvoted
  isDownvoted
  isSuspected
  upvotecount
  downvotecount
  replycount
  createdAt
  User {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const UpvoteDownvotePostFragmentDoc = gql`
    fragment UpvoteDownvotePost on Post {
  isUpvoted
  isDownvoted
  upvotecount
  downvotecount
}
    `;
export const UpdatePostFragmentDoc = gql`
    fragment UpdatePost on Post {
  isUpvoted
  isDownvoted
  upvotecount
  downvotecount
  commentcount
  sharecount
}
    `;
export const BookmarkPostFragmentDoc = gql`
    fragment BookmarkPost on Post {
  isbookmarked
}
    `;
export const UpdateCommentFragmentDoc = gql`
    fragment UpdateComment on Comment {
  isUpvoted
  isDownvoted
  upvotecount
  downvotecount
  replycount
}
    `;
export const UpdateReplyFragmentDoc = gql`
    fragment UpdateReply on Reply {
  isUpvoted
  isDownvoted
  upvotecount
  downvotecount
}
    `;
export const UpdatePollFragmentDoc = gql`
    fragment UpdatePoll on Poll {
  votes
  hasUserSelected
  options {
    optionId
    pollId
    optionText
    hasUserSelected
    votes
  }
}
    `;
export const StockFieldsFragmentDoc = gql`
    fragment StockFields on Stock {
  securityId
  stockName
  slug
  isfollow
  issubscribed
}
    `;
export const UpdateUserFragmentDoc = gql`
    fragment UpdateUser on User {
  isfollow
  issubscribed
  avatar
  cover
  profileType
}
    `;
export const UpdateStockFragmentDoc = gql`
    fragment UpdateStock on Stock {
  isfollow
  issubscribed
  followers
}
    `;
export const UpdateHashtagFragmentDoc = gql`
    fragment UpdateHashtag on Hashtag {
  isfollow
  issubscribed
  followers
}
    `;
export const UpdateClubFragmentDoc = gql`
    fragment UpdateClub on Club {
  ismember
  issubscribed
  totalMemberCount
}
    `;
export const HashTagFieldsFragmentDoc = gql`
    fragment HashTagFields on Hashtag {
  TagId
  hashtagName
  postCount
  isfollow
  issubscribed
  followers
}
    `;
export const GetPollFieldsFragmentDoc = gql`
    fragment GetPollFields on Poll {
  pollId
  question
  userId
  postId
  createdAt
  updatedAt
  expiryEnum
  expiryDate
  hasUserSelected
  hasExpired
  votes
  options {
    optionId
    pollId
    optionText
    hasUserSelected
    votes
  }
}
    `;
export const GetSharedPostFieldsFragmentDoc = gql`
    fragment GetSharedPostFields on Post {
  postId
  User {
    ...UserFields
  }
  Club {
    clubId
    clubHandle
    clubName
  }
  media {
    type
    uri
    name
    height
    width
    rotation
  }
  textV2
  hasPoll
  getPoll {
    ...GetPollFields
  }
  createdAt
  isSuspected
  clubPostShareSetting {
    isVerifiedCanShare
    greenTickCanShare
    normalUserCanShare
  }
  postSharePermissions
  postCategory
  categoryDisplayDetails {
    categoryDisplayName
  }
}
    ${UserFieldsFragmentDoc}
${GetPollFieldsFragmentDoc}`;
export const PostFieldsFragmentDoc = gql`
    fragment PostFields on Post {
  postId
  User {
    ...UserFields
  }
  Club {
    clubId
    clubHandle
    clubName
    canJoinClub
    showDisclaimer
    disclaimer
  }
  media {
    type
    uri
    name
    height
    width
    rotation
  }
  textV2
  isEditable
  postSharePermissions
  hasPoll
  getPoll {
    ...GetPollFields
  }
  createdAt
  upvotecount
  downvotecount
  sharecount
  commentcount
  isUpvoted
  isDownvoted
  isbookmarked
  isSuspected
  isEdited
  isFollowed
  sharePostId
  clubId
  userId
  getSharedPost {
    ...GetSharedPostFields
  }
  clubPostShareSetting {
    isVerifiedCanShare
    greenTickCanShare
    normalUserCanShare
  }
  meta {
    isCover
    isAvatar
  }
  postCategory
  categoryDisplayDetails {
    categoryDisplayName
  }
}
    ${UserFieldsFragmentDoc}
${GetPollFieldsFragmentDoc}
${GetSharedPostFieldsFragmentDoc}`;
export const ReplyFieldsFragmentDoc = gql`
    fragment ReplyFields on Reply {
  textV2
  media {
    type
    uri
    name
  }
  replyId
  isUpvoted
  isDownvoted
  isSuspected
  createdAt
  upvotecount
  downvotecount
  User {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const UpdateNotificationFragmentDoc = gql`
    fragment UpdateNotification on Notification {
  read
}
    `;
export const SEsignupViaOidc_V2Document = gql`
    mutation SEsignupViaOIDC_V2($data: SignupUserInput!, $interimToken: String!, $AcceptTerms: Boolean) {
  SEsignupViaOIDC_V2(
    data: $data
    interimToken: $interimToken
    AcceptTerms: $AcceptTerms
  ) {
    isUserMemberOfStockEdgeClub
    error
    user {
      id
      username
      showNpsV2
    }
    isViewOnly
    profileDetails {
      Id
      UserName
      Email
      Firstname
      Lastname
      RegisteredOn
      Gender
      ImageFilePath
    }
  }
}
    `;
export type SEsignupViaOidc_V2MutationFn = Apollo.MutationFunction<SEsignupViaOidc_V2Mutation, SEsignupViaOidc_V2MutationVariables>;

/**
 * __useSEsignupViaOidc_V2Mutation__
 *
 * To run a mutation, you first call `useSEsignupViaOidc_V2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSEsignupViaOidc_V2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sEsignupViaOidcV2Mutation, { data, loading, error }] = useSEsignupViaOidc_V2Mutation({
 *   variables: {
 *      data: // value for 'data'
 *      interimToken: // value for 'interimToken'
 *      AcceptTerms: // value for 'AcceptTerms'
 *   },
 * });
 */
export function useSEsignupViaOidc_V2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SEsignupViaOidc_V2Mutation, SEsignupViaOidc_V2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SEsignupViaOidc_V2Mutation, SEsignupViaOidc_V2MutationVariables>(SEsignupViaOidc_V2Document, options);
      }
export type SEsignupViaOidc_V2MutationHookResult = ReturnType<typeof useSEsignupViaOidc_V2Mutation>;
export type SEsignupViaOidc_V2MutationResult = Apollo.MutationResult<SEsignupViaOidc_V2Mutation>;
export type SEsignupViaOidc_V2MutationOptions = Apollo.BaseMutationOptions<SEsignupViaOidc_V2Mutation, SEsignupViaOidc_V2MutationVariables>;
export const AccountSyncDocument = gql`
    mutation accountSync {
  accountSync {
    success
    message
  }
}
    `;
export type AccountSyncMutationFn = Apollo.MutationFunction<AccountSyncMutation, AccountSyncMutationVariables>;

/**
 * __useAccountSyncMutation__
 *
 * To run a mutation, you first call `useAccountSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSyncMutation, { data, loading, error }] = useAccountSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useAccountSyncMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AccountSyncMutation, AccountSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AccountSyncMutation, AccountSyncMutationVariables>(AccountSyncDocument, options);
      }
export type AccountSyncMutationHookResult = ReturnType<typeof useAccountSyncMutation>;
export type AccountSyncMutationResult = Apollo.MutationResult<AccountSyncMutation>;
export type AccountSyncMutationOptions = Apollo.BaseMutationOptions<AccountSyncMutation, AccountSyncMutationVariables>;
export const AddBadgeJourneyFeedbackDocument = gql`
    mutation addBadgeJourneyFeedback($questionResponse: [FeedbackQuestionResponseInput]) {
  addBadgeJourneyFeedback(questionResponse: $questionResponse) {
    success
    message
  }
}
    `;
export type AddBadgeJourneyFeedbackMutationFn = Apollo.MutationFunction<AddBadgeJourneyFeedbackMutation, AddBadgeJourneyFeedbackMutationVariables>;

/**
 * __useAddBadgeJourneyFeedbackMutation__
 *
 * To run a mutation, you first call `useAddBadgeJourneyFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBadgeJourneyFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBadgeJourneyFeedbackMutation, { data, loading, error }] = useAddBadgeJourneyFeedbackMutation({
 *   variables: {
 *      questionResponse: // value for 'questionResponse'
 *   },
 * });
 */
export function useAddBadgeJourneyFeedbackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddBadgeJourneyFeedbackMutation, AddBadgeJourneyFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddBadgeJourneyFeedbackMutation, AddBadgeJourneyFeedbackMutationVariables>(AddBadgeJourneyFeedbackDocument, options);
      }
export type AddBadgeJourneyFeedbackMutationHookResult = ReturnType<typeof useAddBadgeJourneyFeedbackMutation>;
export type AddBadgeJourneyFeedbackMutationResult = Apollo.MutationResult<AddBadgeJourneyFeedbackMutation>;
export type AddBadgeJourneyFeedbackMutationOptions = Apollo.BaseMutationOptions<AddBadgeJourneyFeedbackMutation, AddBadgeJourneyFeedbackMutationVariables>;
export const AddGuidedTourStatusForUserDocument = gql`
    mutation addGuidedTourStatusForUser($visitedTourKeys: [Float], $tourComponent: String, $tourSource: TourSourceType) {
  addGuidedTourStatusForUser(
    visitedTourKeys: $visitedTourKeys
    tourComponent: $tourComponent
    tourSource: $tourSource
  ) {
    success
    message
  }
}
    `;
export type AddGuidedTourStatusForUserMutationFn = Apollo.MutationFunction<AddGuidedTourStatusForUserMutation, AddGuidedTourStatusForUserMutationVariables>;

/**
 * __useAddGuidedTourStatusForUserMutation__
 *
 * To run a mutation, you first call `useAddGuidedTourStatusForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGuidedTourStatusForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGuidedTourStatusForUserMutation, { data, loading, error }] = useAddGuidedTourStatusForUserMutation({
 *   variables: {
 *      visitedTourKeys: // value for 'visitedTourKeys'
 *      tourComponent: // value for 'tourComponent'
 *      tourSource: // value for 'tourSource'
 *   },
 * });
 */
export function useAddGuidedTourStatusForUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddGuidedTourStatusForUserMutation, AddGuidedTourStatusForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddGuidedTourStatusForUserMutation, AddGuidedTourStatusForUserMutationVariables>(AddGuidedTourStatusForUserDocument, options);
      }
export type AddGuidedTourStatusForUserMutationHookResult = ReturnType<typeof useAddGuidedTourStatusForUserMutation>;
export type AddGuidedTourStatusForUserMutationResult = Apollo.MutationResult<AddGuidedTourStatusForUserMutation>;
export type AddGuidedTourStatusForUserMutationOptions = Apollo.BaseMutationOptions<AddGuidedTourStatusForUserMutation, AddGuidedTourStatusForUserMutationVariables>;
export const AddNotificationTokenDocument = gql`
    mutation AddNotificationToken($notificationToken: String, $deviceType: DeviceType) {
  addNotificationToken(
    notificationToken: $notificationToken
    deviceType: $deviceType
  ) {
    success
  }
}
    `;
export type AddNotificationTokenMutationFn = Apollo.MutationFunction<AddNotificationTokenMutation, AddNotificationTokenMutationVariables>;

/**
 * __useAddNotificationTokenMutation__
 *
 * To run a mutation, you first call `useAddNotificationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNotificationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNotificationTokenMutation, { data, loading, error }] = useAddNotificationTokenMutation({
 *   variables: {
 *      notificationToken: // value for 'notificationToken'
 *      deviceType: // value for 'deviceType'
 *   },
 * });
 */
export function useAddNotificationTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddNotificationTokenMutation, AddNotificationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddNotificationTokenMutation, AddNotificationTokenMutationVariables>(AddNotificationTokenDocument, options);
      }
export type AddNotificationTokenMutationHookResult = ReturnType<typeof useAddNotificationTokenMutation>;
export type AddNotificationTokenMutationResult = Apollo.MutationResult<AddNotificationTokenMutation>;
export type AddNotificationTokenMutationOptions = Apollo.BaseMutationOptions<AddNotificationTokenMutation, AddNotificationTokenMutationVariables>;
export const AddNpsRatingForWebDocument = gql`
    mutation addNpsRatingForWeb($rating: Int, $reason: String, $RecaptchaToken: String!, $platformType: DeviceType!) {
  addNpsRatingForWeb(
    rating: $rating
    reason: $reason
    RecaptchaToken: $RecaptchaToken
    platformType: $platformType
  ) {
    success
    message
  }
}
    `;
export type AddNpsRatingForWebMutationFn = Apollo.MutationFunction<AddNpsRatingForWebMutation, AddNpsRatingForWebMutationVariables>;

/**
 * __useAddNpsRatingForWebMutation__
 *
 * To run a mutation, you first call `useAddNpsRatingForWebMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNpsRatingForWebMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNpsRatingForWebMutation, { data, loading, error }] = useAddNpsRatingForWebMutation({
 *   variables: {
 *      rating: // value for 'rating'
 *      reason: // value for 'reason'
 *      RecaptchaToken: // value for 'RecaptchaToken'
 *      platformType: // value for 'platformType'
 *   },
 * });
 */
export function useAddNpsRatingForWebMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddNpsRatingForWebMutation, AddNpsRatingForWebMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddNpsRatingForWebMutation, AddNpsRatingForWebMutationVariables>(AddNpsRatingForWebDocument, options);
      }
export type AddNpsRatingForWebMutationHookResult = ReturnType<typeof useAddNpsRatingForWebMutation>;
export type AddNpsRatingForWebMutationResult = Apollo.MutationResult<AddNpsRatingForWebMutation>;
export type AddNpsRatingForWebMutationOptions = Apollo.BaseMutationOptions<AddNpsRatingForWebMutation, AddNpsRatingForWebMutationVariables>;
export const AddToRecentSearchDocument = gql`
    mutation addToRecentSearch($data: [UserRecentSearchInput]) {
  addToRecentSearch(data: $data) {
    success
    message
  }
}
    `;
export type AddToRecentSearchMutationFn = Apollo.MutationFunction<AddToRecentSearchMutation, AddToRecentSearchMutationVariables>;

/**
 * __useAddToRecentSearchMutation__
 *
 * To run a mutation, you first call `useAddToRecentSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToRecentSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToRecentSearchMutation, { data, loading, error }] = useAddToRecentSearchMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddToRecentSearchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddToRecentSearchMutation, AddToRecentSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddToRecentSearchMutation, AddToRecentSearchMutationVariables>(AddToRecentSearchDocument, options);
      }
export type AddToRecentSearchMutationHookResult = ReturnType<typeof useAddToRecentSearchMutation>;
export type AddToRecentSearchMutationResult = Apollo.MutationResult<AddToRecentSearchMutation>;
export type AddToRecentSearchMutationOptions = Apollo.BaseMutationOptions<AddToRecentSearchMutation, AddToRecentSearchMutationVariables>;
export const AddToSavedSearchDocument = gql`
    mutation addToSavedSearch($data: [UserRecentSearchInput]) {
  addToSavedSearch(data: $data) {
    searchId
    isSaved
    User {
      ...UserFields
    }
    Club {
      ...ClubFields
    }
    Hashtag {
      ...HashTagFields
    }
    Dollartag {
      dollarTagId
      dollarTagName
    }
  }
}
    ${UserFieldsFragmentDoc}
${ClubFieldsFragmentDoc}
${HashTagFieldsFragmentDoc}`;
export type AddToSavedSearchMutationFn = Apollo.MutationFunction<AddToSavedSearchMutation, AddToSavedSearchMutationVariables>;

/**
 * __useAddToSavedSearchMutation__
 *
 * To run a mutation, you first call `useAddToSavedSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToSavedSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToSavedSearchMutation, { data, loading, error }] = useAddToSavedSearchMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddToSavedSearchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddToSavedSearchMutation, AddToSavedSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddToSavedSearchMutation, AddToSavedSearchMutationVariables>(AddToSavedSearchDocument, options);
      }
export type AddToSavedSearchMutationHookResult = ReturnType<typeof useAddToSavedSearchMutation>;
export type AddToSavedSearchMutationResult = Apollo.MutationResult<AddToSavedSearchMutation>;
export type AddToSavedSearchMutationOptions = Apollo.BaseMutationOptions<AddToSavedSearchMutation, AddToSavedSearchMutationVariables>;
export const BlockUserDocument = gql`
    mutation blockUser($id: String!) {
  blockUser(id: $id) {
    success
    message
  }
}
    `;
export type BlockUserMutationFn = Apollo.MutationFunction<BlockUserMutation, BlockUserMutationVariables>;

/**
 * __useBlockUserMutation__
 *
 * To run a mutation, you first call `useBlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockUserMutation, { data, loading, error }] = useBlockUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlockUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BlockUserMutation, BlockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BlockUserMutation, BlockUserMutationVariables>(BlockUserDocument, options);
      }
export type BlockUserMutationHookResult = ReturnType<typeof useBlockUserMutation>;
export type BlockUserMutationResult = Apollo.MutationResult<BlockUserMutation>;
export type BlockUserMutationOptions = Apollo.BaseMutationOptions<BlockUserMutation, BlockUserMutationVariables>;
export const CancelFollowDocument = gql`
    mutation CancelFollow($data: FollowArgs) {
  cancelFollow(data: $data) {
    success
  }
}
    `;
export type CancelFollowMutationFn = Apollo.MutationFunction<CancelFollowMutation, CancelFollowMutationVariables>;

/**
 * __useCancelFollowMutation__
 *
 * To run a mutation, you first call `useCancelFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelFollowMutation, { data, loading, error }] = useCancelFollowMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCancelFollowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelFollowMutation, CancelFollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelFollowMutation, CancelFollowMutationVariables>(CancelFollowDocument, options);
      }
export type CancelFollowMutationHookResult = ReturnType<typeof useCancelFollowMutation>;
export type CancelFollowMutationResult = Apollo.MutationResult<CancelFollowMutation>;
export type CancelFollowMutationOptions = Apollo.BaseMutationOptions<CancelFollowMutation, CancelFollowMutationVariables>;
export const CancelFollowUserV2Document = gql`
    mutation cancelFollowUserV2($userId: ID) {
  cancelFollowUserV2(userId: $userId) {
    id
    username
    isfollow
  }
}
    `;
export type CancelFollowUserV2MutationFn = Apollo.MutationFunction<CancelFollowUserV2Mutation, CancelFollowUserV2MutationVariables>;

/**
 * __useCancelFollowUserV2Mutation__
 *
 * To run a mutation, you first call `useCancelFollowUserV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelFollowUserV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelFollowUserV2Mutation, { data, loading, error }] = useCancelFollowUserV2Mutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCancelFollowUserV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelFollowUserV2Mutation, CancelFollowUserV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelFollowUserV2Mutation, CancelFollowUserV2MutationVariables>(CancelFollowUserV2Document, options);
      }
export type CancelFollowUserV2MutationHookResult = ReturnType<typeof useCancelFollowUserV2Mutation>;
export type CancelFollowUserV2MutationResult = Apollo.MutationResult<CancelFollowUserV2Mutation>;
export type CancelFollowUserV2MutationOptions = Apollo.BaseMutationOptions<CancelFollowUserV2Mutation, CancelFollowUserV2MutationVariables>;
export const ClearRecentSearchDocument = gql`
    mutation clearRecentSearch {
  clearRecentSearch {
    success
    message
  }
}
    `;
export type ClearRecentSearchMutationFn = Apollo.MutationFunction<ClearRecentSearchMutation, ClearRecentSearchMutationVariables>;

/**
 * __useClearRecentSearchMutation__
 *
 * To run a mutation, you first call `useClearRecentSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearRecentSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearRecentSearchMutation, { data, loading, error }] = useClearRecentSearchMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearRecentSearchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClearRecentSearchMutation, ClearRecentSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClearRecentSearchMutation, ClearRecentSearchMutationVariables>(ClearRecentSearchDocument, options);
      }
export type ClearRecentSearchMutationHookResult = ReturnType<typeof useClearRecentSearchMutation>;
export type ClearRecentSearchMutationResult = Apollo.MutationResult<ClearRecentSearchMutation>;
export type ClearRecentSearchMutationOptions = Apollo.BaseMutationOptions<ClearRecentSearchMutation, ClearRecentSearchMutationVariables>;
export const CreateBookmarkDocument = gql`
    mutation CreateBookmark($data: CreateBookmark!) {
  createBookmark(data: $data) {
    postId
    userId
    timestamp
  }
}
    `;
export type CreateBookmarkMutationFn = Apollo.MutationFunction<CreateBookmarkMutation, CreateBookmarkMutationVariables>;

/**
 * __useCreateBookmarkMutation__
 *
 * To run a mutation, you first call `useCreateBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookmarkMutation, { data, loading, error }] = useCreateBookmarkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBookmarkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBookmarkMutation, CreateBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBookmarkMutation, CreateBookmarkMutationVariables>(CreateBookmarkDocument, options);
      }
export type CreateBookmarkMutationHookResult = ReturnType<typeof useCreateBookmarkMutation>;
export type CreateBookmarkMutationResult = Apollo.MutationResult<CreateBookmarkMutation>;
export type CreateBookmarkMutationOptions = Apollo.BaseMutationOptions<CreateBookmarkMutation, CreateBookmarkMutationVariables>;
export const CreateCommentV2Document = gql`
    mutation createCommentV2($data: CommentInput, $clubId: String, $clubBasedPermissionToken: String) {
  createCommentV2(
    data: $data
    clubId: $clubId
    clubBasedPermissionToken: $clubBasedPermissionToken
  ) {
    ...CommentFields
  }
}
    ${CommentFieldsFragmentDoc}`;
export type CreateCommentV2MutationFn = Apollo.MutationFunction<CreateCommentV2Mutation, CreateCommentV2MutationVariables>;

/**
 * __useCreateCommentV2Mutation__
 *
 * To run a mutation, you first call `useCreateCommentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentV2Mutation, { data, loading, error }] = useCreateCommentV2Mutation({
 *   variables: {
 *      data: // value for 'data'
 *      clubId: // value for 'clubId'
 *      clubBasedPermissionToken: // value for 'clubBasedPermissionToken'
 *   },
 * });
 */
export function useCreateCommentV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCommentV2Mutation, CreateCommentV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCommentV2Mutation, CreateCommentV2MutationVariables>(CreateCommentV2Document, options);
      }
export type CreateCommentV2MutationHookResult = ReturnType<typeof useCreateCommentV2Mutation>;
export type CreateCommentV2MutationResult = Apollo.MutationResult<CreateCommentV2Mutation>;
export type CreateCommentV2MutationOptions = Apollo.BaseMutationOptions<CreateCommentV2Mutation, CreateCommentV2MutationVariables>;
export const CreateFeedbackDocument = gql`
    mutation createFeedback($data: FeedbackInput) {
  createFeedback(data: $data) {
    feedbackId
    type
    subject
    comment
    status
    attachment {
      type
      uri
      name
    }
  }
}
    `;
export type CreateFeedbackMutationFn = Apollo.MutationFunction<CreateFeedbackMutation, CreateFeedbackMutationVariables>;

/**
 * __useCreateFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackMutation, { data, loading, error }] = useCreateFeedbackMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFeedbackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFeedbackMutation, CreateFeedbackMutationVariables>(CreateFeedbackDocument, options);
      }
export type CreateFeedbackMutationHookResult = ReturnType<typeof useCreateFeedbackMutation>;
export type CreateFeedbackMutationResult = Apollo.MutationResult<CreateFeedbackMutation>;
export type CreateFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>;
export const CreateNormalPostDocument = gql`
    mutation createNormalPost($data: NormalPostInput) {
  createNormalPost(data: $data) {
    post {
      postId
    }
  }
}
    `;
export type CreateNormalPostMutationFn = Apollo.MutationFunction<CreateNormalPostMutation, CreateNormalPostMutationVariables>;

/**
 * __useCreateNormalPostMutation__
 *
 * To run a mutation, you first call `useCreateNormalPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNormalPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNormalPostMutation, { data, loading, error }] = useCreateNormalPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNormalPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNormalPostMutation, CreateNormalPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateNormalPostMutation, CreateNormalPostMutationVariables>(CreateNormalPostDocument, options);
      }
export type CreateNormalPostMutationHookResult = ReturnType<typeof useCreateNormalPostMutation>;
export type CreateNormalPostMutationResult = Apollo.MutationResult<CreateNormalPostMutation>;
export type CreateNormalPostMutationOptions = Apollo.BaseMutationOptions<CreateNormalPostMutation, CreateNormalPostMutationVariables>;
export const CreateQueryPostDocument = gql`
    mutation createQueryPost($data: QueryInput) {
  createQueryPost(data: $data) {
    post {
      postId
    }
  }
}
    `;
export type CreateQueryPostMutationFn = Apollo.MutationFunction<CreateQueryPostMutation, CreateQueryPostMutationVariables>;

/**
 * __useCreateQueryPostMutation__
 *
 * To run a mutation, you first call `useCreateQueryPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQueryPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQueryPostMutation, { data, loading, error }] = useCreateQueryPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateQueryPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateQueryPostMutation, CreateQueryPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateQueryPostMutation, CreateQueryPostMutationVariables>(CreateQueryPostDocument, options);
      }
export type CreateQueryPostMutationHookResult = ReturnType<typeof useCreateQueryPostMutation>;
export type CreateQueryPostMutationResult = Apollo.MutationResult<CreateQueryPostMutation>;
export type CreateQueryPostMutationOptions = Apollo.BaseMutationOptions<CreateQueryPostMutation, CreateQueryPostMutationVariables>;
export const CreateReplyV2Document = gql`
    mutation createReplyV2($data: ReplyInput, $clubBasedPermissionToken: String, $clubId: String) {
  createReplyV2(
    data: $data
    clubBasedPermissionToken: $clubBasedPermissionToken
    clubId: $clubId
  ) {
    ...ReplyFields
  }
}
    ${ReplyFieldsFragmentDoc}`;
export type CreateReplyV2MutationFn = Apollo.MutationFunction<CreateReplyV2Mutation, CreateReplyV2MutationVariables>;

/**
 * __useCreateReplyV2Mutation__
 *
 * To run a mutation, you first call `useCreateReplyV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReplyV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReplyV2Mutation, { data, loading, error }] = useCreateReplyV2Mutation({
 *   variables: {
 *      data: // value for 'data'
 *      clubBasedPermissionToken: // value for 'clubBasedPermissionToken'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useCreateReplyV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateReplyV2Mutation, CreateReplyV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateReplyV2Mutation, CreateReplyV2MutationVariables>(CreateReplyV2Document, options);
      }
export type CreateReplyV2MutationHookResult = ReturnType<typeof useCreateReplyV2Mutation>;
export type CreateReplyV2MutationResult = Apollo.MutationResult<CreateReplyV2Mutation>;
export type CreateReplyV2MutationOptions = Apollo.BaseMutationOptions<CreateReplyV2Mutation, CreateReplyV2MutationVariables>;
export const CreateReportDocument = gql`
    mutation createReport($data: CreateReportInput) {
  createReport(data: $data) {
    repId
    ReportId
    reporter {
      id
      firstName
      lastName
      username
    }
    remark
    reportedBy
    reportedOn
    reportTime
    reportType
    Post {
      postId
      text
    }
    Comment {
      commentId
      text
    }
    Reply {
      replyId
      text
    }
  }
}
    `;
export type CreateReportMutationFn = Apollo.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, options);
      }
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<CreateReportMutation, CreateReportMutationVariables>;
export const CreateStockIdeasPostDocument = gql`
    mutation createStockIdeasPost($data: StockIdeasInput) {
  createStockIdeasPost(data: $data) {
    post {
      postId
    }
    message
    approvalRequestId
  }
}
    `;
export type CreateStockIdeasPostMutationFn = Apollo.MutationFunction<CreateStockIdeasPostMutation, CreateStockIdeasPostMutationVariables>;

/**
 * __useCreateStockIdeasPostMutation__
 *
 * To run a mutation, you first call `useCreateStockIdeasPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockIdeasPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockIdeasPostMutation, { data, loading, error }] = useCreateStockIdeasPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateStockIdeasPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStockIdeasPostMutation, CreateStockIdeasPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateStockIdeasPostMutation, CreateStockIdeasPostMutationVariables>(CreateStockIdeasPostDocument, options);
      }
export type CreateStockIdeasPostMutationHookResult = ReturnType<typeof useCreateStockIdeasPostMutation>;
export type CreateStockIdeasPostMutationResult = Apollo.MutationResult<CreateStockIdeasPostMutation>;
export type CreateStockIdeasPostMutationOptions = Apollo.BaseMutationOptions<CreateStockIdeasPostMutation, CreateStockIdeasPostMutationVariables>;
export const CreateZendeskTicketDocument = gql`
    mutation createZendeskTicket($data: TicketInput) {
  createZendeskTicket(data: $data)
}
    `;
export type CreateZendeskTicketMutationFn = Apollo.MutationFunction<CreateZendeskTicketMutation, CreateZendeskTicketMutationVariables>;

/**
 * __useCreateZendeskTicketMutation__
 *
 * To run a mutation, you first call `useCreateZendeskTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZendeskTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZendeskTicketMutation, { data, loading, error }] = useCreateZendeskTicketMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateZendeskTicketMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateZendeskTicketMutation, CreateZendeskTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateZendeskTicketMutation, CreateZendeskTicketMutationVariables>(CreateZendeskTicketDocument, options);
      }
export type CreateZendeskTicketMutationHookResult = ReturnType<typeof useCreateZendeskTicketMutation>;
export type CreateZendeskTicketMutationResult = Apollo.MutationResult<CreateZendeskTicketMutation>;
export type CreateZendeskTicketMutationOptions = Apollo.BaseMutationOptions<CreateZendeskTicketMutation, CreateZendeskTicketMutationVariables>;
export const CreateZendeskTicketCommentDocument = gql`
    mutation createZendeskTicketComment($data: TicketCommentInput, $ticketId: Int!) {
  createZendeskTicketComment(data: $data, ticketId: $ticketId)
}
    `;
export type CreateZendeskTicketCommentMutationFn = Apollo.MutationFunction<CreateZendeskTicketCommentMutation, CreateZendeskTicketCommentMutationVariables>;

/**
 * __useCreateZendeskTicketCommentMutation__
 *
 * To run a mutation, you first call `useCreateZendeskTicketCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZendeskTicketCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZendeskTicketCommentMutation, { data, loading, error }] = useCreateZendeskTicketCommentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useCreateZendeskTicketCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateZendeskTicketCommentMutation, CreateZendeskTicketCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateZendeskTicketCommentMutation, CreateZendeskTicketCommentMutationVariables>(CreateZendeskTicketCommentDocument, options);
      }
export type CreateZendeskTicketCommentMutationHookResult = ReturnType<typeof useCreateZendeskTicketCommentMutation>;
export type CreateZendeskTicketCommentMutationResult = Apollo.MutationResult<CreateZendeskTicketCommentMutation>;
export type CreateZendeskTicketCommentMutationOptions = Apollo.BaseMutationOptions<CreateZendeskTicketCommentMutation, CreateZendeskTicketCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation deleteComment($data: CommentId, $clubId: String) {
  deleteComment(data: $data, clubId: $clubId) {
    success
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeletePostDocument = gql`
    mutation DeletePost($data: DeletePostInput, $clubId: String) {
  deletePost(data: $data, clubId: $clubId) {
    success
  }
}
    `;
export type DeletePostMutationFn = Apollo.MutationFunction<DeletePostMutation, DeletePostMutationVariables>;

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      data: // value for 'data'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useDeletePostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePostMutation, DeletePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePostMutation, DeletePostMutationVariables>(DeletePostDocument, options);
      }
export type DeletePostMutationHookResult = ReturnType<typeof useDeletePostMutation>;
export type DeletePostMutationResult = Apollo.MutationResult<DeletePostMutation>;
export type DeletePostMutationOptions = Apollo.BaseMutationOptions<DeletePostMutation, DeletePostMutationVariables>;
export const DeleteReplyDocument = gql`
    mutation deleteReply($data: ReplyId, $clubId: String) {
  deleteReply(data: $data, clubId: $clubId) {
    success
  }
}
    `;
export type DeleteReplyMutationFn = Apollo.MutationFunction<DeleteReplyMutation, DeleteReplyMutationVariables>;

/**
 * __useDeleteReplyMutation__
 *
 * To run a mutation, you first call `useDeleteReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReplyMutation, { data, loading, error }] = useDeleteReplyMutation({
 *   variables: {
 *      data: // value for 'data'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useDeleteReplyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteReplyMutation, DeleteReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteReplyMutation, DeleteReplyMutationVariables>(DeleteReplyDocument, options);
      }
export type DeleteReplyMutationHookResult = ReturnType<typeof useDeleteReplyMutation>;
export type DeleteReplyMutationResult = Apollo.MutationResult<DeleteReplyMutation>;
export type DeleteReplyMutationOptions = Apollo.BaseMutationOptions<DeleteReplyMutation, DeleteReplyMutationVariables>;
export const DollarFollowDocument = gql`
    mutation dollarFollow($dollarTagId: String!) {
  dollarFollow(dollarTagId: $dollarTagId) {
    dollarTagId
    isfollow
    issubscribed
    followers
  }
}
    `;
export type DollarFollowMutationFn = Apollo.MutationFunction<DollarFollowMutation, DollarFollowMutationVariables>;

/**
 * __useDollarFollowMutation__
 *
 * To run a mutation, you first call `useDollarFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDollarFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dollarFollowMutation, { data, loading, error }] = useDollarFollowMutation({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *   },
 * });
 */
export function useDollarFollowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DollarFollowMutation, DollarFollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DollarFollowMutation, DollarFollowMutationVariables>(DollarFollowDocument, options);
      }
export type DollarFollowMutationHookResult = ReturnType<typeof useDollarFollowMutation>;
export type DollarFollowMutationResult = Apollo.MutationResult<DollarFollowMutation>;
export type DollarFollowMutationOptions = Apollo.BaseMutationOptions<DollarFollowMutation, DollarFollowMutationVariables>;
export const DollarSubscribeDocument = gql`
    mutation DollarSubscribe($dollarTagId: String!) {
  dollarSubscribe(dollarTagId: $dollarTagId) {
    dollarTagId
    isfollow
    issubscribed
    followers
  }
}
    `;
export type DollarSubscribeMutationFn = Apollo.MutationFunction<DollarSubscribeMutation, DollarSubscribeMutationVariables>;

/**
 * __useDollarSubscribeMutation__
 *
 * To run a mutation, you first call `useDollarSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDollarSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dollarSubscribeMutation, { data, loading, error }] = useDollarSubscribeMutation({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *   },
 * });
 */
export function useDollarSubscribeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DollarSubscribeMutation, DollarSubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DollarSubscribeMutation, DollarSubscribeMutationVariables>(DollarSubscribeDocument, options);
      }
export type DollarSubscribeMutationHookResult = ReturnType<typeof useDollarSubscribeMutation>;
export type DollarSubscribeMutationResult = Apollo.MutationResult<DollarSubscribeMutation>;
export type DollarSubscribeMutationOptions = Apollo.BaseMutationOptions<DollarSubscribeMutation, DollarSubscribeMutationVariables>;
export const DollarUnfollowDocument = gql`
    mutation DollarUnfollow($dollarTagId: String!) {
  dollarUnfollow(dollarTagId: $dollarTagId) {
    dollarTagId
    isfollow
    issubscribed
    followers
  }
}
    `;
export type DollarUnfollowMutationFn = Apollo.MutationFunction<DollarUnfollowMutation, DollarUnfollowMutationVariables>;

/**
 * __useDollarUnfollowMutation__
 *
 * To run a mutation, you first call `useDollarUnfollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDollarUnfollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dollarUnfollowMutation, { data, loading, error }] = useDollarUnfollowMutation({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *   },
 * });
 */
export function useDollarUnfollowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DollarUnfollowMutation, DollarUnfollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DollarUnfollowMutation, DollarUnfollowMutationVariables>(DollarUnfollowDocument, options);
      }
export type DollarUnfollowMutationHookResult = ReturnType<typeof useDollarUnfollowMutation>;
export type DollarUnfollowMutationResult = Apollo.MutationResult<DollarUnfollowMutation>;
export type DollarUnfollowMutationOptions = Apollo.BaseMutationOptions<DollarUnfollowMutation, DollarUnfollowMutationVariables>;
export const DollarUnsubscribeDocument = gql`
    mutation DollarUnsubscribe($dollarTagId: String!) {
  dollarUnsubscribe(dollarTagId: $dollarTagId) {
    dollarTagId
    isfollow
    issubscribed
    followers
  }
}
    `;
export type DollarUnsubscribeMutationFn = Apollo.MutationFunction<DollarUnsubscribeMutation, DollarUnsubscribeMutationVariables>;

/**
 * __useDollarUnsubscribeMutation__
 *
 * To run a mutation, you first call `useDollarUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDollarUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dollarUnsubscribeMutation, { data, loading, error }] = useDollarUnsubscribeMutation({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *   },
 * });
 */
export function useDollarUnsubscribeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DollarUnsubscribeMutation, DollarUnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DollarUnsubscribeMutation, DollarUnsubscribeMutationVariables>(DollarUnsubscribeDocument, options);
      }
export type DollarUnsubscribeMutationHookResult = ReturnType<typeof useDollarUnsubscribeMutation>;
export type DollarUnsubscribeMutationResult = Apollo.MutationResult<DollarUnsubscribeMutation>;
export type DollarUnsubscribeMutationOptions = Apollo.BaseMutationOptions<DollarUnsubscribeMutation, DollarUnsubscribeMutationVariables>;
export const EditNormalPostDocument = gql`
    mutation editNormalPost($data: EditNormalPostInput) {
  editNormalPost(data: $data) {
    post {
      postId
      media {
        type
        uri
        name
        height
        width
        rotation
      }
      textV2
      isEdited
    }
  }
}
    `;
export type EditNormalPostMutationFn = Apollo.MutationFunction<EditNormalPostMutation, EditNormalPostMutationVariables>;

/**
 * __useEditNormalPostMutation__
 *
 * To run a mutation, you first call `useEditNormalPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditNormalPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editNormalPostMutation, { data, loading, error }] = useEditNormalPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEditNormalPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditNormalPostMutation, EditNormalPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditNormalPostMutation, EditNormalPostMutationVariables>(EditNormalPostDocument, options);
      }
export type EditNormalPostMutationHookResult = ReturnType<typeof useEditNormalPostMutation>;
export type EditNormalPostMutationResult = Apollo.MutationResult<EditNormalPostMutation>;
export type EditNormalPostMutationOptions = Apollo.BaseMutationOptions<EditNormalPostMutation, EditNormalPostMutationVariables>;
export const EditQueryDocument = gql`
    mutation editQuery($data: EditQueryInput) {
  editQuery(data: $data) {
    post {
      postId
      media {
        type
        uri
        name
        height
        width
        rotation
      }
      textV2
      isEdited
    }
  }
}
    `;
export type EditQueryMutationFn = Apollo.MutationFunction<EditQueryMutation, EditQueryMutationVariables>;

/**
 * __useEditQueryMutation__
 *
 * To run a mutation, you first call `useEditQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editQueryMutation, { data, loading, error }] = useEditQueryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEditQueryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditQueryMutation, EditQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditQueryMutation, EditQueryMutationVariables>(EditQueryDocument, options);
      }
export type EditQueryMutationHookResult = ReturnType<typeof useEditQueryMutation>;
export type EditQueryMutationResult = Apollo.MutationResult<EditQueryMutation>;
export type EditQueryMutationOptions = Apollo.BaseMutationOptions<EditQueryMutation, EditQueryMutationVariables>;
export const EditStockIdeaDocument = gql`
    mutation editStockIdea($data: EditStockIdeasInput) {
  editStockIdea(data: $data) {
    post {
      postId
      media {
        type
        uri
        name
        height
        width
        rotation
      }
      textV2
      isEdited
    }
  }
}
    `;
export type EditStockIdeaMutationFn = Apollo.MutationFunction<EditStockIdeaMutation, EditStockIdeaMutationVariables>;

/**
 * __useEditStockIdeaMutation__
 *
 * To run a mutation, you first call `useEditStockIdeaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditStockIdeaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editStockIdeaMutation, { data, loading, error }] = useEditStockIdeaMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEditStockIdeaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditStockIdeaMutation, EditStockIdeaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditStockIdeaMutation, EditStockIdeaMutationVariables>(EditStockIdeaDocument, options);
      }
export type EditStockIdeaMutationHookResult = ReturnType<typeof useEditStockIdeaMutation>;
export type EditStockIdeaMutationResult = Apollo.MutationResult<EditStockIdeaMutation>;
export type EditStockIdeaMutationOptions = Apollo.BaseMutationOptions<EditStockIdeaMutation, EditStockIdeaMutationVariables>;
export const ExecuteVisitedOnboardScreensDocument = gql`
    mutation executeVisitedOnboardScreens($data: ScreenResponseArgs) {
  executeVisitedOnboardScreens(data: $data) {
    success
    message
  }
}
    `;
export type ExecuteVisitedOnboardScreensMutationFn = Apollo.MutationFunction<ExecuteVisitedOnboardScreensMutation, ExecuteVisitedOnboardScreensMutationVariables>;

/**
 * __useExecuteVisitedOnboardScreensMutation__
 *
 * To run a mutation, you first call `useExecuteVisitedOnboardScreensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteVisitedOnboardScreensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeVisitedOnboardScreensMutation, { data, loading, error }] = useExecuteVisitedOnboardScreensMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExecuteVisitedOnboardScreensMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExecuteVisitedOnboardScreensMutation, ExecuteVisitedOnboardScreensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ExecuteVisitedOnboardScreensMutation, ExecuteVisitedOnboardScreensMutationVariables>(ExecuteVisitedOnboardScreensDocument, options);
      }
export type ExecuteVisitedOnboardScreensMutationHookResult = ReturnType<typeof useExecuteVisitedOnboardScreensMutation>;
export type ExecuteVisitedOnboardScreensMutationResult = Apollo.MutationResult<ExecuteVisitedOnboardScreensMutation>;
export type ExecuteVisitedOnboardScreensMutationOptions = Apollo.BaseMutationOptions<ExecuteVisitedOnboardScreensMutation, ExecuteVisitedOnboardScreensMutationVariables>;
export const FollowHashtagV2Document = gql`
    mutation followHashtagV2($hashtagId: ID) {
  followHashtagV2(hashtagId: $hashtagId) {
    TagId
    hashtagName
    isfollow
    issubscribed
  }
}
    `;
export type FollowHashtagV2MutationFn = Apollo.MutationFunction<FollowHashtagV2Mutation, FollowHashtagV2MutationVariables>;

/**
 * __useFollowHashtagV2Mutation__
 *
 * To run a mutation, you first call `useFollowHashtagV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowHashtagV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followHashtagV2Mutation, { data, loading, error }] = useFollowHashtagV2Mutation({
 *   variables: {
 *      hashtagId: // value for 'hashtagId'
 *   },
 * });
 */
export function useFollowHashtagV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FollowHashtagV2Mutation, FollowHashtagV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FollowHashtagV2Mutation, FollowHashtagV2MutationVariables>(FollowHashtagV2Document, options);
      }
export type FollowHashtagV2MutationHookResult = ReturnType<typeof useFollowHashtagV2Mutation>;
export type FollowHashtagV2MutationResult = Apollo.MutationResult<FollowHashtagV2Mutation>;
export type FollowHashtagV2MutationOptions = Apollo.BaseMutationOptions<FollowHashtagV2Mutation, FollowHashtagV2MutationVariables>;
export const FollowPostDocument = gql`
    mutation followPost($data: FollowPostInput!) {
  followPost(data: $data) {
    post {
      postId
      isFollowed
    }
    message
  }
}
    `;
export type FollowPostMutationFn = Apollo.MutationFunction<FollowPostMutation, FollowPostMutationVariables>;

/**
 * __useFollowPostMutation__
 *
 * To run a mutation, you first call `useFollowPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followPostMutation, { data, loading, error }] = useFollowPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFollowPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FollowPostMutation, FollowPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FollowPostMutation, FollowPostMutationVariables>(FollowPostDocument, options);
      }
export type FollowPostMutationHookResult = ReturnType<typeof useFollowPostMutation>;
export type FollowPostMutationResult = Apollo.MutationResult<FollowPostMutation>;
export type FollowPostMutationOptions = Apollo.BaseMutationOptions<FollowPostMutation, FollowPostMutationVariables>;
export const FollowUserV2Document = gql`
    mutation followUserV2($userId: ID) {
  followUserV2(userId: $userId) {
    id
    username
    isfollow
    followerCount
    followingCount
  }
}
    `;
export type FollowUserV2MutationFn = Apollo.MutationFunction<FollowUserV2Mutation, FollowUserV2MutationVariables>;

/**
 * __useFollowUserV2Mutation__
 *
 * To run a mutation, you first call `useFollowUserV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUserV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUserV2Mutation, { data, loading, error }] = useFollowUserV2Mutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFollowUserV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FollowUserV2Mutation, FollowUserV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FollowUserV2Mutation, FollowUserV2MutationVariables>(FollowUserV2Document, options);
      }
export type FollowUserV2MutationHookResult = ReturnType<typeof useFollowUserV2Mutation>;
export type FollowUserV2MutationResult = Apollo.MutationResult<FollowUserV2Mutation>;
export type FollowUserV2MutationOptions = Apollo.BaseMutationOptions<FollowUserV2Mutation, FollowUserV2MutationVariables>;
export const HasSeenPopUpDocument = gql`
    mutation hasSeenPopUp($popUpType: String) {
  hasSeenPopUp(popUpType: $popUpType) {
    success {
      success
      message
    }
  }
}
    `;
export type HasSeenPopUpMutationFn = Apollo.MutationFunction<HasSeenPopUpMutation, HasSeenPopUpMutationVariables>;

/**
 * __useHasSeenPopUpMutation__
 *
 * To run a mutation, you first call `useHasSeenPopUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHasSeenPopUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hasSeenPopUpMutation, { data, loading, error }] = useHasSeenPopUpMutation({
 *   variables: {
 *      popUpType: // value for 'popUpType'
 *   },
 * });
 */
export function useHasSeenPopUpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<HasSeenPopUpMutation, HasSeenPopUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<HasSeenPopUpMutation, HasSeenPopUpMutationVariables>(HasSeenPopUpDocument, options);
      }
export type HasSeenPopUpMutationHookResult = ReturnType<typeof useHasSeenPopUpMutation>;
export type HasSeenPopUpMutationResult = Apollo.MutationResult<HasSeenPopUpMutation>;
export type HasSeenPopUpMutationOptions = Apollo.BaseMutationOptions<HasSeenPopUpMutation, HasSeenPopUpMutationVariables>;
export const IgnoreNpsRatingDocument = gql`
    mutation ignoreNpsRating($source: NpsIgnoreSource) {
  ignoreNpsRating(source: $source) {
    success
    message
  }
}
    `;
export type IgnoreNpsRatingMutationFn = Apollo.MutationFunction<IgnoreNpsRatingMutation, IgnoreNpsRatingMutationVariables>;

/**
 * __useIgnoreNpsRatingMutation__
 *
 * To run a mutation, you first call `useIgnoreNpsRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreNpsRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreNpsRatingMutation, { data, loading, error }] = useIgnoreNpsRatingMutation({
 *   variables: {
 *      source: // value for 'source'
 *   },
 * });
 */
export function useIgnoreNpsRatingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IgnoreNpsRatingMutation, IgnoreNpsRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<IgnoreNpsRatingMutation, IgnoreNpsRatingMutationVariables>(IgnoreNpsRatingDocument, options);
      }
export type IgnoreNpsRatingMutationHookResult = ReturnType<typeof useIgnoreNpsRatingMutation>;
export type IgnoreNpsRatingMutationResult = Apollo.MutationResult<IgnoreNpsRatingMutation>;
export type IgnoreNpsRatingMutationOptions = Apollo.BaseMutationOptions<IgnoreNpsRatingMutation, IgnoreNpsRatingMutationVariables>;
export const JoinClubV2Document = gql`
    mutation joinClubV2($data: JoinClubArgs!) {
  joinClubV2(data: $data) {
    clubId
    ismember
    totalMemberCount
  }
}
    `;
export type JoinClubV2MutationFn = Apollo.MutationFunction<JoinClubV2Mutation, JoinClubV2MutationVariables>;

/**
 * __useJoinClubV2Mutation__
 *
 * To run a mutation, you first call `useJoinClubV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinClubV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinClubV2Mutation, { data, loading, error }] = useJoinClubV2Mutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useJoinClubV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<JoinClubV2Mutation, JoinClubV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<JoinClubV2Mutation, JoinClubV2MutationVariables>(JoinClubV2Document, options);
      }
export type JoinClubV2MutationHookResult = ReturnType<typeof useJoinClubV2Mutation>;
export type JoinClubV2MutationResult = Apollo.MutationResult<JoinClubV2Mutation>;
export type JoinClubV2MutationOptions = Apollo.BaseMutationOptions<JoinClubV2Mutation, JoinClubV2MutationVariables>;
export const LeaveClubV2Document = gql`
    mutation leaveClubV2($data: ClubInput!) {
  leaveClubV2(data: $data) {
    clubId
    isFavourite
    ismember
    issubscribed
    totalMemberCount
  }
}
    `;
export type LeaveClubV2MutationFn = Apollo.MutationFunction<LeaveClubV2Mutation, LeaveClubV2MutationVariables>;

/**
 * __useLeaveClubV2Mutation__
 *
 * To run a mutation, you first call `useLeaveClubV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveClubV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveClubV2Mutation, { data, loading, error }] = useLeaveClubV2Mutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLeaveClubV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LeaveClubV2Mutation, LeaveClubV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LeaveClubV2Mutation, LeaveClubV2MutationVariables>(LeaveClubV2Document, options);
      }
export type LeaveClubV2MutationHookResult = ReturnType<typeof useLeaveClubV2Mutation>;
export type LeaveClubV2MutationResult = Apollo.MutationResult<LeaveClubV2Mutation>;
export type LeaveClubV2MutationOptions = Apollo.BaseMutationOptions<LeaveClubV2Mutation, LeaveClubV2MutationVariables>;
export const LoginWithOidc_V2Document = gql`
    mutation loginWithOIDC_V2($accessToken: String!) {
  loginWithOIDC_V2(accessToken: $accessToken) {
    isUserMemberOfStockEdgeClub
    error
    interimToken
    user {
      id
      username
      showNpsV2
    }
    isViewOnly
    profileDetails {
      Id
      UserName
      Email
      Firstname
      Lastname
      RegisteredOn
      Gender
      ImageFilePath
    }
  }
}
    `;
export type LoginWithOidc_V2MutationFn = Apollo.MutationFunction<LoginWithOidc_V2Mutation, LoginWithOidc_V2MutationVariables>;

/**
 * __useLoginWithOidc_V2Mutation__
 *
 * To run a mutation, you first call `useLoginWithOidc_V2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithOidc_V2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithOidcV2Mutation, { data, loading, error }] = useLoginWithOidc_V2Mutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useLoginWithOidc_V2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginWithOidc_V2Mutation, LoginWithOidc_V2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginWithOidc_V2Mutation, LoginWithOidc_V2MutationVariables>(LoginWithOidc_V2Document, options);
      }
export type LoginWithOidc_V2MutationHookResult = ReturnType<typeof useLoginWithOidc_V2Mutation>;
export type LoginWithOidc_V2MutationResult = Apollo.MutationResult<LoginWithOidc_V2Mutation>;
export type LoginWithOidc_V2MutationOptions = Apollo.BaseMutationOptions<LoginWithOidc_V2Mutation, LoginWithOidc_V2MutationVariables>;
export const MarkAsPinPostDocument = gql`
    mutation markAsPinPost($postId: String) {
  markAsPinPost(postId: $postId) {
    ...PostFields
    isPinned
    isPinnedByUser
  }
}
    ${PostFieldsFragmentDoc}`;
export type MarkAsPinPostMutationFn = Apollo.MutationFunction<MarkAsPinPostMutation, MarkAsPinPostMutationVariables>;

/**
 * __useMarkAsPinPostMutation__
 *
 * To run a mutation, you first call `useMarkAsPinPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsPinPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsPinPostMutation, { data, loading, error }] = useMarkAsPinPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useMarkAsPinPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkAsPinPostMutation, MarkAsPinPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkAsPinPostMutation, MarkAsPinPostMutationVariables>(MarkAsPinPostDocument, options);
      }
export type MarkAsPinPostMutationHookResult = ReturnType<typeof useMarkAsPinPostMutation>;
export type MarkAsPinPostMutationResult = Apollo.MutationResult<MarkAsPinPostMutation>;
export type MarkAsPinPostMutationOptions = Apollo.BaseMutationOptions<MarkAsPinPostMutation, MarkAsPinPostMutationVariables>;
export const MarkClubAsFavouriteDocument = gql`
    mutation markClubAsFavourite($clubId: String) {
  markClubAsFavourite(clubId: $clubId) {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;
export type MarkClubAsFavouriteMutationFn = Apollo.MutationFunction<MarkClubAsFavouriteMutation, MarkClubAsFavouriteMutationVariables>;

/**
 * __useMarkClubAsFavouriteMutation__
 *
 * To run a mutation, you first call `useMarkClubAsFavouriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkClubAsFavouriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markClubAsFavouriteMutation, { data, loading, error }] = useMarkClubAsFavouriteMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useMarkClubAsFavouriteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkClubAsFavouriteMutation, MarkClubAsFavouriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkClubAsFavouriteMutation, MarkClubAsFavouriteMutationVariables>(MarkClubAsFavouriteDocument, options);
      }
export type MarkClubAsFavouriteMutationHookResult = ReturnType<typeof useMarkClubAsFavouriteMutation>;
export type MarkClubAsFavouriteMutationResult = Apollo.MutationResult<MarkClubAsFavouriteMutation>;
export type MarkClubAsFavouriteMutationOptions = Apollo.BaseMutationOptions<MarkClubAsFavouriteMutation, MarkClubAsFavouriteMutationVariables>;
export const OnboardUserDocument = gql`
    mutation onboardUser($typeOfUserByUserpreference: UserHashtagContentType, $dollarTagIds: [Int], $hashtagName: [String], $skipOnboarding: Boolean) {
  onboardUser(
    typeOfUserByUserpreference: $typeOfUserByUserpreference
    dollarTagIds: $dollarTagIds
    hashtagName: $hashtagName
    skipOnboarding: $skipOnboarding
  ) {
    success
    message
  }
}
    `;
export type OnboardUserMutationFn = Apollo.MutationFunction<OnboardUserMutation, OnboardUserMutationVariables>;

/**
 * __useOnboardUserMutation__
 *
 * To run a mutation, you first call `useOnboardUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardUserMutation, { data, loading, error }] = useOnboardUserMutation({
 *   variables: {
 *      typeOfUserByUserpreference: // value for 'typeOfUserByUserpreference'
 *      dollarTagIds: // value for 'dollarTagIds'
 *      hashtagName: // value for 'hashtagName'
 *      skipOnboarding: // value for 'skipOnboarding'
 *   },
 * });
 */
export function useOnboardUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OnboardUserMutation, OnboardUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OnboardUserMutation, OnboardUserMutationVariables>(OnboardUserDocument, options);
      }
export type OnboardUserMutationHookResult = ReturnType<typeof useOnboardUserMutation>;
export type OnboardUserMutationResult = Apollo.MutationResult<OnboardUserMutation>;
export type OnboardUserMutationOptions = Apollo.BaseMutationOptions<OnboardUserMutation, OnboardUserMutationVariables>;
export const ReadAllNotificationsDocument = gql`
    mutation readAllNotifications {
  readAllNotifications {
    success
    message
  }
}
    `;
export type ReadAllNotificationsMutationFn = Apollo.MutationFunction<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>;

/**
 * __useReadAllNotificationsMutation__
 *
 * To run a mutation, you first call `useReadAllNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllNotificationsMutation, { data, loading, error }] = useReadAllNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useReadAllNotificationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>(ReadAllNotificationsDocument, options);
      }
export type ReadAllNotificationsMutationHookResult = ReturnType<typeof useReadAllNotificationsMutation>;
export type ReadAllNotificationsMutationResult = Apollo.MutationResult<ReadAllNotificationsMutation>;
export type ReadAllNotificationsMutationOptions = Apollo.BaseMutationOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>;
export const ReadNotificationDocument = gql`
    mutation readNotification($notificationId: String) {
  readNotification(notificationId: $notificationId) {
    success
    message
  }
}
    `;
export type ReadNotificationMutationFn = Apollo.MutationFunction<ReadNotificationMutation, ReadNotificationMutationVariables>;

/**
 * __useReadNotificationMutation__
 *
 * To run a mutation, you first call `useReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationMutation, { data, loading, error }] = useReadNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useReadNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReadNotificationMutation, ReadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument, options);
      }
export type ReadNotificationMutationHookResult = ReturnType<typeof useReadNotificationMutation>;
export type ReadNotificationMutationResult = Apollo.MutationResult<ReadNotificationMutation>;
export type ReadNotificationMutationOptions = Apollo.BaseMutationOptions<ReadNotificationMutation, ReadNotificationMutationVariables>;
export const RejectSuggestedSearchDocument = gql`
    mutation rejectSuggestedSearch($searchId: String) {
  rejectSuggestedSearch(searchId: $searchId) {
    searchId
    User {
      ...UserFields
    }
    Club {
      clubId
      clubName
    }
    Hashtag {
      TagId
      hashtagName
    }
    Dollartag {
      ...DollarTagFields
    }
  }
}
    ${UserFieldsFragmentDoc}
${DollarTagFieldsFragmentDoc}`;
export type RejectSuggestedSearchMutationFn = Apollo.MutationFunction<RejectSuggestedSearchMutation, RejectSuggestedSearchMutationVariables>;

/**
 * __useRejectSuggestedSearchMutation__
 *
 * To run a mutation, you first call `useRejectSuggestedSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectSuggestedSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectSuggestedSearchMutation, { data, loading, error }] = useRejectSuggestedSearchMutation({
 *   variables: {
 *      searchId: // value for 'searchId'
 *   },
 * });
 */
export function useRejectSuggestedSearchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RejectSuggestedSearchMutation, RejectSuggestedSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RejectSuggestedSearchMutation, RejectSuggestedSearchMutationVariables>(RejectSuggestedSearchDocument, options);
      }
export type RejectSuggestedSearchMutationHookResult = ReturnType<typeof useRejectSuggestedSearchMutation>;
export type RejectSuggestedSearchMutationResult = Apollo.MutationResult<RejectSuggestedSearchMutation>;
export type RejectSuggestedSearchMutationOptions = Apollo.BaseMutationOptions<RejectSuggestedSearchMutation, RejectSuggestedSearchMutationVariables>;
export const RemoveBookmarkDocument = gql`
    mutation removeBookmark($data: CreateBookmark) {
  removeBookmark(data: $data) {
    success
  }
}
    `;
export type RemoveBookmarkMutationFn = Apollo.MutationFunction<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>;

/**
 * __useRemoveBookmarkMutation__
 *
 * To run a mutation, you first call `useRemoveBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBookmarkMutation, { data, loading, error }] = useRemoveBookmarkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveBookmarkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>(RemoveBookmarkDocument, options);
      }
export type RemoveBookmarkMutationHookResult = ReturnType<typeof useRemoveBookmarkMutation>;
export type RemoveBookmarkMutationResult = Apollo.MutationResult<RemoveBookmarkMutation>;
export type RemoveBookmarkMutationOptions = Apollo.BaseMutationOptions<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>;
export const RemoveFromRecentSearchDocument = gql`
    mutation removeFromRecentSearch($searchId: String) {
  removeFromRecentSearch(searchId: $searchId) {
    success
    message
  }
}
    `;
export type RemoveFromRecentSearchMutationFn = Apollo.MutationFunction<RemoveFromRecentSearchMutation, RemoveFromRecentSearchMutationVariables>;

/**
 * __useRemoveFromRecentSearchMutation__
 *
 * To run a mutation, you first call `useRemoveFromRecentSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromRecentSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromRecentSearchMutation, { data, loading, error }] = useRemoveFromRecentSearchMutation({
 *   variables: {
 *      searchId: // value for 'searchId'
 *   },
 * });
 */
export function useRemoveFromRecentSearchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveFromRecentSearchMutation, RemoveFromRecentSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveFromRecentSearchMutation, RemoveFromRecentSearchMutationVariables>(RemoveFromRecentSearchDocument, options);
      }
export type RemoveFromRecentSearchMutationHookResult = ReturnType<typeof useRemoveFromRecentSearchMutation>;
export type RemoveFromRecentSearchMutationResult = Apollo.MutationResult<RemoveFromRecentSearchMutation>;
export type RemoveFromRecentSearchMutationOptions = Apollo.BaseMutationOptions<RemoveFromRecentSearchMutation, RemoveFromRecentSearchMutationVariables>;
export const RemoveFromSavedSearchDocument = gql`
    mutation removeFromSavedSearch($searchId: String) {
  removeFromSavedSearch(searchId: $searchId) {
    searchId
    isSaved
  }
}
    `;
export type RemoveFromSavedSearchMutationFn = Apollo.MutationFunction<RemoveFromSavedSearchMutation, RemoveFromSavedSearchMutationVariables>;

/**
 * __useRemoveFromSavedSearchMutation__
 *
 * To run a mutation, you first call `useRemoveFromSavedSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromSavedSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromSavedSearchMutation, { data, loading, error }] = useRemoveFromSavedSearchMutation({
 *   variables: {
 *      searchId: // value for 'searchId'
 *   },
 * });
 */
export function useRemoveFromSavedSearchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveFromSavedSearchMutation, RemoveFromSavedSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveFromSavedSearchMutation, RemoveFromSavedSearchMutationVariables>(RemoveFromSavedSearchDocument, options);
      }
export type RemoveFromSavedSearchMutationHookResult = ReturnType<typeof useRemoveFromSavedSearchMutation>;
export type RemoveFromSavedSearchMutationResult = Apollo.MutationResult<RemoveFromSavedSearchMutation>;
export type RemoveFromSavedSearchMutationOptions = Apollo.BaseMutationOptions<RemoveFromSavedSearchMutation, RemoveFromSavedSearchMutationVariables>;
export const ResolveFollowDocument = gql`
    mutation resolveFollow($followerId: String, $type: FollowStatus) {
  resolveFollow(followerId: $followerId, type: $type) {
    success
  }
}
    `;
export type ResolveFollowMutationFn = Apollo.MutationFunction<ResolveFollowMutation, ResolveFollowMutationVariables>;

/**
 * __useResolveFollowMutation__
 *
 * To run a mutation, you first call `useResolveFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveFollowMutation, { data, loading, error }] = useResolveFollowMutation({
 *   variables: {
 *      followerId: // value for 'followerId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useResolveFollowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResolveFollowMutation, ResolveFollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResolveFollowMutation, ResolveFollowMutationVariables>(ResolveFollowDocument, options);
      }
export type ResolveFollowMutationHookResult = ReturnType<typeof useResolveFollowMutation>;
export type ResolveFollowMutationResult = Apollo.MutationResult<ResolveFollowMutation>;
export type ResolveFollowMutationOptions = Apollo.BaseMutationOptions<ResolveFollowMutation, ResolveFollowMutationVariables>;
export const SelectPollOptionV2Document = gql`
    mutation selectPollOptionV2($data: SelectPollOptionArgs) {
  selectPollOptionV2(data: $data) {
    pollId
    hasUserSelected
    hasExpired
    votes
    options {
      optionId
      hasUserSelected
      votes
    }
  }
}
    `;
export type SelectPollOptionV2MutationFn = Apollo.MutationFunction<SelectPollOptionV2Mutation, SelectPollOptionV2MutationVariables>;

/**
 * __useSelectPollOptionV2Mutation__
 *
 * To run a mutation, you first call `useSelectPollOptionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectPollOptionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectPollOptionV2Mutation, { data, loading, error }] = useSelectPollOptionV2Mutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSelectPollOptionV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SelectPollOptionV2Mutation, SelectPollOptionV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SelectPollOptionV2Mutation, SelectPollOptionV2MutationVariables>(SelectPollOptionV2Document, options);
      }
export type SelectPollOptionV2MutationHookResult = ReturnType<typeof useSelectPollOptionV2Mutation>;
export type SelectPollOptionV2MutationResult = Apollo.MutationResult<SelectPollOptionV2Mutation>;
export type SelectPollOptionV2MutationOptions = Apollo.BaseMutationOptions<SelectPollOptionV2Mutation, SelectPollOptionV2MutationVariables>;
export const SetDefaultFeedDocument = gql`
    mutation setDefaultFeed($feedTypeId: String) {
  setDefaultFeed(feedTypeId: $feedTypeId) {
    feedTypeId
    feedType
    feedDisplayName
    default
    showSmartFeed
  }
}
    `;
export type SetDefaultFeedMutationFn = Apollo.MutationFunction<SetDefaultFeedMutation, SetDefaultFeedMutationVariables>;

/**
 * __useSetDefaultFeedMutation__
 *
 * To run a mutation, you first call `useSetDefaultFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultFeedMutation, { data, loading, error }] = useSetDefaultFeedMutation({
 *   variables: {
 *      feedTypeId: // value for 'feedTypeId'
 *   },
 * });
 */
export function useSetDefaultFeedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetDefaultFeedMutation, SetDefaultFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetDefaultFeedMutation, SetDefaultFeedMutationVariables>(SetDefaultFeedDocument, options);
      }
export type SetDefaultFeedMutationHookResult = ReturnType<typeof useSetDefaultFeedMutation>;
export type SetDefaultFeedMutationResult = Apollo.MutationResult<SetDefaultFeedMutation>;
export type SetDefaultFeedMutationOptions = Apollo.BaseMutationOptions<SetDefaultFeedMutation, SetDefaultFeedMutationVariables>;
export const SharePostV4Document = gql`
    mutation sharePostV4($data: SharePostInput) {
  sharePostV4(data: $data) {
    post {
      postId
    }
    message
    approvalRequestId
  }
}
    `;
export type SharePostV4MutationFn = Apollo.MutationFunction<SharePostV4Mutation, SharePostV4MutationVariables>;

/**
 * __useSharePostV4Mutation__
 *
 * To run a mutation, you first call `useSharePostV4Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharePostV4Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharePostV4Mutation, { data, loading, error }] = useSharePostV4Mutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSharePostV4Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SharePostV4Mutation, SharePostV4MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SharePostV4Mutation, SharePostV4MutationVariables>(SharePostV4Document, options);
      }
export type SharePostV4MutationHookResult = ReturnType<typeof useSharePostV4Mutation>;
export type SharePostV4MutationResult = Apollo.MutationResult<SharePostV4Mutation>;
export type SharePostV4MutationOptions = Apollo.BaseMutationOptions<SharePostV4Mutation, SharePostV4MutationVariables>;
export const ShareStockIdeaUpdateDocument = gql`
    mutation shareStockIdeaUpdate($data: SharePostInput) {
  shareStockIdeaUpdate(data: $data) {
    post {
      postId
    }
    message
    approvalRequestId
  }
}
    `;
export type ShareStockIdeaUpdateMutationFn = Apollo.MutationFunction<ShareStockIdeaUpdateMutation, ShareStockIdeaUpdateMutationVariables>;

/**
 * __useShareStockIdeaUpdateMutation__
 *
 * To run a mutation, you first call `useShareStockIdeaUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareStockIdeaUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareStockIdeaUpdateMutation, { data, loading, error }] = useShareStockIdeaUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useShareStockIdeaUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShareStockIdeaUpdateMutation, ShareStockIdeaUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShareStockIdeaUpdateMutation, ShareStockIdeaUpdateMutationVariables>(ShareStockIdeaUpdateDocument, options);
      }
export type ShareStockIdeaUpdateMutationHookResult = ReturnType<typeof useShareStockIdeaUpdateMutation>;
export type ShareStockIdeaUpdateMutationResult = Apollo.MutationResult<ShareStockIdeaUpdateMutation>;
export type ShareStockIdeaUpdateMutationOptions = Apollo.BaseMutationOptions<ShareStockIdeaUpdateMutation, ShareStockIdeaUpdateMutationVariables>;
export const ToggleDownvoteCommentDocument = gql`
    mutation toggleDownvoteComment($postId: String, $commentId: String, $clubBasedPermissionToken: String, $clubId: String) {
  toggleDownvoteComment(
    postId: $postId
    commentId: $commentId
    clubBasedPermissionToken: $clubBasedPermissionToken
    clubId: $clubId
  ) {
    postId
    commentId
    upvotecount
    downvotecount
    isUpvoted
    isDownvoted
  }
}
    `;
export type ToggleDownvoteCommentMutationFn = Apollo.MutationFunction<ToggleDownvoteCommentMutation, ToggleDownvoteCommentMutationVariables>;

/**
 * __useToggleDownvoteCommentMutation__
 *
 * To run a mutation, you first call `useToggleDownvoteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDownvoteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDownvoteCommentMutation, { data, loading, error }] = useToggleDownvoteCommentMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *      clubBasedPermissionToken: // value for 'clubBasedPermissionToken'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useToggleDownvoteCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleDownvoteCommentMutation, ToggleDownvoteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleDownvoteCommentMutation, ToggleDownvoteCommentMutationVariables>(ToggleDownvoteCommentDocument, options);
      }
export type ToggleDownvoteCommentMutationHookResult = ReturnType<typeof useToggleDownvoteCommentMutation>;
export type ToggleDownvoteCommentMutationResult = Apollo.MutationResult<ToggleDownvoteCommentMutation>;
export type ToggleDownvoteCommentMutationOptions = Apollo.BaseMutationOptions<ToggleDownvoteCommentMutation, ToggleDownvoteCommentMutationVariables>;
export const ToggleDownvotePostDocument = gql`
    mutation toggleDownvotePost($postId: String, $clubBasedPermissionToken: String, $clubId: String) {
  toggleDownvotePost(
    postId: $postId
    clubBasedPermissionToken: $clubBasedPermissionToken
    clubId: $clubId
  ) {
    postId
    upvotecount
    downvotecount
    isUpvoted
    isDownvoted
  }
}
    `;
export type ToggleDownvotePostMutationFn = Apollo.MutationFunction<ToggleDownvotePostMutation, ToggleDownvotePostMutationVariables>;

/**
 * __useToggleDownvotePostMutation__
 *
 * To run a mutation, you first call `useToggleDownvotePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDownvotePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDownvotePostMutation, { data, loading, error }] = useToggleDownvotePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      clubBasedPermissionToken: // value for 'clubBasedPermissionToken'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useToggleDownvotePostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleDownvotePostMutation, ToggleDownvotePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleDownvotePostMutation, ToggleDownvotePostMutationVariables>(ToggleDownvotePostDocument, options);
      }
export type ToggleDownvotePostMutationHookResult = ReturnType<typeof useToggleDownvotePostMutation>;
export type ToggleDownvotePostMutationResult = Apollo.MutationResult<ToggleDownvotePostMutation>;
export type ToggleDownvotePostMutationOptions = Apollo.BaseMutationOptions<ToggleDownvotePostMutation, ToggleDownvotePostMutationVariables>;
export const ToggleDownvoteReplyDocument = gql`
    mutation toggleDownvoteReply($postId: String, $commentId: String, $replyId: String, $clubBasedPermissionToken: String, $clubId: String) {
  toggleDownvoteReply(
    postId: $postId
    commentId: $commentId
    replyId: $replyId
    clubBasedPermissionToken: $clubBasedPermissionToken
    clubId: $clubId
  ) {
    postId
    commentId
    replyId
    upvotecount
    downvotecount
    isUpvoted
    isDownvoted
  }
}
    `;
export type ToggleDownvoteReplyMutationFn = Apollo.MutationFunction<ToggleDownvoteReplyMutation, ToggleDownvoteReplyMutationVariables>;

/**
 * __useToggleDownvoteReplyMutation__
 *
 * To run a mutation, you first call `useToggleDownvoteReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDownvoteReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDownvoteReplyMutation, { data, loading, error }] = useToggleDownvoteReplyMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *      replyId: // value for 'replyId'
 *      clubBasedPermissionToken: // value for 'clubBasedPermissionToken'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useToggleDownvoteReplyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleDownvoteReplyMutation, ToggleDownvoteReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleDownvoteReplyMutation, ToggleDownvoteReplyMutationVariables>(ToggleDownvoteReplyDocument, options);
      }
export type ToggleDownvoteReplyMutationHookResult = ReturnType<typeof useToggleDownvoteReplyMutation>;
export type ToggleDownvoteReplyMutationResult = Apollo.MutationResult<ToggleDownvoteReplyMutation>;
export type ToggleDownvoteReplyMutationOptions = Apollo.BaseMutationOptions<ToggleDownvoteReplyMutation, ToggleDownvoteReplyMutationVariables>;
export const ToggleIsWatchlistVisibleDocument = gql`
    mutation toggleIsWatchlistVisible {
  toggleIsWatchlistVisible
}
    `;
export type ToggleIsWatchlistVisibleMutationFn = Apollo.MutationFunction<ToggleIsWatchlistVisibleMutation, ToggleIsWatchlistVisibleMutationVariables>;

/**
 * __useToggleIsWatchlistVisibleMutation__
 *
 * To run a mutation, you first call `useToggleIsWatchlistVisibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleIsWatchlistVisibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleIsWatchlistVisibleMutation, { data, loading, error }] = useToggleIsWatchlistVisibleMutation({
 *   variables: {
 *   },
 * });
 */
export function useToggleIsWatchlistVisibleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleIsWatchlistVisibleMutation, ToggleIsWatchlistVisibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleIsWatchlistVisibleMutation, ToggleIsWatchlistVisibleMutationVariables>(ToggleIsWatchlistVisibleDocument, options);
      }
export type ToggleIsWatchlistVisibleMutationHookResult = ReturnType<typeof useToggleIsWatchlistVisibleMutation>;
export type ToggleIsWatchlistVisibleMutationResult = Apollo.MutationResult<ToggleIsWatchlistVisibleMutation>;
export type ToggleIsWatchlistVisibleMutationOptions = Apollo.BaseMutationOptions<ToggleIsWatchlistVisibleMutation, ToggleIsWatchlistVisibleMutationVariables>;
export const ToggleSubscribeHashtagDocument = gql`
    mutation toggleSubscribeHashtag($hashtagId: ID) {
  toggleSubscribeHashtag(hashtagId: $hashtagId) {
    TagId
    hashtagName
    isfollow
    issubscribed
  }
}
    `;
export type ToggleSubscribeHashtagMutationFn = Apollo.MutationFunction<ToggleSubscribeHashtagMutation, ToggleSubscribeHashtagMutationVariables>;

/**
 * __useToggleSubscribeHashtagMutation__
 *
 * To run a mutation, you first call `useToggleSubscribeHashtagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleSubscribeHashtagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleSubscribeHashtagMutation, { data, loading, error }] = useToggleSubscribeHashtagMutation({
 *   variables: {
 *      hashtagId: // value for 'hashtagId'
 *   },
 * });
 */
export function useToggleSubscribeHashtagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleSubscribeHashtagMutation, ToggleSubscribeHashtagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleSubscribeHashtagMutation, ToggleSubscribeHashtagMutationVariables>(ToggleSubscribeHashtagDocument, options);
      }
export type ToggleSubscribeHashtagMutationHookResult = ReturnType<typeof useToggleSubscribeHashtagMutation>;
export type ToggleSubscribeHashtagMutationResult = Apollo.MutationResult<ToggleSubscribeHashtagMutation>;
export type ToggleSubscribeHashtagMutationOptions = Apollo.BaseMutationOptions<ToggleSubscribeHashtagMutation, ToggleSubscribeHashtagMutationVariables>;
export const ToggleSubscribeUserDocument = gql`
    mutation toggleSubscribeUser($userId: ID) {
  toggleSubscribeUser(userId: $userId) {
    id
    username
    issubscribed
  }
}
    `;
export type ToggleSubscribeUserMutationFn = Apollo.MutationFunction<ToggleSubscribeUserMutation, ToggleSubscribeUserMutationVariables>;

/**
 * __useToggleSubscribeUserMutation__
 *
 * To run a mutation, you first call `useToggleSubscribeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleSubscribeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleSubscribeUserMutation, { data, loading, error }] = useToggleSubscribeUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useToggleSubscribeUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleSubscribeUserMutation, ToggleSubscribeUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleSubscribeUserMutation, ToggleSubscribeUserMutationVariables>(ToggleSubscribeUserDocument, options);
      }
export type ToggleSubscribeUserMutationHookResult = ReturnType<typeof useToggleSubscribeUserMutation>;
export type ToggleSubscribeUserMutationResult = Apollo.MutationResult<ToggleSubscribeUserMutation>;
export type ToggleSubscribeUserMutationOptions = Apollo.BaseMutationOptions<ToggleSubscribeUserMutation, ToggleSubscribeUserMutationVariables>;
export const ToggleUpvoteCommentDocument = gql`
    mutation toggleUpvoteComment($postId: String, $commentId: String, $clubBasedPermissionToken: String, $clubId: String) {
  toggleUpvoteComment(
    postId: $postId
    commentId: $commentId
    clubBasedPermissionToken: $clubBasedPermissionToken
    clubId: $clubId
  ) {
    postId
    commentId
    upvotecount
    downvotecount
    isUpvoted
    isDownvoted
  }
}
    `;
export type ToggleUpvoteCommentMutationFn = Apollo.MutationFunction<ToggleUpvoteCommentMutation, ToggleUpvoteCommentMutationVariables>;

/**
 * __useToggleUpvoteCommentMutation__
 *
 * To run a mutation, you first call `useToggleUpvoteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUpvoteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUpvoteCommentMutation, { data, loading, error }] = useToggleUpvoteCommentMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *      clubBasedPermissionToken: // value for 'clubBasedPermissionToken'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useToggleUpvoteCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleUpvoteCommentMutation, ToggleUpvoteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleUpvoteCommentMutation, ToggleUpvoteCommentMutationVariables>(ToggleUpvoteCommentDocument, options);
      }
export type ToggleUpvoteCommentMutationHookResult = ReturnType<typeof useToggleUpvoteCommentMutation>;
export type ToggleUpvoteCommentMutationResult = Apollo.MutationResult<ToggleUpvoteCommentMutation>;
export type ToggleUpvoteCommentMutationOptions = Apollo.BaseMutationOptions<ToggleUpvoteCommentMutation, ToggleUpvoteCommentMutationVariables>;
export const ToggleUpvotePostDocument = gql`
    mutation toggleUpvotePost($postId: String, $clubBasedPermissionToken: String, $clubId: String) {
  toggleUpvotePost(
    postId: $postId
    clubBasedPermissionToken: $clubBasedPermissionToken
    clubId: $clubId
  ) {
    postId
    upvotecount
    downvotecount
    isUpvoted
    isDownvoted
  }
}
    `;
export type ToggleUpvotePostMutationFn = Apollo.MutationFunction<ToggleUpvotePostMutation, ToggleUpvotePostMutationVariables>;

/**
 * __useToggleUpvotePostMutation__
 *
 * To run a mutation, you first call `useToggleUpvotePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUpvotePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUpvotePostMutation, { data, loading, error }] = useToggleUpvotePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      clubBasedPermissionToken: // value for 'clubBasedPermissionToken'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useToggleUpvotePostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleUpvotePostMutation, ToggleUpvotePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleUpvotePostMutation, ToggleUpvotePostMutationVariables>(ToggleUpvotePostDocument, options);
      }
export type ToggleUpvotePostMutationHookResult = ReturnType<typeof useToggleUpvotePostMutation>;
export type ToggleUpvotePostMutationResult = Apollo.MutationResult<ToggleUpvotePostMutation>;
export type ToggleUpvotePostMutationOptions = Apollo.BaseMutationOptions<ToggleUpvotePostMutation, ToggleUpvotePostMutationVariables>;
export const ToggleUpvoteReplyDocument = gql`
    mutation toggleUpvoteReply($postId: String, $commentId: String, $replyId: String, $clubBasedPermissionToken: String, $clubId: String) {
  toggleUpvoteReply(
    postId: $postId
    commentId: $commentId
    replyId: $replyId
    clubBasedPermissionToken: $clubBasedPermissionToken
    clubId: $clubId
  ) {
    postId
    commentId
    replyId
    upvotecount
    downvotecount
    isUpvoted
    isDownvoted
  }
}
    `;
export type ToggleUpvoteReplyMutationFn = Apollo.MutationFunction<ToggleUpvoteReplyMutation, ToggleUpvoteReplyMutationVariables>;

/**
 * __useToggleUpvoteReplyMutation__
 *
 * To run a mutation, you first call `useToggleUpvoteReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUpvoteReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUpvoteReplyMutation, { data, loading, error }] = useToggleUpvoteReplyMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *      replyId: // value for 'replyId'
 *      clubBasedPermissionToken: // value for 'clubBasedPermissionToken'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useToggleUpvoteReplyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleUpvoteReplyMutation, ToggleUpvoteReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleUpvoteReplyMutation, ToggleUpvoteReplyMutationVariables>(ToggleUpvoteReplyDocument, options);
      }
export type ToggleUpvoteReplyMutationHookResult = ReturnType<typeof useToggleUpvoteReplyMutation>;
export type ToggleUpvoteReplyMutationResult = Apollo.MutationResult<ToggleUpvoteReplyMutation>;
export type ToggleUpvoteReplyMutationOptions = Apollo.BaseMutationOptions<ToggleUpvoteReplyMutation, ToggleUpvoteReplyMutationVariables>;
export const TurnOffHighlightForAchievementDocument = gql`
    mutation turnOffHighlightForAchievement($achievementType: String) {
  turnOffHighlightForAchievement(achievementType: $achievementType) {
    success
    message
  }
}
    `;
export type TurnOffHighlightForAchievementMutationFn = Apollo.MutationFunction<TurnOffHighlightForAchievementMutation, TurnOffHighlightForAchievementMutationVariables>;

/**
 * __useTurnOffHighlightForAchievementMutation__
 *
 * To run a mutation, you first call `useTurnOffHighlightForAchievementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTurnOffHighlightForAchievementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [turnOffHighlightForAchievementMutation, { data, loading, error }] = useTurnOffHighlightForAchievementMutation({
 *   variables: {
 *      achievementType: // value for 'achievementType'
 *   },
 * });
 */
export function useTurnOffHighlightForAchievementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TurnOffHighlightForAchievementMutation, TurnOffHighlightForAchievementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TurnOffHighlightForAchievementMutation, TurnOffHighlightForAchievementMutationVariables>(TurnOffHighlightForAchievementDocument, options);
      }
export type TurnOffHighlightForAchievementMutationHookResult = ReturnType<typeof useTurnOffHighlightForAchievementMutation>;
export type TurnOffHighlightForAchievementMutationResult = Apollo.MutationResult<TurnOffHighlightForAchievementMutation>;
export type TurnOffHighlightForAchievementMutationOptions = Apollo.BaseMutationOptions<TurnOffHighlightForAchievementMutation, TurnOffHighlightForAchievementMutationVariables>;
export const TurnOffNotificationByTypeOfNotificationDocument = gql`
    mutation turnOffNotificationByTypeOfNotification($notificationId: String) {
  turnOffNotificationByTypeOfNotification(notificationId: $notificationId) {
    success
    message
  }
}
    `;
export type TurnOffNotificationByTypeOfNotificationMutationFn = Apollo.MutationFunction<TurnOffNotificationByTypeOfNotificationMutation, TurnOffNotificationByTypeOfNotificationMutationVariables>;

/**
 * __useTurnOffNotificationByTypeOfNotificationMutation__
 *
 * To run a mutation, you first call `useTurnOffNotificationByTypeOfNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTurnOffNotificationByTypeOfNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [turnOffNotificationByTypeOfNotificationMutation, { data, loading, error }] = useTurnOffNotificationByTypeOfNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useTurnOffNotificationByTypeOfNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TurnOffNotificationByTypeOfNotificationMutation, TurnOffNotificationByTypeOfNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TurnOffNotificationByTypeOfNotificationMutation, TurnOffNotificationByTypeOfNotificationMutationVariables>(TurnOffNotificationByTypeOfNotificationDocument, options);
      }
export type TurnOffNotificationByTypeOfNotificationMutationHookResult = ReturnType<typeof useTurnOffNotificationByTypeOfNotificationMutation>;
export type TurnOffNotificationByTypeOfNotificationMutationResult = Apollo.MutationResult<TurnOffNotificationByTypeOfNotificationMutation>;
export type TurnOffNotificationByTypeOfNotificationMutationOptions = Apollo.BaseMutationOptions<TurnOffNotificationByTypeOfNotificationMutation, TurnOffNotificationByTypeOfNotificationMutationVariables>;
export const UnPinPostDocument = gql`
    mutation unPinPost($postId: String) {
  unPinPost(postId: $postId) {
    ...PostFields
    isPinned
    isPinnedByUser
  }
}
    ${PostFieldsFragmentDoc}`;
export type UnPinPostMutationFn = Apollo.MutationFunction<UnPinPostMutation, UnPinPostMutationVariables>;

/**
 * __useUnPinPostMutation__
 *
 * To run a mutation, you first call `useUnPinPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnPinPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unPinPostMutation, { data, loading, error }] = useUnPinPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useUnPinPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnPinPostMutation, UnPinPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnPinPostMutation, UnPinPostMutationVariables>(UnPinPostDocument, options);
      }
export type UnPinPostMutationHookResult = ReturnType<typeof useUnPinPostMutation>;
export type UnPinPostMutationResult = Apollo.MutationResult<UnPinPostMutation>;
export type UnPinPostMutationOptions = Apollo.BaseMutationOptions<UnPinPostMutation, UnPinPostMutationVariables>;
export const UnblockUserDocument = gql`
    mutation unblockUser($id: String!) {
  unblockUser(id: $id) {
    success
    message
  }
}
    `;
export type UnblockUserMutationFn = Apollo.MutationFunction<UnblockUserMutation, UnblockUserMutationVariables>;

/**
 * __useUnblockUserMutation__
 *
 * To run a mutation, you first call `useUnblockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockUserMutation, { data, loading, error }] = useUnblockUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnblockUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnblockUserMutation, UnblockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnblockUserMutation, UnblockUserMutationVariables>(UnblockUserDocument, options);
      }
export type UnblockUserMutationHookResult = ReturnType<typeof useUnblockUserMutation>;
export type UnblockUserMutationResult = Apollo.MutationResult<UnblockUserMutation>;
export type UnblockUserMutationOptions = Apollo.BaseMutationOptions<UnblockUserMutation, UnblockUserMutationVariables>;
export const UnfollowHashtagV2Document = gql`
    mutation unfollowHashtagV2($hashtagId: ID) {
  unfollowHashtagV2(hashtagId: $hashtagId) {
    TagId
    hashtagName
    isfollow
    issubscribed
  }
}
    `;
export type UnfollowHashtagV2MutationFn = Apollo.MutationFunction<UnfollowHashtagV2Mutation, UnfollowHashtagV2MutationVariables>;

/**
 * __useUnfollowHashtagV2Mutation__
 *
 * To run a mutation, you first call `useUnfollowHashtagV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowHashtagV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowHashtagV2Mutation, { data, loading, error }] = useUnfollowHashtagV2Mutation({
 *   variables: {
 *      hashtagId: // value for 'hashtagId'
 *   },
 * });
 */
export function useUnfollowHashtagV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnfollowHashtagV2Mutation, UnfollowHashtagV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnfollowHashtagV2Mutation, UnfollowHashtagV2MutationVariables>(UnfollowHashtagV2Document, options);
      }
export type UnfollowHashtagV2MutationHookResult = ReturnType<typeof useUnfollowHashtagV2Mutation>;
export type UnfollowHashtagV2MutationResult = Apollo.MutationResult<UnfollowHashtagV2Mutation>;
export type UnfollowHashtagV2MutationOptions = Apollo.BaseMutationOptions<UnfollowHashtagV2Mutation, UnfollowHashtagV2MutationVariables>;
export const UnfollowPostDocument = gql`
    mutation unfollowPost($data: FollowPostInput!) {
  unfollowPost(data: $data) {
    post {
      postId
      isFollowed
    }
    message
  }
}
    `;
export type UnfollowPostMutationFn = Apollo.MutationFunction<UnfollowPostMutation, UnfollowPostMutationVariables>;

/**
 * __useUnfollowPostMutation__
 *
 * To run a mutation, you first call `useUnfollowPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowPostMutation, { data, loading, error }] = useUnfollowPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUnfollowPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnfollowPostMutation, UnfollowPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnfollowPostMutation, UnfollowPostMutationVariables>(UnfollowPostDocument, options);
      }
export type UnfollowPostMutationHookResult = ReturnType<typeof useUnfollowPostMutation>;
export type UnfollowPostMutationResult = Apollo.MutationResult<UnfollowPostMutation>;
export type UnfollowPostMutationOptions = Apollo.BaseMutationOptions<UnfollowPostMutation, UnfollowPostMutationVariables>;
export const UnfollowUserV2Document = gql`
    mutation unfollowUserV2($userId: ID) {
  unfollowUserV2(userId: $userId) {
    id
    username
    isfollow
    followerCount
    followingCount
  }
}
    `;
export type UnfollowUserV2MutationFn = Apollo.MutationFunction<UnfollowUserV2Mutation, UnfollowUserV2MutationVariables>;

/**
 * __useUnfollowUserV2Mutation__
 *
 * To run a mutation, you first call `useUnfollowUserV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowUserV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowUserV2Mutation, { data, loading, error }] = useUnfollowUserV2Mutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnfollowUserV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnfollowUserV2Mutation, UnfollowUserV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnfollowUserV2Mutation, UnfollowUserV2MutationVariables>(UnfollowUserV2Document, options);
      }
export type UnfollowUserV2MutationHookResult = ReturnType<typeof useUnfollowUserV2Mutation>;
export type UnfollowUserV2MutationResult = Apollo.MutationResult<UnfollowUserV2Mutation>;
export type UnfollowUserV2MutationOptions = Apollo.BaseMutationOptions<UnfollowUserV2Mutation, UnfollowUserV2MutationVariables>;
export const UnmarkClubFavouriteDocument = gql`
    mutation unmarkClubFavourite($clubId: String) {
  unmarkClubFavourite(clubId: $clubId) {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;
export type UnmarkClubFavouriteMutationFn = Apollo.MutationFunction<UnmarkClubFavouriteMutation, UnmarkClubFavouriteMutationVariables>;

/**
 * __useUnmarkClubFavouriteMutation__
 *
 * To run a mutation, you first call `useUnmarkClubFavouriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmarkClubFavouriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmarkClubFavouriteMutation, { data, loading, error }] = useUnmarkClubFavouriteMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useUnmarkClubFavouriteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnmarkClubFavouriteMutation, UnmarkClubFavouriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnmarkClubFavouriteMutation, UnmarkClubFavouriteMutationVariables>(UnmarkClubFavouriteDocument, options);
      }
export type UnmarkClubFavouriteMutationHookResult = ReturnType<typeof useUnmarkClubFavouriteMutation>;
export type UnmarkClubFavouriteMutationResult = Apollo.MutationResult<UnmarkClubFavouriteMutation>;
export type UnmarkClubFavouriteMutationOptions = Apollo.BaseMutationOptions<UnmarkClubFavouriteMutation, UnmarkClubFavouriteMutationVariables>;
export const UnreadNotificationDocument = gql`
    mutation unreadNotification($notificationId: String) {
  unreadNotification(notificationId: $notificationId) {
    success
    message
  }
}
    `;
export type UnreadNotificationMutationFn = Apollo.MutationFunction<UnreadNotificationMutation, UnreadNotificationMutationVariables>;

/**
 * __useUnreadNotificationMutation__
 *
 * To run a mutation, you first call `useUnreadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unreadNotificationMutation, { data, loading, error }] = useUnreadNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useUnreadNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnreadNotificationMutation, UnreadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnreadNotificationMutation, UnreadNotificationMutationVariables>(UnreadNotificationDocument, options);
      }
export type UnreadNotificationMutationHookResult = ReturnType<typeof useUnreadNotificationMutation>;
export type UnreadNotificationMutationResult = Apollo.MutationResult<UnreadNotificationMutation>;
export type UnreadNotificationMutationOptions = Apollo.BaseMutationOptions<UnreadNotificationMutation, UnreadNotificationMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($data: UserUpdateArgs!) {
  updateUser(data: $data) {
    id
    username
    firstName
    lastName
    bio
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserImageDocument = gql`
    mutation updateUserImage($data: UserImageArgs!) {
  updateUserImage(data: $data) {
    success
  }
}
    `;
export type UpdateUserImageMutationFn = Apollo.MutationFunction<UpdateUserImageMutation, UpdateUserImageMutationVariables>;

/**
 * __useUpdateUserImageMutation__
 *
 * To run a mutation, you first call `useUpdateUserImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserImageMutation, { data, loading, error }] = useUpdateUserImageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserImageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserImageMutation, UpdateUserImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserImageMutation, UpdateUserImageMutationVariables>(UpdateUserImageDocument, options);
      }
export type UpdateUserImageMutationHookResult = ReturnType<typeof useUpdateUserImageMutation>;
export type UpdateUserImageMutationResult = Apollo.MutationResult<UpdateUserImageMutation>;
export type UpdateUserImageMutationOptions = Apollo.BaseMutationOptions<UpdateUserImageMutation, UpdateUserImageMutationVariables>;
export const UpdateUserSettingsDocument = gql`
    mutation updateUserSettings($data: UpdateUserSettings!) {
  updateUserSettings(data: $data) {
    profileType
  }
}
    `;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, options);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const WithdrawApprovalRequestDocument = gql`
    mutation withdrawApprovalRequest($approvalRequestId: String!) {
  withdrawApprovalRequest(approvalRequestId: $approvalRequestId) {
    success
    message
  }
}
    `;
export type WithdrawApprovalRequestMutationFn = Apollo.MutationFunction<WithdrawApprovalRequestMutation, WithdrawApprovalRequestMutationVariables>;

/**
 * __useWithdrawApprovalRequestMutation__
 *
 * To run a mutation, you first call `useWithdrawApprovalRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawApprovalRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawApprovalRequestMutation, { data, loading, error }] = useWithdrawApprovalRequestMutation({
 *   variables: {
 *      approvalRequestId: // value for 'approvalRequestId'
 *   },
 * });
 */
export function useWithdrawApprovalRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WithdrawApprovalRequestMutation, WithdrawApprovalRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<WithdrawApprovalRequestMutation, WithdrawApprovalRequestMutationVariables>(WithdrawApprovalRequestDocument, options);
      }
export type WithdrawApprovalRequestMutationHookResult = ReturnType<typeof useWithdrawApprovalRequestMutation>;
export type WithdrawApprovalRequestMutationResult = Apollo.MutationResult<WithdrawApprovalRequestMutation>;
export type WithdrawApprovalRequestMutationOptions = Apollo.BaseMutationOptions<WithdrawApprovalRequestMutation, WithdrawApprovalRequestMutationVariables>;
export const ClubExpertStockSectorTopicFilterDocument = gql`
    query ClubExpertStockSectorTopicFilter($offset: Int!, $limit: Int!, $clubId: String!) {
  getClubTrendingStocksViaDollarTag(
    offset: $offset
    limit: $limit
    clubId: $clubId
  ) {
    ...DollarTagFields
  }
  getClubTrendingSectorsViaDollarTag(
    offset: $offset
    limit: $limit
    clubId: $clubId
  ) {
    ...DollarTagFields
  }
  getClubTrendingHashtagsV2(offset: $offset, limit: $limit, clubId: $clubId) {
    TagId
    hashtagName
    postCount
    isfollow
    issubscribed
    followers
  }
  getPopularPeopleClubBased(clubId: $clubId, offset: $offset, limit: $limit) {
    id
    username
    firstName
    lastName
    avatar
    isfollow
    membershipLevel
    isVerified
    greenTick
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useClubExpertStockSectorTopicFilterQuery__
 *
 * To run a query within a React component, call `useClubExpertStockSectorTopicFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useClubExpertStockSectorTopicFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClubExpertStockSectorTopicFilterQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useClubExpertStockSectorTopicFilterQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ClubExpertStockSectorTopicFilterQuery, ClubExpertStockSectorTopicFilterQueryVariables> & ({ variables: ClubExpertStockSectorTopicFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClubExpertStockSectorTopicFilterQuery, ClubExpertStockSectorTopicFilterQueryVariables>(ClubExpertStockSectorTopicFilterDocument, options);
      }
export function useClubExpertStockSectorTopicFilterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClubExpertStockSectorTopicFilterQuery, ClubExpertStockSectorTopicFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClubExpertStockSectorTopicFilterQuery, ClubExpertStockSectorTopicFilterQueryVariables>(ClubExpertStockSectorTopicFilterDocument, options);
        }
export function useClubExpertStockSectorTopicFilterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClubExpertStockSectorTopicFilterQuery, ClubExpertStockSectorTopicFilterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClubExpertStockSectorTopicFilterQuery, ClubExpertStockSectorTopicFilterQueryVariables>(ClubExpertStockSectorTopicFilterDocument, options);
        }
export type ClubExpertStockSectorTopicFilterQueryHookResult = ReturnType<typeof useClubExpertStockSectorTopicFilterQuery>;
export type ClubExpertStockSectorTopicFilterLazyQueryHookResult = ReturnType<typeof useClubExpertStockSectorTopicFilterLazyQuery>;
export type ClubExpertStockSectorTopicFilterSuspenseQueryHookResult = ReturnType<typeof useClubExpertStockSectorTopicFilterSuspenseQuery>;
export type ClubExpertStockSectorTopicFilterQueryResult = Apollo.QueryResult<ClubExpertStockSectorTopicFilterQuery, ClubExpertStockSectorTopicFilterQueryVariables>;
export const GetAnalystHighlightDetailsDocument = gql`
    query GetAnalystHighlightDetails($userId: String) {
  getAnalystHighlightDetails(userId: $userId) {
    awards
    userId
    experience
    qualification
    sebiCertificate
    specializes
  }
}
    `;

/**
 * __useGetAnalystHighlightDetailsQuery__
 *
 * To run a query within a React component, call `useGetAnalystHighlightDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalystHighlightDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalystHighlightDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetAnalystHighlightDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAnalystHighlightDetailsQuery, GetAnalystHighlightDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAnalystHighlightDetailsQuery, GetAnalystHighlightDetailsQueryVariables>(GetAnalystHighlightDetailsDocument, options);
      }
export function useGetAnalystHighlightDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAnalystHighlightDetailsQuery, GetAnalystHighlightDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAnalystHighlightDetailsQuery, GetAnalystHighlightDetailsQueryVariables>(GetAnalystHighlightDetailsDocument, options);
        }
export function useGetAnalystHighlightDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAnalystHighlightDetailsQuery, GetAnalystHighlightDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAnalystHighlightDetailsQuery, GetAnalystHighlightDetailsQueryVariables>(GetAnalystHighlightDetailsDocument, options);
        }
export type GetAnalystHighlightDetailsQueryHookResult = ReturnType<typeof useGetAnalystHighlightDetailsQuery>;
export type GetAnalystHighlightDetailsLazyQueryHookResult = ReturnType<typeof useGetAnalystHighlightDetailsLazyQuery>;
export type GetAnalystHighlightDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAnalystHighlightDetailsSuspenseQuery>;
export type GetAnalystHighlightDetailsQueryResult = Apollo.QueryResult<GetAnalystHighlightDetailsQuery, GetAnalystHighlightDetailsQueryVariables>;
export const CheckIfAddedToSavedSearchDocument = gql`
    query CheckIfAddedToSavedSearch($data: [UserRecentSearchInput]) {
  checkIfAddedToSavedSearch(data: $data) {
    searchId
    isSaved
  }
}
    `;

/**
 * __useCheckIfAddedToSavedSearchQuery__
 *
 * To run a query within a React component, call `useCheckIfAddedToSavedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfAddedToSavedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfAddedToSavedSearchQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCheckIfAddedToSavedSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckIfAddedToSavedSearchQuery, CheckIfAddedToSavedSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckIfAddedToSavedSearchQuery, CheckIfAddedToSavedSearchQueryVariables>(CheckIfAddedToSavedSearchDocument, options);
      }
export function useCheckIfAddedToSavedSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckIfAddedToSavedSearchQuery, CheckIfAddedToSavedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckIfAddedToSavedSearchQuery, CheckIfAddedToSavedSearchQueryVariables>(CheckIfAddedToSavedSearchDocument, options);
        }
export function useCheckIfAddedToSavedSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckIfAddedToSavedSearchQuery, CheckIfAddedToSavedSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckIfAddedToSavedSearchQuery, CheckIfAddedToSavedSearchQueryVariables>(CheckIfAddedToSavedSearchDocument, options);
        }
export type CheckIfAddedToSavedSearchQueryHookResult = ReturnType<typeof useCheckIfAddedToSavedSearchQuery>;
export type CheckIfAddedToSavedSearchLazyQueryHookResult = ReturnType<typeof useCheckIfAddedToSavedSearchLazyQuery>;
export type CheckIfAddedToSavedSearchSuspenseQueryHookResult = ReturnType<typeof useCheckIfAddedToSavedSearchSuspenseQuery>;
export type CheckIfAddedToSavedSearchQueryResult = Apollo.QueryResult<CheckIfAddedToSavedSearchQuery, CheckIfAddedToSavedSearchQueryVariables>;
export const CheckNewPostsByFeedTypeDocument = gql`
    query checkNewPostsByFeedType($date: String, $feedType: String) {
  checkNewPostsByFeedType(date: $date, feedType: $feedType)
}
    `;

/**
 * __useCheckNewPostsByFeedTypeQuery__
 *
 * To run a query within a React component, call `useCheckNewPostsByFeedTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckNewPostsByFeedTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckNewPostsByFeedTypeQuery({
 *   variables: {
 *      date: // value for 'date'
 *      feedType: // value for 'feedType'
 *   },
 * });
 */
export function useCheckNewPostsByFeedTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckNewPostsByFeedTypeQuery, CheckNewPostsByFeedTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckNewPostsByFeedTypeQuery, CheckNewPostsByFeedTypeQueryVariables>(CheckNewPostsByFeedTypeDocument, options);
      }
export function useCheckNewPostsByFeedTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckNewPostsByFeedTypeQuery, CheckNewPostsByFeedTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckNewPostsByFeedTypeQuery, CheckNewPostsByFeedTypeQueryVariables>(CheckNewPostsByFeedTypeDocument, options);
        }
export function useCheckNewPostsByFeedTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckNewPostsByFeedTypeQuery, CheckNewPostsByFeedTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckNewPostsByFeedTypeQuery, CheckNewPostsByFeedTypeQueryVariables>(CheckNewPostsByFeedTypeDocument, options);
        }
export type CheckNewPostsByFeedTypeQueryHookResult = ReturnType<typeof useCheckNewPostsByFeedTypeQuery>;
export type CheckNewPostsByFeedTypeLazyQueryHookResult = ReturnType<typeof useCheckNewPostsByFeedTypeLazyQuery>;
export type CheckNewPostsByFeedTypeSuspenseQueryHookResult = ReturnType<typeof useCheckNewPostsByFeedTypeSuspenseQuery>;
export type CheckNewPostsByFeedTypeQueryResult = Apollo.QueryResult<CheckNewPostsByFeedTypeQuery, CheckNewPostsByFeedTypeQueryVariables>;
export const FollowFollowingClubCountsDocument = gql`
    query FollowFollowingClubCounts($userId: String!) {
  followers: getFollowersCount(data: {id: $userId, entity: User})
  followings: getFollowingsCount(data: {id: $userId, entity: User})
  clubs: getClubsOfUserCount(userId: $userId)
}
    `;

/**
 * __useFollowFollowingClubCountsQuery__
 *
 * To run a query within a React component, call `useFollowFollowingClubCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowFollowingClubCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowFollowingClubCountsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFollowFollowingClubCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FollowFollowingClubCountsQuery, FollowFollowingClubCountsQueryVariables> & ({ variables: FollowFollowingClubCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FollowFollowingClubCountsQuery, FollowFollowingClubCountsQueryVariables>(FollowFollowingClubCountsDocument, options);
      }
export function useFollowFollowingClubCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FollowFollowingClubCountsQuery, FollowFollowingClubCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FollowFollowingClubCountsQuery, FollowFollowingClubCountsQueryVariables>(FollowFollowingClubCountsDocument, options);
        }
export function useFollowFollowingClubCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FollowFollowingClubCountsQuery, FollowFollowingClubCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FollowFollowingClubCountsQuery, FollowFollowingClubCountsQueryVariables>(FollowFollowingClubCountsDocument, options);
        }
export type FollowFollowingClubCountsQueryHookResult = ReturnType<typeof useFollowFollowingClubCountsQuery>;
export type FollowFollowingClubCountsLazyQueryHookResult = ReturnType<typeof useFollowFollowingClubCountsLazyQuery>;
export type FollowFollowingClubCountsSuspenseQueryHookResult = ReturnType<typeof useFollowFollowingClubCountsSuspenseQuery>;
export type FollowFollowingClubCountsQueryResult = Apollo.QueryResult<FollowFollowingClubCountsQuery, FollowFollowingClubCountsQueryVariables>;
export const GetAchievementDetailsDocument = gql`
    query getAchievementDetails($achievementType: String, $sourceOfClick: String) {
  getAchievementDetails(
    achievementType: $achievementType
    sourceOfClick: $sourceOfClick
  ) {
    text1
    text2
    text3
    allowFeedback
    badgeDetails {
      badgeName
      badgeId
      badgeIcon
      badgeType
    }
    share {
      text
      imageLink
      externalImageLink
      externalText
      ctaUrl
    }
  }
}
    `;

/**
 * __useGetAchievementDetailsQuery__
 *
 * To run a query within a React component, call `useGetAchievementDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAchievementDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAchievementDetailsQuery({
 *   variables: {
 *      achievementType: // value for 'achievementType'
 *      sourceOfClick: // value for 'sourceOfClick'
 *   },
 * });
 */
export function useGetAchievementDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAchievementDetailsQuery, GetAchievementDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAchievementDetailsQuery, GetAchievementDetailsQueryVariables>(GetAchievementDetailsDocument, options);
      }
export function useGetAchievementDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAchievementDetailsQuery, GetAchievementDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAchievementDetailsQuery, GetAchievementDetailsQueryVariables>(GetAchievementDetailsDocument, options);
        }
export function useGetAchievementDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAchievementDetailsQuery, GetAchievementDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAchievementDetailsQuery, GetAchievementDetailsQueryVariables>(GetAchievementDetailsDocument, options);
        }
export type GetAchievementDetailsQueryHookResult = ReturnType<typeof useGetAchievementDetailsQuery>;
export type GetAchievementDetailsLazyQueryHookResult = ReturnType<typeof useGetAchievementDetailsLazyQuery>;
export type GetAchievementDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAchievementDetailsSuspenseQuery>;
export type GetAchievementDetailsQueryResult = Apollo.QueryResult<GetAchievementDetailsQuery, GetAchievementDetailsQueryVariables>;
export const GetAllAchievementStatusDocument = gql`
    query getAllAchievementStatus {
  getAllAchievementStatus {
    data {
      achievementType
      achievementName
      milestoneData {
        isMilestoneCompleted
        MilestoneName
        runningMilestone
      }
    }
    errorMessage {
      errCode
      errMessage
    }
  }
}
    `;

/**
 * __useGetAllAchievementStatusQuery__
 *
 * To run a query within a React component, call `useGetAllAchievementStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAchievementStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAchievementStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllAchievementStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllAchievementStatusQuery, GetAllAchievementStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllAchievementStatusQuery, GetAllAchievementStatusQueryVariables>(GetAllAchievementStatusDocument, options);
      }
export function useGetAllAchievementStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllAchievementStatusQuery, GetAllAchievementStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllAchievementStatusQuery, GetAllAchievementStatusQueryVariables>(GetAllAchievementStatusDocument, options);
        }
export function useGetAllAchievementStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAllAchievementStatusQuery, GetAllAchievementStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAllAchievementStatusQuery, GetAllAchievementStatusQueryVariables>(GetAllAchievementStatusDocument, options);
        }
export type GetAllAchievementStatusQueryHookResult = ReturnType<typeof useGetAllAchievementStatusQuery>;
export type GetAllAchievementStatusLazyQueryHookResult = ReturnType<typeof useGetAllAchievementStatusLazyQuery>;
export type GetAllAchievementStatusSuspenseQueryHookResult = ReturnType<typeof useGetAllAchievementStatusSuspenseQuery>;
export type GetAllAchievementStatusQueryResult = Apollo.QueryResult<GetAllAchievementStatusQuery, GetAllAchievementStatusQueryVariables>;
export const GetApprovalRequestByIdDocument = gql`
    query getApprovalRequestById($approvalRequestId: String!) {
  getApprovalRequestById(approvalRequestId: $approvalRequestId) {
    approvalRequestId
    data {
      postCategory
      categoryDisplayName
      text
      media {
        type
        uri
        name
        height
        width
        rotation
      }
      pollData {
        question
        expiryEnum
        options
      }
      tags {
        startIndex
        endIndex
        name
        type
        id
        slug
      }
      clubId
      postId
      commentId
      sharePostId
      sharedPostDetails {
        ...GetSharedPostFields
      }
    }
    User {
      ...UserFields
    }
    Club {
      clubId
      clubHandle
      clubName
      canJoinClub
      showDisclaimer
      disclaimer
    }
    clubId
    requestEntityType
    ownerId
    requestStatus
    remarks
    actionTakenBy {
      ...UserFields
    }
    actionTakenById
    createdAt
    updatedAt
  }
}
    ${GetSharedPostFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useGetApprovalRequestByIdQuery__
 *
 * To run a query within a React component, call `useGetApprovalRequestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalRequestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalRequestByIdQuery({
 *   variables: {
 *      approvalRequestId: // value for 'approvalRequestId'
 *   },
 * });
 */
export function useGetApprovalRequestByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetApprovalRequestByIdQuery, GetApprovalRequestByIdQueryVariables> & ({ variables: GetApprovalRequestByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetApprovalRequestByIdQuery, GetApprovalRequestByIdQueryVariables>(GetApprovalRequestByIdDocument, options);
      }
export function useGetApprovalRequestByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetApprovalRequestByIdQuery, GetApprovalRequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetApprovalRequestByIdQuery, GetApprovalRequestByIdQueryVariables>(GetApprovalRequestByIdDocument, options);
        }
export function useGetApprovalRequestByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetApprovalRequestByIdQuery, GetApprovalRequestByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetApprovalRequestByIdQuery, GetApprovalRequestByIdQueryVariables>(GetApprovalRequestByIdDocument, options);
        }
export type GetApprovalRequestByIdQueryHookResult = ReturnType<typeof useGetApprovalRequestByIdQuery>;
export type GetApprovalRequestByIdLazyQueryHookResult = ReturnType<typeof useGetApprovalRequestByIdLazyQuery>;
export type GetApprovalRequestByIdSuspenseQueryHookResult = ReturnType<typeof useGetApprovalRequestByIdSuspenseQuery>;
export type GetApprovalRequestByIdQueryResult = Apollo.QueryResult<GetApprovalRequestByIdQuery, GetApprovalRequestByIdQueryVariables>;
export const GetApprovalRequestsDocument = gql`
    query getApprovalRequests($filter: ApprovalRequestStatus, $offset: Int!, $limit: Int!) {
  getApprovalRequests(filter: $filter, offset: $offset, limit: $limit) {
    approvalRequestId
    data {
      postCategory
      categoryDisplayName
      text
      media {
        type
        uri
        name
        height
        width
        rotation
      }
      pollData {
        question
        expiryEnum
        options
      }
      tags {
        startIndex
        endIndex
        name
        type
        id
        slug
      }
      clubId
      postId
      commentId
      sharePostId
      sharedPostDetails {
        ...GetSharedPostFields
      }
    }
    User {
      ...UserFields
    }
    Club {
      clubId
      clubHandle
      clubName
      canJoinClub
      showDisclaimer
      disclaimer
    }
    clubId
    requestEntityType
    ownerId
    requestStatus
    remarks
    actionTakenBy {
      ...UserFields
    }
    actionTakenById
    createdAt
    updatedAt
  }
}
    ${GetSharedPostFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useGetApprovalRequestsQuery__
 *
 * To run a query within a React component, call `useGetApprovalRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalRequestsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetApprovalRequestsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables> & ({ variables: GetApprovalRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>(GetApprovalRequestsDocument, options);
      }
export function useGetApprovalRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>(GetApprovalRequestsDocument, options);
        }
export function useGetApprovalRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>(GetApprovalRequestsDocument, options);
        }
export type GetApprovalRequestsQueryHookResult = ReturnType<typeof useGetApprovalRequestsQuery>;
export type GetApprovalRequestsLazyQueryHookResult = ReturnType<typeof useGetApprovalRequestsLazyQuery>;
export type GetApprovalRequestsSuspenseQueryHookResult = ReturnType<typeof useGetApprovalRequestsSuspenseQuery>;
export type GetApprovalRequestsQueryResult = Apollo.QueryResult<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>;
export const GetBadgeFeedbackQuestionDocument = gql`
    query getBadgeFeedbackQuestion($badgeId: String) {
  getBadgeFeedbackQuestion(badgeId: $badgeId) {
    questionId
    questionText
    Badge {
      badgeId
      badgeName
      description
      badgeIcon
      badgeType
    }
    badgeId
    createdAt
  }
}
    `;

/**
 * __useGetBadgeFeedbackQuestionQuery__
 *
 * To run a query within a React component, call `useGetBadgeFeedbackQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgeFeedbackQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgeFeedbackQuestionQuery({
 *   variables: {
 *      badgeId: // value for 'badgeId'
 *   },
 * });
 */
export function useGetBadgeFeedbackQuestionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBadgeFeedbackQuestionQuery, GetBadgeFeedbackQuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBadgeFeedbackQuestionQuery, GetBadgeFeedbackQuestionQueryVariables>(GetBadgeFeedbackQuestionDocument, options);
      }
export function useGetBadgeFeedbackQuestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBadgeFeedbackQuestionQuery, GetBadgeFeedbackQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBadgeFeedbackQuestionQuery, GetBadgeFeedbackQuestionQueryVariables>(GetBadgeFeedbackQuestionDocument, options);
        }
export function useGetBadgeFeedbackQuestionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBadgeFeedbackQuestionQuery, GetBadgeFeedbackQuestionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBadgeFeedbackQuestionQuery, GetBadgeFeedbackQuestionQueryVariables>(GetBadgeFeedbackQuestionDocument, options);
        }
export type GetBadgeFeedbackQuestionQueryHookResult = ReturnType<typeof useGetBadgeFeedbackQuestionQuery>;
export type GetBadgeFeedbackQuestionLazyQueryHookResult = ReturnType<typeof useGetBadgeFeedbackQuestionLazyQuery>;
export type GetBadgeFeedbackQuestionSuspenseQueryHookResult = ReturnType<typeof useGetBadgeFeedbackQuestionSuspenseQuery>;
export type GetBadgeFeedbackQuestionQueryResult = Apollo.QueryResult<GetBadgeFeedbackQuestionQuery, GetBadgeFeedbackQuestionQueryVariables>;
export const GetBadgesOfUserDocument = gql`
    query getBadgesOfUser($userId: String) {
  getBadgesOfUser(userId: $userId) {
    userBadgesList {
      userId
      badgeId
      Badges {
        badgeId
        badgeName
        description
        badgeIcon
        badgeType
      }
      hasTurnedOffPromotion
      sourceOfClick
      achievementType
    }
    errorMessage {
      errMessage
    }
  }
}
    `;

/**
 * __useGetBadgesOfUserQuery__
 *
 * To run a query within a React component, call `useGetBadgesOfUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgesOfUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgesOfUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetBadgesOfUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBadgesOfUserQuery, GetBadgesOfUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBadgesOfUserQuery, GetBadgesOfUserQueryVariables>(GetBadgesOfUserDocument, options);
      }
export function useGetBadgesOfUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBadgesOfUserQuery, GetBadgesOfUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBadgesOfUserQuery, GetBadgesOfUserQueryVariables>(GetBadgesOfUserDocument, options);
        }
export function useGetBadgesOfUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBadgesOfUserQuery, GetBadgesOfUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBadgesOfUserQuery, GetBadgesOfUserQueryVariables>(GetBadgesOfUserDocument, options);
        }
export type GetBadgesOfUserQueryHookResult = ReturnType<typeof useGetBadgesOfUserQuery>;
export type GetBadgesOfUserLazyQueryHookResult = ReturnType<typeof useGetBadgesOfUserLazyQuery>;
export type GetBadgesOfUserSuspenseQueryHookResult = ReturnType<typeof useGetBadgesOfUserSuspenseQuery>;
export type GetBadgesOfUserQueryResult = Apollo.QueryResult<GetBadgesOfUserQuery, GetBadgesOfUserQueryVariables>;
export const GetBlockedListDocument = gql`
    query getBlockedList {
  getBlockedList {
    ...UserFields
    cover
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetBlockedListQuery__
 *
 * To run a query within a React component, call `useGetBlockedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockedListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBlockedListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBlockedListQuery, GetBlockedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBlockedListQuery, GetBlockedListQueryVariables>(GetBlockedListDocument, options);
      }
export function useGetBlockedListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockedListQuery, GetBlockedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBlockedListQuery, GetBlockedListQueryVariables>(GetBlockedListDocument, options);
        }
export function useGetBlockedListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBlockedListQuery, GetBlockedListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBlockedListQuery, GetBlockedListQueryVariables>(GetBlockedListDocument, options);
        }
export type GetBlockedListQueryHookResult = ReturnType<typeof useGetBlockedListQuery>;
export type GetBlockedListLazyQueryHookResult = ReturnType<typeof useGetBlockedListLazyQuery>;
export type GetBlockedListSuspenseQueryHookResult = ReturnType<typeof useGetBlockedListSuspenseQuery>;
export type GetBlockedListQueryResult = Apollo.QueryResult<GetBlockedListQuery, GetBlockedListQueryVariables>;
export const GetBookmarkV2Document = gql`
    query getBookmarkV2($offset: Int!, $limit: Int!) {
  getBookmarkV2(offset: $offset, limit: $limit) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetBookmarkV2Query__
 *
 * To run a query within a React component, call `useGetBookmarkV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetBookmarkV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookmarkV2Query({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBookmarkV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GetBookmarkV2Query, GetBookmarkV2QueryVariables> & ({ variables: GetBookmarkV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBookmarkV2Query, GetBookmarkV2QueryVariables>(GetBookmarkV2Document, options);
      }
export function useGetBookmarkV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookmarkV2Query, GetBookmarkV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBookmarkV2Query, GetBookmarkV2QueryVariables>(GetBookmarkV2Document, options);
        }
export function useGetBookmarkV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBookmarkV2Query, GetBookmarkV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBookmarkV2Query, GetBookmarkV2QueryVariables>(GetBookmarkV2Document, options);
        }
export type GetBookmarkV2QueryHookResult = ReturnType<typeof useGetBookmarkV2Query>;
export type GetBookmarkV2LazyQueryHookResult = ReturnType<typeof useGetBookmarkV2LazyQuery>;
export type GetBookmarkV2SuspenseQueryHookResult = ReturnType<typeof useGetBookmarkV2SuspenseQuery>;
export type GetBookmarkV2QueryResult = Apollo.QueryResult<GetBookmarkV2Query, GetBookmarkV2QueryVariables>;
export const GetBrokenStreakDetailsDocument = gql`
    query getBrokenStreakDetails {
  getBrokenStreakDetails {
    data {
      userId
      prevStreak {
        isCurrentWeek
        weekDisplayName
        hasCompleted
        currentWeekDayCount
        weekNumber
        weekHeader
        weekHeaderMessage
        isBrokenWeek
        weekFooter
        days {
          dayName
          dayDate
          hasVisited
          visitedState
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrokenStreakDetailsQuery__
 *
 * To run a query within a React component, call `useGetBrokenStreakDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokenStreakDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokenStreakDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrokenStreakDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBrokenStreakDetailsQuery, GetBrokenStreakDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBrokenStreakDetailsQuery, GetBrokenStreakDetailsQueryVariables>(GetBrokenStreakDetailsDocument, options);
      }
export function useGetBrokenStreakDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBrokenStreakDetailsQuery, GetBrokenStreakDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBrokenStreakDetailsQuery, GetBrokenStreakDetailsQueryVariables>(GetBrokenStreakDetailsDocument, options);
        }
export function useGetBrokenStreakDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBrokenStreakDetailsQuery, GetBrokenStreakDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBrokenStreakDetailsQuery, GetBrokenStreakDetailsQueryVariables>(GetBrokenStreakDetailsDocument, options);
        }
export type GetBrokenStreakDetailsQueryHookResult = ReturnType<typeof useGetBrokenStreakDetailsQuery>;
export type GetBrokenStreakDetailsLazyQueryHookResult = ReturnType<typeof useGetBrokenStreakDetailsLazyQuery>;
export type GetBrokenStreakDetailsSuspenseQueryHookResult = ReturnType<typeof useGetBrokenStreakDetailsSuspenseQuery>;
export type GetBrokenStreakDetailsQueryResult = Apollo.QueryResult<GetBrokenStreakDetailsQuery, GetBrokenStreakDetailsQueryVariables>;
export const GetCategoriesDocument = gql`
    query getCategories {
  getCategories {
    clubCategoryId
    clubCategoryName
    headline
    description
    priority
    icon
    cover
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export function useGetCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetCategoryByIdDocument = gql`
    query getCategoryById($clubCategoryId: String) {
  getCategoryById(clubCategoryId: $clubCategoryId) {
    clubCategoryId
    clubCategoryName
    headline
    description
    priority
    icon
    cover
  }
}
    `;

/**
 * __useGetCategoryByIdQuery__
 *
 * To run a query within a React component, call `useGetCategoryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryByIdQuery({
 *   variables: {
 *      clubCategoryId: // value for 'clubCategoryId'
 *   },
 * });
 */
export function useGetCategoryByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>(GetCategoryByIdDocument, options);
      }
export function useGetCategoryByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>(GetCategoryByIdDocument, options);
        }
export function useGetCategoryByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>(GetCategoryByIdDocument, options);
        }
export type GetCategoryByIdQueryHookResult = ReturnType<typeof useGetCategoryByIdQuery>;
export type GetCategoryByIdLazyQueryHookResult = ReturnType<typeof useGetCategoryByIdLazyQuery>;
export type GetCategoryByIdSuspenseQueryHookResult = ReturnType<typeof useGetCategoryByIdSuspenseQuery>;
export type GetCategoryByIdQueryResult = Apollo.QueryResult<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>;
export const GetClubDocument = gql`
    query GetClub($clubId: String!) {
  getClub(clubId: $clubId) {
    ...ClubFields
    clubType
    memberType
    rule
    viewFeedPermission {
      canViewPost
      canSeeMarketingPost
    }
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetClubQuery__
 *
 * To run a query within a React component, call `useGetClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetClubQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClubQuery, GetClubQueryVariables> & ({ variables: GetClubQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubQuery, GetClubQueryVariables>(GetClubDocument, options);
      }
export function useGetClubLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubQuery, GetClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubQuery, GetClubQueryVariables>(GetClubDocument, options);
        }
export function useGetClubSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClubQuery, GetClubQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClubQuery, GetClubQueryVariables>(GetClubDocument, options);
        }
export type GetClubQueryHookResult = ReturnType<typeof useGetClubQuery>;
export type GetClubLazyQueryHookResult = ReturnType<typeof useGetClubLazyQuery>;
export type GetClubSuspenseQueryHookResult = ReturnType<typeof useGetClubSuspenseQuery>;
export type GetClubQueryResult = Apollo.QueryResult<GetClubQuery, GetClubQueryVariables>;
export const GetClubCategoryListDocument = gql`
    query getClubCategoryList {
  getClubCategoryList {
    clubCategoryId
    clubCategoryName
    headline
    description
    priority
    icon
    cover
  }
}
    `;

/**
 * __useGetClubCategoryListQuery__
 *
 * To run a query within a React component, call `useGetClubCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubCategoryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClubCategoryListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClubCategoryListQuery, GetClubCategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubCategoryListQuery, GetClubCategoryListQueryVariables>(GetClubCategoryListDocument, options);
      }
export function useGetClubCategoryListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubCategoryListQuery, GetClubCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubCategoryListQuery, GetClubCategoryListQueryVariables>(GetClubCategoryListDocument, options);
        }
export function useGetClubCategoryListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClubCategoryListQuery, GetClubCategoryListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClubCategoryListQuery, GetClubCategoryListQueryVariables>(GetClubCategoryListDocument, options);
        }
export type GetClubCategoryListQueryHookResult = ReturnType<typeof useGetClubCategoryListQuery>;
export type GetClubCategoryListLazyQueryHookResult = ReturnType<typeof useGetClubCategoryListLazyQuery>;
export type GetClubCategoryListSuspenseQueryHookResult = ReturnType<typeof useGetClubCategoryListSuspenseQuery>;
export type GetClubCategoryListQueryResult = Apollo.QueryResult<GetClubCategoryListQuery, GetClubCategoryListQueryVariables>;
export const GetClubListForSmartFeedDocument = gql`
    query getClubListForSmartFeed($data: String!) {
  getClubListForSmartFeed(data: $data) {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetClubListForSmartFeedQuery__
 *
 * To run a query within a React component, call `useGetClubListForSmartFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubListForSmartFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubListForSmartFeedQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetClubListForSmartFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClubListForSmartFeedQuery, GetClubListForSmartFeedQueryVariables> & ({ variables: GetClubListForSmartFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubListForSmartFeedQuery, GetClubListForSmartFeedQueryVariables>(GetClubListForSmartFeedDocument, options);
      }
export function useGetClubListForSmartFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubListForSmartFeedQuery, GetClubListForSmartFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubListForSmartFeedQuery, GetClubListForSmartFeedQueryVariables>(GetClubListForSmartFeedDocument, options);
        }
export function useGetClubListForSmartFeedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClubListForSmartFeedQuery, GetClubListForSmartFeedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClubListForSmartFeedQuery, GetClubListForSmartFeedQueryVariables>(GetClubListForSmartFeedDocument, options);
        }
export type GetClubListForSmartFeedQueryHookResult = ReturnType<typeof useGetClubListForSmartFeedQuery>;
export type GetClubListForSmartFeedLazyQueryHookResult = ReturnType<typeof useGetClubListForSmartFeedLazyQuery>;
export type GetClubListForSmartFeedSuspenseQueryHookResult = ReturnType<typeof useGetClubListForSmartFeedSuspenseQuery>;
export type GetClubListForSmartFeedQueryResult = Apollo.QueryResult<GetClubListForSmartFeedQuery, GetClubListForSmartFeedQueryVariables>;
export const GetClubMarketingPostsDocument = gql`
    query getClubMarketingPosts($clubId: String) {
  getClubMarketingPosts(clubId: $clubId) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetClubMarketingPostsQuery__
 *
 * To run a query within a React component, call `useGetClubMarketingPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubMarketingPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubMarketingPostsQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetClubMarketingPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClubMarketingPostsQuery, GetClubMarketingPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubMarketingPostsQuery, GetClubMarketingPostsQueryVariables>(GetClubMarketingPostsDocument, options);
      }
export function useGetClubMarketingPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubMarketingPostsQuery, GetClubMarketingPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubMarketingPostsQuery, GetClubMarketingPostsQueryVariables>(GetClubMarketingPostsDocument, options);
        }
export function useGetClubMarketingPostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClubMarketingPostsQuery, GetClubMarketingPostsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClubMarketingPostsQuery, GetClubMarketingPostsQueryVariables>(GetClubMarketingPostsDocument, options);
        }
export type GetClubMarketingPostsQueryHookResult = ReturnType<typeof useGetClubMarketingPostsQuery>;
export type GetClubMarketingPostsLazyQueryHookResult = ReturnType<typeof useGetClubMarketingPostsLazyQuery>;
export type GetClubMarketingPostsSuspenseQueryHookResult = ReturnType<typeof useGetClubMarketingPostsSuspenseQuery>;
export type GetClubMarketingPostsQueryResult = Apollo.QueryResult<GetClubMarketingPostsQuery, GetClubMarketingPostsQueryVariables>;
export const GetClubMediaPostsDocument = gql`
    query getClubMediaPosts($data: ClubInput, $offset: Int, $limit: Int) {
  getClubMediaPosts(data: $data, offset: $offset, limit: $limit) {
    postId
    media {
      type
      uri
      name
    }
  }
}
    `;

/**
 * __useGetClubMediaPostsQuery__
 *
 * To run a query within a React component, call `useGetClubMediaPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubMediaPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubMediaPostsQuery({
 *   variables: {
 *      data: // value for 'data'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetClubMediaPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClubMediaPostsQuery, GetClubMediaPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubMediaPostsQuery, GetClubMediaPostsQueryVariables>(GetClubMediaPostsDocument, options);
      }
export function useGetClubMediaPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubMediaPostsQuery, GetClubMediaPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubMediaPostsQuery, GetClubMediaPostsQueryVariables>(GetClubMediaPostsDocument, options);
        }
export function useGetClubMediaPostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClubMediaPostsQuery, GetClubMediaPostsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClubMediaPostsQuery, GetClubMediaPostsQueryVariables>(GetClubMediaPostsDocument, options);
        }
export type GetClubMediaPostsQueryHookResult = ReturnType<typeof useGetClubMediaPostsQuery>;
export type GetClubMediaPostsLazyQueryHookResult = ReturnType<typeof useGetClubMediaPostsLazyQuery>;
export type GetClubMediaPostsSuspenseQueryHookResult = ReturnType<typeof useGetClubMediaPostsSuspenseQuery>;
export type GetClubMediaPostsQueryResult = Apollo.QueryResult<GetClubMediaPostsQuery, GetClubMediaPostsQueryVariables>;
export const GetClubPermissionsBasedOnFeaturesDocument = gql`
    query getClubPermissionsBasedOnFeatures {
  getClubPermissionsBasedOnFeatures {
    clubId
    permissions
    club_permissions_token
  }
}
    `;

/**
 * __useGetClubPermissionsBasedOnFeaturesQuery__
 *
 * To run a query within a React component, call `useGetClubPermissionsBasedOnFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubPermissionsBasedOnFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubPermissionsBasedOnFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClubPermissionsBasedOnFeaturesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClubPermissionsBasedOnFeaturesQuery, GetClubPermissionsBasedOnFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubPermissionsBasedOnFeaturesQuery, GetClubPermissionsBasedOnFeaturesQueryVariables>(GetClubPermissionsBasedOnFeaturesDocument, options);
      }
export function useGetClubPermissionsBasedOnFeaturesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubPermissionsBasedOnFeaturesQuery, GetClubPermissionsBasedOnFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubPermissionsBasedOnFeaturesQuery, GetClubPermissionsBasedOnFeaturesQueryVariables>(GetClubPermissionsBasedOnFeaturesDocument, options);
        }
export function useGetClubPermissionsBasedOnFeaturesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClubPermissionsBasedOnFeaturesQuery, GetClubPermissionsBasedOnFeaturesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClubPermissionsBasedOnFeaturesQuery, GetClubPermissionsBasedOnFeaturesQueryVariables>(GetClubPermissionsBasedOnFeaturesDocument, options);
        }
export type GetClubPermissionsBasedOnFeaturesQueryHookResult = ReturnType<typeof useGetClubPermissionsBasedOnFeaturesQuery>;
export type GetClubPermissionsBasedOnFeaturesLazyQueryHookResult = ReturnType<typeof useGetClubPermissionsBasedOnFeaturesLazyQuery>;
export type GetClubPermissionsBasedOnFeaturesSuspenseQueryHookResult = ReturnType<typeof useGetClubPermissionsBasedOnFeaturesSuspenseQuery>;
export type GetClubPermissionsBasedOnFeaturesQueryResult = Apollo.QueryResult<GetClubPermissionsBasedOnFeaturesQuery, GetClubPermissionsBasedOnFeaturesQueryVariables>;
export const ClubPostDocument = gql`
    query clubPost($clubId: String!, $preferredHashtagId: String, $limit: Int!, $offset: Int!) {
  getClubPosts(
    clubId: $clubId
    preferredHashtagId: $preferredHashtagId
    limit: $limit
    offset: $offset
  ) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useClubPostQuery__
 *
 * To run a query within a React component, call `useClubPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useClubPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClubPostQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      preferredHashtagId: // value for 'preferredHashtagId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useClubPostQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ClubPostQuery, ClubPostQueryVariables> & ({ variables: ClubPostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClubPostQuery, ClubPostQueryVariables>(ClubPostDocument, options);
      }
export function useClubPostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClubPostQuery, ClubPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClubPostQuery, ClubPostQueryVariables>(ClubPostDocument, options);
        }
export function useClubPostSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClubPostQuery, ClubPostQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClubPostQuery, ClubPostQueryVariables>(ClubPostDocument, options);
        }
export type ClubPostQueryHookResult = ReturnType<typeof useClubPostQuery>;
export type ClubPostLazyQueryHookResult = ReturnType<typeof useClubPostLazyQuery>;
export type ClubPostSuspenseQueryHookResult = ReturnType<typeof useClubPostSuspenseQuery>;
export type ClubPostQueryResult = Apollo.QueryResult<ClubPostQuery, ClubPostQueryVariables>;
export const GetClubPostsSinceDateDocument = gql`
    query getClubPostsSinceDate($clubId: String!, $since: String, $limit: Int!) {
  getClubPostsSinceDate(clubId: $clubId, since: $since, limit: $limit) {
    since
    posts {
      ...PostFields
    }
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetClubPostsSinceDateQuery__
 *
 * To run a query within a React component, call `useGetClubPostsSinceDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubPostsSinceDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubPostsSinceDateQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      since: // value for 'since'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetClubPostsSinceDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClubPostsSinceDateQuery, GetClubPostsSinceDateQueryVariables> & ({ variables: GetClubPostsSinceDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubPostsSinceDateQuery, GetClubPostsSinceDateQueryVariables>(GetClubPostsSinceDateDocument, options);
      }
export function useGetClubPostsSinceDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubPostsSinceDateQuery, GetClubPostsSinceDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubPostsSinceDateQuery, GetClubPostsSinceDateQueryVariables>(GetClubPostsSinceDateDocument, options);
        }
export function useGetClubPostsSinceDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClubPostsSinceDateQuery, GetClubPostsSinceDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClubPostsSinceDateQuery, GetClubPostsSinceDateQueryVariables>(GetClubPostsSinceDateDocument, options);
        }
export type GetClubPostsSinceDateQueryHookResult = ReturnType<typeof useGetClubPostsSinceDateQuery>;
export type GetClubPostsSinceDateLazyQueryHookResult = ReturnType<typeof useGetClubPostsSinceDateLazyQuery>;
export type GetClubPostsSinceDateSuspenseQueryHookResult = ReturnType<typeof useGetClubPostsSinceDateSuspenseQuery>;
export type GetClubPostsSinceDateQueryResult = Apollo.QueryResult<GetClubPostsSinceDateQuery, GetClubPostsSinceDateQueryVariables>;
export const GetClubTrendingHashtagsV2Document = gql`
    query getClubTrendingHashtagsV2($offset: Int!, $limit: Int!, $clubId: String!) {
  getClubTrendingHashtagsV2(offset: $offset, limit: $limit, clubId: $clubId) {
    TagId
    hashtagName
    postCount
    isfollow
    issubscribed
    followers
  }
}
    `;

/**
 * __useGetClubTrendingHashtagsV2Query__
 *
 * To run a query within a React component, call `useGetClubTrendingHashtagsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetClubTrendingHashtagsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubTrendingHashtagsV2Query({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetClubTrendingHashtagsV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GetClubTrendingHashtagsV2Query, GetClubTrendingHashtagsV2QueryVariables> & ({ variables: GetClubTrendingHashtagsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubTrendingHashtagsV2Query, GetClubTrendingHashtagsV2QueryVariables>(GetClubTrendingHashtagsV2Document, options);
      }
export function useGetClubTrendingHashtagsV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubTrendingHashtagsV2Query, GetClubTrendingHashtagsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubTrendingHashtagsV2Query, GetClubTrendingHashtagsV2QueryVariables>(GetClubTrendingHashtagsV2Document, options);
        }
export function useGetClubTrendingHashtagsV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClubTrendingHashtagsV2Query, GetClubTrendingHashtagsV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClubTrendingHashtagsV2Query, GetClubTrendingHashtagsV2QueryVariables>(GetClubTrendingHashtagsV2Document, options);
        }
export type GetClubTrendingHashtagsV2QueryHookResult = ReturnType<typeof useGetClubTrendingHashtagsV2Query>;
export type GetClubTrendingHashtagsV2LazyQueryHookResult = ReturnType<typeof useGetClubTrendingHashtagsV2LazyQuery>;
export type GetClubTrendingHashtagsV2SuspenseQueryHookResult = ReturnType<typeof useGetClubTrendingHashtagsV2SuspenseQuery>;
export type GetClubTrendingHashtagsV2QueryResult = Apollo.QueryResult<GetClubTrendingHashtagsV2Query, GetClubTrendingHashtagsV2QueryVariables>;
export const GetClubTrendingSectorsViaDollarTagDocument = gql`
    query getClubTrendingSectorsViaDollarTag($offset: Int!, $limit: Int!, $clubId: String!) {
  getClubTrendingSectorsViaDollarTag(
    offset: $offset
    limit: $limit
    clubId: $clubId
  ) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetClubTrendingSectorsViaDollarTagQuery__
 *
 * To run a query within a React component, call `useGetClubTrendingSectorsViaDollarTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubTrendingSectorsViaDollarTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubTrendingSectorsViaDollarTagQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetClubTrendingSectorsViaDollarTagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClubTrendingSectorsViaDollarTagQuery, GetClubTrendingSectorsViaDollarTagQueryVariables> & ({ variables: GetClubTrendingSectorsViaDollarTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubTrendingSectorsViaDollarTagQuery, GetClubTrendingSectorsViaDollarTagQueryVariables>(GetClubTrendingSectorsViaDollarTagDocument, options);
      }
export function useGetClubTrendingSectorsViaDollarTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubTrendingSectorsViaDollarTagQuery, GetClubTrendingSectorsViaDollarTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubTrendingSectorsViaDollarTagQuery, GetClubTrendingSectorsViaDollarTagQueryVariables>(GetClubTrendingSectorsViaDollarTagDocument, options);
        }
export function useGetClubTrendingSectorsViaDollarTagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClubTrendingSectorsViaDollarTagQuery, GetClubTrendingSectorsViaDollarTagQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClubTrendingSectorsViaDollarTagQuery, GetClubTrendingSectorsViaDollarTagQueryVariables>(GetClubTrendingSectorsViaDollarTagDocument, options);
        }
export type GetClubTrendingSectorsViaDollarTagQueryHookResult = ReturnType<typeof useGetClubTrendingSectorsViaDollarTagQuery>;
export type GetClubTrendingSectorsViaDollarTagLazyQueryHookResult = ReturnType<typeof useGetClubTrendingSectorsViaDollarTagLazyQuery>;
export type GetClubTrendingSectorsViaDollarTagSuspenseQueryHookResult = ReturnType<typeof useGetClubTrendingSectorsViaDollarTagSuspenseQuery>;
export type GetClubTrendingSectorsViaDollarTagQueryResult = Apollo.QueryResult<GetClubTrendingSectorsViaDollarTagQuery, GetClubTrendingSectorsViaDollarTagQueryVariables>;
export const GetClubTrendingStocksViaDollarTagDocument = gql`
    query getClubTrendingStocksViaDollarTag($offset: Int!, $limit: Int!, $clubId: String!) {
  getClubTrendingStocksViaDollarTag(
    offset: $offset
    limit: $limit
    clubId: $clubId
  ) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetClubTrendingStocksViaDollarTagQuery__
 *
 * To run a query within a React component, call `useGetClubTrendingStocksViaDollarTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubTrendingStocksViaDollarTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubTrendingStocksViaDollarTagQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetClubTrendingStocksViaDollarTagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClubTrendingStocksViaDollarTagQuery, GetClubTrendingStocksViaDollarTagQueryVariables> & ({ variables: GetClubTrendingStocksViaDollarTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubTrendingStocksViaDollarTagQuery, GetClubTrendingStocksViaDollarTagQueryVariables>(GetClubTrendingStocksViaDollarTagDocument, options);
      }
export function useGetClubTrendingStocksViaDollarTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubTrendingStocksViaDollarTagQuery, GetClubTrendingStocksViaDollarTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubTrendingStocksViaDollarTagQuery, GetClubTrendingStocksViaDollarTagQueryVariables>(GetClubTrendingStocksViaDollarTagDocument, options);
        }
export function useGetClubTrendingStocksViaDollarTagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClubTrendingStocksViaDollarTagQuery, GetClubTrendingStocksViaDollarTagQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClubTrendingStocksViaDollarTagQuery, GetClubTrendingStocksViaDollarTagQueryVariables>(GetClubTrendingStocksViaDollarTagDocument, options);
        }
export type GetClubTrendingStocksViaDollarTagQueryHookResult = ReturnType<typeof useGetClubTrendingStocksViaDollarTagQuery>;
export type GetClubTrendingStocksViaDollarTagLazyQueryHookResult = ReturnType<typeof useGetClubTrendingStocksViaDollarTagLazyQuery>;
export type GetClubTrendingStocksViaDollarTagSuspenseQueryHookResult = ReturnType<typeof useGetClubTrendingStocksViaDollarTagSuspenseQuery>;
export type GetClubTrendingStocksViaDollarTagQueryResult = Apollo.QueryResult<GetClubTrendingStocksViaDollarTagQuery, GetClubTrendingStocksViaDollarTagQueryVariables>;
export const GetClubsByCategoryDocument = gql`
    query getClubsByCategory($clubCategoryId: String) {
  getClubsByCategory(clubCategoryId: $clubCategoryId) {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetClubsByCategoryQuery__
 *
 * To run a query within a React component, call `useGetClubsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubsByCategoryQuery({
 *   variables: {
 *      clubCategoryId: // value for 'clubCategoryId'
 *   },
 * });
 */
export function useGetClubsByCategoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClubsByCategoryQuery, GetClubsByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubsByCategoryQuery, GetClubsByCategoryQueryVariables>(GetClubsByCategoryDocument, options);
      }
export function useGetClubsByCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubsByCategoryQuery, GetClubsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubsByCategoryQuery, GetClubsByCategoryQueryVariables>(GetClubsByCategoryDocument, options);
        }
export function useGetClubsByCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClubsByCategoryQuery, GetClubsByCategoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClubsByCategoryQuery, GetClubsByCategoryQueryVariables>(GetClubsByCategoryDocument, options);
        }
export type GetClubsByCategoryQueryHookResult = ReturnType<typeof useGetClubsByCategoryQuery>;
export type GetClubsByCategoryLazyQueryHookResult = ReturnType<typeof useGetClubsByCategoryLazyQuery>;
export type GetClubsByCategorySuspenseQueryHookResult = ReturnType<typeof useGetClubsByCategorySuspenseQuery>;
export type GetClubsByCategoryQueryResult = Apollo.QueryResult<GetClubsByCategoryQuery, GetClubsByCategoryQueryVariables>;
export const GetClubsListForPlatformDocument = gql`
    query GetClubsListForPlatform($offset: Int, $limit: Int) {
  getClubsListForPlatform(offset: $offset, limit: $limit) {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetClubsListForPlatformQuery__
 *
 * To run a query within a React component, call `useGetClubsListForPlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubsListForPlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubsListForPlatformQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetClubsListForPlatformQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClubsListForPlatformQuery, GetClubsListForPlatformQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubsListForPlatformQuery, GetClubsListForPlatformQueryVariables>(GetClubsListForPlatformDocument, options);
      }
export function useGetClubsListForPlatformLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubsListForPlatformQuery, GetClubsListForPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubsListForPlatformQuery, GetClubsListForPlatformQueryVariables>(GetClubsListForPlatformDocument, options);
        }
export function useGetClubsListForPlatformSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClubsListForPlatformQuery, GetClubsListForPlatformQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClubsListForPlatformQuery, GetClubsListForPlatformQueryVariables>(GetClubsListForPlatformDocument, options);
        }
export type GetClubsListForPlatformQueryHookResult = ReturnType<typeof useGetClubsListForPlatformQuery>;
export type GetClubsListForPlatformLazyQueryHookResult = ReturnType<typeof useGetClubsListForPlatformLazyQuery>;
export type GetClubsListForPlatformSuspenseQueryHookResult = ReturnType<typeof useGetClubsListForPlatformSuspenseQuery>;
export type GetClubsListForPlatformQueryResult = Apollo.QueryResult<GetClubsListForPlatformQuery, GetClubsListForPlatformQueryVariables>;
export const GetClubsOfUserDocument = gql`
    query getClubsOfUser($userId: String!, $entitlement: Boolean, $offset: Int, $limit: Int) {
  getClubsOfUser(
    userId: $userId
    entitlement: $entitlement
    offset: $offset
    limit: $limit
  ) {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetClubsOfUserQuery__
 *
 * To run a query within a React component, call `useGetClubsOfUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubsOfUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubsOfUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      entitlement: // value for 'entitlement'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetClubsOfUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClubsOfUserQuery, GetClubsOfUserQueryVariables> & ({ variables: GetClubsOfUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubsOfUserQuery, GetClubsOfUserQueryVariables>(GetClubsOfUserDocument, options);
      }
export function useGetClubsOfUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubsOfUserQuery, GetClubsOfUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubsOfUserQuery, GetClubsOfUserQueryVariables>(GetClubsOfUserDocument, options);
        }
export function useGetClubsOfUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClubsOfUserQuery, GetClubsOfUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClubsOfUserQuery, GetClubsOfUserQueryVariables>(GetClubsOfUserDocument, options);
        }
export type GetClubsOfUserQueryHookResult = ReturnType<typeof useGetClubsOfUserQuery>;
export type GetClubsOfUserLazyQueryHookResult = ReturnType<typeof useGetClubsOfUserLazyQuery>;
export type GetClubsOfUserSuspenseQueryHookResult = ReturnType<typeof useGetClubsOfUserSuspenseQuery>;
export type GetClubsOfUserQueryResult = Apollo.QueryResult<GetClubsOfUserQuery, GetClubsOfUserQueryVariables>;
export const GetCommentsConnectionDocument = gql`
    query GetCommentsConnection($postId: String!, $before: String, $after: String, $first: Int, $takeCursorElement: Boolean, $commentId: String) {
  getCommentsConnection(
    postId: $postId
    before: $before
    after: $after
    first: $first
    takeCursorElement: $takeCursorElement
    commentId: $commentId
  ) {
    edges {
      cursor
      node {
        ...CommentFields
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${CommentFieldsFragmentDoc}`;

/**
 * __useGetCommentsConnectionQuery__
 *
 * To run a query within a React component, call `useGetCommentsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsConnectionQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      takeCursorElement: // value for 'takeCursorElement'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useGetCommentsConnectionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCommentsConnectionQuery, GetCommentsConnectionQueryVariables> & ({ variables: GetCommentsConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCommentsConnectionQuery, GetCommentsConnectionQueryVariables>(GetCommentsConnectionDocument, options);
      }
export function useGetCommentsConnectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCommentsConnectionQuery, GetCommentsConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCommentsConnectionQuery, GetCommentsConnectionQueryVariables>(GetCommentsConnectionDocument, options);
        }
export function useGetCommentsConnectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCommentsConnectionQuery, GetCommentsConnectionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCommentsConnectionQuery, GetCommentsConnectionQueryVariables>(GetCommentsConnectionDocument, options);
        }
export type GetCommentsConnectionQueryHookResult = ReturnType<typeof useGetCommentsConnectionQuery>;
export type GetCommentsConnectionLazyQueryHookResult = ReturnType<typeof useGetCommentsConnectionLazyQuery>;
export type GetCommentsConnectionSuspenseQueryHookResult = ReturnType<typeof useGetCommentsConnectionSuspenseQuery>;
export type GetCommentsConnectionQueryResult = Apollo.QueryResult<GetCommentsConnectionQuery, GetCommentsConnectionQueryVariables>;
export const GetDollarTagDetailsDocument = gql`
    query getDollarTagDetails($dollarTagId: Int) {
  getDollarTagDetails(dollarTagId: $dollarTagId) {
    ...DollarTagFields
    sourceEntityId
    viewFeedPermission {
      canViewPost
      canSeeMarketingPost
    }
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetDollarTagDetailsQuery__
 *
 * To run a query within a React component, call `useGetDollarTagDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDollarTagDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDollarTagDetailsQuery({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *   },
 * });
 */
export function useGetDollarTagDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDollarTagDetailsQuery, GetDollarTagDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDollarTagDetailsQuery, GetDollarTagDetailsQueryVariables>(GetDollarTagDetailsDocument, options);
      }
export function useGetDollarTagDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDollarTagDetailsQuery, GetDollarTagDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDollarTagDetailsQuery, GetDollarTagDetailsQueryVariables>(GetDollarTagDetailsDocument, options);
        }
export function useGetDollarTagDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDollarTagDetailsQuery, GetDollarTagDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDollarTagDetailsQuery, GetDollarTagDetailsQueryVariables>(GetDollarTagDetailsDocument, options);
        }
export type GetDollarTagDetailsQueryHookResult = ReturnType<typeof useGetDollarTagDetailsQuery>;
export type GetDollarTagDetailsLazyQueryHookResult = ReturnType<typeof useGetDollarTagDetailsLazyQuery>;
export type GetDollarTagDetailsSuspenseQueryHookResult = ReturnType<typeof useGetDollarTagDetailsSuspenseQuery>;
export type GetDollarTagDetailsQueryResult = Apollo.QueryResult<GetDollarTagDetailsQuery, GetDollarTagDetailsQueryVariables>;
export const GetDollarTagForSecurityIdDocument = gql`
    query GetDollarTagForSecurityId($securityId: Int!) {
  getDollarTagForSecurityId(securityId: $securityId) {
    dollarTagId
    slug
    dollarTagType
  }
}
    `;

/**
 * __useGetDollarTagForSecurityIdQuery__
 *
 * To run a query within a React component, call `useGetDollarTagForSecurityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDollarTagForSecurityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDollarTagForSecurityIdQuery({
 *   variables: {
 *      securityId: // value for 'securityId'
 *   },
 * });
 */
export function useGetDollarTagForSecurityIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDollarTagForSecurityIdQuery, GetDollarTagForSecurityIdQueryVariables> & ({ variables: GetDollarTagForSecurityIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDollarTagForSecurityIdQuery, GetDollarTagForSecurityIdQueryVariables>(GetDollarTagForSecurityIdDocument, options);
      }
export function useGetDollarTagForSecurityIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDollarTagForSecurityIdQuery, GetDollarTagForSecurityIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDollarTagForSecurityIdQuery, GetDollarTagForSecurityIdQueryVariables>(GetDollarTagForSecurityIdDocument, options);
        }
export function useGetDollarTagForSecurityIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDollarTagForSecurityIdQuery, GetDollarTagForSecurityIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDollarTagForSecurityIdQuery, GetDollarTagForSecurityIdQueryVariables>(GetDollarTagForSecurityIdDocument, options);
        }
export type GetDollarTagForSecurityIdQueryHookResult = ReturnType<typeof useGetDollarTagForSecurityIdQuery>;
export type GetDollarTagForSecurityIdLazyQueryHookResult = ReturnType<typeof useGetDollarTagForSecurityIdLazyQuery>;
export type GetDollarTagForSecurityIdSuspenseQueryHookResult = ReturnType<typeof useGetDollarTagForSecurityIdSuspenseQuery>;
export type GetDollarTagForSecurityIdQueryResult = Apollo.QueryResult<GetDollarTagForSecurityIdQuery, GetDollarTagForSecurityIdQueryVariables>;
export const GetDollartagBySearchTextDocument = gql`
    query getDollartagBySearchText($searchText: String!, $offset: Int, $limit: Int!) {
  getDollartagBySearchText(
    searchText: $searchText
    offset: $offset
    limit: $limit
  ) {
    dollarTagId
    dollarTagName
    slug
    dollarTagType
  }
}
    `;

/**
 * __useGetDollartagBySearchTextQuery__
 *
 * To run a query within a React component, call `useGetDollartagBySearchTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDollartagBySearchTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDollartagBySearchTextQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDollartagBySearchTextQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDollartagBySearchTextQuery, GetDollartagBySearchTextQueryVariables> & ({ variables: GetDollartagBySearchTextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDollartagBySearchTextQuery, GetDollartagBySearchTextQueryVariables>(GetDollartagBySearchTextDocument, options);
      }
export function useGetDollartagBySearchTextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDollartagBySearchTextQuery, GetDollartagBySearchTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDollartagBySearchTextQuery, GetDollartagBySearchTextQueryVariables>(GetDollartagBySearchTextDocument, options);
        }
export function useGetDollartagBySearchTextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDollartagBySearchTextQuery, GetDollartagBySearchTextQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDollartagBySearchTextQuery, GetDollartagBySearchTextQueryVariables>(GetDollartagBySearchTextDocument, options);
        }
export type GetDollartagBySearchTextQueryHookResult = ReturnType<typeof useGetDollartagBySearchTextQuery>;
export type GetDollartagBySearchTextLazyQueryHookResult = ReturnType<typeof useGetDollartagBySearchTextLazyQuery>;
export type GetDollartagBySearchTextSuspenseQueryHookResult = ReturnType<typeof useGetDollartagBySearchTextSuspenseQuery>;
export type GetDollartagBySearchTextQueryResult = Apollo.QueryResult<GetDollartagBySearchTextQuery, GetDollartagBySearchTextQueryVariables>;
export const GetDollartagMarketingPostsDocument = gql`
    query getDollartagMarketingPosts($dollarTagId: Int) {
  getDollartagMarketingPosts(dollarTagId: $dollarTagId) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetDollartagMarketingPostsQuery__
 *
 * To run a query within a React component, call `useGetDollartagMarketingPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDollartagMarketingPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDollartagMarketingPostsQuery({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *   },
 * });
 */
export function useGetDollartagMarketingPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDollartagMarketingPostsQuery, GetDollartagMarketingPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDollartagMarketingPostsQuery, GetDollartagMarketingPostsQueryVariables>(GetDollartagMarketingPostsDocument, options);
      }
export function useGetDollartagMarketingPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDollartagMarketingPostsQuery, GetDollartagMarketingPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDollartagMarketingPostsQuery, GetDollartagMarketingPostsQueryVariables>(GetDollartagMarketingPostsDocument, options);
        }
export function useGetDollartagMarketingPostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDollartagMarketingPostsQuery, GetDollartagMarketingPostsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDollartagMarketingPostsQuery, GetDollartagMarketingPostsQueryVariables>(GetDollartagMarketingPostsDocument, options);
        }
export type GetDollartagMarketingPostsQueryHookResult = ReturnType<typeof useGetDollartagMarketingPostsQuery>;
export type GetDollartagMarketingPostsLazyQueryHookResult = ReturnType<typeof useGetDollartagMarketingPostsLazyQuery>;
export type GetDollartagMarketingPostsSuspenseQueryHookResult = ReturnType<typeof useGetDollartagMarketingPostsSuspenseQuery>;
export type GetDollartagMarketingPostsQueryResult = Apollo.QueryResult<GetDollartagMarketingPostsQuery, GetDollartagMarketingPostsQueryVariables>;
export const GetEditPostHistoryDocument = gql`
    query getEditPostHistory($postId: String!) {
  getEditPostHistory(postId: $postId) {
    text
    editedAt
    media {
      type
      uri
      name
      height
      width
      rotation
    }
    tags {
      startIndex
      endIndex
      name
      type
      id
      slug
    }
  }
}
    `;

/**
 * __useGetEditPostHistoryQuery__
 *
 * To run a query within a React component, call `useGetEditPostHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPostHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPostHistoryQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetEditPostHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEditPostHistoryQuery, GetEditPostHistoryQueryVariables> & ({ variables: GetEditPostHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEditPostHistoryQuery, GetEditPostHistoryQueryVariables>(GetEditPostHistoryDocument, options);
      }
export function useGetEditPostHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEditPostHistoryQuery, GetEditPostHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEditPostHistoryQuery, GetEditPostHistoryQueryVariables>(GetEditPostHistoryDocument, options);
        }
export function useGetEditPostHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEditPostHistoryQuery, GetEditPostHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEditPostHistoryQuery, GetEditPostHistoryQueryVariables>(GetEditPostHistoryDocument, options);
        }
export type GetEditPostHistoryQueryHookResult = ReturnType<typeof useGetEditPostHistoryQuery>;
export type GetEditPostHistoryLazyQueryHookResult = ReturnType<typeof useGetEditPostHistoryLazyQuery>;
export type GetEditPostHistorySuspenseQueryHookResult = ReturnType<typeof useGetEditPostHistorySuspenseQuery>;
export type GetEditPostHistoryQueryResult = Apollo.QueryResult<GetEditPostHistoryQuery, GetEditPostHistoryQueryVariables>;
export const GetEditPostHistoryV2Document = gql`
    query getEditPostHistoryV2($postId: String!) {
  getEditPostHistoryV2(postId: $postId) {
    postId
    User {
      ...UserFields
    }
    categoryDisplayDetails {
      categoryDisplayName
    }
    Club {
      clubId
      clubHandle
      clubName
      canJoinClub
      showDisclaimer
      disclaimer
    }
    media {
      type
      uri
      name
      height
      width
      rotation
    }
    textV2
    hasPoll
    getPoll {
      ...GetPollFields
    }
    createdAt
    editedAt
    upvotecount
    downvotecount
    sharecount
    commentcount
    isEdited
    isFollowed
    sharePostId
    getSharedPost {
      ...GetSharedPostFields
    }
    clubPostShareSetting {
      isVerifiedCanShare
      greenTickCanShare
      normalUserCanShare
    }
    editHistory {
      text
      editedAt
      media {
        type
        uri
        name
        height
        width
        rotation
      }
      User {
        ...UserFields
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${GetPollFieldsFragmentDoc}
${GetSharedPostFieldsFragmentDoc}`;

/**
 * __useGetEditPostHistoryV2Query__
 *
 * To run a query within a React component, call `useGetEditPostHistoryV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPostHistoryV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPostHistoryV2Query({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetEditPostHistoryV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GetEditPostHistoryV2Query, GetEditPostHistoryV2QueryVariables> & ({ variables: GetEditPostHistoryV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEditPostHistoryV2Query, GetEditPostHistoryV2QueryVariables>(GetEditPostHistoryV2Document, options);
      }
export function useGetEditPostHistoryV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEditPostHistoryV2Query, GetEditPostHistoryV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEditPostHistoryV2Query, GetEditPostHistoryV2QueryVariables>(GetEditPostHistoryV2Document, options);
        }
export function useGetEditPostHistoryV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEditPostHistoryV2Query, GetEditPostHistoryV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEditPostHistoryV2Query, GetEditPostHistoryV2QueryVariables>(GetEditPostHistoryV2Document, options);
        }
export type GetEditPostHistoryV2QueryHookResult = ReturnType<typeof useGetEditPostHistoryV2Query>;
export type GetEditPostHistoryV2LazyQueryHookResult = ReturnType<typeof useGetEditPostHistoryV2LazyQuery>;
export type GetEditPostHistoryV2SuspenseQueryHookResult = ReturnType<typeof useGetEditPostHistoryV2SuspenseQuery>;
export type GetEditPostHistoryV2QueryResult = Apollo.QueryResult<GetEditPostHistoryV2Query, GetEditPostHistoryV2QueryVariables>;
export const GetFavouriteClubsOfUserDocument = gql`
    query getFavouriteClubsOfUser {
  getFavouriteClubsOfUser {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetFavouriteClubsOfUserQuery__
 *
 * To run a query within a React component, call `useGetFavouriteClubsOfUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavouriteClubsOfUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavouriteClubsOfUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFavouriteClubsOfUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFavouriteClubsOfUserQuery, GetFavouriteClubsOfUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFavouriteClubsOfUserQuery, GetFavouriteClubsOfUserQueryVariables>(GetFavouriteClubsOfUserDocument, options);
      }
export function useGetFavouriteClubsOfUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFavouriteClubsOfUserQuery, GetFavouriteClubsOfUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFavouriteClubsOfUserQuery, GetFavouriteClubsOfUserQueryVariables>(GetFavouriteClubsOfUserDocument, options);
        }
export function useGetFavouriteClubsOfUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFavouriteClubsOfUserQuery, GetFavouriteClubsOfUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFavouriteClubsOfUserQuery, GetFavouriteClubsOfUserQueryVariables>(GetFavouriteClubsOfUserDocument, options);
        }
export type GetFavouriteClubsOfUserQueryHookResult = ReturnType<typeof useGetFavouriteClubsOfUserQuery>;
export type GetFavouriteClubsOfUserLazyQueryHookResult = ReturnType<typeof useGetFavouriteClubsOfUserLazyQuery>;
export type GetFavouriteClubsOfUserSuspenseQueryHookResult = ReturnType<typeof useGetFavouriteClubsOfUserSuspenseQuery>;
export type GetFavouriteClubsOfUserQueryResult = Apollo.QueryResult<GetFavouriteClubsOfUserQuery, GetFavouriteClubsOfUserQueryVariables>;
export const GetFeatureToClubPermissionByIdDocument = gql`
    query getFeatureToClubPermissionById($clubId: String) {
  getFeatureToClubPermissionById(clubId: $clubId) {
    clubId
    permissions
    club_permissions_token
  }
}
    `;

/**
 * __useGetFeatureToClubPermissionByIdQuery__
 *
 * To run a query within a React component, call `useGetFeatureToClubPermissionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureToClubPermissionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureToClubPermissionByIdQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetFeatureToClubPermissionByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeatureToClubPermissionByIdQuery, GetFeatureToClubPermissionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeatureToClubPermissionByIdQuery, GetFeatureToClubPermissionByIdQueryVariables>(GetFeatureToClubPermissionByIdDocument, options);
      }
export function useGetFeatureToClubPermissionByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeatureToClubPermissionByIdQuery, GetFeatureToClubPermissionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeatureToClubPermissionByIdQuery, GetFeatureToClubPermissionByIdQueryVariables>(GetFeatureToClubPermissionByIdDocument, options);
        }
export function useGetFeatureToClubPermissionByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFeatureToClubPermissionByIdQuery, GetFeatureToClubPermissionByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFeatureToClubPermissionByIdQuery, GetFeatureToClubPermissionByIdQueryVariables>(GetFeatureToClubPermissionByIdDocument, options);
        }
export type GetFeatureToClubPermissionByIdQueryHookResult = ReturnType<typeof useGetFeatureToClubPermissionByIdQuery>;
export type GetFeatureToClubPermissionByIdLazyQueryHookResult = ReturnType<typeof useGetFeatureToClubPermissionByIdLazyQuery>;
export type GetFeatureToClubPermissionByIdSuspenseQueryHookResult = ReturnType<typeof useGetFeatureToClubPermissionByIdSuspenseQuery>;
export type GetFeatureToClubPermissionByIdQueryResult = Apollo.QueryResult<GetFeatureToClubPermissionByIdQuery, GetFeatureToClubPermissionByIdQueryVariables>;
export const GetFeatureToPlatformPermissionDocument = gql`
    query getFeatureToPlatformPermission {
  getFeatureToPlatformPermission
}
    `;

/**
 * __useGetFeatureToPlatformPermissionQuery__
 *
 * To run a query within a React component, call `useGetFeatureToPlatformPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureToPlatformPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureToPlatformPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeatureToPlatformPermissionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeatureToPlatformPermissionQuery, GetFeatureToPlatformPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeatureToPlatformPermissionQuery, GetFeatureToPlatformPermissionQueryVariables>(GetFeatureToPlatformPermissionDocument, options);
      }
export function useGetFeatureToPlatformPermissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeatureToPlatformPermissionQuery, GetFeatureToPlatformPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeatureToPlatformPermissionQuery, GetFeatureToPlatformPermissionQueryVariables>(GetFeatureToPlatformPermissionDocument, options);
        }
export function useGetFeatureToPlatformPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFeatureToPlatformPermissionQuery, GetFeatureToPlatformPermissionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFeatureToPlatformPermissionQuery, GetFeatureToPlatformPermissionQueryVariables>(GetFeatureToPlatformPermissionDocument, options);
        }
export type GetFeatureToPlatformPermissionQueryHookResult = ReturnType<typeof useGetFeatureToPlatformPermissionQuery>;
export type GetFeatureToPlatformPermissionLazyQueryHookResult = ReturnType<typeof useGetFeatureToPlatformPermissionLazyQuery>;
export type GetFeatureToPlatformPermissionSuspenseQueryHookResult = ReturnType<typeof useGetFeatureToPlatformPermissionSuspenseQuery>;
export type GetFeatureToPlatformPermissionQueryResult = Apollo.QueryResult<GetFeatureToPlatformPermissionQuery, GetFeatureToPlatformPermissionQueryVariables>;
export const GetFeedByTypeDocument = gql`
    query getFeedByType($feedType: String, $offset: Int, $limit: Int) {
  getFeedByType(feedType: $feedType, offset: $offset, limit: $limit) {
    actId
    activityId
    activityType
    createdAt
    avatar
    cover
    user {
      id
      firstName
      lastName
      avatar
      cover
      username
      isVerified
      greenTick
      tick3
      profileType
    }
    followingUser {
      id
      firstName
      lastName
      username
      avatar
      cover
      isVerified
      greenTick
      tick3
      profileType
    }
    club {
      clubId
      clubHandle
      avatar
      cover
      clubName
    }
    followingHashtag {
      hashtagName
      hashtagType
    }
    followingStocktag {
      securityId
      stockName
      slug
      nseListingId
      bseListingId
    }
    post {
      ...PostFields
      comments {
        ...CommentFields
        replies {
          ...ReplyFields
        }
      }
    }
  }
}
    ${PostFieldsFragmentDoc}
${CommentFieldsFragmentDoc}
${ReplyFieldsFragmentDoc}`;

/**
 * __useGetFeedByTypeQuery__
 *
 * To run a query within a React component, call `useGetFeedByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedByTypeQuery({
 *   variables: {
 *      feedType: // value for 'feedType'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetFeedByTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeedByTypeQuery, GetFeedByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeedByTypeQuery, GetFeedByTypeQueryVariables>(GetFeedByTypeDocument, options);
      }
export function useGetFeedByTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeedByTypeQuery, GetFeedByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeedByTypeQuery, GetFeedByTypeQueryVariables>(GetFeedByTypeDocument, options);
        }
export function useGetFeedByTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFeedByTypeQuery, GetFeedByTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFeedByTypeQuery, GetFeedByTypeQueryVariables>(GetFeedByTypeDocument, options);
        }
export type GetFeedByTypeQueryHookResult = ReturnType<typeof useGetFeedByTypeQuery>;
export type GetFeedByTypeLazyQueryHookResult = ReturnType<typeof useGetFeedByTypeLazyQuery>;
export type GetFeedByTypeSuspenseQueryHookResult = ReturnType<typeof useGetFeedByTypeSuspenseQuery>;
export type GetFeedByTypeQueryResult = Apollo.QueryResult<GetFeedByTypeQuery, GetFeedByTypeQueryVariables>;
export const GetFeedbackTypesDocument = gql`
    query getFeedbackTypes {
  getFeedbackTypes
}
    `;

/**
 * __useGetFeedbackTypesQuery__
 *
 * To run a query within a React component, call `useGetFeedbackTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeedbackTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeedbackTypesQuery, GetFeedbackTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeedbackTypesQuery, GetFeedbackTypesQueryVariables>(GetFeedbackTypesDocument, options);
      }
export function useGetFeedbackTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeedbackTypesQuery, GetFeedbackTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeedbackTypesQuery, GetFeedbackTypesQueryVariables>(GetFeedbackTypesDocument, options);
        }
export function useGetFeedbackTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFeedbackTypesQuery, GetFeedbackTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFeedbackTypesQuery, GetFeedbackTypesQueryVariables>(GetFeedbackTypesDocument, options);
        }
export type GetFeedbackTypesQueryHookResult = ReturnType<typeof useGetFeedbackTypesQuery>;
export type GetFeedbackTypesLazyQueryHookResult = ReturnType<typeof useGetFeedbackTypesLazyQuery>;
export type GetFeedbackTypesSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackTypesSuspenseQuery>;
export type GetFeedbackTypesQueryResult = Apollo.QueryResult<GetFeedbackTypesQuery, GetFeedbackTypesQueryVariables>;
export const GetGuidedTourDocument = gql`
    query getGuidedTour($tourComponent: String, $tourSource: TourSourceType) {
  getGuidedTour(tourComponent: $tourComponent, tourSource: $tourSource) {
    tourId
    tourComponent
    tourKey
    tourDescription
  }
}
    `;

/**
 * __useGetGuidedTourQuery__
 *
 * To run a query within a React component, call `useGetGuidedTourQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuidedTourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuidedTourQuery({
 *   variables: {
 *      tourComponent: // value for 'tourComponent'
 *      tourSource: // value for 'tourSource'
 *   },
 * });
 */
export function useGetGuidedTourQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuidedTourQuery, GetGuidedTourQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGuidedTourQuery, GetGuidedTourQueryVariables>(GetGuidedTourDocument, options);
      }
export function useGetGuidedTourLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuidedTourQuery, GetGuidedTourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGuidedTourQuery, GetGuidedTourQueryVariables>(GetGuidedTourDocument, options);
        }
export function useGetGuidedTourSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetGuidedTourQuery, GetGuidedTourQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetGuidedTourQuery, GetGuidedTourQueryVariables>(GetGuidedTourDocument, options);
        }
export type GetGuidedTourQueryHookResult = ReturnType<typeof useGetGuidedTourQuery>;
export type GetGuidedTourLazyQueryHookResult = ReturnType<typeof useGetGuidedTourLazyQuery>;
export type GetGuidedTourSuspenseQueryHookResult = ReturnType<typeof useGetGuidedTourSuspenseQuery>;
export type GetGuidedTourQueryResult = Apollo.QueryResult<GetGuidedTourQuery, GetGuidedTourQueryVariables>;
export const GetHashTagDetailsDocument = gql`
    query getHashTagDetails($hashTagName: String, $hashtagId: String) {
  getHashTagDetails(hashTagName: $hashTagName, hashtagId: $hashtagId) {
    hashtag {
      TagId
      hashtagName
      hashtagType
      postCount
      isfollow
      issubscribed
      followers
      viewFeedPermission {
        canViewPost
        canSeeMarketingPost
      }
    }
    discussions
    followers
  }
}
    `;

/**
 * __useGetHashTagDetailsQuery__
 *
 * To run a query within a React component, call `useGetHashTagDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashTagDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashTagDetailsQuery({
 *   variables: {
 *      hashTagName: // value for 'hashTagName'
 *      hashtagId: // value for 'hashtagId'
 *   },
 * });
 */
export function useGetHashTagDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHashTagDetailsQuery, GetHashTagDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHashTagDetailsQuery, GetHashTagDetailsQueryVariables>(GetHashTagDetailsDocument, options);
      }
export function useGetHashTagDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHashTagDetailsQuery, GetHashTagDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHashTagDetailsQuery, GetHashTagDetailsQueryVariables>(GetHashTagDetailsDocument, options);
        }
export function useGetHashTagDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetHashTagDetailsQuery, GetHashTagDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetHashTagDetailsQuery, GetHashTagDetailsQueryVariables>(GetHashTagDetailsDocument, options);
        }
export type GetHashTagDetailsQueryHookResult = ReturnType<typeof useGetHashTagDetailsQuery>;
export type GetHashTagDetailsLazyQueryHookResult = ReturnType<typeof useGetHashTagDetailsLazyQuery>;
export type GetHashTagDetailsSuspenseQueryHookResult = ReturnType<typeof useGetHashTagDetailsSuspenseQuery>;
export type GetHashTagDetailsQueryResult = Apollo.QueryResult<GetHashTagDetailsQuery, GetHashTagDetailsQueryVariables>;
export const GetHashTagsUserTalksAboutDocument = gql`
    query GetHashTagsUserTalksAbout($userId: String!) {
  getHashTagsUserTalksAbout(userId: $userId) {
    TagId
    hashtagName
    isfollow
  }
}
    `;

/**
 * __useGetHashTagsUserTalksAboutQuery__
 *
 * To run a query within a React component, call `useGetHashTagsUserTalksAboutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashTagsUserTalksAboutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashTagsUserTalksAboutQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetHashTagsUserTalksAboutQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetHashTagsUserTalksAboutQuery, GetHashTagsUserTalksAboutQueryVariables> & ({ variables: GetHashTagsUserTalksAboutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHashTagsUserTalksAboutQuery, GetHashTagsUserTalksAboutQueryVariables>(GetHashTagsUserTalksAboutDocument, options);
      }
export function useGetHashTagsUserTalksAboutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHashTagsUserTalksAboutQuery, GetHashTagsUserTalksAboutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHashTagsUserTalksAboutQuery, GetHashTagsUserTalksAboutQueryVariables>(GetHashTagsUserTalksAboutDocument, options);
        }
export function useGetHashTagsUserTalksAboutSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetHashTagsUserTalksAboutQuery, GetHashTagsUserTalksAboutQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetHashTagsUserTalksAboutQuery, GetHashTagsUserTalksAboutQueryVariables>(GetHashTagsUserTalksAboutDocument, options);
        }
export type GetHashTagsUserTalksAboutQueryHookResult = ReturnType<typeof useGetHashTagsUserTalksAboutQuery>;
export type GetHashTagsUserTalksAboutLazyQueryHookResult = ReturnType<typeof useGetHashTagsUserTalksAboutLazyQuery>;
export type GetHashTagsUserTalksAboutSuspenseQueryHookResult = ReturnType<typeof useGetHashTagsUserTalksAboutSuspenseQuery>;
export type GetHashTagsUserTalksAboutQueryResult = Apollo.QueryResult<GetHashTagsUserTalksAboutQuery, GetHashTagsUserTalksAboutQueryVariables>;
export const GetHashtagBySearchTextDocument = gql`
    query getHashtagBySearchText($data: GetHashtagBySearchTextArgs) {
  getHashtagBySearchText(data: $data) {
    Hashtag {
      hashtagName
      hashtagType
    }
  }
}
    `;

/**
 * __useGetHashtagBySearchTextQuery__
 *
 * To run a query within a React component, call `useGetHashtagBySearchTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashtagBySearchTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashtagBySearchTextQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetHashtagBySearchTextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHashtagBySearchTextQuery, GetHashtagBySearchTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHashtagBySearchTextQuery, GetHashtagBySearchTextQueryVariables>(GetHashtagBySearchTextDocument, options);
      }
export function useGetHashtagBySearchTextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHashtagBySearchTextQuery, GetHashtagBySearchTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHashtagBySearchTextQuery, GetHashtagBySearchTextQueryVariables>(GetHashtagBySearchTextDocument, options);
        }
export function useGetHashtagBySearchTextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetHashtagBySearchTextQuery, GetHashtagBySearchTextQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetHashtagBySearchTextQuery, GetHashtagBySearchTextQueryVariables>(GetHashtagBySearchTextDocument, options);
        }
export type GetHashtagBySearchTextQueryHookResult = ReturnType<typeof useGetHashtagBySearchTextQuery>;
export type GetHashtagBySearchTextLazyQueryHookResult = ReturnType<typeof useGetHashtagBySearchTextLazyQuery>;
export type GetHashtagBySearchTextSuspenseQueryHookResult = ReturnType<typeof useGetHashtagBySearchTextSuspenseQuery>;
export type GetHashtagBySearchTextQueryResult = Apollo.QueryResult<GetHashtagBySearchTextQuery, GetHashtagBySearchTextQueryVariables>;
export const GetHashtagFollowingsDocument = gql`
    query getHashtagFollowings($userId: String!, $offset: Int!, $limit: Int!) {
  getHashtagFollowings(userId: $userId, offset: $offset, limit: $limit) {
    hashtagName
    postCount
    isfollow
    issubscribed
    followers
  }
}
    `;

/**
 * __useGetHashtagFollowingsQuery__
 *
 * To run a query within a React component, call `useGetHashtagFollowingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashtagFollowingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashtagFollowingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetHashtagFollowingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetHashtagFollowingsQuery, GetHashtagFollowingsQueryVariables> & ({ variables: GetHashtagFollowingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHashtagFollowingsQuery, GetHashtagFollowingsQueryVariables>(GetHashtagFollowingsDocument, options);
      }
export function useGetHashtagFollowingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHashtagFollowingsQuery, GetHashtagFollowingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHashtagFollowingsQuery, GetHashtagFollowingsQueryVariables>(GetHashtagFollowingsDocument, options);
        }
export function useGetHashtagFollowingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetHashtagFollowingsQuery, GetHashtagFollowingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetHashtagFollowingsQuery, GetHashtagFollowingsQueryVariables>(GetHashtagFollowingsDocument, options);
        }
export type GetHashtagFollowingsQueryHookResult = ReturnType<typeof useGetHashtagFollowingsQuery>;
export type GetHashtagFollowingsLazyQueryHookResult = ReturnType<typeof useGetHashtagFollowingsLazyQuery>;
export type GetHashtagFollowingsSuspenseQueryHookResult = ReturnType<typeof useGetHashtagFollowingsSuspenseQuery>;
export type GetHashtagFollowingsQueryResult = Apollo.QueryResult<GetHashtagFollowingsQuery, GetHashtagFollowingsQueryVariables>;
export const GetHashtagMarketingPostsDocument = gql`
    query getHashtagMarketingPosts($hashTagName: String, $hashtagId: String) {
  getHashtagMarketingPosts(hashTagName: $hashTagName, hashtagId: $hashtagId) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetHashtagMarketingPostsQuery__
 *
 * To run a query within a React component, call `useGetHashtagMarketingPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashtagMarketingPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashtagMarketingPostsQuery({
 *   variables: {
 *      hashTagName: // value for 'hashTagName'
 *      hashtagId: // value for 'hashtagId'
 *   },
 * });
 */
export function useGetHashtagMarketingPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHashtagMarketingPostsQuery, GetHashtagMarketingPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHashtagMarketingPostsQuery, GetHashtagMarketingPostsQueryVariables>(GetHashtagMarketingPostsDocument, options);
      }
export function useGetHashtagMarketingPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHashtagMarketingPostsQuery, GetHashtagMarketingPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHashtagMarketingPostsQuery, GetHashtagMarketingPostsQueryVariables>(GetHashtagMarketingPostsDocument, options);
        }
export function useGetHashtagMarketingPostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetHashtagMarketingPostsQuery, GetHashtagMarketingPostsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetHashtagMarketingPostsQuery, GetHashtagMarketingPostsQueryVariables>(GetHashtagMarketingPostsDocument, options);
        }
export type GetHashtagMarketingPostsQueryHookResult = ReturnType<typeof useGetHashtagMarketingPostsQuery>;
export type GetHashtagMarketingPostsLazyQueryHookResult = ReturnType<typeof useGetHashtagMarketingPostsLazyQuery>;
export type GetHashtagMarketingPostsSuspenseQueryHookResult = ReturnType<typeof useGetHashtagMarketingPostsSuspenseQuery>;
export type GetHashtagMarketingPostsQueryResult = Apollo.QueryResult<GetHashtagMarketingPostsQuery, GetHashtagMarketingPostsQueryVariables>;
export const GetHashtagsListBasedOnTypeOfContentDocument = gql`
    query getHashtagsListBasedOnTypeOfContent($typeOfContentMadeByHashtag: UserHashtagContentType) {
  getHashtagsListBasedOnTypeOfContent(
    typeOfContentMadeByHashtag: $typeOfContentMadeByHashtag
  ) {
    hashtagName
  }
}
    `;

/**
 * __useGetHashtagsListBasedOnTypeOfContentQuery__
 *
 * To run a query within a React component, call `useGetHashtagsListBasedOnTypeOfContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashtagsListBasedOnTypeOfContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashtagsListBasedOnTypeOfContentQuery({
 *   variables: {
 *      typeOfContentMadeByHashtag: // value for 'typeOfContentMadeByHashtag'
 *   },
 * });
 */
export function useGetHashtagsListBasedOnTypeOfContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHashtagsListBasedOnTypeOfContentQuery, GetHashtagsListBasedOnTypeOfContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHashtagsListBasedOnTypeOfContentQuery, GetHashtagsListBasedOnTypeOfContentQueryVariables>(GetHashtagsListBasedOnTypeOfContentDocument, options);
      }
export function useGetHashtagsListBasedOnTypeOfContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHashtagsListBasedOnTypeOfContentQuery, GetHashtagsListBasedOnTypeOfContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHashtagsListBasedOnTypeOfContentQuery, GetHashtagsListBasedOnTypeOfContentQueryVariables>(GetHashtagsListBasedOnTypeOfContentDocument, options);
        }
export function useGetHashtagsListBasedOnTypeOfContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetHashtagsListBasedOnTypeOfContentQuery, GetHashtagsListBasedOnTypeOfContentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetHashtagsListBasedOnTypeOfContentQuery, GetHashtagsListBasedOnTypeOfContentQueryVariables>(GetHashtagsListBasedOnTypeOfContentDocument, options);
        }
export type GetHashtagsListBasedOnTypeOfContentQueryHookResult = ReturnType<typeof useGetHashtagsListBasedOnTypeOfContentQuery>;
export type GetHashtagsListBasedOnTypeOfContentLazyQueryHookResult = ReturnType<typeof useGetHashtagsListBasedOnTypeOfContentLazyQuery>;
export type GetHashtagsListBasedOnTypeOfContentSuspenseQueryHookResult = ReturnType<typeof useGetHashtagsListBasedOnTypeOfContentSuspenseQuery>;
export type GetHashtagsListBasedOnTypeOfContentQueryResult = Apollo.QueryResult<GetHashtagsListBasedOnTypeOfContentQuery, GetHashtagsListBasedOnTypeOfContentQueryVariables>;
export const GetImportantProfilesDocument = gql`
    query getImportantProfiles {
  getImportantProfiles {
    ...UserFields
    cover
    isfollow
    postCount
    followerCount
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetImportantProfilesQuery__
 *
 * To run a query within a React component, call `useGetImportantProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportantProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportantProfilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetImportantProfilesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetImportantProfilesQuery, GetImportantProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetImportantProfilesQuery, GetImportantProfilesQueryVariables>(GetImportantProfilesDocument, options);
      }
export function useGetImportantProfilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetImportantProfilesQuery, GetImportantProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetImportantProfilesQuery, GetImportantProfilesQueryVariables>(GetImportantProfilesDocument, options);
        }
export function useGetImportantProfilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetImportantProfilesQuery, GetImportantProfilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetImportantProfilesQuery, GetImportantProfilesQueryVariables>(GetImportantProfilesDocument, options);
        }
export type GetImportantProfilesQueryHookResult = ReturnType<typeof useGetImportantProfilesQuery>;
export type GetImportantProfilesLazyQueryHookResult = ReturnType<typeof useGetImportantProfilesLazyQuery>;
export type GetImportantProfilesSuspenseQueryHookResult = ReturnType<typeof useGetImportantProfilesSuspenseQuery>;
export type GetImportantProfilesQueryResult = Apollo.QueryResult<GetImportantProfilesQuery, GetImportantProfilesQueryVariables>;
export const GetInterstitialsDocument = gql`
    query getInterstitials($platformType: platformTypeForInterstitial!) {
  getInterstitials(platformType: $platformType) {
    interstitialsId
    componentType
    position
    data
    title
  }
}
    `;

/**
 * __useGetInterstitialsQuery__
 *
 * To run a query within a React component, call `useGetInterstitialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterstitialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterstitialsQuery({
 *   variables: {
 *      platformType: // value for 'platformType'
 *   },
 * });
 */
export function useGetInterstitialsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetInterstitialsQuery, GetInterstitialsQueryVariables> & ({ variables: GetInterstitialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInterstitialsQuery, GetInterstitialsQueryVariables>(GetInterstitialsDocument, options);
      }
export function useGetInterstitialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInterstitialsQuery, GetInterstitialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInterstitialsQuery, GetInterstitialsQueryVariables>(GetInterstitialsDocument, options);
        }
export function useGetInterstitialsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetInterstitialsQuery, GetInterstitialsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetInterstitialsQuery, GetInterstitialsQueryVariables>(GetInterstitialsDocument, options);
        }
export type GetInterstitialsQueryHookResult = ReturnType<typeof useGetInterstitialsQuery>;
export type GetInterstitialsLazyQueryHookResult = ReturnType<typeof useGetInterstitialsLazyQuery>;
export type GetInterstitialsSuspenseQueryHookResult = ReturnType<typeof useGetInterstitialsSuspenseQuery>;
export type GetInterstitialsQueryResult = Apollo.QueryResult<GetInterstitialsQuery, GetInterstitialsQueryVariables>;
export const GetListOfClubsWithPostPermissionDocument = gql`
    query getListOfClubsWithPostPermission {
  getListOfClubsWithPostPermission {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetListOfClubsWithPostPermissionQuery__
 *
 * To run a query within a React component, call `useGetListOfClubsWithPostPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOfClubsWithPostPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListOfClubsWithPostPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListOfClubsWithPostPermissionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetListOfClubsWithPostPermissionQuery, GetListOfClubsWithPostPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetListOfClubsWithPostPermissionQuery, GetListOfClubsWithPostPermissionQueryVariables>(GetListOfClubsWithPostPermissionDocument, options);
      }
export function useGetListOfClubsWithPostPermissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetListOfClubsWithPostPermissionQuery, GetListOfClubsWithPostPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetListOfClubsWithPostPermissionQuery, GetListOfClubsWithPostPermissionQueryVariables>(GetListOfClubsWithPostPermissionDocument, options);
        }
export function useGetListOfClubsWithPostPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetListOfClubsWithPostPermissionQuery, GetListOfClubsWithPostPermissionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetListOfClubsWithPostPermissionQuery, GetListOfClubsWithPostPermissionQueryVariables>(GetListOfClubsWithPostPermissionDocument, options);
        }
export type GetListOfClubsWithPostPermissionQueryHookResult = ReturnType<typeof useGetListOfClubsWithPostPermissionQuery>;
export type GetListOfClubsWithPostPermissionLazyQueryHookResult = ReturnType<typeof useGetListOfClubsWithPostPermissionLazyQuery>;
export type GetListOfClubsWithPostPermissionSuspenseQueryHookResult = ReturnType<typeof useGetListOfClubsWithPostPermissionSuspenseQuery>;
export type GetListOfClubsWithPostPermissionQueryResult = Apollo.QueryResult<GetListOfClubsWithPostPermissionQuery, GetListOfClubsWithPostPermissionQueryVariables>;
export const GetListOfClubsWithQueryPermissionDocument = gql`
    query getListOfClubsWithQueryPermission {
  getListOfClubsWithQueryPermission {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetListOfClubsWithQueryPermissionQuery__
 *
 * To run a query within a React component, call `useGetListOfClubsWithQueryPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOfClubsWithQueryPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListOfClubsWithQueryPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListOfClubsWithQueryPermissionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetListOfClubsWithQueryPermissionQuery, GetListOfClubsWithQueryPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetListOfClubsWithQueryPermissionQuery, GetListOfClubsWithQueryPermissionQueryVariables>(GetListOfClubsWithQueryPermissionDocument, options);
      }
export function useGetListOfClubsWithQueryPermissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetListOfClubsWithQueryPermissionQuery, GetListOfClubsWithQueryPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetListOfClubsWithQueryPermissionQuery, GetListOfClubsWithQueryPermissionQueryVariables>(GetListOfClubsWithQueryPermissionDocument, options);
        }
export function useGetListOfClubsWithQueryPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetListOfClubsWithQueryPermissionQuery, GetListOfClubsWithQueryPermissionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetListOfClubsWithQueryPermissionQuery, GetListOfClubsWithQueryPermissionQueryVariables>(GetListOfClubsWithQueryPermissionDocument, options);
        }
export type GetListOfClubsWithQueryPermissionQueryHookResult = ReturnType<typeof useGetListOfClubsWithQueryPermissionQuery>;
export type GetListOfClubsWithQueryPermissionLazyQueryHookResult = ReturnType<typeof useGetListOfClubsWithQueryPermissionLazyQuery>;
export type GetListOfClubsWithQueryPermissionSuspenseQueryHookResult = ReturnType<typeof useGetListOfClubsWithQueryPermissionSuspenseQuery>;
export type GetListOfClubsWithQueryPermissionQueryResult = Apollo.QueryResult<GetListOfClubsWithQueryPermissionQuery, GetListOfClubsWithQueryPermissionQueryVariables>;
export const GetListOfClubsWithStockIdeaPermissionDocument = gql`
    query getListOfClubsWithStockIdeaPermission {
  getListOfClubsWithStockIdeaPermission {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetListOfClubsWithStockIdeaPermissionQuery__
 *
 * To run a query within a React component, call `useGetListOfClubsWithStockIdeaPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOfClubsWithStockIdeaPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListOfClubsWithStockIdeaPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListOfClubsWithStockIdeaPermissionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetListOfClubsWithStockIdeaPermissionQuery, GetListOfClubsWithStockIdeaPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetListOfClubsWithStockIdeaPermissionQuery, GetListOfClubsWithStockIdeaPermissionQueryVariables>(GetListOfClubsWithStockIdeaPermissionDocument, options);
      }
export function useGetListOfClubsWithStockIdeaPermissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetListOfClubsWithStockIdeaPermissionQuery, GetListOfClubsWithStockIdeaPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetListOfClubsWithStockIdeaPermissionQuery, GetListOfClubsWithStockIdeaPermissionQueryVariables>(GetListOfClubsWithStockIdeaPermissionDocument, options);
        }
export function useGetListOfClubsWithStockIdeaPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetListOfClubsWithStockIdeaPermissionQuery, GetListOfClubsWithStockIdeaPermissionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetListOfClubsWithStockIdeaPermissionQuery, GetListOfClubsWithStockIdeaPermissionQueryVariables>(GetListOfClubsWithStockIdeaPermissionDocument, options);
        }
export type GetListOfClubsWithStockIdeaPermissionQueryHookResult = ReturnType<typeof useGetListOfClubsWithStockIdeaPermissionQuery>;
export type GetListOfClubsWithStockIdeaPermissionLazyQueryHookResult = ReturnType<typeof useGetListOfClubsWithStockIdeaPermissionLazyQuery>;
export type GetListOfClubsWithStockIdeaPermissionSuspenseQueryHookResult = ReturnType<typeof useGetListOfClubsWithStockIdeaPermissionSuspenseQuery>;
export type GetListOfClubsWithStockIdeaPermissionQueryResult = Apollo.QueryResult<GetListOfClubsWithStockIdeaPermissionQuery, GetListOfClubsWithStockIdeaPermissionQueryVariables>;
export const GetMarketExpertsDocument = gql`
    query getMarketExperts($limit: Int, $offset: Int) {
  getMarketExperts(limit: $limit, offset: $offset) {
    ...UserFields
    cover
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetMarketExpertsQuery__
 *
 * To run a query within a React component, call `useGetMarketExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketExpertsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetMarketExpertsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMarketExpertsQuery, GetMarketExpertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMarketExpertsQuery, GetMarketExpertsQueryVariables>(GetMarketExpertsDocument, options);
      }
export function useGetMarketExpertsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMarketExpertsQuery, GetMarketExpertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMarketExpertsQuery, GetMarketExpertsQueryVariables>(GetMarketExpertsDocument, options);
        }
export function useGetMarketExpertsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMarketExpertsQuery, GetMarketExpertsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMarketExpertsQuery, GetMarketExpertsQueryVariables>(GetMarketExpertsDocument, options);
        }
export type GetMarketExpertsQueryHookResult = ReturnType<typeof useGetMarketExpertsQuery>;
export type GetMarketExpertsLazyQueryHookResult = ReturnType<typeof useGetMarketExpertsLazyQuery>;
export type GetMarketExpertsSuspenseQueryHookResult = ReturnType<typeof useGetMarketExpertsSuspenseQuery>;
export type GetMarketExpertsQueryResult = Apollo.QueryResult<GetMarketExpertsQuery, GetMarketExpertsQueryVariables>;
export const GetProfileMediaDocument = gql`
    query getProfileMedia($data: UserId, $offset: Int, $limit: Int) {
  getMediaPosts(data: $data, offset: $offset, limit: $limit) {
    postId
    media {
      type
      uri
      name
    }
  }
}
    `;

/**
 * __useGetProfileMediaQuery__
 *
 * To run a query within a React component, call `useGetProfileMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileMediaQuery({
 *   variables: {
 *      data: // value for 'data'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetProfileMediaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProfileMediaQuery, GetProfileMediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfileMediaQuery, GetProfileMediaQueryVariables>(GetProfileMediaDocument, options);
      }
export function useGetProfileMediaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileMediaQuery, GetProfileMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfileMediaQuery, GetProfileMediaQueryVariables>(GetProfileMediaDocument, options);
        }
export function useGetProfileMediaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProfileMediaQuery, GetProfileMediaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProfileMediaQuery, GetProfileMediaQueryVariables>(GetProfileMediaDocument, options);
        }
export type GetProfileMediaQueryHookResult = ReturnType<typeof useGetProfileMediaQuery>;
export type GetProfileMediaLazyQueryHookResult = ReturnType<typeof useGetProfileMediaLazyQuery>;
export type GetProfileMediaSuspenseQueryHookResult = ReturnType<typeof useGetProfileMediaSuspenseQuery>;
export type GetProfileMediaQueryResult = Apollo.QueryResult<GetProfileMediaQuery, GetProfileMediaQueryVariables>;
export const GetMembersDocument = gql`
    query getMembers($clubId: String!, $offset: Int, $limit: Int) {
  getMembers(clubId: $clubId, offset: $offset, limit: $limit) {
    ...UserFields
    cover
    isfollow
    followerCount
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetMembersQuery__
 *
 * To run a query within a React component, call `useGetMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMembersQuery, GetMembersQueryVariables> & ({ variables: GetMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
      }
export function useGetMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
export function useGetMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
export type GetMembersQueryHookResult = ReturnType<typeof useGetMembersQuery>;
export type GetMembersLazyQueryHookResult = ReturnType<typeof useGetMembersLazyQuery>;
export type GetMembersSuspenseQueryHookResult = ReturnType<typeof useGetMembersSuspenseQuery>;
export type GetMembersQueryResult = Apollo.QueryResult<GetMembersQuery, GetMembersQueryVariables>;
export const GetMultipleExternalResourceDocument = gql`
    query getMultipleExternalResource($type: [String]) {
  getMultipleExternalResource(type: $type) {
    id
    type
    value
  }
}
    `;

/**
 * __useGetMultipleExternalResourceQuery__
 *
 * To run a query within a React component, call `useGetMultipleExternalResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultipleExternalResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultipleExternalResourceQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetMultipleExternalResourceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMultipleExternalResourceQuery, GetMultipleExternalResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMultipleExternalResourceQuery, GetMultipleExternalResourceQueryVariables>(GetMultipleExternalResourceDocument, options);
      }
export function useGetMultipleExternalResourceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMultipleExternalResourceQuery, GetMultipleExternalResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMultipleExternalResourceQuery, GetMultipleExternalResourceQueryVariables>(GetMultipleExternalResourceDocument, options);
        }
export function useGetMultipleExternalResourceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMultipleExternalResourceQuery, GetMultipleExternalResourceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMultipleExternalResourceQuery, GetMultipleExternalResourceQueryVariables>(GetMultipleExternalResourceDocument, options);
        }
export type GetMultipleExternalResourceQueryHookResult = ReturnType<typeof useGetMultipleExternalResourceQuery>;
export type GetMultipleExternalResourceLazyQueryHookResult = ReturnType<typeof useGetMultipleExternalResourceLazyQuery>;
export type GetMultipleExternalResourceSuspenseQueryHookResult = ReturnType<typeof useGetMultipleExternalResourceSuspenseQuery>;
export type GetMultipleExternalResourceQueryResult = Apollo.QueryResult<GetMultipleExternalResourceQuery, GetMultipleExternalResourceQueryVariables>;
export const GetMyFeedbacksDocument = gql`
    query getMyFeedbacks {
  getMyFeedbacks {
    feedbackId
    user {
      firstName
      lastName
      id
      username
      avatar
      cover
      isVerified
      greenTick
      tick3
    }
    type
    subject
    comment
    status
    attachment {
      type
      uri
      name
    }
  }
}
    `;

/**
 * __useGetMyFeedbacksQuery__
 *
 * To run a query within a React component, call `useGetMyFeedbacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyFeedbacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyFeedbacksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyFeedbacksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyFeedbacksQuery, GetMyFeedbacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyFeedbacksQuery, GetMyFeedbacksQueryVariables>(GetMyFeedbacksDocument, options);
      }
export function useGetMyFeedbacksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyFeedbacksQuery, GetMyFeedbacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyFeedbacksQuery, GetMyFeedbacksQueryVariables>(GetMyFeedbacksDocument, options);
        }
export function useGetMyFeedbacksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyFeedbacksQuery, GetMyFeedbacksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyFeedbacksQuery, GetMyFeedbacksQueryVariables>(GetMyFeedbacksDocument, options);
        }
export type GetMyFeedbacksQueryHookResult = ReturnType<typeof useGetMyFeedbacksQuery>;
export type GetMyFeedbacksLazyQueryHookResult = ReturnType<typeof useGetMyFeedbacksLazyQuery>;
export type GetMyFeedbacksSuspenseQueryHookResult = ReturnType<typeof useGetMyFeedbacksSuspenseQuery>;
export type GetMyFeedbacksQueryResult = Apollo.QueryResult<GetMyFeedbacksQuery, GetMyFeedbacksQueryVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications($page: Int, $limit: Int, $offset: Int, $filter: NotificationFilter) {
  getNotifications(page: $page, limit: $limit, offset: $offset, filter: $filter) {
    notificationId
    notificationType
    createdAt
    link
    message
    read
    isGeneratedByAdmin
    User {
      ...UserFields
    }
    Notifier {
      ...UserFields
    }
    Club {
      clubHandle
      clubId
      clubName
    }
    postId
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export function useGetNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetOnboardScreenContentDocument = gql`
    query getOnboardScreenContent($screenName: ScreenName, $input: JSON) {
  getOnboardScreenContent(screenName: $screenName, input: $input)
}
    `;

/**
 * __useGetOnboardScreenContentQuery__
 *
 * To run a query within a React component, call `useGetOnboardScreenContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardScreenContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardScreenContentQuery({
 *   variables: {
 *      screenName: // value for 'screenName'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOnboardScreenContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOnboardScreenContentQuery, GetOnboardScreenContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOnboardScreenContentQuery, GetOnboardScreenContentQueryVariables>(GetOnboardScreenContentDocument, options);
      }
export function useGetOnboardScreenContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOnboardScreenContentQuery, GetOnboardScreenContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOnboardScreenContentQuery, GetOnboardScreenContentQueryVariables>(GetOnboardScreenContentDocument, options);
        }
export function useGetOnboardScreenContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOnboardScreenContentQuery, GetOnboardScreenContentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOnboardScreenContentQuery, GetOnboardScreenContentQueryVariables>(GetOnboardScreenContentDocument, options);
        }
export type GetOnboardScreenContentQueryHookResult = ReturnType<typeof useGetOnboardScreenContentQuery>;
export type GetOnboardScreenContentLazyQueryHookResult = ReturnType<typeof useGetOnboardScreenContentLazyQuery>;
export type GetOnboardScreenContentSuspenseQueryHookResult = ReturnType<typeof useGetOnboardScreenContentSuspenseQuery>;
export type GetOnboardScreenContentQueryResult = Apollo.QueryResult<GetOnboardScreenContentQuery, GetOnboardScreenContentQueryVariables>;
export const GetPeopleListForSmartFeedDocument = gql`
    query getPeopleListForSmartFeed($data: String!) {
  getPeopleListForSmartFeed(data: $data) {
    ...UserFields
    isfollow
    followerCount
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetPeopleListForSmartFeedQuery__
 *
 * To run a query within a React component, call `useGetPeopleListForSmartFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPeopleListForSmartFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeopleListForSmartFeedQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetPeopleListForSmartFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPeopleListForSmartFeedQuery, GetPeopleListForSmartFeedQueryVariables> & ({ variables: GetPeopleListForSmartFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPeopleListForSmartFeedQuery, GetPeopleListForSmartFeedQueryVariables>(GetPeopleListForSmartFeedDocument, options);
      }
export function useGetPeopleListForSmartFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPeopleListForSmartFeedQuery, GetPeopleListForSmartFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPeopleListForSmartFeedQuery, GetPeopleListForSmartFeedQueryVariables>(GetPeopleListForSmartFeedDocument, options);
        }
export function useGetPeopleListForSmartFeedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPeopleListForSmartFeedQuery, GetPeopleListForSmartFeedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPeopleListForSmartFeedQuery, GetPeopleListForSmartFeedQueryVariables>(GetPeopleListForSmartFeedDocument, options);
        }
export type GetPeopleListForSmartFeedQueryHookResult = ReturnType<typeof useGetPeopleListForSmartFeedQuery>;
export type GetPeopleListForSmartFeedLazyQueryHookResult = ReturnType<typeof useGetPeopleListForSmartFeedLazyQuery>;
export type GetPeopleListForSmartFeedSuspenseQueryHookResult = ReturnType<typeof useGetPeopleListForSmartFeedSuspenseQuery>;
export type GetPeopleListForSmartFeedQueryResult = Apollo.QueryResult<GetPeopleListForSmartFeedQuery, GetPeopleListForSmartFeedQueryVariables>;
export const GetPermissionToFeatureMappingListDocument = gql`
    query getPermissionToFeatureMappingList {
  getPermissionToFeatureMappingList {
    clubFeatures {
      clubId
      features
    }
    platformFeatures {
      permission
      features
    }
  }
}
    `;

/**
 * __useGetPermissionToFeatureMappingListQuery__
 *
 * To run a query within a React component, call `useGetPermissionToFeatureMappingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionToFeatureMappingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionToFeatureMappingListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPermissionToFeatureMappingListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPermissionToFeatureMappingListQuery, GetPermissionToFeatureMappingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPermissionToFeatureMappingListQuery, GetPermissionToFeatureMappingListQueryVariables>(GetPermissionToFeatureMappingListDocument, options);
      }
export function useGetPermissionToFeatureMappingListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPermissionToFeatureMappingListQuery, GetPermissionToFeatureMappingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPermissionToFeatureMappingListQuery, GetPermissionToFeatureMappingListQueryVariables>(GetPermissionToFeatureMappingListDocument, options);
        }
export function useGetPermissionToFeatureMappingListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPermissionToFeatureMappingListQuery, GetPermissionToFeatureMappingListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPermissionToFeatureMappingListQuery, GetPermissionToFeatureMappingListQueryVariables>(GetPermissionToFeatureMappingListDocument, options);
        }
export type GetPermissionToFeatureMappingListQueryHookResult = ReturnType<typeof useGetPermissionToFeatureMappingListQuery>;
export type GetPermissionToFeatureMappingListLazyQueryHookResult = ReturnType<typeof useGetPermissionToFeatureMappingListLazyQuery>;
export type GetPermissionToFeatureMappingListSuspenseQueryHookResult = ReturnType<typeof useGetPermissionToFeatureMappingListSuspenseQuery>;
export type GetPermissionToFeatureMappingListQueryResult = Apollo.QueryResult<GetPermissionToFeatureMappingListQuery, GetPermissionToFeatureMappingListQueryVariables>;
export const GetPinnedPostDocument = gql`
    query getPinnedPost($userId: String) {
  getPinnedPost(userId: $userId) {
    ...PostFields
    isPinned
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetPinnedPostQuery__
 *
 * To run a query within a React component, call `useGetPinnedPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPinnedPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPinnedPostQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPinnedPostQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPinnedPostQuery, GetPinnedPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPinnedPostQuery, GetPinnedPostQueryVariables>(GetPinnedPostDocument, options);
      }
export function useGetPinnedPostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPinnedPostQuery, GetPinnedPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPinnedPostQuery, GetPinnedPostQueryVariables>(GetPinnedPostDocument, options);
        }
export function useGetPinnedPostSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPinnedPostQuery, GetPinnedPostQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPinnedPostQuery, GetPinnedPostQueryVariables>(GetPinnedPostDocument, options);
        }
export type GetPinnedPostQueryHookResult = ReturnType<typeof useGetPinnedPostQuery>;
export type GetPinnedPostLazyQueryHookResult = ReturnType<typeof useGetPinnedPostLazyQuery>;
export type GetPinnedPostSuspenseQueryHookResult = ReturnType<typeof useGetPinnedPostSuspenseQuery>;
export type GetPinnedPostQueryResult = Apollo.QueryResult<GetPinnedPostQuery, GetPinnedPostQueryVariables>;
export const GetPopUpDocument = gql`
    query getPopUp {
  getPopUp {
    data {
      popUpType
      data
      popUpDelay
    }
  }
}
    `;

/**
 * __useGetPopUpQuery__
 *
 * To run a query within a React component, call `useGetPopUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopUpQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPopUpQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPopUpQuery, GetPopUpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPopUpQuery, GetPopUpQueryVariables>(GetPopUpDocument, options);
      }
export function useGetPopUpLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPopUpQuery, GetPopUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPopUpQuery, GetPopUpQueryVariables>(GetPopUpDocument, options);
        }
export function useGetPopUpSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPopUpQuery, GetPopUpQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPopUpQuery, GetPopUpQueryVariables>(GetPopUpDocument, options);
        }
export type GetPopUpQueryHookResult = ReturnType<typeof useGetPopUpQuery>;
export type GetPopUpLazyQueryHookResult = ReturnType<typeof useGetPopUpLazyQuery>;
export type GetPopUpSuspenseQueryHookResult = ReturnType<typeof useGetPopUpSuspenseQuery>;
export type GetPopUpQueryResult = Apollo.QueryResult<GetPopUpQuery, GetPopUpQueryVariables>;
export const GetPopularClubsInPlatformDocument = gql`
    query GetPopularClubsInPlatform {
  getPopularClubsInPlatform {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetPopularClubsInPlatformQuery__
 *
 * To run a query within a React component, call `useGetPopularClubsInPlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularClubsInPlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularClubsInPlatformQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPopularClubsInPlatformQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPopularClubsInPlatformQuery, GetPopularClubsInPlatformQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPopularClubsInPlatformQuery, GetPopularClubsInPlatformQueryVariables>(GetPopularClubsInPlatformDocument, options);
      }
export function useGetPopularClubsInPlatformLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPopularClubsInPlatformQuery, GetPopularClubsInPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPopularClubsInPlatformQuery, GetPopularClubsInPlatformQueryVariables>(GetPopularClubsInPlatformDocument, options);
        }
export function useGetPopularClubsInPlatformSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPopularClubsInPlatformQuery, GetPopularClubsInPlatformQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPopularClubsInPlatformQuery, GetPopularClubsInPlatformQueryVariables>(GetPopularClubsInPlatformDocument, options);
        }
export type GetPopularClubsInPlatformQueryHookResult = ReturnType<typeof useGetPopularClubsInPlatformQuery>;
export type GetPopularClubsInPlatformLazyQueryHookResult = ReturnType<typeof useGetPopularClubsInPlatformLazyQuery>;
export type GetPopularClubsInPlatformSuspenseQueryHookResult = ReturnType<typeof useGetPopularClubsInPlatformSuspenseQuery>;
export type GetPopularClubsInPlatformQueryResult = Apollo.QueryResult<GetPopularClubsInPlatformQuery, GetPopularClubsInPlatformQueryVariables>;
export const GetPopularPeopleClubBasedDocument = gql`
    query getPopularPeopleClubBased($clubId: String, $offset: Int, $limit: Int) {
  getPopularPeopleClubBased(clubId: $clubId, offset: $offset, limit: $limit) {
    id
    username
    firstName
    lastName
    avatar
    isfollow
    membershipLevel
    isVerified
    greenTick
  }
}
    `;

/**
 * __useGetPopularPeopleClubBasedQuery__
 *
 * To run a query within a React component, call `useGetPopularPeopleClubBasedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularPeopleClubBasedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularPeopleClubBasedQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPopularPeopleClubBasedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPopularPeopleClubBasedQuery, GetPopularPeopleClubBasedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPopularPeopleClubBasedQuery, GetPopularPeopleClubBasedQueryVariables>(GetPopularPeopleClubBasedDocument, options);
      }
export function useGetPopularPeopleClubBasedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPopularPeopleClubBasedQuery, GetPopularPeopleClubBasedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPopularPeopleClubBasedQuery, GetPopularPeopleClubBasedQueryVariables>(GetPopularPeopleClubBasedDocument, options);
        }
export function useGetPopularPeopleClubBasedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPopularPeopleClubBasedQuery, GetPopularPeopleClubBasedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPopularPeopleClubBasedQuery, GetPopularPeopleClubBasedQueryVariables>(GetPopularPeopleClubBasedDocument, options);
        }
export type GetPopularPeopleClubBasedQueryHookResult = ReturnType<typeof useGetPopularPeopleClubBasedQuery>;
export type GetPopularPeopleClubBasedLazyQueryHookResult = ReturnType<typeof useGetPopularPeopleClubBasedLazyQuery>;
export type GetPopularPeopleClubBasedSuspenseQueryHookResult = ReturnType<typeof useGetPopularPeopleClubBasedSuspenseQuery>;
export type GetPopularPeopleClubBasedQueryResult = Apollo.QueryResult<GetPopularPeopleClubBasedQuery, GetPopularPeopleClubBasedQueryVariables>;
export const GetPopularUsersDocument = gql`
    query getPopularUsers($limit: Int, $offset: Int) {
  getPopularUsers(limit: $limit, offset: $offset) {
    ...UserFields
    cover
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetPopularUsersQuery__
 *
 * To run a query within a React component, call `useGetPopularUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetPopularUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPopularUsersQuery, GetPopularUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPopularUsersQuery, GetPopularUsersQueryVariables>(GetPopularUsersDocument, options);
      }
export function useGetPopularUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPopularUsersQuery, GetPopularUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPopularUsersQuery, GetPopularUsersQueryVariables>(GetPopularUsersDocument, options);
        }
export function useGetPopularUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPopularUsersQuery, GetPopularUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPopularUsersQuery, GetPopularUsersQueryVariables>(GetPopularUsersDocument, options);
        }
export type GetPopularUsersQueryHookResult = ReturnType<typeof useGetPopularUsersQuery>;
export type GetPopularUsersLazyQueryHookResult = ReturnType<typeof useGetPopularUsersLazyQuery>;
export type GetPopularUsersSuspenseQueryHookResult = ReturnType<typeof useGetPopularUsersSuspenseQuery>;
export type GetPopularUsersQueryResult = Apollo.QueryResult<GetPopularUsersQuery, GetPopularUsersQueryVariables>;
export const GetPostByDollarTagDocument = gql`
    query getPostByDollarTag($dollarTagId: Int!, $offset: Int, $limit: Int) {
  getPostByDollarTag(dollarTagId: $dollarTagId, offset: $offset, limit: $limit) {
    ...PostFields
    topCommentId
    comments {
      ...CommentFields
      isTopComment
    }
  }
}
    ${PostFieldsFragmentDoc}
${CommentFieldsFragmentDoc}`;

/**
 * __useGetPostByDollarTagQuery__
 *
 * To run a query within a React component, call `useGetPostByDollarTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByDollarTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByDollarTagQuery({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPostByDollarTagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostByDollarTagQuery, GetPostByDollarTagQueryVariables> & ({ variables: GetPostByDollarTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostByDollarTagQuery, GetPostByDollarTagQueryVariables>(GetPostByDollarTagDocument, options);
      }
export function useGetPostByDollarTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostByDollarTagQuery, GetPostByDollarTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostByDollarTagQuery, GetPostByDollarTagQueryVariables>(GetPostByDollarTagDocument, options);
        }
export function useGetPostByDollarTagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostByDollarTagQuery, GetPostByDollarTagQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostByDollarTagQuery, GetPostByDollarTagQueryVariables>(GetPostByDollarTagDocument, options);
        }
export type GetPostByDollarTagQueryHookResult = ReturnType<typeof useGetPostByDollarTagQuery>;
export type GetPostByDollarTagLazyQueryHookResult = ReturnType<typeof useGetPostByDollarTagLazyQuery>;
export type GetPostByDollarTagSuspenseQueryHookResult = ReturnType<typeof useGetPostByDollarTagSuspenseQuery>;
export type GetPostByDollarTagQueryResult = Apollo.QueryResult<GetPostByDollarTagQuery, GetPostByDollarTagQueryVariables>;
export const GetPostByDollarTagSinceDateDocument = gql`
    query getPostByDollarTagSinceDate($dollarTagId: Int!, $since: String, $limit: Int!) {
  getPostByDollarTagSinceDate(
    dollarTagId: $dollarTagId
    since: $since
    limit: $limit
  ) {
    since
    posts {
      ...PostFields
    }
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetPostByDollarTagSinceDateQuery__
 *
 * To run a query within a React component, call `useGetPostByDollarTagSinceDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByDollarTagSinceDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByDollarTagSinceDateQuery({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *      since: // value for 'since'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPostByDollarTagSinceDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostByDollarTagSinceDateQuery, GetPostByDollarTagSinceDateQueryVariables> & ({ variables: GetPostByDollarTagSinceDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostByDollarTagSinceDateQuery, GetPostByDollarTagSinceDateQueryVariables>(GetPostByDollarTagSinceDateDocument, options);
      }
export function useGetPostByDollarTagSinceDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostByDollarTagSinceDateQuery, GetPostByDollarTagSinceDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostByDollarTagSinceDateQuery, GetPostByDollarTagSinceDateQueryVariables>(GetPostByDollarTagSinceDateDocument, options);
        }
export function useGetPostByDollarTagSinceDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostByDollarTagSinceDateQuery, GetPostByDollarTagSinceDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostByDollarTagSinceDateQuery, GetPostByDollarTagSinceDateQueryVariables>(GetPostByDollarTagSinceDateDocument, options);
        }
export type GetPostByDollarTagSinceDateQueryHookResult = ReturnType<typeof useGetPostByDollarTagSinceDateQuery>;
export type GetPostByDollarTagSinceDateLazyQueryHookResult = ReturnType<typeof useGetPostByDollarTagSinceDateLazyQuery>;
export type GetPostByDollarTagSinceDateSuspenseQueryHookResult = ReturnType<typeof useGetPostByDollarTagSinceDateSuspenseQuery>;
export type GetPostByDollarTagSinceDateQueryResult = Apollo.QueryResult<GetPostByDollarTagSinceDateQuery, GetPostByDollarTagSinceDateQueryVariables>;
export const GetPostByHashTagSinceDateDocument = gql`
    query getPostByHashTagSinceDate($hashTagName: String, $since: String, $limit: Int!) {
  getPostByHashTagSinceDate(
    hashTagName: $hashTagName
    since: $since
    limit: $limit
  ) {
    since
    posts {
      ...PostFields
    }
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetPostByHashTagSinceDateQuery__
 *
 * To run a query within a React component, call `useGetPostByHashTagSinceDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByHashTagSinceDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByHashTagSinceDateQuery({
 *   variables: {
 *      hashTagName: // value for 'hashTagName'
 *      since: // value for 'since'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPostByHashTagSinceDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostByHashTagSinceDateQuery, GetPostByHashTagSinceDateQueryVariables> & ({ variables: GetPostByHashTagSinceDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostByHashTagSinceDateQuery, GetPostByHashTagSinceDateQueryVariables>(GetPostByHashTagSinceDateDocument, options);
      }
export function useGetPostByHashTagSinceDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostByHashTagSinceDateQuery, GetPostByHashTagSinceDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostByHashTagSinceDateQuery, GetPostByHashTagSinceDateQueryVariables>(GetPostByHashTagSinceDateDocument, options);
        }
export function useGetPostByHashTagSinceDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostByHashTagSinceDateQuery, GetPostByHashTagSinceDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostByHashTagSinceDateQuery, GetPostByHashTagSinceDateQueryVariables>(GetPostByHashTagSinceDateDocument, options);
        }
export type GetPostByHashTagSinceDateQueryHookResult = ReturnType<typeof useGetPostByHashTagSinceDateQuery>;
export type GetPostByHashTagSinceDateLazyQueryHookResult = ReturnType<typeof useGetPostByHashTagSinceDateLazyQuery>;
export type GetPostByHashTagSinceDateSuspenseQueryHookResult = ReturnType<typeof useGetPostByHashTagSinceDateSuspenseQuery>;
export type GetPostByHashTagSinceDateQueryResult = Apollo.QueryResult<GetPostByHashTagSinceDateQuery, GetPostByHashTagSinceDateQueryVariables>;
export const SinglePostDocument = gql`
    query SinglePost($data: PostId) {
  getPostById(data: $data) {
    ...PostFields
    comments {
      User {
        id
        firstName
        lastName
        avatar
        cover
        greenTick
      }
      replycount
      postId
      commentId
      userId
      textV2
      isSuspected
      media {
        type
        uri
        name
        height
        width
        rotation
      }
      tags {
        startIndex
        endIndex
        name
        type
        id
        slug
      }
      createdAt
      updatedAt
      linkPreview {
        siteName
        images
        url
        description
        title
      }
      replies {
        replyId
        postId
        userId
        commentId
        textV2
        isSuspected
        User {
          id
          firstName
          lastName
          avatar
          cover
          greenTick
        }
        media {
          type
          uri
          name
          height
          width
          rotation
        }
        tags {
          startIndex
          endIndex
          name
          type
          id
          slug
        }
        createdAt
        updatedAt
        linkPreview {
          siteName
          images
          url
          description
          title
        }
      }
    }
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useSinglePostQuery__
 *
 * To run a query within a React component, call `useSinglePostQuery` and pass it any options that fit your needs.
 * When your component renders, `useSinglePostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSinglePostQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSinglePostQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SinglePostQuery, SinglePostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SinglePostQuery, SinglePostQueryVariables>(SinglePostDocument, options);
      }
export function useSinglePostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SinglePostQuery, SinglePostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SinglePostQuery, SinglePostQueryVariables>(SinglePostDocument, options);
        }
export function useSinglePostSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SinglePostQuery, SinglePostQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SinglePostQuery, SinglePostQueryVariables>(SinglePostDocument, options);
        }
export type SinglePostQueryHookResult = ReturnType<typeof useSinglePostQuery>;
export type SinglePostLazyQueryHookResult = ReturnType<typeof useSinglePostLazyQuery>;
export type SinglePostSuspenseQueryHookResult = ReturnType<typeof useSinglePostSuspenseQuery>;
export type SinglePostQueryResult = Apollo.QueryResult<SinglePostQuery, SinglePostQueryVariables>;
export const GetPostDetailsByIdDocument = gql`
    query getPostDetailsById($postId: String!) {
  getPostDetailsById(postId: $postId) {
    post {
      postId
      postCategory
      categoryDisplayDetails {
        categoryDisplayName
      }
      User {
        ...UserFields
        isfollow
      }
      Club {
        clubId
        clubHandle
        clubName
        canJoinClub
        showDisclaimer
        disclaimer
        totalMemberCount
      }
      media {
        type
        uri
        name
        height
        width
        rotation
      }
      textV2
      isEditable
      hasPoll
      getPoll {
        ...GetPollFields
      }
      createdAt
      upvotecount
      downvotecount
      sharecount
      commentcount
      isUpvoted
      isDownvoted
      isbookmarked
      isSuspected
      isEdited
      isFollowed
      sharePostId
      getSharedPost {
        ...GetSharedPostFields
      }
      clubPostShareSetting {
        isVerifiedCanShare
        greenTickCanShare
        normalUserCanShare
      }
      postSharePermissions
      meta {
        isCover
        isAvatar
      }
    }
    error {
      errCode
      errMessage
      errLabel
    }
  }
}
    ${UserFieldsFragmentDoc}
${GetPollFieldsFragmentDoc}
${GetSharedPostFieldsFragmentDoc}`;

/**
 * __useGetPostDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetPostDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostDetailsByIdQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostDetailsByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostDetailsByIdQuery, GetPostDetailsByIdQueryVariables> & ({ variables: GetPostDetailsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostDetailsByIdQuery, GetPostDetailsByIdQueryVariables>(GetPostDetailsByIdDocument, options);
      }
export function useGetPostDetailsByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostDetailsByIdQuery, GetPostDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostDetailsByIdQuery, GetPostDetailsByIdQueryVariables>(GetPostDetailsByIdDocument, options);
        }
export function useGetPostDetailsByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostDetailsByIdQuery, GetPostDetailsByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostDetailsByIdQuery, GetPostDetailsByIdQueryVariables>(GetPostDetailsByIdDocument, options);
        }
export type GetPostDetailsByIdQueryHookResult = ReturnType<typeof useGetPostDetailsByIdQuery>;
export type GetPostDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetPostDetailsByIdLazyQuery>;
export type GetPostDetailsByIdSuspenseQueryHookResult = ReturnType<typeof useGetPostDetailsByIdSuspenseQuery>;
export type GetPostDetailsByIdQueryResult = Apollo.QueryResult<GetPostDetailsByIdQuery, GetPostDetailsByIdQueryVariables>;
export const GetPostPermissionsInAnyClubDocument = gql`
    query getPostPermissionsInAnyClub {
  getPostPermissionsInAnyClub
}
    `;

/**
 * __useGetPostPermissionsInAnyClubQuery__
 *
 * To run a query within a React component, call `useGetPostPermissionsInAnyClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostPermissionsInAnyClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostPermissionsInAnyClubQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPostPermissionsInAnyClubQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPostPermissionsInAnyClubQuery, GetPostPermissionsInAnyClubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostPermissionsInAnyClubQuery, GetPostPermissionsInAnyClubQueryVariables>(GetPostPermissionsInAnyClubDocument, options);
      }
export function useGetPostPermissionsInAnyClubLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostPermissionsInAnyClubQuery, GetPostPermissionsInAnyClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostPermissionsInAnyClubQuery, GetPostPermissionsInAnyClubQueryVariables>(GetPostPermissionsInAnyClubDocument, options);
        }
export function useGetPostPermissionsInAnyClubSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostPermissionsInAnyClubQuery, GetPostPermissionsInAnyClubQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostPermissionsInAnyClubQuery, GetPostPermissionsInAnyClubQueryVariables>(GetPostPermissionsInAnyClubDocument, options);
        }
export type GetPostPermissionsInAnyClubQueryHookResult = ReturnType<typeof useGetPostPermissionsInAnyClubQuery>;
export type GetPostPermissionsInAnyClubLazyQueryHookResult = ReturnType<typeof useGetPostPermissionsInAnyClubLazyQuery>;
export type GetPostPermissionsInAnyClubSuspenseQueryHookResult = ReturnType<typeof useGetPostPermissionsInAnyClubSuspenseQuery>;
export type GetPostPermissionsInAnyClubQueryResult = Apollo.QueryResult<GetPostPermissionsInAnyClubQuery, GetPostPermissionsInAnyClubQueryVariables>;
export const GetPostsByFiltersDocument = gql`
    query getPostsByFilters($limit: Int!, $filter: SearchPostsFilterArgs!, $clubId: String, $since: String) {
  getPostsByFilters(
    limit: $limit
    filter: $filter
    clubId: $clubId
    since: $since
  ) {
    since
    hasMore
    posts {
      ...PostFields
    }
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetPostsByFiltersQuery__
 *
 * To run a query within a React component, call `useGetPostsByFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsByFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsByFiltersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      clubId: // value for 'clubId'
 *      since: // value for 'since'
 *   },
 * });
 */
export function useGetPostsByFiltersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostsByFiltersQuery, GetPostsByFiltersQueryVariables> & ({ variables: GetPostsByFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostsByFiltersQuery, GetPostsByFiltersQueryVariables>(GetPostsByFiltersDocument, options);
      }
export function useGetPostsByFiltersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostsByFiltersQuery, GetPostsByFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostsByFiltersQuery, GetPostsByFiltersQueryVariables>(GetPostsByFiltersDocument, options);
        }
export function useGetPostsByFiltersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostsByFiltersQuery, GetPostsByFiltersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostsByFiltersQuery, GetPostsByFiltersQueryVariables>(GetPostsByFiltersDocument, options);
        }
export type GetPostsByFiltersQueryHookResult = ReturnType<typeof useGetPostsByFiltersQuery>;
export type GetPostsByFiltersLazyQueryHookResult = ReturnType<typeof useGetPostsByFiltersLazyQuery>;
export type GetPostsByFiltersSuspenseQueryHookResult = ReturnType<typeof useGetPostsByFiltersSuspenseQuery>;
export type GetPostsByFiltersQueryResult = Apollo.QueryResult<GetPostsByFiltersQuery, GetPostsByFiltersQueryVariables>;
export const GetPostsByHashTagDocument = gql`
    query getPostsByHashTag($hashTagName: String, $page: Int!) {
  getPostsByHashTag(hashTagName: $hashTagName, page: $page) {
    hashtag {
      hashtagName
      hashtagType
      postCount
      isfollow
      issubscribed
    }
    discussions
    followers
    post {
      commentcount
      upvotecount
      downvotecount
      sharecount
      hasPoll
      getPoll {
        ...GetPollFields
      }
      clubId
      User {
        id
        firstName
        lastName
        username
        avatar
        isVerified
        greenTick
        tick3
      }
      Club {
        clubId
        clubHandle
        clubName
      }
      postId
      userId
      stockName
      target
      stopLoss
      ideaType
      media {
        type
        uri
        name
        height
        width
        rotation
      }
      text
      tags {
        startIndex
        endIndex
        name
        type
        id
        slug
      }
      postType
      isUpvoted
      isDownvoted
      isbookmarked
      isSuspected
      createdAt
      updatedAt
      linkPreview {
        siteName
        images
        url
        description
        title
      }
      sharePostId
      userShares
      getSharedPost {
        ...GetSharedPostFields
      }
    }
  }
}
    ${GetPollFieldsFragmentDoc}
${GetSharedPostFieldsFragmentDoc}`;

/**
 * __useGetPostsByHashTagQuery__
 *
 * To run a query within a React component, call `useGetPostsByHashTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsByHashTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsByHashTagQuery({
 *   variables: {
 *      hashTagName: // value for 'hashTagName'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetPostsByHashTagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostsByHashTagQuery, GetPostsByHashTagQueryVariables> & ({ variables: GetPostsByHashTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostsByHashTagQuery, GetPostsByHashTagQueryVariables>(GetPostsByHashTagDocument, options);
      }
export function useGetPostsByHashTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostsByHashTagQuery, GetPostsByHashTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostsByHashTagQuery, GetPostsByHashTagQueryVariables>(GetPostsByHashTagDocument, options);
        }
export function useGetPostsByHashTagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostsByHashTagQuery, GetPostsByHashTagQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostsByHashTagQuery, GetPostsByHashTagQueryVariables>(GetPostsByHashTagDocument, options);
        }
export type GetPostsByHashTagQueryHookResult = ReturnType<typeof useGetPostsByHashTagQuery>;
export type GetPostsByHashTagLazyQueryHookResult = ReturnType<typeof useGetPostsByHashTagLazyQuery>;
export type GetPostsByHashTagSuspenseQueryHookResult = ReturnType<typeof useGetPostsByHashTagSuspenseQuery>;
export type GetPostsByHashTagQueryResult = Apollo.QueryResult<GetPostsByHashTagQuery, GetPostsByHashTagQueryVariables>;
export const GetPostsByHashTagV2Document = gql`
    query getPostsByHashTagV2($hashTagName: String, $offset: Int, $limit: Int) {
  getPostsByHashTagV2(hashTagName: $hashTagName, offset: $offset, limit: $limit) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetPostsByHashTagV2Query__
 *
 * To run a query within a React component, call `useGetPostsByHashTagV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsByHashTagV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsByHashTagV2Query({
 *   variables: {
 *      hashTagName: // value for 'hashTagName'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPostsByHashTagV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPostsByHashTagV2Query, GetPostsByHashTagV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostsByHashTagV2Query, GetPostsByHashTagV2QueryVariables>(GetPostsByHashTagV2Document, options);
      }
export function useGetPostsByHashTagV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostsByHashTagV2Query, GetPostsByHashTagV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostsByHashTagV2Query, GetPostsByHashTagV2QueryVariables>(GetPostsByHashTagV2Document, options);
        }
export function useGetPostsByHashTagV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostsByHashTagV2Query, GetPostsByHashTagV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostsByHashTagV2Query, GetPostsByHashTagV2QueryVariables>(GetPostsByHashTagV2Document, options);
        }
export type GetPostsByHashTagV2QueryHookResult = ReturnType<typeof useGetPostsByHashTagV2Query>;
export type GetPostsByHashTagV2LazyQueryHookResult = ReturnType<typeof useGetPostsByHashTagV2LazyQuery>;
export type GetPostsByHashTagV2SuspenseQueryHookResult = ReturnType<typeof useGetPostsByHashTagV2SuspenseQuery>;
export type GetPostsByHashTagV2QueryResult = Apollo.QueryResult<GetPostsByHashTagV2Query, GetPostsByHashTagV2QueryVariables>;
export const GetPostsConnectionByFilterDocument = gql`
    query getPostsConnectionByFilter($first: Int, $after: String, $before: String, $filter: GlobalSearchForPosts!) {
  getPostsConnectionByFilter(
    first: $first
    after: $after
    before: $before
    filter: $filter
  ) {
    pageInfo {
      startCursor
      hasPreviousPage
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        ...PostFields
        isPinned
        isPinnedByUser
      }
    }
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetPostsConnectionByFilterQuery__
 *
 * To run a query within a React component, call `useGetPostsConnectionByFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsConnectionByFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsConnectionByFilterQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPostsConnectionByFilterQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostsConnectionByFilterQuery, GetPostsConnectionByFilterQueryVariables> & ({ variables: GetPostsConnectionByFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostsConnectionByFilterQuery, GetPostsConnectionByFilterQueryVariables>(GetPostsConnectionByFilterDocument, options);
      }
export function useGetPostsConnectionByFilterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostsConnectionByFilterQuery, GetPostsConnectionByFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostsConnectionByFilterQuery, GetPostsConnectionByFilterQueryVariables>(GetPostsConnectionByFilterDocument, options);
        }
export function useGetPostsConnectionByFilterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPostsConnectionByFilterQuery, GetPostsConnectionByFilterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPostsConnectionByFilterQuery, GetPostsConnectionByFilterQueryVariables>(GetPostsConnectionByFilterDocument, options);
        }
export type GetPostsConnectionByFilterQueryHookResult = ReturnType<typeof useGetPostsConnectionByFilterQuery>;
export type GetPostsConnectionByFilterLazyQueryHookResult = ReturnType<typeof useGetPostsConnectionByFilterLazyQuery>;
export type GetPostsConnectionByFilterSuspenseQueryHookResult = ReturnType<typeof useGetPostsConnectionByFilterSuspenseQuery>;
export type GetPostsConnectionByFilterQueryResult = Apollo.QueryResult<GetPostsConnectionByFilterQuery, GetPostsConnectionByFilterQueryVariables>;
export const GetPowerUserStreakDetailsDocument = gql`
    query getPowerUserStreakDetails {
  getPowerUserStreakDetails {
    data {
      userId
      weekData {
        isCurrentWeek
        weekDisplayName
        hasCompleted
        currentWeekDayCount
        weekNumber
        weekHeader
        weekHeaderMessage
        weekFooter
        days {
          dayName
          dayDate
          hasVisited
          visitedState
        }
      }
    }
  }
}
    `;

/**
 * __useGetPowerUserStreakDetailsQuery__
 *
 * To run a query within a React component, call `useGetPowerUserStreakDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPowerUserStreakDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPowerUserStreakDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPowerUserStreakDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPowerUserStreakDetailsQuery, GetPowerUserStreakDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPowerUserStreakDetailsQuery, GetPowerUserStreakDetailsQueryVariables>(GetPowerUserStreakDetailsDocument, options);
      }
export function useGetPowerUserStreakDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPowerUserStreakDetailsQuery, GetPowerUserStreakDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPowerUserStreakDetailsQuery, GetPowerUserStreakDetailsQueryVariables>(GetPowerUserStreakDetailsDocument, options);
        }
export function useGetPowerUserStreakDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPowerUserStreakDetailsQuery, GetPowerUserStreakDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPowerUserStreakDetailsQuery, GetPowerUserStreakDetailsQueryVariables>(GetPowerUserStreakDetailsDocument, options);
        }
export type GetPowerUserStreakDetailsQueryHookResult = ReturnType<typeof useGetPowerUserStreakDetailsQuery>;
export type GetPowerUserStreakDetailsLazyQueryHookResult = ReturnType<typeof useGetPowerUserStreakDetailsLazyQuery>;
export type GetPowerUserStreakDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPowerUserStreakDetailsSuspenseQuery>;
export type GetPowerUserStreakDetailsQueryResult = Apollo.QueryResult<GetPowerUserStreakDetailsQuery, GetPowerUserStreakDetailsQueryVariables>;
export const GetPreferredHashTagsUserTalksAboutDocument = gql`
    query GetPreferredHashTagsUserTalksAbout($userId: String) {
  getPreferredHashTagsUserTalksAbout(userId: $userId) {
    hashtagName
    TagId
  }
}
    `;

/**
 * __useGetPreferredHashTagsUserTalksAboutQuery__
 *
 * To run a query within a React component, call `useGetPreferredHashTagsUserTalksAboutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferredHashTagsUserTalksAboutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferredHashTagsUserTalksAboutQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPreferredHashTagsUserTalksAboutQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPreferredHashTagsUserTalksAboutQuery, GetPreferredHashTagsUserTalksAboutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPreferredHashTagsUserTalksAboutQuery, GetPreferredHashTagsUserTalksAboutQueryVariables>(GetPreferredHashTagsUserTalksAboutDocument, options);
      }
export function useGetPreferredHashTagsUserTalksAboutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPreferredHashTagsUserTalksAboutQuery, GetPreferredHashTagsUserTalksAboutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPreferredHashTagsUserTalksAboutQuery, GetPreferredHashTagsUserTalksAboutQueryVariables>(GetPreferredHashTagsUserTalksAboutDocument, options);
        }
export function useGetPreferredHashTagsUserTalksAboutSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPreferredHashTagsUserTalksAboutQuery, GetPreferredHashTagsUserTalksAboutQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPreferredHashTagsUserTalksAboutQuery, GetPreferredHashTagsUserTalksAboutQueryVariables>(GetPreferredHashTagsUserTalksAboutDocument, options);
        }
export type GetPreferredHashTagsUserTalksAboutQueryHookResult = ReturnType<typeof useGetPreferredHashTagsUserTalksAboutQuery>;
export type GetPreferredHashTagsUserTalksAboutLazyQueryHookResult = ReturnType<typeof useGetPreferredHashTagsUserTalksAboutLazyQuery>;
export type GetPreferredHashTagsUserTalksAboutSuspenseQueryHookResult = ReturnType<typeof useGetPreferredHashTagsUserTalksAboutSuspenseQuery>;
export type GetPreferredHashTagsUserTalksAboutQueryResult = Apollo.QueryResult<GetPreferredHashTagsUserTalksAboutQuery, GetPreferredHashTagsUserTalksAboutQueryVariables>;
export const GetPreferredHashtagsDocument = gql`
    query getPreferredHashtags {
  getPreferredHashtags {
    hashtagName
    hashtagType
    followers
    TagId
    isfollow
    issubscribed
    postCount
    isPreferred
  }
}
    `;

/**
 * __useGetPreferredHashtagsQuery__
 *
 * To run a query within a React component, call `useGetPreferredHashtagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferredHashtagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferredHashtagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPreferredHashtagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPreferredHashtagsQuery, GetPreferredHashtagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPreferredHashtagsQuery, GetPreferredHashtagsQueryVariables>(GetPreferredHashtagsDocument, options);
      }
export function useGetPreferredHashtagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPreferredHashtagsQuery, GetPreferredHashtagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPreferredHashtagsQuery, GetPreferredHashtagsQueryVariables>(GetPreferredHashtagsDocument, options);
        }
export function useGetPreferredHashtagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPreferredHashtagsQuery, GetPreferredHashtagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPreferredHashtagsQuery, GetPreferredHashtagsQueryVariables>(GetPreferredHashtagsDocument, options);
        }
export type GetPreferredHashtagsQueryHookResult = ReturnType<typeof useGetPreferredHashtagsQuery>;
export type GetPreferredHashtagsLazyQueryHookResult = ReturnType<typeof useGetPreferredHashtagsLazyQuery>;
export type GetPreferredHashtagsSuspenseQueryHookResult = ReturnType<typeof useGetPreferredHashtagsSuspenseQuery>;
export type GetPreferredHashtagsQueryResult = Apollo.QueryResult<GetPreferredHashtagsQuery, GetPreferredHashtagsQueryVariables>;
export const GetPreferredHashtagsByClubDocument = gql`
    query getPreferredHashtagsByClub($clubId: String) {
  getPreferredHashtagsByClub(clubId: $clubId) {
    hashtagName
    TagId
  }
}
    `;

/**
 * __useGetPreferredHashtagsByClubQuery__
 *
 * To run a query within a React component, call `useGetPreferredHashtagsByClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferredHashtagsByClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferredHashtagsByClubQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetPreferredHashtagsByClubQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPreferredHashtagsByClubQuery, GetPreferredHashtagsByClubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPreferredHashtagsByClubQuery, GetPreferredHashtagsByClubQueryVariables>(GetPreferredHashtagsByClubDocument, options);
      }
export function useGetPreferredHashtagsByClubLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPreferredHashtagsByClubQuery, GetPreferredHashtagsByClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPreferredHashtagsByClubQuery, GetPreferredHashtagsByClubQueryVariables>(GetPreferredHashtagsByClubDocument, options);
        }
export function useGetPreferredHashtagsByClubSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPreferredHashtagsByClubQuery, GetPreferredHashtagsByClubQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPreferredHashtagsByClubQuery, GetPreferredHashtagsByClubQueryVariables>(GetPreferredHashtagsByClubDocument, options);
        }
export type GetPreferredHashtagsByClubQueryHookResult = ReturnType<typeof useGetPreferredHashtagsByClubQuery>;
export type GetPreferredHashtagsByClubLazyQueryHookResult = ReturnType<typeof useGetPreferredHashtagsByClubLazyQuery>;
export type GetPreferredHashtagsByClubSuspenseQueryHookResult = ReturnType<typeof useGetPreferredHashtagsByClubSuspenseQuery>;
export type GetPreferredHashtagsByClubQueryResult = Apollo.QueryResult<GetPreferredHashtagsByClubQuery, GetPreferredHashtagsByClubQueryVariables>;
export const ProfileInfoDocument = gql`
    query ProfileInfo($data: UserId) {
  getProfileInfo(data: $data) {
    ...UserFields
    profileType
    isfollow
    issubscribed
    followerCount
    followingCount
    cover
    bio
    watchlistVisibleStatus
    viewFeedPermission {
      canViewPost
      canSeeMarketingPost
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useProfileInfoQuery__
 *
 * To run a query within a React component, call `useProfileInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileInfoQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProfileInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProfileInfoQuery, ProfileInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfileInfoQuery, ProfileInfoQueryVariables>(ProfileInfoDocument, options);
      }
export function useProfileInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfileInfoQuery, ProfileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfileInfoQuery, ProfileInfoQueryVariables>(ProfileInfoDocument, options);
        }
export function useProfileInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfileInfoQuery, ProfileInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfileInfoQuery, ProfileInfoQueryVariables>(ProfileInfoDocument, options);
        }
export type ProfileInfoQueryHookResult = ReturnType<typeof useProfileInfoQuery>;
export type ProfileInfoLazyQueryHookResult = ReturnType<typeof useProfileInfoLazyQuery>;
export type ProfileInfoSuspenseQueryHookResult = ReturnType<typeof useProfileInfoSuspenseQuery>;
export type ProfileInfoQueryResult = Apollo.QueryResult<ProfileInfoQuery, ProfileInfoQueryVariables>;
export const GetProfileMarketingPostsDocument = gql`
    query getProfileMarketingPosts($data: UserId) {
  getProfileMarketingPosts(data: $data) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetProfileMarketingPostsQuery__
 *
 * To run a query within a React component, call `useGetProfileMarketingPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileMarketingPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileMarketingPostsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetProfileMarketingPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProfileMarketingPostsQuery, GetProfileMarketingPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfileMarketingPostsQuery, GetProfileMarketingPostsQueryVariables>(GetProfileMarketingPostsDocument, options);
      }
export function useGetProfileMarketingPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileMarketingPostsQuery, GetProfileMarketingPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfileMarketingPostsQuery, GetProfileMarketingPostsQueryVariables>(GetProfileMarketingPostsDocument, options);
        }
export function useGetProfileMarketingPostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProfileMarketingPostsQuery, GetProfileMarketingPostsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProfileMarketingPostsQuery, GetProfileMarketingPostsQueryVariables>(GetProfileMarketingPostsDocument, options);
        }
export type GetProfileMarketingPostsQueryHookResult = ReturnType<typeof useGetProfileMarketingPostsQuery>;
export type GetProfileMarketingPostsLazyQueryHookResult = ReturnType<typeof useGetProfileMarketingPostsLazyQuery>;
export type GetProfileMarketingPostsSuspenseQueryHookResult = ReturnType<typeof useGetProfileMarketingPostsSuspenseQuery>;
export type GetProfileMarketingPostsQueryResult = Apollo.QueryResult<GetProfileMarketingPostsQuery, GetProfileMarketingPostsQueryVariables>;
export const GetProfilePostsSinceDateDocument = gql`
    query getProfilePostsSinceDate($data: UserId, $since: String, $limit: Int!) {
  getProfilePostsSinceDate(data: $data, since: $since, limit: $limit) {
    since
    posts {
      ...PostFields
      isPinned
    }
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetProfilePostsSinceDateQuery__
 *
 * To run a query within a React component, call `useGetProfilePostsSinceDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilePostsSinceDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilePostsSinceDateQuery({
 *   variables: {
 *      data: // value for 'data'
 *      since: // value for 'since'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetProfilePostsSinceDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProfilePostsSinceDateQuery, GetProfilePostsSinceDateQueryVariables> & ({ variables: GetProfilePostsSinceDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfilePostsSinceDateQuery, GetProfilePostsSinceDateQueryVariables>(GetProfilePostsSinceDateDocument, options);
      }
export function useGetProfilePostsSinceDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfilePostsSinceDateQuery, GetProfilePostsSinceDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfilePostsSinceDateQuery, GetProfilePostsSinceDateQueryVariables>(GetProfilePostsSinceDateDocument, options);
        }
export function useGetProfilePostsSinceDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProfilePostsSinceDateQuery, GetProfilePostsSinceDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProfilePostsSinceDateQuery, GetProfilePostsSinceDateQueryVariables>(GetProfilePostsSinceDateDocument, options);
        }
export type GetProfilePostsSinceDateQueryHookResult = ReturnType<typeof useGetProfilePostsSinceDateQuery>;
export type GetProfilePostsSinceDateLazyQueryHookResult = ReturnType<typeof useGetProfilePostsSinceDateLazyQuery>;
export type GetProfilePostsSinceDateSuspenseQueryHookResult = ReturnType<typeof useGetProfilePostsSinceDateSuspenseQuery>;
export type GetProfilePostsSinceDateQueryResult = Apollo.QueryResult<GetProfilePostsSinceDateQuery, GetProfilePostsSinceDateQueryVariables>;
export const GetProfilePostsV2Document = gql`
    query getProfilePostsV2($data: UserId, $limit: Int!, $offset: Int!) {
  getProfilePostsV2(data: $data, limit: $limit, offset: $offset) {
    ...PostFields
    isPinned
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetProfilePostsV2Query__
 *
 * To run a query within a React component, call `useGetProfilePostsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilePostsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilePostsV2Query({
 *   variables: {
 *      data: // value for 'data'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetProfilePostsV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GetProfilePostsV2Query, GetProfilePostsV2QueryVariables> & ({ variables: GetProfilePostsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfilePostsV2Query, GetProfilePostsV2QueryVariables>(GetProfilePostsV2Document, options);
      }
export function useGetProfilePostsV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfilePostsV2Query, GetProfilePostsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfilePostsV2Query, GetProfilePostsV2QueryVariables>(GetProfilePostsV2Document, options);
        }
export function useGetProfilePostsV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProfilePostsV2Query, GetProfilePostsV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProfilePostsV2Query, GetProfilePostsV2QueryVariables>(GetProfilePostsV2Document, options);
        }
export type GetProfilePostsV2QueryHookResult = ReturnType<typeof useGetProfilePostsV2Query>;
export type GetProfilePostsV2LazyQueryHookResult = ReturnType<typeof useGetProfilePostsV2LazyQuery>;
export type GetProfilePostsV2SuspenseQueryHookResult = ReturnType<typeof useGetProfilePostsV2SuspenseQuery>;
export type GetProfilePostsV2QueryResult = Apollo.QueryResult<GetProfilePostsV2Query, GetProfilePostsV2QueryVariables>;
export const GetPromotionDocument = gql`
    query getPromotion {
  getPromotion {
    promotionId
    redirectURL
    imageURL
  }
}
    `;

/**
 * __useGetPromotionQuery__
 *
 * To run a query within a React component, call `useGetPromotionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPromotionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPromotionQuery, GetPromotionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPromotionQuery, GetPromotionQueryVariables>(GetPromotionDocument, options);
      }
export function useGetPromotionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPromotionQuery, GetPromotionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPromotionQuery, GetPromotionQueryVariables>(GetPromotionDocument, options);
        }
export function useGetPromotionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPromotionQuery, GetPromotionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPromotionQuery, GetPromotionQueryVariables>(GetPromotionDocument, options);
        }
export type GetPromotionQueryHookResult = ReturnType<typeof useGetPromotionQuery>;
export type GetPromotionLazyQueryHookResult = ReturnType<typeof useGetPromotionLazyQuery>;
export type GetPromotionSuspenseQueryHookResult = ReturnType<typeof useGetPromotionSuspenseQuery>;
export type GetPromotionQueryResult = Apollo.QueryResult<GetPromotionQuery, GetPromotionQueryVariables>;
export const GetPromotionForSmartFeedDocument = gql`
    query getPromotionForSmartFeed($data: String!) {
  getPromotionForSmartFeed(data: $data) {
    promotionId
    redirectURL
    shareableURL
    imageURL
  }
}
    `;

/**
 * __useGetPromotionForSmartFeedQuery__
 *
 * To run a query within a React component, call `useGetPromotionForSmartFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotionForSmartFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotionForSmartFeedQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetPromotionForSmartFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPromotionForSmartFeedQuery, GetPromotionForSmartFeedQueryVariables> & ({ variables: GetPromotionForSmartFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPromotionForSmartFeedQuery, GetPromotionForSmartFeedQueryVariables>(GetPromotionForSmartFeedDocument, options);
      }
export function useGetPromotionForSmartFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPromotionForSmartFeedQuery, GetPromotionForSmartFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPromotionForSmartFeedQuery, GetPromotionForSmartFeedQueryVariables>(GetPromotionForSmartFeedDocument, options);
        }
export function useGetPromotionForSmartFeedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPromotionForSmartFeedQuery, GetPromotionForSmartFeedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPromotionForSmartFeedQuery, GetPromotionForSmartFeedQueryVariables>(GetPromotionForSmartFeedDocument, options);
        }
export type GetPromotionForSmartFeedQueryHookResult = ReturnType<typeof useGetPromotionForSmartFeedQuery>;
export type GetPromotionForSmartFeedLazyQueryHookResult = ReturnType<typeof useGetPromotionForSmartFeedLazyQuery>;
export type GetPromotionForSmartFeedSuspenseQueryHookResult = ReturnType<typeof useGetPromotionForSmartFeedSuspenseQuery>;
export type GetPromotionForSmartFeedQueryResult = Apollo.QueryResult<GetPromotionForSmartFeedQuery, GetPromotionForSmartFeedQueryVariables>;
export const GetReactionsDocument = gql`
    query getReactions($postId: String, $commentId: String, $replyId: String, $voteType: Int, $limit: Int, $offset: Int) {
  getReactions(
    postId: $postId
    commentId: $commentId
    replyId: $replyId
    voteType: $voteType
    limit: $limit
    offset: $offset
  ) {
    voteId
    postId
    commentId
    replyId
    createdAt
    vote
    User {
      ...UserFields
      isfollow
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetReactionsQuery__
 *
 * To run a query within a React component, call `useGetReactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReactionsQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *      replyId: // value for 'replyId'
 *      voteType: // value for 'voteType'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetReactionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReactionsQuery, GetReactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReactionsQuery, GetReactionsQueryVariables>(GetReactionsDocument, options);
      }
export function useGetReactionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReactionsQuery, GetReactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReactionsQuery, GetReactionsQueryVariables>(GetReactionsDocument, options);
        }
export function useGetReactionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReactionsQuery, GetReactionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetReactionsQuery, GetReactionsQueryVariables>(GetReactionsDocument, options);
        }
export type GetReactionsQueryHookResult = ReturnType<typeof useGetReactionsQuery>;
export type GetReactionsLazyQueryHookResult = ReturnType<typeof useGetReactionsLazyQuery>;
export type GetReactionsSuspenseQueryHookResult = ReturnType<typeof useGetReactionsSuspenseQuery>;
export type GetReactionsQueryResult = Apollo.QueryResult<GetReactionsQuery, GetReactionsQueryVariables>;
export const GetRecentSearchDocument = gql`
    query getRecentSearch {
  getRecentSearch {
    ...UserRecentSearchOutput
  }
}
    ${UserRecentSearchOutputFragmentDoc}`;

/**
 * __useGetRecentSearchQuery__
 *
 * To run a query within a React component, call `useGetRecentSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentSearchQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecentSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecentSearchQuery, GetRecentSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRecentSearchQuery, GetRecentSearchQueryVariables>(GetRecentSearchDocument, options);
      }
export function useGetRecentSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecentSearchQuery, GetRecentSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRecentSearchQuery, GetRecentSearchQueryVariables>(GetRecentSearchDocument, options);
        }
export function useGetRecentSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRecentSearchQuery, GetRecentSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRecentSearchQuery, GetRecentSearchQueryVariables>(GetRecentSearchDocument, options);
        }
export type GetRecentSearchQueryHookResult = ReturnType<typeof useGetRecentSearchQuery>;
export type GetRecentSearchLazyQueryHookResult = ReturnType<typeof useGetRecentSearchLazyQuery>;
export type GetRecentSearchSuspenseQueryHookResult = ReturnType<typeof useGetRecentSearchSuspenseQuery>;
export type GetRecentSearchQueryResult = Apollo.QueryResult<GetRecentSearchQuery, GetRecentSearchQueryVariables>;
export const GetRecommendedPostsDocument = gql`
    query getRecommendedPosts($limit: Int!, $offset: Int!) {
  getRecommendedPosts(limit: $limit, offset: $offset) {
    actId
    activityId
    activityType
    createdAt
    avatar
    cover
    user {
      id
      firstName
      lastName
      avatar
      cover
      username
      isVerified
      greenTick
      tick3
      profileType
    }
    followingUser {
      id
      firstName
      lastName
      username
      avatar
      cover
      isVerified
      greenTick
      tick3
      profileType
    }
    club {
      clubId
      clubHandle
      avatar
      cover
      clubName
    }
    followingHashtag {
      hashtagName
      hashtagType
    }
    followingStocktag {
      securityId
      stockName
      slug
      nseListingId
      bseListingId
    }
    post {
      ...PostFields
      comments {
        ...CommentFields
        replies {
          ...ReplyFields
        }
      }
    }
  }
}
    ${PostFieldsFragmentDoc}
${CommentFieldsFragmentDoc}
${ReplyFieldsFragmentDoc}`;

/**
 * __useGetRecommendedPostsQuery__
 *
 * To run a query within a React component, call `useGetRecommendedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedPostsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetRecommendedPostsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRecommendedPostsQuery, GetRecommendedPostsQueryVariables> & ({ variables: GetRecommendedPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRecommendedPostsQuery, GetRecommendedPostsQueryVariables>(GetRecommendedPostsDocument, options);
      }
export function useGetRecommendedPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecommendedPostsQuery, GetRecommendedPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRecommendedPostsQuery, GetRecommendedPostsQueryVariables>(GetRecommendedPostsDocument, options);
        }
export function useGetRecommendedPostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRecommendedPostsQuery, GetRecommendedPostsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRecommendedPostsQuery, GetRecommendedPostsQueryVariables>(GetRecommendedPostsDocument, options);
        }
export type GetRecommendedPostsQueryHookResult = ReturnType<typeof useGetRecommendedPostsQuery>;
export type GetRecommendedPostsLazyQueryHookResult = ReturnType<typeof useGetRecommendedPostsLazyQuery>;
export type GetRecommendedPostsSuspenseQueryHookResult = ReturnType<typeof useGetRecommendedPostsSuspenseQuery>;
export type GetRecommendedPostsQueryResult = Apollo.QueryResult<GetRecommendedPostsQuery, GetRecommendedPostsQueryVariables>;
export const GetReferBannerDocument = gql`
    query getReferBanner {
  getReferBanner
}
    `;

/**
 * __useGetReferBannerQuery__
 *
 * To run a query within a React component, call `useGetReferBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferBannerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferBannerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReferBannerQuery, GetReferBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReferBannerQuery, GetReferBannerQueryVariables>(GetReferBannerDocument, options);
      }
export function useGetReferBannerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReferBannerQuery, GetReferBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReferBannerQuery, GetReferBannerQueryVariables>(GetReferBannerDocument, options);
        }
export function useGetReferBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReferBannerQuery, GetReferBannerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetReferBannerQuery, GetReferBannerQueryVariables>(GetReferBannerDocument, options);
        }
export type GetReferBannerQueryHookResult = ReturnType<typeof useGetReferBannerQuery>;
export type GetReferBannerLazyQueryHookResult = ReturnType<typeof useGetReferBannerLazyQuery>;
export type GetReferBannerSuspenseQueryHookResult = ReturnType<typeof useGetReferBannerSuspenseQuery>;
export type GetReferBannerQueryResult = Apollo.QueryResult<GetReferBannerQuery, GetReferBannerQueryVariables>;
export const GetReferMsgDocument = gql`
    query getReferMsg {
  getReferMsg {
    url
    message
  }
}
    `;

/**
 * __useGetReferMsgQuery__
 *
 * To run a query within a React component, call `useGetReferMsgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferMsgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferMsgQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferMsgQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReferMsgQuery, GetReferMsgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReferMsgQuery, GetReferMsgQueryVariables>(GetReferMsgDocument, options);
      }
export function useGetReferMsgLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReferMsgQuery, GetReferMsgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReferMsgQuery, GetReferMsgQueryVariables>(GetReferMsgDocument, options);
        }
export function useGetReferMsgSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReferMsgQuery, GetReferMsgQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetReferMsgQuery, GetReferMsgQueryVariables>(GetReferMsgDocument, options);
        }
export type GetReferMsgQueryHookResult = ReturnType<typeof useGetReferMsgQuery>;
export type GetReferMsgLazyQueryHookResult = ReturnType<typeof useGetReferMsgLazyQuery>;
export type GetReferMsgSuspenseQueryHookResult = ReturnType<typeof useGetReferMsgSuspenseQuery>;
export type GetReferMsgQueryResult = Apollo.QueryResult<GetReferMsgQuery, GetReferMsgQueryVariables>;
export const GetRepliesConnectionDocument = gql`
    query GetRepliesConnection($commentId: String!, $first: Int!, $before: String, $after: String, $takeCursorElement: Boolean, $replyId: String) {
  getRepliesConnection(
    commentId: $commentId
    first: $first
    before: $before
    after: $after
    takeCursorElement: $takeCursorElement
    replyId: $replyId
  ) {
    edges {
      cursor
      node {
        ...ReplyFields
      }
    }
    pageInfo {
      startCursor
      hasPreviousPage
      hasNextPage
      endCursor
    }
  }
}
    ${ReplyFieldsFragmentDoc}`;

/**
 * __useGetRepliesConnectionQuery__
 *
 * To run a query within a React component, call `useGetRepliesConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRepliesConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRepliesConnectionQuery({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      takeCursorElement: // value for 'takeCursorElement'
 *      replyId: // value for 'replyId'
 *   },
 * });
 */
export function useGetRepliesConnectionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRepliesConnectionQuery, GetRepliesConnectionQueryVariables> & ({ variables: GetRepliesConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRepliesConnectionQuery, GetRepliesConnectionQueryVariables>(GetRepliesConnectionDocument, options);
      }
export function useGetRepliesConnectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRepliesConnectionQuery, GetRepliesConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRepliesConnectionQuery, GetRepliesConnectionQueryVariables>(GetRepliesConnectionDocument, options);
        }
export function useGetRepliesConnectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRepliesConnectionQuery, GetRepliesConnectionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRepliesConnectionQuery, GetRepliesConnectionQueryVariables>(GetRepliesConnectionDocument, options);
        }
export type GetRepliesConnectionQueryHookResult = ReturnType<typeof useGetRepliesConnectionQuery>;
export type GetRepliesConnectionLazyQueryHookResult = ReturnType<typeof useGetRepliesConnectionLazyQuery>;
export type GetRepliesConnectionSuspenseQueryHookResult = ReturnType<typeof useGetRepliesConnectionSuspenseQuery>;
export type GetRepliesConnectionQueryResult = Apollo.QueryResult<GetRepliesConnectionQuery, GetRepliesConnectionQueryVariables>;
export const GetReportTypesDocument = gql`
    query getReportTypes {
  getReportTypes
}
    `;

/**
 * __useGetReportTypesQuery__
 *
 * To run a query within a React component, call `useGetReportTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReportTypesQuery, GetReportTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportTypesQuery, GetReportTypesQueryVariables>(GetReportTypesDocument, options);
      }
export function useGetReportTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReportTypesQuery, GetReportTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportTypesQuery, GetReportTypesQueryVariables>(GetReportTypesDocument, options);
        }
export function useGetReportTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReportTypesQuery, GetReportTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetReportTypesQuery, GetReportTypesQueryVariables>(GetReportTypesDocument, options);
        }
export type GetReportTypesQueryHookResult = ReturnType<typeof useGetReportTypesQuery>;
export type GetReportTypesLazyQueryHookResult = ReturnType<typeof useGetReportTypesLazyQuery>;
export type GetReportTypesSuspenseQueryHookResult = ReturnType<typeof useGetReportTypesSuspenseQuery>;
export type GetReportTypesQueryResult = Apollo.QueryResult<GetReportTypesQuery, GetReportTypesQueryVariables>;
export const GetSavedSearchDocument = gql`
    query GetSavedSearch($offset: Int, $limit: Int) {
  getSavedSearch(offset: $offset, limit: $limit) {
    ...UserRecentSearchOutput
  }
}
    ${UserRecentSearchOutputFragmentDoc}`;

/**
 * __useGetSavedSearchQuery__
 *
 * To run a query within a React component, call `useGetSavedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedSearchQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSavedSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSavedSearchQuery, GetSavedSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSavedSearchQuery, GetSavedSearchQueryVariables>(GetSavedSearchDocument, options);
      }
export function useGetSavedSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSavedSearchQuery, GetSavedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSavedSearchQuery, GetSavedSearchQueryVariables>(GetSavedSearchDocument, options);
        }
export function useGetSavedSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSavedSearchQuery, GetSavedSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSavedSearchQuery, GetSavedSearchQueryVariables>(GetSavedSearchDocument, options);
        }
export type GetSavedSearchQueryHookResult = ReturnType<typeof useGetSavedSearchQuery>;
export type GetSavedSearchLazyQueryHookResult = ReturnType<typeof useGetSavedSearchLazyQuery>;
export type GetSavedSearchSuspenseQueryHookResult = ReturnType<typeof useGetSavedSearchSuspenseQuery>;
export type GetSavedSearchQueryResult = Apollo.QueryResult<GetSavedSearchQuery, GetSavedSearchQueryVariables>;
export const GetScreensDocument = gql`
    query getScreens {
  getScreens {
    screenName
    priority
  }
}
    `;

/**
 * __useGetScreensQuery__
 *
 * To run a query within a React component, call `useGetScreensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreensQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScreensQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetScreensQuery, GetScreensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetScreensQuery, GetScreensQueryVariables>(GetScreensDocument, options);
      }
export function useGetScreensLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetScreensQuery, GetScreensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetScreensQuery, GetScreensQueryVariables>(GetScreensDocument, options);
        }
export function useGetScreensSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetScreensQuery, GetScreensQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetScreensQuery, GetScreensQueryVariables>(GetScreensDocument, options);
        }
export type GetScreensQueryHookResult = ReturnType<typeof useGetScreensQuery>;
export type GetScreensLazyQueryHookResult = ReturnType<typeof useGetScreensLazyQuery>;
export type GetScreensSuspenseQueryHookResult = ReturnType<typeof useGetScreensSuspenseQuery>;
export type GetScreensQueryResult = Apollo.QueryResult<GetScreensQuery, GetScreensQueryVariables>;
export const GetSectorBySearchTextViaDollarTagForWatchlistDocument = gql`
    query getSectorBySearchTextViaDollarTagForWatchlist($searchText: String!, $offset: Int, $limit: Int!) {
  getSectorBySearchTextViaDollarTagForWatchlist(
    searchText: $searchText
    offset: $offset
    limit: $limit
  ) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetSectorBySearchTextViaDollarTagForWatchlistQuery__
 *
 * To run a query within a React component, call `useGetSectorBySearchTextViaDollarTagForWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectorBySearchTextViaDollarTagForWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectorBySearchTextViaDollarTagForWatchlistQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSectorBySearchTextViaDollarTagForWatchlistQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSectorBySearchTextViaDollarTagForWatchlistQuery, GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables> & ({ variables: GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSectorBySearchTextViaDollarTagForWatchlistQuery, GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables>(GetSectorBySearchTextViaDollarTagForWatchlistDocument, options);
      }
export function useGetSectorBySearchTextViaDollarTagForWatchlistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSectorBySearchTextViaDollarTagForWatchlistQuery, GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSectorBySearchTextViaDollarTagForWatchlistQuery, GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables>(GetSectorBySearchTextViaDollarTagForWatchlistDocument, options);
        }
export function useGetSectorBySearchTextViaDollarTagForWatchlistSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSectorBySearchTextViaDollarTagForWatchlistQuery, GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSectorBySearchTextViaDollarTagForWatchlistQuery, GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables>(GetSectorBySearchTextViaDollarTagForWatchlistDocument, options);
        }
export type GetSectorBySearchTextViaDollarTagForWatchlistQueryHookResult = ReturnType<typeof useGetSectorBySearchTextViaDollarTagForWatchlistQuery>;
export type GetSectorBySearchTextViaDollarTagForWatchlistLazyQueryHookResult = ReturnType<typeof useGetSectorBySearchTextViaDollarTagForWatchlistLazyQuery>;
export type GetSectorBySearchTextViaDollarTagForWatchlistSuspenseQueryHookResult = ReturnType<typeof useGetSectorBySearchTextViaDollarTagForWatchlistSuspenseQuery>;
export type GetSectorBySearchTextViaDollarTagForWatchlistQueryResult = Apollo.QueryResult<GetSectorBySearchTextViaDollarTagForWatchlistQuery, GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables>;
export const GetSectorListForSmartFeedDocument = gql`
    query getSectorListForSmartFeed($data: String!) {
  getSectorListForSmartFeed(data: $data) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetSectorListForSmartFeedQuery__
 *
 * To run a query within a React component, call `useGetSectorListForSmartFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectorListForSmartFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectorListForSmartFeedQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSectorListForSmartFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSectorListForSmartFeedQuery, GetSectorListForSmartFeedQueryVariables> & ({ variables: GetSectorListForSmartFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSectorListForSmartFeedQuery, GetSectorListForSmartFeedQueryVariables>(GetSectorListForSmartFeedDocument, options);
      }
export function useGetSectorListForSmartFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSectorListForSmartFeedQuery, GetSectorListForSmartFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSectorListForSmartFeedQuery, GetSectorListForSmartFeedQueryVariables>(GetSectorListForSmartFeedDocument, options);
        }
export function useGetSectorListForSmartFeedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSectorListForSmartFeedQuery, GetSectorListForSmartFeedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSectorListForSmartFeedQuery, GetSectorListForSmartFeedQueryVariables>(GetSectorListForSmartFeedDocument, options);
        }
export type GetSectorListForSmartFeedQueryHookResult = ReturnType<typeof useGetSectorListForSmartFeedQuery>;
export type GetSectorListForSmartFeedLazyQueryHookResult = ReturnType<typeof useGetSectorListForSmartFeedLazyQuery>;
export type GetSectorListForSmartFeedSuspenseQueryHookResult = ReturnType<typeof useGetSectorListForSmartFeedSuspenseQuery>;
export type GetSectorListForSmartFeedQueryResult = Apollo.QueryResult<GetSectorListForSmartFeedQuery, GetSectorListForSmartFeedQueryVariables>;
export const GetSectorsUserTalksAboutDocument = gql`
    query getSectorsUserTalksAbout($userId: String!) {
  getSectorsUserTalksAbout(userId: $userId) {
    dollarTagId
    dollarTagName
    isfollow
    dollarTagType
  }
}
    `;

/**
 * __useGetSectorsUserTalksAboutQuery__
 *
 * To run a query within a React component, call `useGetSectorsUserTalksAboutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectorsUserTalksAboutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectorsUserTalksAboutQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetSectorsUserTalksAboutQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSectorsUserTalksAboutQuery, GetSectorsUserTalksAboutQueryVariables> & ({ variables: GetSectorsUserTalksAboutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSectorsUserTalksAboutQuery, GetSectorsUserTalksAboutQueryVariables>(GetSectorsUserTalksAboutDocument, options);
      }
export function useGetSectorsUserTalksAboutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSectorsUserTalksAboutQuery, GetSectorsUserTalksAboutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSectorsUserTalksAboutQuery, GetSectorsUserTalksAboutQueryVariables>(GetSectorsUserTalksAboutDocument, options);
        }
export function useGetSectorsUserTalksAboutSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSectorsUserTalksAboutQuery, GetSectorsUserTalksAboutQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSectorsUserTalksAboutQuery, GetSectorsUserTalksAboutQueryVariables>(GetSectorsUserTalksAboutDocument, options);
        }
export type GetSectorsUserTalksAboutQueryHookResult = ReturnType<typeof useGetSectorsUserTalksAboutQuery>;
export type GetSectorsUserTalksAboutLazyQueryHookResult = ReturnType<typeof useGetSectorsUserTalksAboutLazyQuery>;
export type GetSectorsUserTalksAboutSuspenseQueryHookResult = ReturnType<typeof useGetSectorsUserTalksAboutSuspenseQuery>;
export type GetSectorsUserTalksAboutQueryResult = Apollo.QueryResult<GetSectorsUserTalksAboutQuery, GetSectorsUserTalksAboutQueryVariables>;
export const GetSelfFeedDocument = gql`
    query GetSelfFeed($limit: Int!, $offset: Int!) {
  getSelfFeed(limit: $limit, offset: $offset) {
    actId
    activityId
    activityType
    createdAt
    avatar
    cover
    user {
      id
      firstName
      lastName
      avatar
      username
      isVerified
      greenTick
      profileType
      tick3
    }
    followingUser {
      id
      firstName
      lastName
      username
      avatar
      isVerified
      greenTick
      tick3
      profileType
    }
    club {
      clubId
      clubHandle
      avatar
      clubName
    }
    followingHashtag {
      hashtagName
      hashtagType
    }
    followingStocktag {
      securityId
      stockName
      slug
      nseListingId
      bseListingId
    }
    post {
      ...PostFields
      comments {
        ...CommentFields
        replies {
          ...ReplyFields
        }
      }
    }
  }
}
    ${PostFieldsFragmentDoc}
${CommentFieldsFragmentDoc}
${ReplyFieldsFragmentDoc}`;

/**
 * __useGetSelfFeedQuery__
 *
 * To run a query within a React component, call `useGetSelfFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelfFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelfFeedQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSelfFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSelfFeedQuery, GetSelfFeedQueryVariables> & ({ variables: GetSelfFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSelfFeedQuery, GetSelfFeedQueryVariables>(GetSelfFeedDocument, options);
      }
export function useGetSelfFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSelfFeedQuery, GetSelfFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSelfFeedQuery, GetSelfFeedQueryVariables>(GetSelfFeedDocument, options);
        }
export function useGetSelfFeedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSelfFeedQuery, GetSelfFeedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSelfFeedQuery, GetSelfFeedQueryVariables>(GetSelfFeedDocument, options);
        }
export type GetSelfFeedQueryHookResult = ReturnType<typeof useGetSelfFeedQuery>;
export type GetSelfFeedLazyQueryHookResult = ReturnType<typeof useGetSelfFeedLazyQuery>;
export type GetSelfFeedSuspenseQueryHookResult = ReturnType<typeof useGetSelfFeedSuspenseQuery>;
export type GetSelfFeedQueryResult = Apollo.QueryResult<GetSelfFeedQuery, GetSelfFeedQueryVariables>;
export const GetShareFeedForPostDocument = gql`
    query getShareFeedForPost($postId: String!, $offset: Int, $limit: Int) {
  getShareFeedForPost(postId: $postId, offset: $offset, limit: $limit) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetShareFeedForPostQuery__
 *
 * To run a query within a React component, call `useGetShareFeedForPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareFeedForPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareFeedForPostQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetShareFeedForPostQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetShareFeedForPostQuery, GetShareFeedForPostQueryVariables> & ({ variables: GetShareFeedForPostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetShareFeedForPostQuery, GetShareFeedForPostQueryVariables>(GetShareFeedForPostDocument, options);
      }
export function useGetShareFeedForPostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShareFeedForPostQuery, GetShareFeedForPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetShareFeedForPostQuery, GetShareFeedForPostQueryVariables>(GetShareFeedForPostDocument, options);
        }
export function useGetShareFeedForPostSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetShareFeedForPostQuery, GetShareFeedForPostQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetShareFeedForPostQuery, GetShareFeedForPostQueryVariables>(GetShareFeedForPostDocument, options);
        }
export type GetShareFeedForPostQueryHookResult = ReturnType<typeof useGetShareFeedForPostQuery>;
export type GetShareFeedForPostLazyQueryHookResult = ReturnType<typeof useGetShareFeedForPostLazyQuery>;
export type GetShareFeedForPostSuspenseQueryHookResult = ReturnType<typeof useGetShareFeedForPostSuspenseQuery>;
export type GetShareFeedForPostQueryResult = Apollo.QueryResult<GetShareFeedForPostQuery, GetShareFeedForPostQueryVariables>;
export const GetStockListForSmartFeedDocument = gql`
    query getStockListForSmartFeed($data: String!) {
  getStockListForSmartFeed(data: $data) {
    ...DollarTagFields
    sourceEntityId
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetStockListForSmartFeedQuery__
 *
 * To run a query within a React component, call `useGetStockListForSmartFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockListForSmartFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockListForSmartFeedQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetStockListForSmartFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStockListForSmartFeedQuery, GetStockListForSmartFeedQueryVariables> & ({ variables: GetStockListForSmartFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStockListForSmartFeedQuery, GetStockListForSmartFeedQueryVariables>(GetStockListForSmartFeedDocument, options);
      }
export function useGetStockListForSmartFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStockListForSmartFeedQuery, GetStockListForSmartFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStockListForSmartFeedQuery, GetStockListForSmartFeedQueryVariables>(GetStockListForSmartFeedDocument, options);
        }
export function useGetStockListForSmartFeedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetStockListForSmartFeedQuery, GetStockListForSmartFeedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStockListForSmartFeedQuery, GetStockListForSmartFeedQueryVariables>(GetStockListForSmartFeedDocument, options);
        }
export type GetStockListForSmartFeedQueryHookResult = ReturnType<typeof useGetStockListForSmartFeedQuery>;
export type GetStockListForSmartFeedLazyQueryHookResult = ReturnType<typeof useGetStockListForSmartFeedLazyQuery>;
export type GetStockListForSmartFeedSuspenseQueryHookResult = ReturnType<typeof useGetStockListForSmartFeedSuspenseQuery>;
export type GetStockListForSmartFeedQueryResult = Apollo.QueryResult<GetStockListForSmartFeedQuery, GetStockListForSmartFeedQueryVariables>;
export const GetStockTagDetailsDocument = gql`
    query getStockTagDetails($securityId: Int) {
  getStockTagDetails(securityId: $securityId) {
    stock {
      isfollow
      issubscribed
      stockName
      securityId
    }
    discussions
    followers
  }
}
    `;

/**
 * __useGetStockTagDetailsQuery__
 *
 * To run a query within a React component, call `useGetStockTagDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockTagDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockTagDetailsQuery({
 *   variables: {
 *      securityId: // value for 'securityId'
 *   },
 * });
 */
export function useGetStockTagDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStockTagDetailsQuery, GetStockTagDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStockTagDetailsQuery, GetStockTagDetailsQueryVariables>(GetStockTagDetailsDocument, options);
      }
export function useGetStockTagDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStockTagDetailsQuery, GetStockTagDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStockTagDetailsQuery, GetStockTagDetailsQueryVariables>(GetStockTagDetailsDocument, options);
        }
export function useGetStockTagDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetStockTagDetailsQuery, GetStockTagDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStockTagDetailsQuery, GetStockTagDetailsQueryVariables>(GetStockTagDetailsDocument, options);
        }
export type GetStockTagDetailsQueryHookResult = ReturnType<typeof useGetStockTagDetailsQuery>;
export type GetStockTagDetailsLazyQueryHookResult = ReturnType<typeof useGetStockTagDetailsLazyQuery>;
export type GetStockTagDetailsSuspenseQueryHookResult = ReturnType<typeof useGetStockTagDetailsSuspenseQuery>;
export type GetStockTagDetailsQueryResult = Apollo.QueryResult<GetStockTagDetailsQuery, GetStockTagDetailsQueryVariables>;
export const GetStocksBySearchTextForWatchlistDocument = gql`
    query getStocksBySearchTextForWatchlist($searchText: String!, $offset: Int!, $limit: Int!) {
  getStocksBySearchTextForWatchlist(
    searchText: $searchText
    offset: $offset
    limit: $limit
  ) {
    securityId
    stockName
    slug
    isfollow
  }
}
    `;

/**
 * __useGetStocksBySearchTextForWatchlistQuery__
 *
 * To run a query within a React component, call `useGetStocksBySearchTextForWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStocksBySearchTextForWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStocksBySearchTextForWatchlistQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetStocksBySearchTextForWatchlistQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStocksBySearchTextForWatchlistQuery, GetStocksBySearchTextForWatchlistQueryVariables> & ({ variables: GetStocksBySearchTextForWatchlistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStocksBySearchTextForWatchlistQuery, GetStocksBySearchTextForWatchlistQueryVariables>(GetStocksBySearchTextForWatchlistDocument, options);
      }
export function useGetStocksBySearchTextForWatchlistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStocksBySearchTextForWatchlistQuery, GetStocksBySearchTextForWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStocksBySearchTextForWatchlistQuery, GetStocksBySearchTextForWatchlistQueryVariables>(GetStocksBySearchTextForWatchlistDocument, options);
        }
export function useGetStocksBySearchTextForWatchlistSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetStocksBySearchTextForWatchlistQuery, GetStocksBySearchTextForWatchlistQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStocksBySearchTextForWatchlistQuery, GetStocksBySearchTextForWatchlistQueryVariables>(GetStocksBySearchTextForWatchlistDocument, options);
        }
export type GetStocksBySearchTextForWatchlistQueryHookResult = ReturnType<typeof useGetStocksBySearchTextForWatchlistQuery>;
export type GetStocksBySearchTextForWatchlistLazyQueryHookResult = ReturnType<typeof useGetStocksBySearchTextForWatchlistLazyQuery>;
export type GetStocksBySearchTextForWatchlistSuspenseQueryHookResult = ReturnType<typeof useGetStocksBySearchTextForWatchlistSuspenseQuery>;
export type GetStocksBySearchTextForWatchlistQueryResult = Apollo.QueryResult<GetStocksBySearchTextForWatchlistQuery, GetStocksBySearchTextForWatchlistQueryVariables>;
export const GetStocksBySearchTextViaDollarTagForWatchlistDocument = gql`
    query getStocksBySearchTextViaDollarTagForWatchlist($searchText: String!, $offset: Int, $limit: Int!) {
  getStocksBySearchTextViaDollarTagForWatchlist(
    searchText: $searchText
    offset: $offset
    limit: $limit
  ) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetStocksBySearchTextViaDollarTagForWatchlistQuery__
 *
 * To run a query within a React component, call `useGetStocksBySearchTextViaDollarTagForWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStocksBySearchTextViaDollarTagForWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStocksBySearchTextViaDollarTagForWatchlistQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetStocksBySearchTextViaDollarTagForWatchlistQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStocksBySearchTextViaDollarTagForWatchlistQuery, GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables> & ({ variables: GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStocksBySearchTextViaDollarTagForWatchlistQuery, GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables>(GetStocksBySearchTextViaDollarTagForWatchlistDocument, options);
      }
export function useGetStocksBySearchTextViaDollarTagForWatchlistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStocksBySearchTextViaDollarTagForWatchlistQuery, GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStocksBySearchTextViaDollarTagForWatchlistQuery, GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables>(GetStocksBySearchTextViaDollarTagForWatchlistDocument, options);
        }
export function useGetStocksBySearchTextViaDollarTagForWatchlistSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetStocksBySearchTextViaDollarTagForWatchlistQuery, GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStocksBySearchTextViaDollarTagForWatchlistQuery, GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables>(GetStocksBySearchTextViaDollarTagForWatchlistDocument, options);
        }
export type GetStocksBySearchTextViaDollarTagForWatchlistQueryHookResult = ReturnType<typeof useGetStocksBySearchTextViaDollarTagForWatchlistQuery>;
export type GetStocksBySearchTextViaDollarTagForWatchlistLazyQueryHookResult = ReturnType<typeof useGetStocksBySearchTextViaDollarTagForWatchlistLazyQuery>;
export type GetStocksBySearchTextViaDollarTagForWatchlistSuspenseQueryHookResult = ReturnType<typeof useGetStocksBySearchTextViaDollarTagForWatchlistSuspenseQuery>;
export type GetStocksBySearchTextViaDollarTagForWatchlistQueryResult = Apollo.QueryResult<GetStocksBySearchTextViaDollarTagForWatchlistQuery, GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables>;
export const GetStocksUserTalksAboutDocument = gql`
    query getStocksUserTalksAbout($userId: String!) {
  getStocksUserTalksAbout(userId: $userId) {
    dollarTagId
    dollarTagName
    isfollow
    dollarTagType
  }
}
    `;

/**
 * __useGetStocksUserTalksAboutQuery__
 *
 * To run a query within a React component, call `useGetStocksUserTalksAboutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStocksUserTalksAboutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStocksUserTalksAboutQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetStocksUserTalksAboutQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStocksUserTalksAboutQuery, GetStocksUserTalksAboutQueryVariables> & ({ variables: GetStocksUserTalksAboutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStocksUserTalksAboutQuery, GetStocksUserTalksAboutQueryVariables>(GetStocksUserTalksAboutDocument, options);
      }
export function useGetStocksUserTalksAboutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStocksUserTalksAboutQuery, GetStocksUserTalksAboutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStocksUserTalksAboutQuery, GetStocksUserTalksAboutQueryVariables>(GetStocksUserTalksAboutDocument, options);
        }
export function useGetStocksUserTalksAboutSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetStocksUserTalksAboutQuery, GetStocksUserTalksAboutQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStocksUserTalksAboutQuery, GetStocksUserTalksAboutQueryVariables>(GetStocksUserTalksAboutDocument, options);
        }
export type GetStocksUserTalksAboutQueryHookResult = ReturnType<typeof useGetStocksUserTalksAboutQuery>;
export type GetStocksUserTalksAboutLazyQueryHookResult = ReturnType<typeof useGetStocksUserTalksAboutLazyQuery>;
export type GetStocksUserTalksAboutSuspenseQueryHookResult = ReturnType<typeof useGetStocksUserTalksAboutSuspenseQuery>;
export type GetStocksUserTalksAboutQueryResult = Apollo.QueryResult<GetStocksUserTalksAboutQuery, GetStocksUserTalksAboutQueryVariables>;
export const SuggestedPeopleDocument = gql`
    query SuggestedPeople {
  getSuggestedPeople {
    ...UserFields
    cover
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useSuggestedPeopleQuery__
 *
 * To run a query within a React component, call `useSuggestedPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedPeopleQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuggestedPeopleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SuggestedPeopleQuery, SuggestedPeopleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuggestedPeopleQuery, SuggestedPeopleQueryVariables>(SuggestedPeopleDocument, options);
      }
export function useSuggestedPeopleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuggestedPeopleQuery, SuggestedPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuggestedPeopleQuery, SuggestedPeopleQueryVariables>(SuggestedPeopleDocument, options);
        }
export function useSuggestedPeopleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuggestedPeopleQuery, SuggestedPeopleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuggestedPeopleQuery, SuggestedPeopleQueryVariables>(SuggestedPeopleDocument, options);
        }
export type SuggestedPeopleQueryHookResult = ReturnType<typeof useSuggestedPeopleQuery>;
export type SuggestedPeopleLazyQueryHookResult = ReturnType<typeof useSuggestedPeopleLazyQuery>;
export type SuggestedPeopleSuspenseQueryHookResult = ReturnType<typeof useSuggestedPeopleSuspenseQuery>;
export type SuggestedPeopleQueryResult = Apollo.QueryResult<SuggestedPeopleQuery, SuggestedPeopleQueryVariables>;
export const GetSuggestedSearchDocument = gql`
    query getSuggestedSearch($offset: Int, $limit: Int) {
  getSuggestedSearch(offset: $offset, limit: $limit) {
    searchId
    User {
      ...UserFields
    }
    Club {
      clubId
      clubName
    }
    Hashtag {
      TagId
      hashtagName
    }
    Dollartag {
      ...DollarTagFields
    }
  }
}
    ${UserFieldsFragmentDoc}
${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetSuggestedSearchQuery__
 *
 * To run a query within a React component, call `useGetSuggestedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedSearchQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSuggestedSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSuggestedSearchQuery, GetSuggestedSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSuggestedSearchQuery, GetSuggestedSearchQueryVariables>(GetSuggestedSearchDocument, options);
      }
export function useGetSuggestedSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSuggestedSearchQuery, GetSuggestedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSuggestedSearchQuery, GetSuggestedSearchQueryVariables>(GetSuggestedSearchDocument, options);
        }
export function useGetSuggestedSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSuggestedSearchQuery, GetSuggestedSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSuggestedSearchQuery, GetSuggestedSearchQueryVariables>(GetSuggestedSearchDocument, options);
        }
export type GetSuggestedSearchQueryHookResult = ReturnType<typeof useGetSuggestedSearchQuery>;
export type GetSuggestedSearchLazyQueryHookResult = ReturnType<typeof useGetSuggestedSearchLazyQuery>;
export type GetSuggestedSearchSuspenseQueryHookResult = ReturnType<typeof useGetSuggestedSearchSuspenseQuery>;
export type GetSuggestedSearchQueryResult = Apollo.QueryResult<GetSuggestedSearchQuery, GetSuggestedSearchQueryVariables>;
export const GetTick3ExpertsDocument = gql`
    query getTick3Experts($limit: Int, $offset: Int) {
  getTick3Experts(limit: $limit, offset: $offset) {
    ...UserFields
    cover
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetTick3ExpertsQuery__
 *
 * To run a query within a React component, call `useGetTick3ExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTick3ExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTick3ExpertsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetTick3ExpertsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTick3ExpertsQuery, GetTick3ExpertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTick3ExpertsQuery, GetTick3ExpertsQueryVariables>(GetTick3ExpertsDocument, options);
      }
export function useGetTick3ExpertsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTick3ExpertsQuery, GetTick3ExpertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTick3ExpertsQuery, GetTick3ExpertsQueryVariables>(GetTick3ExpertsDocument, options);
        }
export function useGetTick3ExpertsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTick3ExpertsQuery, GetTick3ExpertsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTick3ExpertsQuery, GetTick3ExpertsQueryVariables>(GetTick3ExpertsDocument, options);
        }
export type GetTick3ExpertsQueryHookResult = ReturnType<typeof useGetTick3ExpertsQuery>;
export type GetTick3ExpertsLazyQueryHookResult = ReturnType<typeof useGetTick3ExpertsLazyQuery>;
export type GetTick3ExpertsSuspenseQueryHookResult = ReturnType<typeof useGetTick3ExpertsSuspenseQuery>;
export type GetTick3ExpertsQueryResult = Apollo.QueryResult<GetTick3ExpertsQuery, GetTick3ExpertsQueryVariables>;
export const GetTicketByIdDocument = gql`
    query getTicketById($ticketId: Int!) {
  getTicketById(ticketId: $ticketId)
}
    `;

/**
 * __useGetTicketByIdQuery__
 *
 * To run a query within a React component, call `useGetTicketByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketByIdQuery({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useGetTicketByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTicketByIdQuery, GetTicketByIdQueryVariables> & ({ variables: GetTicketByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTicketByIdQuery, GetTicketByIdQueryVariables>(GetTicketByIdDocument, options);
      }
export function useGetTicketByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTicketByIdQuery, GetTicketByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTicketByIdQuery, GetTicketByIdQueryVariables>(GetTicketByIdDocument, options);
        }
export function useGetTicketByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTicketByIdQuery, GetTicketByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTicketByIdQuery, GetTicketByIdQueryVariables>(GetTicketByIdDocument, options);
        }
export type GetTicketByIdQueryHookResult = ReturnType<typeof useGetTicketByIdQuery>;
export type GetTicketByIdLazyQueryHookResult = ReturnType<typeof useGetTicketByIdLazyQuery>;
export type GetTicketByIdSuspenseQueryHookResult = ReturnType<typeof useGetTicketByIdSuspenseQuery>;
export type GetTicketByIdQueryResult = Apollo.QueryResult<GetTicketByIdQuery, GetTicketByIdQueryVariables>;
export const GetTopicListForSmartFeedDocument = gql`
    query getTopicListForSmartFeed($data: String!) {
  getTopicListForSmartFeed(data: $data) {
    ...HashTagFields
  }
}
    ${HashTagFieldsFragmentDoc}`;

/**
 * __useGetTopicListForSmartFeedQuery__
 *
 * To run a query within a React component, call `useGetTopicListForSmartFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicListForSmartFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicListForSmartFeedQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetTopicListForSmartFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTopicListForSmartFeedQuery, GetTopicListForSmartFeedQueryVariables> & ({ variables: GetTopicListForSmartFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTopicListForSmartFeedQuery, GetTopicListForSmartFeedQueryVariables>(GetTopicListForSmartFeedDocument, options);
      }
export function useGetTopicListForSmartFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTopicListForSmartFeedQuery, GetTopicListForSmartFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTopicListForSmartFeedQuery, GetTopicListForSmartFeedQueryVariables>(GetTopicListForSmartFeedDocument, options);
        }
export function useGetTopicListForSmartFeedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTopicListForSmartFeedQuery, GetTopicListForSmartFeedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTopicListForSmartFeedQuery, GetTopicListForSmartFeedQueryVariables>(GetTopicListForSmartFeedDocument, options);
        }
export type GetTopicListForSmartFeedQueryHookResult = ReturnType<typeof useGetTopicListForSmartFeedQuery>;
export type GetTopicListForSmartFeedLazyQueryHookResult = ReturnType<typeof useGetTopicListForSmartFeedLazyQuery>;
export type GetTopicListForSmartFeedSuspenseQueryHookResult = ReturnType<typeof useGetTopicListForSmartFeedSuspenseQuery>;
export type GetTopicListForSmartFeedQueryResult = Apollo.QueryResult<GetTopicListForSmartFeedQuery, GetTopicListForSmartFeedQueryVariables>;
export const GetTrendingHashTagsV2Document = gql`
    query getTrendingHashTagsV2($offset: Int, $limit: Int) {
  getTrendingHashTagsV2(offset: $offset, limit: $limit) {
    ...HashTagFields
    TagId
  }
}
    ${HashTagFieldsFragmentDoc}`;

/**
 * __useGetTrendingHashTagsV2Query__
 *
 * To run a query within a React component, call `useGetTrendingHashTagsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingHashTagsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingHashTagsV2Query({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTrendingHashTagsV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTrendingHashTagsV2Query, GetTrendingHashTagsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTrendingHashTagsV2Query, GetTrendingHashTagsV2QueryVariables>(GetTrendingHashTagsV2Document, options);
      }
export function useGetTrendingHashTagsV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTrendingHashTagsV2Query, GetTrendingHashTagsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTrendingHashTagsV2Query, GetTrendingHashTagsV2QueryVariables>(GetTrendingHashTagsV2Document, options);
        }
export function useGetTrendingHashTagsV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTrendingHashTagsV2Query, GetTrendingHashTagsV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTrendingHashTagsV2Query, GetTrendingHashTagsV2QueryVariables>(GetTrendingHashTagsV2Document, options);
        }
export type GetTrendingHashTagsV2QueryHookResult = ReturnType<typeof useGetTrendingHashTagsV2Query>;
export type GetTrendingHashTagsV2LazyQueryHookResult = ReturnType<typeof useGetTrendingHashTagsV2LazyQuery>;
export type GetTrendingHashTagsV2SuspenseQueryHookResult = ReturnType<typeof useGetTrendingHashTagsV2SuspenseQuery>;
export type GetTrendingHashTagsV2QueryResult = Apollo.QueryResult<GetTrendingHashTagsV2Query, GetTrendingHashTagsV2QueryVariables>;
export const GetTrendingSectorsByDollarTagDocument = gql`
    query GetTrendingSectorsByDollarTag($offset: Int!, $limit: Int!) {
  getTrendingSectorsByDollarTag(offset: $offset, limit: $limit) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetTrendingSectorsByDollarTagQuery__
 *
 * To run a query within a React component, call `useGetTrendingSectorsByDollarTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingSectorsByDollarTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingSectorsByDollarTagQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTrendingSectorsByDollarTagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTrendingSectorsByDollarTagQuery, GetTrendingSectorsByDollarTagQueryVariables> & ({ variables: GetTrendingSectorsByDollarTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTrendingSectorsByDollarTagQuery, GetTrendingSectorsByDollarTagQueryVariables>(GetTrendingSectorsByDollarTagDocument, options);
      }
export function useGetTrendingSectorsByDollarTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTrendingSectorsByDollarTagQuery, GetTrendingSectorsByDollarTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTrendingSectorsByDollarTagQuery, GetTrendingSectorsByDollarTagQueryVariables>(GetTrendingSectorsByDollarTagDocument, options);
        }
export function useGetTrendingSectorsByDollarTagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTrendingSectorsByDollarTagQuery, GetTrendingSectorsByDollarTagQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTrendingSectorsByDollarTagQuery, GetTrendingSectorsByDollarTagQueryVariables>(GetTrendingSectorsByDollarTagDocument, options);
        }
export type GetTrendingSectorsByDollarTagQueryHookResult = ReturnType<typeof useGetTrendingSectorsByDollarTagQuery>;
export type GetTrendingSectorsByDollarTagLazyQueryHookResult = ReturnType<typeof useGetTrendingSectorsByDollarTagLazyQuery>;
export type GetTrendingSectorsByDollarTagSuspenseQueryHookResult = ReturnType<typeof useGetTrendingSectorsByDollarTagSuspenseQuery>;
export type GetTrendingSectorsByDollarTagQueryResult = Apollo.QueryResult<GetTrendingSectorsByDollarTagQuery, GetTrendingSectorsByDollarTagQueryVariables>;
export const TrendingStocksDocument = gql`
    query TrendingStocks($skip: Int!, $take: Int!) {
  getTrendingStocks(skip: $skip, take: $take) {
    stock {
      securityId
      slug
      stockName
      postCount
      isfollow
      issubscribed
      bseListingId
      nseListingId
      slug
    }
    followers
    userAvatars
  }
}
    `;

/**
 * __useTrendingStocksQuery__
 *
 * To run a query within a React component, call `useTrendingStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrendingStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrendingStocksQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useTrendingStocksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TrendingStocksQuery, TrendingStocksQueryVariables> & ({ variables: TrendingStocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrendingStocksQuery, TrendingStocksQueryVariables>(TrendingStocksDocument, options);
      }
export function useTrendingStocksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrendingStocksQuery, TrendingStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrendingStocksQuery, TrendingStocksQueryVariables>(TrendingStocksDocument, options);
        }
export function useTrendingStocksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrendingStocksQuery, TrendingStocksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TrendingStocksQuery, TrendingStocksQueryVariables>(TrendingStocksDocument, options);
        }
export type TrendingStocksQueryHookResult = ReturnType<typeof useTrendingStocksQuery>;
export type TrendingStocksLazyQueryHookResult = ReturnType<typeof useTrendingStocksLazyQuery>;
export type TrendingStocksSuspenseQueryHookResult = ReturnType<typeof useTrendingStocksSuspenseQuery>;
export type TrendingStocksQueryResult = Apollo.QueryResult<TrendingStocksQuery, TrendingStocksQueryVariables>;
export const GetTrendingStocksByDollarTagDocument = gql`
    query GetTrendingStocksByDollarTag($offset: Int!, $limit: Int!) {
  getTrendingStocksByDollarTag(offset: $offset, limit: $limit) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetTrendingStocksByDollarTagQuery__
 *
 * To run a query within a React component, call `useGetTrendingStocksByDollarTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingStocksByDollarTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingStocksByDollarTagQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTrendingStocksByDollarTagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTrendingStocksByDollarTagQuery, GetTrendingStocksByDollarTagQueryVariables> & ({ variables: GetTrendingStocksByDollarTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTrendingStocksByDollarTagQuery, GetTrendingStocksByDollarTagQueryVariables>(GetTrendingStocksByDollarTagDocument, options);
      }
export function useGetTrendingStocksByDollarTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTrendingStocksByDollarTagQuery, GetTrendingStocksByDollarTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTrendingStocksByDollarTagQuery, GetTrendingStocksByDollarTagQueryVariables>(GetTrendingStocksByDollarTagDocument, options);
        }
export function useGetTrendingStocksByDollarTagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTrendingStocksByDollarTagQuery, GetTrendingStocksByDollarTagQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTrendingStocksByDollarTagQuery, GetTrendingStocksByDollarTagQueryVariables>(GetTrendingStocksByDollarTagDocument, options);
        }
export type GetTrendingStocksByDollarTagQueryHookResult = ReturnType<typeof useGetTrendingStocksByDollarTagQuery>;
export type GetTrendingStocksByDollarTagLazyQueryHookResult = ReturnType<typeof useGetTrendingStocksByDollarTagLazyQuery>;
export type GetTrendingStocksByDollarTagSuspenseQueryHookResult = ReturnType<typeof useGetTrendingStocksByDollarTagSuspenseQuery>;
export type GetTrendingStocksByDollarTagQueryResult = Apollo.QueryResult<GetTrendingStocksByDollarTagQuery, GetTrendingStocksByDollarTagQueryVariables>;
export const GetTrendingStocksV2Document = gql`
    query getTrendingStocksV2($offset: Int, $limit: Int) {
  getTrendingStocksV2(offset: $offset, limit: $limit) {
    ...StockFields
    postCount
    followers
  }
}
    ${StockFieldsFragmentDoc}`;

/**
 * __useGetTrendingStocksV2Query__
 *
 * To run a query within a React component, call `useGetTrendingStocksV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingStocksV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingStocksV2Query({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTrendingStocksV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTrendingStocksV2Query, GetTrendingStocksV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTrendingStocksV2Query, GetTrendingStocksV2QueryVariables>(GetTrendingStocksV2Document, options);
      }
export function useGetTrendingStocksV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTrendingStocksV2Query, GetTrendingStocksV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTrendingStocksV2Query, GetTrendingStocksV2QueryVariables>(GetTrendingStocksV2Document, options);
        }
export function useGetTrendingStocksV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTrendingStocksV2Query, GetTrendingStocksV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTrendingStocksV2Query, GetTrendingStocksV2QueryVariables>(GetTrendingStocksV2Document, options);
        }
export type GetTrendingStocksV2QueryHookResult = ReturnType<typeof useGetTrendingStocksV2Query>;
export type GetTrendingStocksV2LazyQueryHookResult = ReturnType<typeof useGetTrendingStocksV2LazyQuery>;
export type GetTrendingStocksV2SuspenseQueryHookResult = ReturnType<typeof useGetTrendingStocksV2SuspenseQuery>;
export type GetTrendingStocksV2QueryResult = Apollo.QueryResult<GetTrendingStocksV2Query, GetTrendingStocksV2QueryVariables>;
export const GetTurnOffNotificationTextDocument = gql`
    query getTurnOffNotificationText($notificationId: String) {
  getTurnOffNotificationText(notificationId: $notificationId)
}
    `;

/**
 * __useGetTurnOffNotificationTextQuery__
 *
 * To run a query within a React component, call `useGetTurnOffNotificationTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTurnOffNotificationTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTurnOffNotificationTextQuery({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useGetTurnOffNotificationTextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTurnOffNotificationTextQuery, GetTurnOffNotificationTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTurnOffNotificationTextQuery, GetTurnOffNotificationTextQueryVariables>(GetTurnOffNotificationTextDocument, options);
      }
export function useGetTurnOffNotificationTextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTurnOffNotificationTextQuery, GetTurnOffNotificationTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTurnOffNotificationTextQuery, GetTurnOffNotificationTextQueryVariables>(GetTurnOffNotificationTextDocument, options);
        }
export function useGetTurnOffNotificationTextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTurnOffNotificationTextQuery, GetTurnOffNotificationTextQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTurnOffNotificationTextQuery, GetTurnOffNotificationTextQueryVariables>(GetTurnOffNotificationTextDocument, options);
        }
export type GetTurnOffNotificationTextQueryHookResult = ReturnType<typeof useGetTurnOffNotificationTextQuery>;
export type GetTurnOffNotificationTextLazyQueryHookResult = ReturnType<typeof useGetTurnOffNotificationTextLazyQuery>;
export type GetTurnOffNotificationTextSuspenseQueryHookResult = ReturnType<typeof useGetTurnOffNotificationTextSuspenseQuery>;
export type GetTurnOffNotificationTextQueryResult = Apollo.QueryResult<GetTurnOffNotificationTextQuery, GetTurnOffNotificationTextQueryVariables>;
export const GetUniqueUsernameDocument = gql`
    query getUniqueUsername($username: String!) {
  getUniqueUsername(username: $username) {
    success
  }
}
    `;

/**
 * __useGetUniqueUsernameQuery__
 *
 * To run a query within a React component, call `useGetUniqueUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqueUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqueUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetUniqueUsernameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUniqueUsernameQuery, GetUniqueUsernameQueryVariables> & ({ variables: GetUniqueUsernameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUniqueUsernameQuery, GetUniqueUsernameQueryVariables>(GetUniqueUsernameDocument, options);
      }
export function useGetUniqueUsernameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUniqueUsernameQuery, GetUniqueUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUniqueUsernameQuery, GetUniqueUsernameQueryVariables>(GetUniqueUsernameDocument, options);
        }
export function useGetUniqueUsernameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUniqueUsernameQuery, GetUniqueUsernameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUniqueUsernameQuery, GetUniqueUsernameQueryVariables>(GetUniqueUsernameDocument, options);
        }
export type GetUniqueUsernameQueryHookResult = ReturnType<typeof useGetUniqueUsernameQuery>;
export type GetUniqueUsernameLazyQueryHookResult = ReturnType<typeof useGetUniqueUsernameLazyQuery>;
export type GetUniqueUsernameSuspenseQueryHookResult = ReturnType<typeof useGetUniqueUsernameSuspenseQuery>;
export type GetUniqueUsernameQueryResult = Apollo.QueryResult<GetUniqueUsernameQuery, GetUniqueUsernameQueryVariables>;
export const GetUpcomingEventsDocument = gql`
    query getUpcomingEvents($limit: Int, $offset: Int) {
  getUpcomingEvents(limit: $limit, offset: $offset) {
    eventId
    title
    imageUrl
    ctaButtonText
    ctaButtonUrl
    startTime
    endTime
    description
  }
}
    `;

/**
 * __useGetUpcomingEventsQuery__
 *
 * To run a query within a React component, call `useGetUpcomingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingEventsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetUpcomingEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUpcomingEventsQuery, GetUpcomingEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUpcomingEventsQuery, GetUpcomingEventsQueryVariables>(GetUpcomingEventsDocument, options);
      }
export function useGetUpcomingEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUpcomingEventsQuery, GetUpcomingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUpcomingEventsQuery, GetUpcomingEventsQueryVariables>(GetUpcomingEventsDocument, options);
        }
export function useGetUpcomingEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUpcomingEventsQuery, GetUpcomingEventsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUpcomingEventsQuery, GetUpcomingEventsQueryVariables>(GetUpcomingEventsDocument, options);
        }
export type GetUpcomingEventsQueryHookResult = ReturnType<typeof useGetUpcomingEventsQuery>;
export type GetUpcomingEventsLazyQueryHookResult = ReturnType<typeof useGetUpcomingEventsLazyQuery>;
export type GetUpcomingEventsSuspenseQueryHookResult = ReturnType<typeof useGetUpcomingEventsSuspenseQuery>;
export type GetUpcomingEventsQueryResult = Apollo.QueryResult<GetUpcomingEventsQuery, GetUpcomingEventsQueryVariables>;
export const GetUserFeedTypeListDocument = gql`
    query getUserFeedTypeList {
  getUserFeedTypeList {
    feedTypeId
    feedType
    feedDisplayName
    default
    showSmartFeed
  }
}
    `;

/**
 * __useGetUserFeedTypeListQuery__
 *
 * To run a query within a React component, call `useGetUserFeedTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFeedTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFeedTypeListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserFeedTypeListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserFeedTypeListQuery, GetUserFeedTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserFeedTypeListQuery, GetUserFeedTypeListQueryVariables>(GetUserFeedTypeListDocument, options);
      }
export function useGetUserFeedTypeListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserFeedTypeListQuery, GetUserFeedTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserFeedTypeListQuery, GetUserFeedTypeListQueryVariables>(GetUserFeedTypeListDocument, options);
        }
export function useGetUserFeedTypeListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserFeedTypeListQuery, GetUserFeedTypeListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserFeedTypeListQuery, GetUserFeedTypeListQueryVariables>(GetUserFeedTypeListDocument, options);
        }
export type GetUserFeedTypeListQueryHookResult = ReturnType<typeof useGetUserFeedTypeListQuery>;
export type GetUserFeedTypeListLazyQueryHookResult = ReturnType<typeof useGetUserFeedTypeListLazyQuery>;
export type GetUserFeedTypeListSuspenseQueryHookResult = ReturnType<typeof useGetUserFeedTypeListSuspenseQuery>;
export type GetUserFeedTypeListQueryResult = Apollo.QueryResult<GetUserFeedTypeListQuery, GetUserFeedTypeListQueryVariables>;
export const GetUserFollowersDocument = gql`
    query getUserFollowers($userId: String!, $offset: Int!, $limit: Int!) {
  getUserFollowers(userId: $userId, offset: $offset, limit: $limit) {
    ...UserFields
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserFollowersQuery__
 *
 * To run a query within a React component, call `useGetUserFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFollowersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserFollowersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserFollowersQuery, GetUserFollowersQueryVariables> & ({ variables: GetUserFollowersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserFollowersQuery, GetUserFollowersQueryVariables>(GetUserFollowersDocument, options);
      }
export function useGetUserFollowersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserFollowersQuery, GetUserFollowersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserFollowersQuery, GetUserFollowersQueryVariables>(GetUserFollowersDocument, options);
        }
export function useGetUserFollowersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserFollowersQuery, GetUserFollowersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserFollowersQuery, GetUserFollowersQueryVariables>(GetUserFollowersDocument, options);
        }
export type GetUserFollowersQueryHookResult = ReturnType<typeof useGetUserFollowersQuery>;
export type GetUserFollowersLazyQueryHookResult = ReturnType<typeof useGetUserFollowersLazyQuery>;
export type GetUserFollowersSuspenseQueryHookResult = ReturnType<typeof useGetUserFollowersSuspenseQuery>;
export type GetUserFollowersQueryResult = Apollo.QueryResult<GetUserFollowersQuery, GetUserFollowersQueryVariables>;
export const GetUserFollowingsDocument = gql`
    query getUserFollowings($userId: String!, $offset: Int!, $limit: Int!) {
  getUserFollowings(userId: $userId, offset: $offset, limit: $limit) {
    ...UserFields
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserFollowingsQuery__
 *
 * To run a query within a React component, call `useGetUserFollowingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFollowingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFollowingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserFollowingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserFollowingsQuery, GetUserFollowingsQueryVariables> & ({ variables: GetUserFollowingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserFollowingsQuery, GetUserFollowingsQueryVariables>(GetUserFollowingsDocument, options);
      }
export function useGetUserFollowingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserFollowingsQuery, GetUserFollowingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserFollowingsQuery, GetUserFollowingsQueryVariables>(GetUserFollowingsDocument, options);
        }
export function useGetUserFollowingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserFollowingsQuery, GetUserFollowingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserFollowingsQuery, GetUserFollowingsQueryVariables>(GetUserFollowingsDocument, options);
        }
export type GetUserFollowingsQueryHookResult = ReturnType<typeof useGetUserFollowingsQuery>;
export type GetUserFollowingsLazyQueryHookResult = ReturnType<typeof useGetUserFollowingsLazyQuery>;
export type GetUserFollowingsSuspenseQueryHookResult = ReturnType<typeof useGetUserFollowingsSuspenseQuery>;
export type GetUserFollowingsQueryResult = Apollo.QueryResult<GetUserFollowingsQuery, GetUserFollowingsQueryVariables>;
export const GetUserLevelNameFromSeDocument = gql`
    query getUserLevelNameFromSE {
  getUserLevelNameFromSE
}
    `;

/**
 * __useGetUserLevelNameFromSeQuery__
 *
 * To run a query within a React component, call `useGetUserLevelNameFromSeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLevelNameFromSeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLevelNameFromSeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLevelNameFromSeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserLevelNameFromSeQuery, GetUserLevelNameFromSeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserLevelNameFromSeQuery, GetUserLevelNameFromSeQueryVariables>(GetUserLevelNameFromSeDocument, options);
      }
export function useGetUserLevelNameFromSeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserLevelNameFromSeQuery, GetUserLevelNameFromSeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserLevelNameFromSeQuery, GetUserLevelNameFromSeQueryVariables>(GetUserLevelNameFromSeDocument, options);
        }
export function useGetUserLevelNameFromSeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserLevelNameFromSeQuery, GetUserLevelNameFromSeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserLevelNameFromSeQuery, GetUserLevelNameFromSeQueryVariables>(GetUserLevelNameFromSeDocument, options);
        }
export type GetUserLevelNameFromSeQueryHookResult = ReturnType<typeof useGetUserLevelNameFromSeQuery>;
export type GetUserLevelNameFromSeLazyQueryHookResult = ReturnType<typeof useGetUserLevelNameFromSeLazyQuery>;
export type GetUserLevelNameFromSeSuspenseQueryHookResult = ReturnType<typeof useGetUserLevelNameFromSeSuspenseQuery>;
export type GetUserLevelNameFromSeQueryResult = Apollo.QueryResult<GetUserLevelNameFromSeQuery, GetUserLevelNameFromSeQueryVariables>;
export const GetUserListDocument = gql`
    query getUserList($data: GetUserListArgs) {
  getUserList(data: $data) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserListQuery__
 *
 * To run a query within a React component, call `useGetUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserListQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetUserListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserListQuery, GetUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserListQuery, GetUserListQueryVariables>(GetUserListDocument, options);
      }
export function useGetUserListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserListQuery, GetUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserListQuery, GetUserListQueryVariables>(GetUserListDocument, options);
        }
export function useGetUserListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserListQuery, GetUserListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserListQuery, GetUserListQueryVariables>(GetUserListDocument, options);
        }
export type GetUserListQueryHookResult = ReturnType<typeof useGetUserListQuery>;
export type GetUserListLazyQueryHookResult = ReturnType<typeof useGetUserListLazyQuery>;
export type GetUserListSuspenseQueryHookResult = ReturnType<typeof useGetUserListSuspenseQuery>;
export type GetUserListQueryResult = Apollo.QueryResult<GetUserListQuery, GetUserListQueryVariables>;
export const GetUserWatchlistDocument = gql`
    query getUserWatchlist($userId: String!, $type: dollarTagEnum, $offset: Int, $limit: Int) {
  getUserWatchlist(userId: $userId, type: $type, offset: $offset, limit: $limit) {
    dollarTagId
    dollarTagName
    slug
    dollarTagType
    sourceEntityId
    isfollow
  }
}
    `;

/**
 * __useGetUserWatchlistQuery__
 *
 * To run a query within a React component, call `useGetUserWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWatchlistQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      type: // value for 'type'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserWatchlistQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserWatchlistQuery, GetUserWatchlistQueryVariables> & ({ variables: GetUserWatchlistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserWatchlistQuery, GetUserWatchlistQueryVariables>(GetUserWatchlistDocument, options);
      }
export function useGetUserWatchlistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserWatchlistQuery, GetUserWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserWatchlistQuery, GetUserWatchlistQueryVariables>(GetUserWatchlistDocument, options);
        }
export function useGetUserWatchlistSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserWatchlistQuery, GetUserWatchlistQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserWatchlistQuery, GetUserWatchlistQueryVariables>(GetUserWatchlistDocument, options);
        }
export type GetUserWatchlistQueryHookResult = ReturnType<typeof useGetUserWatchlistQuery>;
export type GetUserWatchlistLazyQueryHookResult = ReturnType<typeof useGetUserWatchlistLazyQuery>;
export type GetUserWatchlistSuspenseQueryHookResult = ReturnType<typeof useGetUserWatchlistSuspenseQuery>;
export type GetUserWatchlistQueryResult = Apollo.QueryResult<GetUserWatchlistQuery, GetUserWatchlistQueryVariables>;
export const GetVerifiedUsersDocument = gql`
    query getVerifiedUsers($limit: Int, $offset: Int) {
  getVerifiedUsers(limit: $limit, offset: $offset) {
    ...UserFields
    cover
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetVerifiedUsersQuery__
 *
 * To run a query within a React component, call `useGetVerifiedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerifiedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerifiedUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetVerifiedUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVerifiedUsersQuery, GetVerifiedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVerifiedUsersQuery, GetVerifiedUsersQueryVariables>(GetVerifiedUsersDocument, options);
      }
export function useGetVerifiedUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVerifiedUsersQuery, GetVerifiedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVerifiedUsersQuery, GetVerifiedUsersQueryVariables>(GetVerifiedUsersDocument, options);
        }
export function useGetVerifiedUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVerifiedUsersQuery, GetVerifiedUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVerifiedUsersQuery, GetVerifiedUsersQueryVariables>(GetVerifiedUsersDocument, options);
        }
export type GetVerifiedUsersQueryHookResult = ReturnType<typeof useGetVerifiedUsersQuery>;
export type GetVerifiedUsersLazyQueryHookResult = ReturnType<typeof useGetVerifiedUsersLazyQuery>;
export type GetVerifiedUsersSuspenseQueryHookResult = ReturnType<typeof useGetVerifiedUsersSuspenseQuery>;
export type GetVerifiedUsersQueryResult = Apollo.QueryResult<GetVerifiedUsersQuery, GetVerifiedUsersQueryVariables>;
export const GetVoterListDocument = gql`
    query GetVoterList($pollId: String!, $limit: Int, $offset: Int) {
  getVoterList(pollId: $pollId, limit: $limit, offset: $offset) {
    ...UserFields
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetVoterListQuery__
 *
 * To run a query within a React component, call `useGetVoterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoterListQuery({
 *   variables: {
 *      pollId: // value for 'pollId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetVoterListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVoterListQuery, GetVoterListQueryVariables> & ({ variables: GetVoterListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVoterListQuery, GetVoterListQueryVariables>(GetVoterListDocument, options);
      }
export function useGetVoterListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVoterListQuery, GetVoterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVoterListQuery, GetVoterListQueryVariables>(GetVoterListDocument, options);
        }
export function useGetVoterListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVoterListQuery, GetVoterListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVoterListQuery, GetVoterListQueryVariables>(GetVoterListDocument, options);
        }
export type GetVoterListQueryHookResult = ReturnType<typeof useGetVoterListQuery>;
export type GetVoterListLazyQueryHookResult = ReturnType<typeof useGetVoterListLazyQuery>;
export type GetVoterListSuspenseQueryHookResult = ReturnType<typeof useGetVoterListSuspenseQuery>;
export type GetVoterListQueryResult = Apollo.QueryResult<GetVoterListQuery, GetVoterListQueryVariables>;
export const GetWatchListDocument = gql`
    query getWatchList($offset: Int, $limit: Int) {
  getWatchlist(offset: $offset, limit: $limit) {
    securityId
    stockName
    slug
    isfollow
  }
}
    `;

/**
 * __useGetWatchListQuery__
 *
 * To run a query within a React component, call `useGetWatchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWatchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWatchListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetWatchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWatchListQuery, GetWatchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWatchListQuery, GetWatchListQueryVariables>(GetWatchListDocument, options);
      }
export function useGetWatchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWatchListQuery, GetWatchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWatchListQuery, GetWatchListQueryVariables>(GetWatchListDocument, options);
        }
export function useGetWatchListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWatchListQuery, GetWatchListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWatchListQuery, GetWatchListQueryVariables>(GetWatchListDocument, options);
        }
export type GetWatchListQueryHookResult = ReturnType<typeof useGetWatchListQuery>;
export type GetWatchListLazyQueryHookResult = ReturnType<typeof useGetWatchListLazyQuery>;
export type GetWatchListSuspenseQueryHookResult = ReturnType<typeof useGetWatchListSuspenseQuery>;
export type GetWatchListQueryResult = Apollo.QueryResult<GetWatchListQuery, GetWatchListQueryVariables>;
export const GetWatchlistCountDocument = gql`
    query getWatchlistCount($userId: String!) {
  getWatchlistCount(userId: $userId)
}
    `;

/**
 * __useGetWatchlistCountQuery__
 *
 * To run a query within a React component, call `useGetWatchlistCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWatchlistCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWatchlistCountQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetWatchlistCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWatchlistCountQuery, GetWatchlistCountQueryVariables> & ({ variables: GetWatchlistCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWatchlistCountQuery, GetWatchlistCountQueryVariables>(GetWatchlistCountDocument, options);
      }
export function useGetWatchlistCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWatchlistCountQuery, GetWatchlistCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWatchlistCountQuery, GetWatchlistCountQueryVariables>(GetWatchlistCountDocument, options);
        }
export function useGetWatchlistCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWatchlistCountQuery, GetWatchlistCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWatchlistCountQuery, GetWatchlistCountQueryVariables>(GetWatchlistCountDocument, options);
        }
export type GetWatchlistCountQueryHookResult = ReturnType<typeof useGetWatchlistCountQuery>;
export type GetWatchlistCountLazyQueryHookResult = ReturnType<typeof useGetWatchlistCountLazyQuery>;
export type GetWatchlistCountSuspenseQueryHookResult = ReturnType<typeof useGetWatchlistCountSuspenseQuery>;
export type GetWatchlistCountQueryResult = Apollo.QueryResult<GetWatchlistCountQuery, GetWatchlistCountQueryVariables>;
export const GetWatchlistV2Document = gql`
    query getWatchlistV2($offset: Int, $limit: Int, $type: dollarTagEnum) {
  getWatchlistV2(offset: $offset, limit: $limit, type: $type) {
    dollarTagId
    dollarTagName
    slug
    alias
    dollarTagType
    sourceEntityId
    sourceEntityIdType
    isfollow
    issubscribed
    followers
  }
}
    `;

/**
 * __useGetWatchlistV2Query__
 *
 * To run a query within a React component, call `useGetWatchlistV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetWatchlistV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWatchlistV2Query({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetWatchlistV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWatchlistV2Query, GetWatchlistV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWatchlistV2Query, GetWatchlistV2QueryVariables>(GetWatchlistV2Document, options);
      }
export function useGetWatchlistV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWatchlistV2Query, GetWatchlistV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWatchlistV2Query, GetWatchlistV2QueryVariables>(GetWatchlistV2Document, options);
        }
export function useGetWatchlistV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWatchlistV2Query, GetWatchlistV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWatchlistV2Query, GetWatchlistV2QueryVariables>(GetWatchlistV2Document, options);
        }
export type GetWatchlistV2QueryHookResult = ReturnType<typeof useGetWatchlistV2Query>;
export type GetWatchlistV2LazyQueryHookResult = ReturnType<typeof useGetWatchlistV2LazyQuery>;
export type GetWatchlistV2SuspenseQueryHookResult = ReturnType<typeof useGetWatchlistV2SuspenseQuery>;
export type GetWatchlistV2QueryResult = Apollo.QueryResult<GetWatchlistV2Query, GetWatchlistV2QueryVariables>;
export const GetZendeskTicketCommentsDocument = gql`
    query getZendeskTicketComments($ticketId: Int!) {
  getZendeskTicketComments(ticketId: $ticketId)
}
    `;

/**
 * __useGetZendeskTicketCommentsQuery__
 *
 * To run a query within a React component, call `useGetZendeskTicketCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZendeskTicketCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZendeskTicketCommentsQuery({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useGetZendeskTicketCommentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetZendeskTicketCommentsQuery, GetZendeskTicketCommentsQueryVariables> & ({ variables: GetZendeskTicketCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetZendeskTicketCommentsQuery, GetZendeskTicketCommentsQueryVariables>(GetZendeskTicketCommentsDocument, options);
      }
export function useGetZendeskTicketCommentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetZendeskTicketCommentsQuery, GetZendeskTicketCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetZendeskTicketCommentsQuery, GetZendeskTicketCommentsQueryVariables>(GetZendeskTicketCommentsDocument, options);
        }
export function useGetZendeskTicketCommentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetZendeskTicketCommentsQuery, GetZendeskTicketCommentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetZendeskTicketCommentsQuery, GetZendeskTicketCommentsQueryVariables>(GetZendeskTicketCommentsDocument, options);
        }
export type GetZendeskTicketCommentsQueryHookResult = ReturnType<typeof useGetZendeskTicketCommentsQuery>;
export type GetZendeskTicketCommentsLazyQueryHookResult = ReturnType<typeof useGetZendeskTicketCommentsLazyQuery>;
export type GetZendeskTicketCommentsSuspenseQueryHookResult = ReturnType<typeof useGetZendeskTicketCommentsSuspenseQuery>;
export type GetZendeskTicketCommentsQueryResult = Apollo.QueryResult<GetZendeskTicketCommentsQuery, GetZendeskTicketCommentsQueryVariables>;
export const GetZendeskTicketTypeListDocument = gql`
    query getZendeskTicketTypeList {
  getZendeskTicketTypeList
}
    `;

/**
 * __useGetZendeskTicketTypeListQuery__
 *
 * To run a query within a React component, call `useGetZendeskTicketTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZendeskTicketTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZendeskTicketTypeListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetZendeskTicketTypeListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetZendeskTicketTypeListQuery, GetZendeskTicketTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetZendeskTicketTypeListQuery, GetZendeskTicketTypeListQueryVariables>(GetZendeskTicketTypeListDocument, options);
      }
export function useGetZendeskTicketTypeListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetZendeskTicketTypeListQuery, GetZendeskTicketTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetZendeskTicketTypeListQuery, GetZendeskTicketTypeListQueryVariables>(GetZendeskTicketTypeListDocument, options);
        }
export function useGetZendeskTicketTypeListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetZendeskTicketTypeListQuery, GetZendeskTicketTypeListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetZendeskTicketTypeListQuery, GetZendeskTicketTypeListQueryVariables>(GetZendeskTicketTypeListDocument, options);
        }
export type GetZendeskTicketTypeListQueryHookResult = ReturnType<typeof useGetZendeskTicketTypeListQuery>;
export type GetZendeskTicketTypeListLazyQueryHookResult = ReturnType<typeof useGetZendeskTicketTypeListLazyQuery>;
export type GetZendeskTicketTypeListSuspenseQueryHookResult = ReturnType<typeof useGetZendeskTicketTypeListSuspenseQuery>;
export type GetZendeskTicketTypeListQueryResult = Apollo.QueryResult<GetZendeskTicketTypeListQuery, GetZendeskTicketTypeListQueryVariables>;
export const GetZendeskTicketsByUserDocument = gql`
    query getZendeskTicketsByUser($limit: Int!, $page: Int!, $filter: ZendeskSearchfilter) {
  getZendeskTicketsByUser(limit: $limit, page: $page, filter: $filter) {
    total
    tickets
  }
}
    `;

/**
 * __useGetZendeskTicketsByUserQuery__
 *
 * To run a query within a React component, call `useGetZendeskTicketsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZendeskTicketsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZendeskTicketsByUserQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetZendeskTicketsByUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetZendeskTicketsByUserQuery, GetZendeskTicketsByUserQueryVariables> & ({ variables: GetZendeskTicketsByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetZendeskTicketsByUserQuery, GetZendeskTicketsByUserQueryVariables>(GetZendeskTicketsByUserDocument, options);
      }
export function useGetZendeskTicketsByUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetZendeskTicketsByUserQuery, GetZendeskTicketsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetZendeskTicketsByUserQuery, GetZendeskTicketsByUserQueryVariables>(GetZendeskTicketsByUserDocument, options);
        }
export function useGetZendeskTicketsByUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetZendeskTicketsByUserQuery, GetZendeskTicketsByUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetZendeskTicketsByUserQuery, GetZendeskTicketsByUserQueryVariables>(GetZendeskTicketsByUserDocument, options);
        }
export type GetZendeskTicketsByUserQueryHookResult = ReturnType<typeof useGetZendeskTicketsByUserQuery>;
export type GetZendeskTicketsByUserLazyQueryHookResult = ReturnType<typeof useGetZendeskTicketsByUserLazyQuery>;
export type GetZendeskTicketsByUserSuspenseQueryHookResult = ReturnType<typeof useGetZendeskTicketsByUserSuspenseQuery>;
export type GetZendeskTicketsByUserQueryResult = Apollo.QueryResult<GetZendeskTicketsByUserQuery, GetZendeskTicketsByUserQueryVariables>;
export const IsFeatureVisibleDocument = gql`
    query isFeatureVisible($featureName: String) {
  isFeatureVisible(featureName: $featureName)
}
    `;

/**
 * __useIsFeatureVisibleQuery__
 *
 * To run a query within a React component, call `useIsFeatureVisibleQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsFeatureVisibleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsFeatureVisibleQuery({
 *   variables: {
 *      featureName: // value for 'featureName'
 *   },
 * });
 */
export function useIsFeatureVisibleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IsFeatureVisibleQuery, IsFeatureVisibleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsFeatureVisibleQuery, IsFeatureVisibleQueryVariables>(IsFeatureVisibleDocument, options);
      }
export function useIsFeatureVisibleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsFeatureVisibleQuery, IsFeatureVisibleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsFeatureVisibleQuery, IsFeatureVisibleQueryVariables>(IsFeatureVisibleDocument, options);
        }
export function useIsFeatureVisibleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IsFeatureVisibleQuery, IsFeatureVisibleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IsFeatureVisibleQuery, IsFeatureVisibleQueryVariables>(IsFeatureVisibleDocument, options);
        }
export type IsFeatureVisibleQueryHookResult = ReturnType<typeof useIsFeatureVisibleQuery>;
export type IsFeatureVisibleLazyQueryHookResult = ReturnType<typeof useIsFeatureVisibleLazyQuery>;
export type IsFeatureVisibleSuspenseQueryHookResult = ReturnType<typeof useIsFeatureVisibleSuspenseQuery>;
export type IsFeatureVisibleQueryResult = Apollo.QueryResult<IsFeatureVisibleQuery, IsFeatureVisibleQueryVariables>;
export const IsReportDocument = gql`
    query isReport($postId: String, $commentId: String, $replyId: String, $userId: String, $clubId: String) {
  getIsReported(
    postId: $postId
    commentId: $commentId
    replyId: $replyId
    userId: $userId
    clubId: $clubId
  )
}
    `;

/**
 * __useIsReportQuery__
 *
 * To run a query within a React component, call `useIsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsReportQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *      replyId: // value for 'replyId'
 *      userId: // value for 'userId'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useIsReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IsReportQuery, IsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsReportQuery, IsReportQueryVariables>(IsReportDocument, options);
      }
export function useIsReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsReportQuery, IsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsReportQuery, IsReportQueryVariables>(IsReportDocument, options);
        }
export function useIsReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IsReportQuery, IsReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IsReportQuery, IsReportQueryVariables>(IsReportDocument, options);
        }
export type IsReportQueryHookResult = ReturnType<typeof useIsReportQuery>;
export type IsReportLazyQueryHookResult = ReturnType<typeof useIsReportLazyQuery>;
export type IsReportSuspenseQueryHookResult = ReturnType<typeof useIsReportSuspenseQuery>;
export type IsReportQueryResult = Apollo.QueryResult<IsReportQuery, IsReportQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...UserFields
    profileType
    showNpsV2
    watchlistVisibleStatus
    hasUnderApprovalRequests
    viewFeedPermission {
      canViewPost
      canSeeMarketingPost
    }
    highlightedAchievements {
      achievementType
      sourceOfClick
      promotionImage
      promotionText
      badges {
        badgeId
        badgeName
        badgeIcon
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const GetPopularClubsDocument = gql`
    query getPopularClubs {
  private: getPopularClubs(clubType: Private) {
    ...ClubFields
  }
  paid: getPopularClubs(clubType: Paid) {
    ...ClubFields
  }
  public: getPopularClubs(clubType: Public) {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetPopularClubsQuery__
 *
 * To run a query within a React component, call `useGetPopularClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularClubsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPopularClubsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPopularClubsQuery, GetPopularClubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPopularClubsQuery, GetPopularClubsQueryVariables>(GetPopularClubsDocument, options);
      }
export function useGetPopularClubsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPopularClubsQuery, GetPopularClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPopularClubsQuery, GetPopularClubsQueryVariables>(GetPopularClubsDocument, options);
        }
export function useGetPopularClubsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPopularClubsQuery, GetPopularClubsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPopularClubsQuery, GetPopularClubsQueryVariables>(GetPopularClubsDocument, options);
        }
export type GetPopularClubsQueryHookResult = ReturnType<typeof useGetPopularClubsQuery>;
export type GetPopularClubsLazyQueryHookResult = ReturnType<typeof useGetPopularClubsLazyQuery>;
export type GetPopularClubsSuspenseQueryHookResult = ReturnType<typeof useGetPopularClubsSuspenseQuery>;
export type GetPopularClubsQueryResult = Apollo.QueryResult<GetPopularClubsQuery, GetPopularClubsQueryVariables>;
export const PostMoreMenuDocument = gql`
    query PostMoreMenu($postId: String!) {
  isFollowed: isPostFollowed(postId: $postId)
  isBookmarked: getIsBookmarked(postId: $postId)
  isReported: getIsReported(postId: $postId)
}
    `;

/**
 * __usePostMoreMenuQuery__
 *
 * To run a query within a React component, call `usePostMoreMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostMoreMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostMoreMenuQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostMoreMenuQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PostMoreMenuQuery, PostMoreMenuQueryVariables> & ({ variables: PostMoreMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PostMoreMenuQuery, PostMoreMenuQueryVariables>(PostMoreMenuDocument, options);
      }
export function usePostMoreMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PostMoreMenuQuery, PostMoreMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PostMoreMenuQuery, PostMoreMenuQueryVariables>(PostMoreMenuDocument, options);
        }
export function usePostMoreMenuSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PostMoreMenuQuery, PostMoreMenuQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PostMoreMenuQuery, PostMoreMenuQueryVariables>(PostMoreMenuDocument, options);
        }
export type PostMoreMenuQueryHookResult = ReturnType<typeof usePostMoreMenuQuery>;
export type PostMoreMenuLazyQueryHookResult = ReturnType<typeof usePostMoreMenuLazyQuery>;
export type PostMoreMenuSuspenseQueryHookResult = ReturnType<typeof usePostMoreMenuSuspenseQuery>;
export type PostMoreMenuQueryResult = Apollo.QueryResult<PostMoreMenuQuery, PostMoreMenuQueryVariables>;
export const SearchStocksDocument = gql`
    query SearchStocks($search: String!, $take: Int, $skip: Int) {
  getStocksBySearchText(data: {searchText: $search, skip: $skip, take: $take}) {
    stock {
      securityId
      stockName
      slug
      postCount
      isfollow
      issubscribed
    }
  }
}
    `;

/**
 * __useSearchStocksQuery__
 *
 * To run a query within a React component, call `useSearchStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchStocksQuery({
 *   variables: {
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSearchStocksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchStocksQuery, SearchStocksQueryVariables> & ({ variables: SearchStocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchStocksQuery, SearchStocksQueryVariables>(SearchStocksDocument, options);
      }
export function useSearchStocksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchStocksQuery, SearchStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchStocksQuery, SearchStocksQueryVariables>(SearchStocksDocument, options);
        }
export function useSearchStocksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchStocksQuery, SearchStocksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchStocksQuery, SearchStocksQueryVariables>(SearchStocksDocument, options);
        }
export type SearchStocksQueryHookResult = ReturnType<typeof useSearchStocksQuery>;
export type SearchStocksLazyQueryHookResult = ReturnType<typeof useSearchStocksLazyQuery>;
export type SearchStocksSuspenseQueryHookResult = ReturnType<typeof useSearchStocksSuspenseQuery>;
export type SearchStocksQueryResult = Apollo.QueryResult<SearchStocksQuery, SearchStocksQueryVariables>;
export const SearchTopicDocument = gql`
    query SearchTopic($search: String!, $take: Int, $skip: Int) {
  getHashtagBySearchText(data: {searchText: $search, skip: $skip, take: $take}) {
    Hashtag {
      hashtagName
      hashtagType
      postCount
      isfollow
      issubscribed
    }
    userAvatars
    followers
  }
}
    `;

/**
 * __useSearchTopicQuery__
 *
 * To run a query within a React component, call `useSearchTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTopicQuery({
 *   variables: {
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSearchTopicQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchTopicQuery, SearchTopicQueryVariables> & ({ variables: SearchTopicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchTopicQuery, SearchTopicQueryVariables>(SearchTopicDocument, options);
      }
export function useSearchTopicLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchTopicQuery, SearchTopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchTopicQuery, SearchTopicQueryVariables>(SearchTopicDocument, options);
        }
export function useSearchTopicSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchTopicQuery, SearchTopicQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchTopicQuery, SearchTopicQueryVariables>(SearchTopicDocument, options);
        }
export type SearchTopicQueryHookResult = ReturnType<typeof useSearchTopicQuery>;
export type SearchTopicLazyQueryHookResult = ReturnType<typeof useSearchTopicLazyQuery>;
export type SearchTopicSuspenseQueryHookResult = ReturnType<typeof useSearchTopicSuspenseQuery>;
export type SearchTopicQueryResult = Apollo.QueryResult<SearchTopicQuery, SearchTopicQueryVariables>;
export const SearchUserDocument = gql`
    query SearchUser($search: String!, $take: Int, $skip: Int) {
  getUserList(data: {searchText: $search, skip: $skip, take: $take}) {
    id
    firstName
    lastName
    username
    userTags
    avatar
    cover
    email
    phone
    bio
    isfollow
    isVerified
    greenTick
    tick3
  }
}
    `;

/**
 * __useSearchUserQuery__
 *
 * To run a query within a React component, call `useSearchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserQuery({
 *   variables: {
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSearchUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchUserQuery, SearchUserQueryVariables> & ({ variables: SearchUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
      }
export function useSearchUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
        }
export function useSearchUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
        }
export type SearchUserQueryHookResult = ReturnType<typeof useSearchUserQuery>;
export type SearchUserLazyQueryHookResult = ReturnType<typeof useSearchUserLazyQuery>;
export type SearchUserSuspenseQueryHookResult = ReturnType<typeof useSearchUserSuspenseQuery>;
export type SearchUserQueryResult = Apollo.QueryResult<SearchUserQuery, SearchUserQueryVariables>;
export const ShowEventsDotDocument = gql`
    query ShowEventsDot {
  showEventsDot
}
    `;

/**
 * __useShowEventsDotQuery__
 *
 * To run a query within a React component, call `useShowEventsDotQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowEventsDotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowEventsDotQuery({
 *   variables: {
 *   },
 * });
 */
export function useShowEventsDotQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShowEventsDotQuery, ShowEventsDotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShowEventsDotQuery, ShowEventsDotQueryVariables>(ShowEventsDotDocument, options);
      }
export function useShowEventsDotLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShowEventsDotQuery, ShowEventsDotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShowEventsDotQuery, ShowEventsDotQueryVariables>(ShowEventsDotDocument, options);
        }
export function useShowEventsDotSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShowEventsDotQuery, ShowEventsDotQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShowEventsDotQuery, ShowEventsDotQueryVariables>(ShowEventsDotDocument, options);
        }
export type ShowEventsDotQueryHookResult = ReturnType<typeof useShowEventsDotQuery>;
export type ShowEventsDotLazyQueryHookResult = ReturnType<typeof useShowEventsDotLazyQuery>;
export type ShowEventsDotSuspenseQueryHookResult = ReturnType<typeof useShowEventsDotSuspenseQuery>;
export type ShowEventsDotQueryResult = Apollo.QueryResult<ShowEventsDotQuery, ShowEventsDotQueryVariables>;
export const UnifiedSearchV2Document = gql`
    query unifiedSearchV2($searchText: String!, $type: SearchType!, $limit: Int, $offset: Int) {
  unifiedSearchV2(
    searchText: $searchText
    type: $type
    limit: $limit
    offset: $offset
  ) {
    hashtag {
      hashtag {
        hashtagName
        postCount
        TagId
      }
      followers
    }
    user {
      ...UserFields
    }
    club {
      clubId
      clubHandle
      clubName
      avatar
      clubBio
    }
    dollarTag {
      dollarTag {
        dollarTagId
        dollarTagName
        slug
        dollarTagType
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUnifiedSearchV2Query__
 *
 * To run a query within a React component, call `useUnifiedSearchV2Query` and pass it any options that fit your needs.
 * When your component renders, `useUnifiedSearchV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnifiedSearchV2Query({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      type: // value for 'type'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useUnifiedSearchV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<UnifiedSearchV2Query, UnifiedSearchV2QueryVariables> & ({ variables: UnifiedSearchV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnifiedSearchV2Query, UnifiedSearchV2QueryVariables>(UnifiedSearchV2Document, options);
      }
export function useUnifiedSearchV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnifiedSearchV2Query, UnifiedSearchV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnifiedSearchV2Query, UnifiedSearchV2QueryVariables>(UnifiedSearchV2Document, options);
        }
export function useUnifiedSearchV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UnifiedSearchV2Query, UnifiedSearchV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UnifiedSearchV2Query, UnifiedSearchV2QueryVariables>(UnifiedSearchV2Document, options);
        }
export type UnifiedSearchV2QueryHookResult = ReturnType<typeof useUnifiedSearchV2Query>;
export type UnifiedSearchV2LazyQueryHookResult = ReturnType<typeof useUnifiedSearchV2LazyQuery>;
export type UnifiedSearchV2SuspenseQueryHookResult = ReturnType<typeof useUnifiedSearchV2SuspenseQuery>;
export type UnifiedSearchV2QueryResult = Apollo.QueryResult<UnifiedSearchV2Query, UnifiedSearchV2QueryVariables>;
export const GetChartPeriodsDocument = gql`
    query GetChartPeriods($input: GetChartPeriodsInput) {
  GetChartPeriods(input: $input) @rest(type: "ChartPeriod", path: "/stock/GetChartPeriods", method: "POST", bodyKey: "input") {
    Code
    FromDate
    IntervalType
    Text
    Todate
    IsActive @client
  }
}
    `;

/**
 * __useGetChartPeriodsQuery__
 *
 * To run a query within a React component, call `useGetChartPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChartPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChartPeriodsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChartPeriodsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetChartPeriodsQuery, GetChartPeriodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetChartPeriodsQuery, GetChartPeriodsQueryVariables>(GetChartPeriodsDocument, options);
      }
export function useGetChartPeriodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetChartPeriodsQuery, GetChartPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetChartPeriodsQuery, GetChartPeriodsQueryVariables>(GetChartPeriodsDocument, options);
        }
export function useGetChartPeriodsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetChartPeriodsQuery, GetChartPeriodsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetChartPeriodsQuery, GetChartPeriodsQueryVariables>(GetChartPeriodsDocument, options);
        }
export type GetChartPeriodsQueryHookResult = ReturnType<typeof useGetChartPeriodsQuery>;
export type GetChartPeriodsLazyQueryHookResult = ReturnType<typeof useGetChartPeriodsLazyQuery>;
export type GetChartPeriodsSuspenseQueryHookResult = ReturnType<typeof useGetChartPeriodsSuspenseQuery>;
export type GetChartPeriodsQueryResult = Apollo.QueryResult<GetChartPeriodsQuery, GetChartPeriodsQueryVariables>;
export const GetCompanyEquityInfoDocument = gql`
    query GetCompanyEquityInfo($input: GetCompanyEquityInfoInput) {
  GetCompanyEquityInfo(input: $input) @rest(type: "CompanyEquityInfo", path: "/stock/GetCompanyEquityInfo", method: "POST", bodyKey: "input") {
    BookNavPerShare
    EPS
    FaceValue
    Fincode
    ID
    Industry
    IndustryID
    IndustryPE
    IndustrySlug
    MCAP
    NumberOfSharesSubscribed
    PE
    Price
    PriceToBookNavPerShare
    Sector
    SectorID
    SectorSlug
    Security
    SecuritySlug
    TTMEPS
    TTMNetProfit
    TTMPE
    TTMYearEnd
    Website
    YearEnd
    Yield
  }
}
    `;

/**
 * __useGetCompanyEquityInfoQuery__
 *
 * To run a query within a React component, call `useGetCompanyEquityInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyEquityInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyEquityInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCompanyEquityInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyEquityInfoQuery, GetCompanyEquityInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCompanyEquityInfoQuery, GetCompanyEquityInfoQueryVariables>(GetCompanyEquityInfoDocument, options);
      }
export function useGetCompanyEquityInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyEquityInfoQuery, GetCompanyEquityInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCompanyEquityInfoQuery, GetCompanyEquityInfoQueryVariables>(GetCompanyEquityInfoDocument, options);
        }
export function useGetCompanyEquityInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompanyEquityInfoQuery, GetCompanyEquityInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCompanyEquityInfoQuery, GetCompanyEquityInfoQueryVariables>(GetCompanyEquityInfoDocument, options);
        }
export type GetCompanyEquityInfoQueryHookResult = ReturnType<typeof useGetCompanyEquityInfoQuery>;
export type GetCompanyEquityInfoLazyQueryHookResult = ReturnType<typeof useGetCompanyEquityInfoLazyQuery>;
export type GetCompanyEquityInfoSuspenseQueryHookResult = ReturnType<typeof useGetCompanyEquityInfoSuspenseQuery>;
export type GetCompanyEquityInfoQueryResult = Apollo.QueryResult<GetCompanyEquityInfoQuery, GetCompanyEquityInfoQueryVariables>;
export const GetCompanyEquityTypeInfoDocument = gql`
    query GetCompanyEquityTypeInfo($input: GetCompanyEquityTypeInfoInput) {
  GetCompanyEquityTypeInfo(input: $input) @rest(type: "CompanyEquityTypeInfo", path: "/stock/GetCompanyEquityTypeInfo", method: "POST", bodyKey: "input") {
    ID
    StatementType
    YearEnd
    IsActive @client
  }
}
    `;

/**
 * __useGetCompanyEquityTypeInfoQuery__
 *
 * To run a query within a React component, call `useGetCompanyEquityTypeInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyEquityTypeInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyEquityTypeInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCompanyEquityTypeInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyEquityTypeInfoQuery, GetCompanyEquityTypeInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCompanyEquityTypeInfoQuery, GetCompanyEquityTypeInfoQueryVariables>(GetCompanyEquityTypeInfoDocument, options);
      }
export function useGetCompanyEquityTypeInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyEquityTypeInfoQuery, GetCompanyEquityTypeInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCompanyEquityTypeInfoQuery, GetCompanyEquityTypeInfoQueryVariables>(GetCompanyEquityTypeInfoDocument, options);
        }
export function useGetCompanyEquityTypeInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompanyEquityTypeInfoQuery, GetCompanyEquityTypeInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCompanyEquityTypeInfoQuery, GetCompanyEquityTypeInfoQueryVariables>(GetCompanyEquityTypeInfoDocument, options);
        }
export type GetCompanyEquityTypeInfoQueryHookResult = ReturnType<typeof useGetCompanyEquityTypeInfoQuery>;
export type GetCompanyEquityTypeInfoLazyQueryHookResult = ReturnType<typeof useGetCompanyEquityTypeInfoLazyQuery>;
export type GetCompanyEquityTypeInfoSuspenseQueryHookResult = ReturnType<typeof useGetCompanyEquityTypeInfoSuspenseQuery>;
export type GetCompanyEquityTypeInfoQueryResult = Apollo.QueryResult<GetCompanyEquityTypeInfoQuery, GetCompanyEquityTypeInfoQueryVariables>;
export const GetCompanyProfileForSecurityDocument = gql`
    query GetCompanyProfileForSecurity($input: GetCompanyProfileForSecurityInput) {
  GetCompanyProfileForSecurity(input: $input) @rest(type: "CompanyProfileForSecurity", path: "/stock/GetCompanyProfileForSecurity", method: "POST", bodyKey: "input") {
    ID
    Name
    ProfileText
    Slug
  }
}
    `;

/**
 * __useGetCompanyProfileForSecurityQuery__
 *
 * To run a query within a React component, call `useGetCompanyProfileForSecurityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyProfileForSecurityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyProfileForSecurityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCompanyProfileForSecurityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCompanyProfileForSecurityQuery, GetCompanyProfileForSecurityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCompanyProfileForSecurityQuery, GetCompanyProfileForSecurityQueryVariables>(GetCompanyProfileForSecurityDocument, options);
      }
export function useGetCompanyProfileForSecurityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyProfileForSecurityQuery, GetCompanyProfileForSecurityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCompanyProfileForSecurityQuery, GetCompanyProfileForSecurityQueryVariables>(GetCompanyProfileForSecurityDocument, options);
        }
export function useGetCompanyProfileForSecuritySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCompanyProfileForSecurityQuery, GetCompanyProfileForSecurityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCompanyProfileForSecurityQuery, GetCompanyProfileForSecurityQueryVariables>(GetCompanyProfileForSecurityDocument, options);
        }
export type GetCompanyProfileForSecurityQueryHookResult = ReturnType<typeof useGetCompanyProfileForSecurityQuery>;
export type GetCompanyProfileForSecurityLazyQueryHookResult = ReturnType<typeof useGetCompanyProfileForSecurityLazyQuery>;
export type GetCompanyProfileForSecuritySuspenseQueryHookResult = ReturnType<typeof useGetCompanyProfileForSecuritySuspenseQuery>;
export type GetCompanyProfileForSecurityQueryResult = Apollo.QueryResult<GetCompanyProfileForSecurityQuery, GetCompanyProfileForSecurityQueryVariables>;
export const GetIntradayPricesDocument = gql`
    query GetIntradayPrices($input: GetIntradayPricesInput) {
  GetIntradayPrices(input: $input) @rest(type: "ChartPrice", path: "/stock/GetIntradayPrices", method: "POST", bodyKey: "input") {
    Close
    Date
    High
    Low
    Open
    TradeQuantity
  }
}
    `;

/**
 * __useGetIntradayPricesQuery__
 *
 * To run a query within a React component, call `useGetIntradayPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntradayPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntradayPricesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIntradayPricesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIntradayPricesQuery, GetIntradayPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIntradayPricesQuery, GetIntradayPricesQueryVariables>(GetIntradayPricesDocument, options);
      }
export function useGetIntradayPricesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIntradayPricesQuery, GetIntradayPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIntradayPricesQuery, GetIntradayPricesQueryVariables>(GetIntradayPricesDocument, options);
        }
export function useGetIntradayPricesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIntradayPricesQuery, GetIntradayPricesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIntradayPricesQuery, GetIntradayPricesQueryVariables>(GetIntradayPricesDocument, options);
        }
export type GetIntradayPricesQueryHookResult = ReturnType<typeof useGetIntradayPricesQuery>;
export type GetIntradayPricesLazyQueryHookResult = ReturnType<typeof useGetIntradayPricesLazyQuery>;
export type GetIntradayPricesSuspenseQueryHookResult = ReturnType<typeof useGetIntradayPricesSuspenseQuery>;
export type GetIntradayPricesQueryResult = Apollo.QueryResult<GetIntradayPricesQuery, GetIntradayPricesQueryVariables>;
export const GetLatestListingPriceDocument = gql`
    query GetLatestListingPrice($input: GetLatestListingPriceInput) {
  GetLatestListingPrice(input: $input) @rest(type: "ListingPrice", path: "/stock/GetLatestListingPrice", method: "POST", bodyKey: "input") {
    C
    C1
    CZ
    CZG
    Date
    H
    L
    O
    TQ
  }
}
    `;

/**
 * __useGetLatestListingPriceQuery__
 *
 * To run a query within a React component, call `useGetLatestListingPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestListingPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestListingPriceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLatestListingPriceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLatestListingPriceQuery, GetLatestListingPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLatestListingPriceQuery, GetLatestListingPriceQueryVariables>(GetLatestListingPriceDocument, options);
      }
export function useGetLatestListingPriceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLatestListingPriceQuery, GetLatestListingPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLatestListingPriceQuery, GetLatestListingPriceQueryVariables>(GetLatestListingPriceDocument, options);
        }
export function useGetLatestListingPriceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetLatestListingPriceQuery, GetLatestListingPriceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetLatestListingPriceQuery, GetLatestListingPriceQueryVariables>(GetLatestListingPriceDocument, options);
        }
export type GetLatestListingPriceQueryHookResult = ReturnType<typeof useGetLatestListingPriceQuery>;
export type GetLatestListingPriceLazyQueryHookResult = ReturnType<typeof useGetLatestListingPriceLazyQuery>;
export type GetLatestListingPriceSuspenseQueryHookResult = ReturnType<typeof useGetLatestListingPriceSuspenseQuery>;
export type GetLatestListingPriceQueryResult = Apollo.QueryResult<GetLatestListingPriceQuery, GetLatestListingPriceQueryVariables>;
export const GetListingsForSecurityDocument = gql`
    query GetListingsForSecurity($input: GetListingsForSecurityInput) {
  GetListingsForSecurity(input: $input) @rest(type: "Exchange", path: "/stock/GetListingsForSecurity", method: "POST", bodyKey: "input") {
    Exchange
    ExchangeName
    ListingID
    SecurityID
    SecurityName
    ShortName
    Symbol
    IsActive @client
  }
}
    `;

/**
 * __useGetListingsForSecurityQuery__
 *
 * To run a query within a React component, call `useGetListingsForSecurityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingsForSecurityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingsForSecurityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetListingsForSecurityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetListingsForSecurityQuery, GetListingsForSecurityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetListingsForSecurityQuery, GetListingsForSecurityQueryVariables>(GetListingsForSecurityDocument, options);
      }
export function useGetListingsForSecurityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetListingsForSecurityQuery, GetListingsForSecurityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetListingsForSecurityQuery, GetListingsForSecurityQueryVariables>(GetListingsForSecurityDocument, options);
        }
export function useGetListingsForSecuritySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetListingsForSecurityQuery, GetListingsForSecurityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetListingsForSecurityQuery, GetListingsForSecurityQueryVariables>(GetListingsForSecurityDocument, options);
        }
export type GetListingsForSecurityQueryHookResult = ReturnType<typeof useGetListingsForSecurityQuery>;
export type GetListingsForSecurityLazyQueryHookResult = ReturnType<typeof useGetListingsForSecurityLazyQuery>;
export type GetListingsForSecuritySuspenseQueryHookResult = ReturnType<typeof useGetListingsForSecuritySuspenseQuery>;
export type GetListingsForSecurityQueryResult = Apollo.QueryResult<GetListingsForSecurityQuery, GetListingsForSecurityQueryVariables>;
export const GetPricesDocument = gql`
    query GetPrices($input: GetPricesInput) {
  GetPrices(input: $input) @rest(type: "ChartPrice", path: "/stock/GetPrices", method: "POST", bodyKey: "input") {
    Close
    Date
    High
    Low
    Open
    TradeQuantity
  }
}
    `;

/**
 * __useGetPricesQuery__
 *
 * To run a query within a React component, call `useGetPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPricesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPricesQuery, GetPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPricesQuery, GetPricesQueryVariables>(GetPricesDocument, options);
      }
export function useGetPricesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPricesQuery, GetPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPricesQuery, GetPricesQueryVariables>(GetPricesDocument, options);
        }
export function useGetPricesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPricesQuery, GetPricesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPricesQuery, GetPricesQueryVariables>(GetPricesDocument, options);
        }
export type GetPricesQueryHookResult = ReturnType<typeof useGetPricesQuery>;
export type GetPricesLazyQueryHookResult = ReturnType<typeof useGetPricesLazyQuery>;
export type GetPricesSuspenseQueryHookResult = ReturnType<typeof useGetPricesSuspenseQuery>;
export type GetPricesQueryResult = Apollo.QueryResult<GetPricesQuery, GetPricesQueryVariables>;
export const NewActivityCountDocument = gql`
    subscription NewActivityCount($userId: String!) {
  newActivityCount(userId: $userId)
}
    `;

/**
 * __useNewActivityCountSubscription__
 *
 * To run a query within a React component, call `useNewActivityCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewActivityCountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewActivityCountSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNewActivityCountSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<NewActivityCountSubscription, NewActivityCountSubscriptionVariables> & ({ variables: NewActivityCountSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<NewActivityCountSubscription, NewActivityCountSubscriptionVariables>(NewActivityCountDocument, options);
      }
export type NewActivityCountSubscriptionHookResult = ReturnType<typeof useNewActivityCountSubscription>;
export type NewActivityCountSubscriptionResult = Apollo.SubscriptionResult<NewActivityCountSubscription>;
export const NotificationCreatedDocument = gql`
    subscription notificationCreated($userId: String!, $type: type!) {
  notificationCreated(userId: $userId, type: $type) {
    message
    link
    notificationId
    notificationType
    createdAt
    User {
      id
      firstName
      lastName
      avatar
      username
    }
    Club {
      clubId
      clubHandle
      clubName
    }
    userId
    Notifier {
      id
      firstName
      lastName
      avatar
      username
    }
  }
}
    `;

/**
 * __useNotificationCreatedSubscription__
 *
 * To run a query within a React component, call `useNotificationCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationCreatedSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useNotificationCreatedSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<NotificationCreatedSubscription, NotificationCreatedSubscriptionVariables> & ({ variables: NotificationCreatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<NotificationCreatedSubscription, NotificationCreatedSubscriptionVariables>(NotificationCreatedDocument, options);
      }
export type NotificationCreatedSubscriptionHookResult = ReturnType<typeof useNotificationCreatedSubscription>;
export type NotificationCreatedSubscriptionResult = Apollo.SubscriptionResult<NotificationCreatedSubscription>;
export const NotificationCountDocument = gql`
    subscription NotificationCount($userId: String!) {
  counts: notificationCount(userId: $userId)
}
    `;

/**
 * __useNotificationCountSubscription__
 *
 * To run a query within a React component, call `useNotificationCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationCountSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNotificationCountSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<NotificationCountSubscription, NotificationCountSubscriptionVariables> & ({ variables: NotificationCountSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<NotificationCountSubscription, NotificationCountSubscriptionVariables>(NotificationCountDocument, options);
      }
export type NotificationCountSubscriptionHookResult = ReturnType<typeof useNotificationCountSubscription>;
export type NotificationCountSubscriptionResult = Apollo.SubscriptionResult<NotificationCountSubscription>;
export const UnderApprovalCountDocument = gql`
    subscription underApprovalCount($userId: String!) {
  underApprovalCount(userId: $userId)
}
    `;

/**
 * __useUnderApprovalCountSubscription__
 *
 * To run a query within a React component, call `useUnderApprovalCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUnderApprovalCountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnderApprovalCountSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnderApprovalCountSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<UnderApprovalCountSubscription, UnderApprovalCountSubscriptionVariables> & ({ variables: UnderApprovalCountSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<UnderApprovalCountSubscription, UnderApprovalCountSubscriptionVariables>(UnderApprovalCountDocument, options);
      }
export type UnderApprovalCountSubscriptionHookResult = ReturnType<typeof useUnderApprovalCountSubscription>;
export type UnderApprovalCountSubscriptionResult = Apollo.SubscriptionResult<UnderApprovalCountSubscription>;